/* tslint:disable */
/* eslint-disable */
/**
 * Local Provider Approval API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbpLoginResult
 */
export interface AbpLoginResult {
    /**
     * 
     * @type {LoginResultType}
     * @memberof AbpLoginResult
     */
    'result'?: LoginResultType;
    /**
     * 
     * @type {string}
     * @memberof AbpLoginResult
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionApiDescriptionModel
 */
export interface ActionApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'uniqueName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'httpMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'url'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionApiDescriptionModel
     */
    'supportedVersions'?: Array<string> | null;
    /**
     * 
     * @type {Array<MethodParameterApiDescriptionModel>}
     * @memberof ActionApiDescriptionModel
     */
    'parametersOnMethod'?: Array<MethodParameterApiDescriptionModel> | null;
    /**
     * 
     * @type {Array<ParameterApiDescriptionModel>}
     * @memberof ActionApiDescriptionModel
     */
    'parameters'?: Array<ParameterApiDescriptionModel> | null;
    /**
     * 
     * @type {ActionApiDescriptionModelReturnValue}
     * @memberof ActionApiDescriptionModel
     */
    'returnValue'?: ActionApiDescriptionModelReturnValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActionApiDescriptionModel
     */
    'allowAnonymous'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'implementFrom'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionApiDescriptionModelReturnValue
 */
export interface ActionApiDescriptionModelReturnValue {
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModelReturnValue
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModelReturnValue
     */
    'typeSimple'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionDefinitionGroup
 */
export interface ActionPermissionDefinitionGroup {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionGroup
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionGroup
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionDefinitionPermission
 */
export interface ActionPermissionDefinitionPermission {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'parent'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGrantInfoDto
 */
export interface ActionPermissionGrantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'parentName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActionPermissionGrantInfoDto
     */
    'isGranted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionPermissionGrantInfoDto
     */
    'allowedProviders'?: Array<string> | null;
    /**
     * 
     * @type {Array<ActionPermissionProviderInfoDto>}
     * @memberof ActionPermissionGrantInfoDto
     */
    'grantedProviders'?: Array<ActionPermissionProviderInfoDto> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGroup
 */
export interface ActionPermissionGroup {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroup
     */
    'permissionGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroup
     */
    'permissionGroupDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionDefinitionPermission>}
     * @memberof ActionPermissionGroup
     */
    'permissions'?: Array<ActionPermissionDefinitionPermission> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGroupDto
 */
export interface ActionPermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGrantInfoDto>}
     * @memberof ActionPermissionGroupDto
     */
    'permissions'?: Array<ActionPermissionGrantInfoDto> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionProviderInfoDto
 */
export interface ActionPermissionProviderInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionProviderInfoDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionProviderInfoDto
     */
    'providerKey'?: string | null;
}
/**
 * 
 * @export
 * @interface AddExceptionDto
 */
export interface AddExceptionDto {
    /**
     * 
     * @type {number}
     * @memberof AddExceptionDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddExceptionDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddExceptionDto
     */
    'exceptionId'?: number;
}
/**
 * 
 * @export
 * @interface AddRemarkDto
 */
export interface AddRemarkDto {
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface AddShipmentNumberInputDto
 */
export interface AddShipmentNumberInputDto {
    /**
     * 
     * @type {number}
     * @memberof AddShipmentNumberInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentNumberInputDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddShipmentNumberInputDto
     */
    'shippingDocs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AddStatusDto
 */
export interface AddStatusDto {
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface AdvancedSearchListDto
 */
export interface AdvancedSearchListDto {
    /**
     * 
     * @type {Array<DriverAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'drivers'?: Array<DriverAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<VehicleAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'vehicles'?: Array<VehicleAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<EldDeviceAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'eldDevices'?: Array<EldDeviceAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<TrailerAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'trailers'?: Array<TrailerAdvancedSearchListDto> | null;
}
/**
 * 
 * @export
 * @interface AgentCompanyInputDto
 */
export interface AgentCompanyInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCompanyInputDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentCompanyInputDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompanyInputDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof AgentCompanyInputDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCompanyInputDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCompanyInputDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCompanyInputDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof AgentCompanyInputDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCompanyInputDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof AgentCompanyInputDto
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCompanyInputDto
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCompanyInputDto
     */
    'noNewShiftIfNoCertify'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentCustomerAdministrationResultDto
 */
export interface AgentCustomerAdministrationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'parentTenantRegistrationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDto
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentCustomerAdministrationResultDtoAgentOperationResultDto
 */
export interface AgentCustomerAdministrationResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentCustomerAdministrationResultDtoAgentOperationResultDtoData}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDto
     */
    'data'?: AgentCustomerAdministrationResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
 */
export interface AgentCustomerAdministrationResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'parentTenantRegistrationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerAdministrationResultDtoAgentOperationResultDtoData
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentCustomerEntityResultDto
 */
export interface AgentCustomerEntityResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCustomerEntityResultDto
     */
    'entityId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentCustomerEntityResultDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCustomerEntityResultDto
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentCustomerEntityResultDtoAgentOperationResultDto
 */
export interface AgentCustomerEntityResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentCustomerEntityResultDtoAgentOperationResultDtoData}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDto
     */
    'data'?: AgentCustomerEntityResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentCustomerEntityResultDtoAgentOperationResultDtoData
 */
export interface AgentCustomerEntityResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDtoData
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDtoData
     */
    'entityId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDtoData
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentCustomerEntityResultDtoAgentOperationResultDtoData
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentCustomerReassignInputDto
 */
export interface AgentCustomerReassignInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentCustomerReassignInputDto
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDailyLogsReportInputDto
 */
export interface AgentDailyLogsReportInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentDailyLogsReportInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDailyLogsReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDailyLogsReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {DailyLogsDownloadFormat}
     * @memberof AgentDailyLogsReportInputDto
     */
    'downloadFormat'?: DailyLogsDownloadFormat;
}
/**
 * 
 * @export
 * @interface AgentDriverCreateInputDto
 */
export interface AgentDriverCreateInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof AgentDriverCreateInputDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCreateInputDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCreateInputDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCreateInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof AgentDriverCreateInputDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCreateInputDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof AgentDriverCreateInputDto
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCreateInputDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgentDriverCsvExportInputDto
 */
export interface AgentDriverCsvExportInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AgentDriverCsvExportInputDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCsvExportInputDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentDriverCsvExportInputDto
     */
    'status'?: RecordStatus | null;
}
/**
 * 
 * @export
 * @interface AgentDriverCsvExportReferenceDto
 */
export interface AgentDriverCsvExportReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDto
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverCsvExportReferenceDtoAgentOperationResultDto
 */
export interface AgentDriverCsvExportReferenceDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDto
     */
    'data'?: AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
 */
export interface AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'itemCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverCsvExportReferenceDtoAgentOperationResultDtoData
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogCursorDto
 */
export interface AgentDriverLogCursorDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogCursorDto
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogCursorDto
     */
    'eventId'?: number;
}
/**
 * 
 * @export
 * @interface AgentDriverLogDriverDto
 */
export interface AgentDriverLogDriverDto {
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogDriverDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogEventDto
 */
export interface AgentDriverLogEventDto {
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'event'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'recordStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogEventDto
     */
    'isCarryIn'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'odometerMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDto
     */
    'engineHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'shippingDocuments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {AgentDriverLogEventDtoEvidence}
     * @memberof AgentDriverLogEventDto
     */
    'evidence'?: AgentDriverLogEventDtoEvidence | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogEventDtoEvidence
 */
export interface AgentDriverLogEventDtoEvidence {
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'eventType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'sequenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'originalEventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'referencedEventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'endTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventDtoEvidence
     */
    'longitude'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogEventEvidenceDto
 */
export interface AgentDriverLogEventEvidenceDto {
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'eventType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'sequenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'originalEventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'referencedEventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'endTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogEventEvidenceDto
     */
    'longitude'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadInputDto
 */
export interface AgentDriverLogReadInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadInputDto
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogReadInputDto
     */
    'includeAuditHistory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadInputDto
     */
    'afterStartTimeUtc'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogReadInputDto
     */
    'afterEventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogReadInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadResultDto
 */
export interface AgentDriverLogReadResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {AgentDriverLogReadResultDtoDriver}
     * @memberof AgentDriverLogReadResultDto
     */
    'driver'?: AgentDriverLogReadResultDtoDriver | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'dayStartUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'dayEndUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'dataThroughUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDto
     */
    'view'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogReadResultDto
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {AgentDriverLogReadResultDtoNextCursor}
     * @memberof AgentDriverLogReadResultDto
     */
    'nextCursor'?: AgentDriverLogReadResultDtoNextCursor | null;
    /**
     * 
     * @type {Array<AgentDriverLogEventDto>}
     * @memberof AgentDriverLogReadResultDto
     */
    'events'?: Array<AgentDriverLogEventDto> | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadResultDtoAgentOperationResultDto
 */
export interface AgentDriverLogReadResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentDriverLogReadResultDtoAgentOperationResultDtoData}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDto
     */
    'data'?: AgentDriverLogReadResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadResultDtoAgentOperationResultDtoData
 */
export interface AgentDriverLogReadResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {AgentDriverLogReadResultDtoDriver}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'driver'?: AgentDriverLogReadResultDtoDriver | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'dayStartUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'dayEndUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'dataThroughUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'view'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {AgentDriverLogReadResultDtoNextCursor}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'nextCursor'?: AgentDriverLogReadResultDtoNextCursor | null;
    /**
     * 
     * @type {Array<AgentDriverLogEventDto>}
     * @memberof AgentDriverLogReadResultDtoAgentOperationResultDtoData
     */
    'events'?: Array<AgentDriverLogEventDto> | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadResultDtoDriver
 */
export interface AgentDriverLogReadResultDtoDriver {
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogReadResultDtoDriver
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoDriver
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoDriver
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogReadResultDtoNextCursor
 */
export interface AgentDriverLogReadResultDtoNextCursor {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogReadResultDtoNextCursor
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogReadResultDtoNextCursor
     */
    'eventId'?: number;
}
/**
 * 
 * @export
 * @interface AgentDriverLogoutResultDto
 */
export interface AgentDriverLogoutResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogoutResultDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDto
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogoutResultDto
     */
    'revokedGrantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDto
     */
    'invalidatedAtUtc'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogoutResultDtoAgentOperationResultDto
 */
export interface AgentDriverLogoutResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentDriverLogoutResultDtoAgentOperationResultDtoData}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDto
     */
    'data'?: AgentDriverLogoutResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentDriverLogoutResultDtoAgentOperationResultDtoData
 */
export interface AgentDriverLogoutResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDtoData
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDtoData
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDtoData
     */
    'revokedGrantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverLogoutResultDtoAgentOperationResultDtoData
     */
    'invalidatedAtUtc'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDriverUpdateInputDto
 */
export interface AgentDriverUpdateInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof AgentDriverUpdateInputDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverUpdateInputDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverUpdateInputDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentDriverUpdateInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof AgentDriverUpdateInputDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentDriverUpdateInputDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof AgentDriverUpdateInputDto
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AgentDriverUpdateInputDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgentEldResetResultDto
 */
export interface AgentEldResetResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentEldResetResultDto
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentEldResetResultDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDto
     */
    'commandAuditId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDto
     */
    'deviceCommandToken'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentEldResetResultDtoAgentOperationResultDto
 */
export interface AgentEldResetResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentEldResetResultDtoAgentOperationResultDtoData}
     * @memberof AgentEldResetResultDtoAgentOperationResultDto
     */
    'data'?: AgentEldResetResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentEldResetResultDtoAgentOperationResultDtoData
 */
export interface AgentEldResetResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'commandAuditId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldResetResultDtoAgentOperationResultDtoData
     */
    'deviceCommandToken'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsExportInputDto
 */
export interface AgentEldUsageByEventsExportInputDto {
    /**
     * 
     * @type {ReportFormat}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentEldUsageByEventsExportInputDto
     */
    'used'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsInputDto
 */
export interface AgentEldUsageByEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentEldUsageByEventsInputDto
     */
    'used'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsItemDto
 */
export interface AgentEldUsageByEventsItemDto {
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'numberOfDays'?: number;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentEldUsageByEventsItemDto
     */
    'customerOwned'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsResultDto
 */
export interface AgentEldUsageByEventsResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'usedDeviceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'totalDeviceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'totalUsageDays'?: number;
    /**
     * 
     * @type {Array<AgentEldUsageByEventsItemDto>}
     * @memberof AgentEldUsageByEventsResultDto
     */
    'items'?: Array<AgentEldUsageByEventsItemDto> | null;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsResultDtoAgentOperationResultDto
 */
export interface AgentEldUsageByEventsResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentEldUsageByEventsResultDtoAgentOperationResultDtoData}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDto
     */
    'data'?: AgentEldUsageByEventsResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
 */
export interface AgentEldUsageByEventsResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'usedDeviceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'totalDeviceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'totalUsageDays'?: number;
    /**
     * 
     * @type {Array<AgentEldUsageByEventsItemDto>}
     * @memberof AgentEldUsageByEventsResultDtoAgentOperationResultDtoData
     */
    'items'?: Array<AgentEldUsageByEventsItemDto> | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaEmailTransferInputDto
 */
export interface AgentFmcsaEmailTransferInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaEmailTransferInputDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionListInputDto
 */
export interface AgentFmcsaInspectionListInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'submittedFromUtc': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'submittedToUtc': string;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'reportType'?: FmcsaInspectionReportType | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionListItemDto
 */
export interface AgentFmcsaInspectionListItemDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'inspectionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'driverIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'inspectionTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'fileAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDto
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionListItemDtoPagedResultDto
 */
export interface AgentFmcsaInspectionListItemDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentFmcsaInspectionListItemDto>}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDto
     */
    'items'?: Array<AgentFmcsaInspectionListItemDto> | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
 */
export interface AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto
     */
    'data'?: AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData
 */
export interface AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentFmcsaInspectionListItemDto>}
     * @memberof AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDtoData
     */
    'items'?: Array<AgentFmcsaInspectionListItemDto> | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionResultDto
 */
export interface AgentFmcsaInspectionResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'inspectionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'inspectionTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'providerStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'broadcast'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'errorCount'?: number | null;
    /**
     * 
     * @type {Array<AgentFmcsaValidationErrorDto>}
     * @memberof AgentFmcsaInspectionResultDto
     */
    'errors'?: Array<AgentFmcsaValidationErrorDto> | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionResultDtoAgentOperationResultDto
 */
export interface AgentFmcsaInspectionResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentFmcsaInspectionResultDtoAgentOperationResultDtoData}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDto
     */
    'data'?: AgentFmcsaInspectionResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
 */
export interface AgentFmcsaInspectionResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'inspectionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'inspectionTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'providerStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'broadcast'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'errorCount'?: number | null;
    /**
     * 
     * @type {Array<AgentFmcsaValidationErrorDto>}
     * @memberof AgentFmcsaInspectionResultDtoAgentOperationResultDtoData
     */
    'errors'?: Array<AgentFmcsaValidationErrorDto> | null;
}
/**
 * 
 * @export
 * @interface AgentFmcsaManualInspectionInputDto
 */
export interface AgentFmcsaManualInspectionInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaManualInspectionInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaManualInspectionInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaManualInspectionInputDto
     */
    'inspectionTime': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaManualInspectionInputDto
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaManualInspectionInputDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AgentFmcsaTransferInputDto
 */
export interface AgentFmcsaTransferInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaTransferInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaTransferInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaTransferInputDto
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaTransferInputDto
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaTransferInputDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AgentFmcsaValidationErrorDto
 */
export interface AgentFmcsaValidationErrorDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'errorType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'detail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'line'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentFmcsaValidationErrorDto
     */
    'end'?: number;
}
/**
 * 
 * @export
 * @interface AgentGrantMasterAccountResultDto
 */
export interface AgentGrantMasterAccountResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'masterUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'masterUserEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'notificationJobId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentGrantMasterAccountResultDto
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentGrantMasterAccountResultDtoAgentOperationResultDto
 */
export interface AgentGrantMasterAccountResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentGrantMasterAccountResultDtoAgentOperationResultDtoData}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDto
     */
    'data'?: AgentGrantMasterAccountResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
 */
export interface AgentGrantMasterAccountResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'masterUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'masterUserEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'notificationJobId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentGrantMasterAccountResultDtoAgentOperationResultDtoData
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentIftaReportInputDto
 */
export interface AgentIftaReportInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentIftaReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentIftaReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentIftaReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgentIftaReportInputDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgentIftaReportInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof AgentIftaReportInputDto
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceCreateInputDto
 */
export interface AgentMasterEldDeviceCreateInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceCreateInputDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceDeleteResultDto
 */
export interface AgentMasterEldDeviceDeleteResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceDeleteResultDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceDeleteResultDto
     */
    'deleted'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDtoData
     */
    'deleted'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceListInputDto
 */
export interface AgentMasterEldDeviceListInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'vendorType'?: Vendor | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'status'?: RecordStatus | null;
    /**
     * 
     * @type {AgentMasterEldDeviceSortField}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'sortBy'?: AgentMasterEldDeviceSortField;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'sortDescending'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceListInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDto
 */
export interface AgentMasterEldDeviceResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldDeviceResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldDeviceResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldDeviceResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldDeviceResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoAgentOperationResultDtoData
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDtoPagedResultDto
 */
export interface AgentMasterEldDeviceResultDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentMasterEldDeviceResultDto>}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDto
     */
    'items'?: Array<AgentMasterEldDeviceResultDto> | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentMasterEldDeviceResultDto>}
     * @memberof AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDtoData
     */
    'items'?: Array<AgentMasterEldDeviceResultDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgentMasterEldDeviceSortField = {
    Id: 'Id',
    SerialNumber: 'SerialNumber',
    VendorType: 'VendorType',
    DeviceType: 'DeviceType',
    AssignedToTenantId: 'AssignedToTenantId',
    Status: 'Status'
} as const;

export type AgentMasterEldDeviceSortField = typeof AgentMasterEldDeviceSortField[keyof typeof AgentMasterEldDeviceSortField];


/**
 * 
 * @export
 * @interface AgentMasterEldDeviceUpdateInputDto
 */
export interface AgentMasterEldDeviceUpdateInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUpdateInputDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceUsageHistoryResultDto
 */
export interface AgentMasterEldDeviceUsageHistoryResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDto
     */
    'deviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentMasterEldDeviceUsagePeriodDto>}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDto
     */
    'periods'?: Array<AgentMasterEldDeviceUsagePeriodDto> | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData
     */
    'deviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AgentMasterEldDeviceUsagePeriodDto>}
     * @memberof AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDtoData
     */
    'periods'?: Array<AgentMasterEldDeviceUsagePeriodDto> | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldDeviceUsagePeriodDto
 */
export interface AgentMasterEldDeviceUsagePeriodDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'usageType'?: EldDeviceUsageType;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'startTimeUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldDeviceUsagePeriodDto
     */
    'endTimeUtc'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldTransferInputDto
 */
export interface AgentMasterEldTransferInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldTransferInputDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferInputDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferInputDto
     */
    'targetTenantId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferInputDto
     */
    'unassignFromVehicleIfNeeded'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldTransferResultDto
 */
export interface AgentMasterEldTransferResultDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldTransferResultDto
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDto
     */
    'previousTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDto
     */
    'currentTenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldTransferResultDto
     */
    'previousVehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDto
     */
    'previousVehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDto
     */
    'vehicleUnassigned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDto
     */
    'tenantChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDto
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldTransferResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldTransferResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldTransferResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldTransferResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldTransferResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldTransferResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'previousTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'currentTenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'previousVehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'previousVehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'vehicleUnassigned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'tenantChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldTransferResultDtoAgentOperationResultDtoData
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldVehicleAssignmentResultDto
 */
export interface AgentMasterEldVehicleAssignmentResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'assigned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldVehicleAssignmentResultDto
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
 */
export interface AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto
     */
    'data'?: AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
 */
export interface AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'masterEldDeviceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'assigned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDtoData
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface AgentMasterEldVehicleInputDto
 */
export interface AgentMasterEldVehicleInputDto {
    /**
     * 
     * @type {number}
     * @memberof AgentMasterEldVehicleInputDto
     */
    'vehicleId'?: number;
}
/**
 * 
 * @export
 * @interface AgentOperationsApiInfoDto
 */
export interface AgentOperationsApiInfoDto {
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDto
     */
    'contractVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDto
     */
    'routePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDto
     */
    'authenticationFlow'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDto
     */
    'tenantContextMode'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentOperationsApiInfoDtoAgentOperationResultDto
 */
export interface AgentOperationsApiInfoDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentOperationsApiInfoDtoAgentOperationResultDtoData}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDto
     */
    'data'?: AgentOperationsApiInfoDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentOperationsApiInfoDtoAgentOperationResultDtoData
 */
export interface AgentOperationsApiInfoDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDtoData
     */
    'contractVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDtoData
     */
    'routePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDtoData
     */
    'authenticationFlow'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentOperationsApiInfoDtoAgentOperationResultDtoData
     */
    'tenantContextMode'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgentReportKind = {
    EldUsageByEvents: 'EldUsageByEvents',
    Ifta: 'Ifta',
    DailyLogs: 'DailyLogs'
} as const;

export type AgentReportKind = typeof AgentReportKind[keyof typeof AgentReportKind];


/**
 * 
 * @export
 * @interface AgentReportReferenceDto
 */
export interface AgentReportReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'reportId'?: string;
    /**
     * 
     * @type {AgentReportKind}
     * @memberof AgentReportReferenceDto
     */
    'reportKind'?: AgentReportKind;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'requestedAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'statusUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDto
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentReportReferenceDtoAgentOperationResultDto
 */
export interface AgentReportReferenceDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentReportReferenceDtoAgentOperationResultDtoData}
     * @memberof AgentReportReferenceDtoAgentOperationResultDto
     */
    'data'?: AgentReportReferenceDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentReportReferenceDtoAgentOperationResultDtoData
 */
export interface AgentReportReferenceDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'reportId'?: string;
    /**
     * 
     * @type {AgentReportKind}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'reportKind'?: AgentReportKind;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'requestedAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'statusUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportReferenceDtoAgentOperationResultDtoData
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentReportStatusDto
 */
export interface AgentReportStatusDto {
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'reportId'?: string;
    /**
     * 
     * @type {AgentReportKind}
     * @memberof AgentReportStatusDto
     */
    'reportKind'?: AgentReportKind;
    /**
     * 
     * @type {ReportStatus}
     * @memberof AgentReportStatusDto
     */
    'status'?: ReportStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentReportStatusDto
     */
    'isReady'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'requestedAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDto
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentReportStatusDtoAgentOperationResultDto
 */
export interface AgentReportStatusDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentReportStatusDtoAgentOperationResultDtoData}
     * @memberof AgentReportStatusDtoAgentOperationResultDto
     */
    'data'?: AgentReportStatusDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentReportStatusDtoAgentOperationResultDtoData
 */
export interface AgentReportStatusDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'reportId'?: string;
    /**
     * 
     * @type {AgentReportKind}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'reportKind'?: AgentReportKind;
    /**
     * 
     * @type {ReportStatus}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'status'?: ReportStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'isReady'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'requestedAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'expiresAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentReportStatusDtoAgentOperationResultDtoData
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentSupportReasonInputDto
 */
export interface AgentSupportReasonInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentSupportReasonInputDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface AgentTenantEldDeviceInputDto
 */
export interface AgentTenantEldDeviceInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentTenantEldDeviceInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof AgentTenantEldDeviceInputDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof AgentTenantEldDeviceInputDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantEldDeviceInputDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantEldDeviceInputDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentTenantRegistrationRejectInputDto
 */
export interface AgentTenantRegistrationRejectInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationRejectInputDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentTenantRegistrationResultDto
 */
export interface AgentTenantRegistrationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDto
     */
    'registrationId'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof AgentTenantRegistrationResultDto
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDto
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDto
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentTenantRegistrationResultDtoAgentOperationResultDto
 */
export interface AgentTenantRegistrationResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentTenantRegistrationResultDtoAgentOperationResultDtoData}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDto
     */
    'data'?: AgentTenantRegistrationResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentTenantRegistrationResultDtoAgentOperationResultDtoData
 */
export interface AgentTenantRegistrationResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDtoData
     */
    'registrationId'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDtoData
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDtoData
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTenantRegistrationResultDtoAgentOperationResultDtoData
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentTrailerInputDto
 */
export interface AgentTrailerInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentTrailerInputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof AgentTrailerInputDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof AgentTrailerInputDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTrailerInputDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTrailerInputDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentTrailerInputDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof AgentTrailerInputDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof AgentTrailerInputDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof AgentTrailerInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentTrailerInputDto
     */
    'gpsSerial'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentVehicleInputDto
 */
export interface AgentVehicleInputDto {
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentVehicleInputDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof AgentVehicleInputDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof AgentVehicleInputDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentVehicleInputDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentVehicleInputDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentVehicleInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof AgentVehicleInputDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof AgentVehicleInputDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentVehicleInputDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentVehicleInputDto
     */
    'odometerOffset'?: number;
}
/**
 * 
 * @export
 * @interface AgentWelcomeEmailResultDto
 */
export interface AgentWelcomeEmailResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDto
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDto
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDto
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentWelcomeEmailResultDtoAgentOperationResultDto
 */
export interface AgentWelcomeEmailResultDtoAgentOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'operationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {AgentWelcomeEmailResultDtoAgentOperationResultDtoData}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDto
     */
    'data'?: AgentWelcomeEmailResultDtoAgentOperationResultDtoData | null;
}
/**
 * 
 * @export
 * @interface AgentWelcomeEmailResultDtoAgentOperationResultDtoData
 */
export interface AgentWelcomeEmailResultDtoAgentOperationResultDtoData {
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDtoData
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDtoData
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDtoData
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentWelcomeEmailResultDtoAgentOperationResultDtoData
     */
    'jobId'?: string | null;
}
/**
 * 
 * @export
 * @interface AllDriversDto
 */
export interface AllDriversDto {
    /**
     * 
     * @type {string}
     * @memberof AllDriversDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllDriversDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'offDutyIdleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'onDutyIdleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'fuelConsumptionValueAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'fuelConsumptionValueTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'maxIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'minIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'averageIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'totalIdleTime'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AllDriversDto
     */
    'eventScale'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AllDriversDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllDriversDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface AllDriversDtoPagedResultDto
 */
export interface AllDriversDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof AllDriversDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AllDriversDto>}
     * @memberof AllDriversDtoPagedResultDto
     */
    'items'?: Array<AllDriversDto> | null;
}
/**
 * 
 * @export
 * @interface AllDriversInputDto
 */
export interface AllDriversInputDto {
    /**
     * 
     * @type {string}
     * @memberof AllDriversInputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllDriversInputDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof AllDriversInputDto
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {number}
     * @memberof AllDriversInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAccountLoginPostRequest
 */
export interface ApiAccountLoginPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountLoginPostRequest
     */
    'userNameOrEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountLoginPostRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAccountLoginPostRequest
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAccountMyProfileChangePasswordPostRequest
 */
export interface ApiAccountMyProfileChangePasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileChangePasswordPostRequest
     */
    'currentPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileChangePasswordPostRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ApiAccountMyProfileGetRequest
 */
export interface ApiAccountMyProfileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAccountRegisterPostRequest
 */
export interface ApiAccountRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'appName': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAccountRegisterPostRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAccountResetPasswordPostRequest
 */
export interface ApiAccountResetPasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'resetToken': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAccountSendPasswordResetCodePostRequest
 */
export interface ApiAccountSendPasswordResetCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'appName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'returnUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'returnUrlHash'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
 */
export interface ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsMasterEldDevicesListPostRequest
 */
export interface ApiAppAgentOperationsMasterEldDevicesListPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'vendorType'?: Vendor | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'status'?: RecordStatus | null;
    /**
     * 
     * @type {AgentMasterEldDeviceSortField}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'sortBy'?: AgentMasterEldDeviceSortField;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'sortDescending'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsMasterEldDevicesListPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsMasterEldDevicesPostRequest
 */
export interface ApiAppAgentOperationsMasterEldDevicesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesPostRequest
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
 */
export interface ApiAppAgentOperationsMasterEldDevicesTransferPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
     */
    'targetTenantId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsMasterEldDevicesTransferPostRequest
     */
    'unassignFromVehicleIfNeeded'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
 */
export interface ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'dbServer': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'dbName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'appUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'webApiUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'adminName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest
     */
    'domainName': string;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest
 */
export interface ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest
 */
export interface ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantRegistrationsPostRequest
 */
export interface ApiAppAgentOperationsTenantRegistrationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantRegistrationsPostRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest
     */
    'noNewShiftIfNoCertify'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
     */
    'includeAuditHistory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
     */
    'afterStartTimeUtc'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
     */
    'afterEventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest
     */
    'status'?: RecordStatus | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdDriversPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'cycleRules': Array<CycleRuleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdDriversPostRequest
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'recipientEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'submittedFromUtc': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'submittedToUtc': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'reportType'?: FmcsaInspectionReportType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
     */
    'inspectionTime': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest
     */
    'vehicleId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {DailyLogsDownloadFormat}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest
     */
    'downloadFormat'?: DailyLogsDownloadFormat;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest {
    /**
     * 
     * @type {ReportFormat}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest
     */
    'used'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest
     */
    'used'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest
     */
    'gpsSerial'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
 */
export interface ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest
     */
    'odometerOffset'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyExportPostRequest
 */
export interface ApiAppCompanyExportPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'exportFormat'?: string | null;
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyGetFilteredListPostRequest
 */
export interface ApiAppCompanyGetFilteredListPostRequest {
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyGetRequest
 */
export interface ApiAppCompanyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppCompanyGetRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppCompanyGetRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppCompanyGetRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppCompanyGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppCompanyGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyIdDeleteRequest
 */
export interface ApiAppCompanyIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dutyCycleId'?: Array<number> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyUpdateManyPutRequest
 */
export interface ApiAppCompanyUpdateManyPutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppCompanyUpdateManyPutRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppCompanyUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
 */
export interface ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'dot': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {Array<CompanyDutyCycle>}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'companyDutyCycles'?: Array<CompanyDutyCycle> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest
 */
export interface ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiAppCustomerserviceaccountServiceaccountPostRequest
 */
export interface ApiAppCustomerserviceaccountServiceaccountPostRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferDriversExportPostRequest
 */
export interface ApiAppDataTransferDriversExportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'status'?: RecordStatus | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ApiAppDataTransferDriversExportPostRequest
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferDriversImportPostRequest
 */
export interface ApiAppDataTransferDriversImportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferDriversImportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferDriversImportPostRequest
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferLocationsExportPostRequest
 */
export interface ApiAppDataTransferLocationsExportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ApiAppDataTransferLocationsExportPostRequest
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferLocationsImportPostRequest
 */
export interface ApiAppDataTransferLocationsImportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferLocationsImportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferLocationsImportPostRequest
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferTrailersExportPostRequest
 */
export interface ApiAppDataTransferTrailersExportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferTrailersExportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ApiAppDataTransferTrailersExportPostRequest
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppDataTransferTrailersExportPostRequest
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferTrailersImportPostRequest
 */
export interface ApiAppDataTransferTrailersImportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferTrailersImportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferTrailersImportPostRequest
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferVehiclesExportPostRequest
 */
export interface ApiAppDataTransferVehiclesExportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferVehiclesExportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppDataTransferVehiclesExportPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ApiAppDataTransferVehiclesExportPostRequest
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @interface ApiAppDataTransferVehiclesImportPostRequest
 */
export interface ApiAppDataTransferVehiclesImportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferVehiclesImportPostRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDataTransferVehiclesImportPostRequest
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountChangePasswordPostRequest
 */
export interface ApiAppDemoaccountChangePasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountChangePasswordPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountChangePasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountIdDeleteRequest
 */
export interface ApiAppDemoaccountIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountPostRequest
 */
export interface ApiAppDemoaccountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'tenantId': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountUpdateManyPutRequest
 */
export interface ApiAppDemoaccountUpdateManyPutRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppDemoaccountUpdateManyPutRequest
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppDemoaccountUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppDisconnecteddrivingGetFilteredListPostRequest
 */
export interface ApiAppDisconnecteddrivingGetFilteredListPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'groupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'isOngoing'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDisconnecteddrivingGetFilteredListPostRequest
     */
    'skipCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDisconnecteddrivingResolvePostRequest
 */
export interface ApiAppDisconnecteddrivingResolvePostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppDisconnecteddrivingResolvePostRequest
     */
    'locationIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ApiAppDocumentcenterDocumentforentityDeleteRequest
 */
export interface ApiAppDocumentcenterDocumentforentityDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'entityType': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'entityId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppDocumentcenterGetdocumentbyidPostRequest
 */
export interface ApiAppDocumentcenterGetdocumentbyidPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterGetdocumentbyidPostRequest
     */
    'documentId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterGetdocumentbyidPostRequest
     */
    'entityType': number;
}
/**
 * 
 * @export
 * @interface ApiAppDriverChangepasswordPostRequest
 */
export interface ApiAppDriverChangepasswordPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverChangepasswordPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverChangepasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppDriverGetRequest
 */
export interface ApiAppDriverGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppDriverGetRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDriverGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppDriverGetRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'password': string;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppDriverGetRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppDriverGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'hideUnidentifiedEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppDriverIdDeleteRequest
 */
export interface ApiAppDriverIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppDriverRolloverPostRequest
 */
export interface ApiAppDriverRolloverPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverRolloverPostRequest
     */
    'fromDriverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverRolloverPostRequest
     */
    'toCoDriverId': number;
}
/**
 * 
 * @export
 * @interface ApiAppDriverSignaturePostRequest
 */
export interface ApiAppDriverSignaturePostRequest {
    /**
     * 
     * @type {Array<SignatureDto>}
     * @memberof ApiAppDriverSignaturePostRequest
     */
    'signatures'?: Array<SignatureDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
 */
export interface ApiAppDriverlogsGetdriverdutystatuseventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'showAllEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
 */
export interface ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licenceCountry'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licenceState'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'fcmToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'fcmTokenTimestamp'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'hideUnidentifiedEvents'?: boolean | null;
    /**
     * 
     * @type {Array<Event>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'events'?: Array<Event> | null;
    /**
     * 
     * @type {Array<Cycle>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'cycles'?: Array<Cycle> | null;
    /**
     * 
     * @type {Array<GroupDriver>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverGroups'?: Array<GroupDriver> | null;
    /**
     * 
     * @type {Array<Violation>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'violations'?: Array<Violation> | null;
    /**
     * 
     * @type {Array<DvirReport>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'dvirReports'?: Array<DvirReport> | null;
    /**
     * 
     * @type {Array<DriverSignature>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverSignatures'?: Array<DriverSignature> | null;
    /**
     * 
     * @type {Array<DriverDutyCycle>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverDutyCycles'?: Array<DriverDutyCycle> | null;
    /**
     * 
     * @type {Array<IdlingEvent>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'idlingEvents'?: Array<IdlingEvent> | null;
    /**
     * 
     * @type {Array<IdlingFuelConsumption>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'idlingFuelConsumptions'?: Array<IdlingFuelConsumption> | null;
    /**
     * 
     * @type {DriverCurrentDutyStatusEvent}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentDutyStatusEvent'?: DriverCurrentDutyStatusEvent | null;
    /**
     * 
     * @type {DriverCurrentShift}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentShift'?: DriverCurrentShift | null;
    /**
     * 
     * @type {DriverCurrentCycle}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentCycle'?: DriverCurrentCycle | null;
    /**
     * 
     * @type {DriverCurrentHosStatus}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentHosStatus'?: DriverCurrentHosStatus | null;
    /**
     * 
     * @type {Array<DriverCycle>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverCycles'?: Array<DriverCycle> | null;
    /**
     * 
     * @type {Array<DriverShift>}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'driverShifts'?: Array<DriverShift> | null;
    /**
     * 
     * @type {DriverUser}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'user'?: DriverUser | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDvirDvirreportPostRequest
 */
export interface ApiAppDvirDvirreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {Array<DvirDefectDto>}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'defects'?: Array<DvirDefectDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppDvirformGetRequest
 */
export interface ApiAppDvirformGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirformGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDvirformGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof ApiAppDvirformGetRequest
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDvirformGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirformGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDvirformIdDeleteRequest
 */
export interface ApiAppDvirformIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDvirvehicledefectsResolvePostRequest
 */
export interface ApiAppDvirvehicledefectsResolvePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'defectId'?: number;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'isCorrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceGetRequest
 */
export interface ApiAppElddeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppElddeviceGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppElddeviceGetRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppElddeviceGetRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddeviceGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceIdDeleteRequest
 */
export interface ApiAppElddeviceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
 */
export interface ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface ApiAppElddisconnectionReporteldconnectionPostRequest
 */
export interface ApiAppElddisconnectionReporteldconnectionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'time'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppEldfileexportGetRequest
 */
export interface ApiAppEldfileexportGetRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEldfileexportGetRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportGetRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportGetRequest
     */
    'timeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportGetRequest
     */
    'timeTo'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEldfileexportIdDeleteRequest
 */
export interface ApiAppEldfileexportIdDeleteRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'timeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'timeTo'?: string;
    /**
     * 
     * @type {ExportStatus}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'status'?: ExportStatus;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'creatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'creatorSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileexportIdDeleteRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEldfileimportGetRequest
 */
export interface ApiAppEldfileimportGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportGetRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportGetRequest
     */
    'importDateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportGetRequest
     */
    'importDateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportGetRequest
     */
    'eldFileUploadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEldfileimportIdDeleteRequest
 */
export interface ApiAppEldfileimportIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportIdDeleteRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {ImportStatus}
     * @memberof ApiAppEldfileimportIdDeleteRequest
     */
    'status'?: ImportStatus;
    /**
     * 
     * @type {Array<EldFileImportFileDataDto>}
     * @memberof ApiAppEldfileimportIdDeleteRequest
     */
    'eldFiles'?: Array<EldFileImportFileDataDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEldfileimportIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEldfileimportIdDeleteRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventAddremarkPostRequest
 */
export interface ApiAppEventAddremarkPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventAddstatusPostRequest
 */
export interface ApiAppEventAddstatusPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventAssignPutRequest
 */
export interface ApiAppEventAssignPutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventAssignPutRequest
     */
    'eventIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAssignPutRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAssignPutRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventAssignPutRequest
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBatchPostRequest
 */
export interface ApiAppEventBatchPostRequest {
    /**
     * 
     * @type {Array<CreateOrUpdateEventDto>}
     * @memberof ApiAppEventBatchPostRequest
     */
    'events'?: Array<CreateOrUpdateEventDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetcodriverPostRequest
 */
export interface ApiAppEventBulksetcodriverPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetshippingdocsPostRequest
 */
export interface ApiAppEventBulksetshippingdocsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'shippingDocs'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksettrailersPostRequest
 */
export interface ApiAppEventBulksettrailersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetvehiclePostRequest
 */
export interface ApiAppEventBulksetvehiclePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventCertifylogdatePostRequest
 */
export interface ApiAppEventCertifylogdatePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventCertifylogdatePostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventCertifylogdatePostRequest
     */
    'logDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventConverteventtopersonaluseoryardmovePostRequest
 */
export interface ApiAppEventConverteventtopersonaluseoryardmovePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventConverteventtopersonaluseoryardmovePostRequest
     */
    'endEventId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventConverteventtopersonaluseoryardmovePostRequest
     */
    'isPersonalUse'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventDeleteManyDeleteRequest
 */
export interface ApiAppEventDeleteManyDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventDeleteManyDeleteRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppEventDeleteManyDeleteRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventFixeventsPostRequest
 */
export interface ApiAppEventFixeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixEngineHours'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixSequenceNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixOdometer'?: boolean;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixDirection': FixEventsDirection;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'endEvent': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventIdDeleteRequest
 */
export interface ApiAppEventIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'time'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'origin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'minTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'maxTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'totalVehicleMiles'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventInvalidatemobileeventsPostRequest
 */
export interface ApiAppEventInvalidatemobileeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventInvalidatemobileeventsPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventInvalidatemobileeventsPostRequest
     */
    'fromStartTime'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventPersonaluseoryardmoveeventPostRequest
 */
export interface ApiAppEventPersonaluseoryardmoveeventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventPersonaluseoryardmoveeventPostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventPersonaluseoryardmoveeventPostRequest
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventPersonaluseoryardmoveeventPostRequest
     */
    'isPersonalUse'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventPersonaluseoryardmoveeventPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventPersonaluseoryardmoveeventPostRequest
     */
    'dutyStatusAbbreviation'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventReassigneventsPostRequest
 */
export interface ApiAppEventReassigneventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'endEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'driverId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventRebuildcyclePostRequest
 */
export interface ApiAppEventRebuildcyclePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventRebuildcyclePostRequest
     */
    'cycleId': string;
}
/**
 * 
 * @export
 * @interface ApiAppEventRebuildcyclefromeventPostRequest
 */
export interface ApiAppEventRebuildcyclefromeventPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventRebuildcyclefromeventPostRequest
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventRegenerateintermediatesPostRequest
 */
export interface ApiAppEventRegenerateintermediatesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventRegenerateintermediatesPostRequest
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventResizeeventsPostRequest
 */
export interface ApiAppEventResizeeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'eventId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'durationAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventSetdrivingnotePostRequest
 */
export interface ApiAppEventSetdrivingnotePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventShifteventsPostRequest
 */
export interface ApiAppEventShifteventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'endEvent': number;
    /**
     * 
     * @type {ShiftEventsDirection}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'direction': ShiftEventsDirection;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'timeAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventShipmentnumberPostRequest
 */
export interface ApiAppEventShipmentnumberPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'shippingDocs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventSmartfixeventsPostRequest
 */
export interface ApiAppEventSmartfixeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'to': string;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'fixEventsDirection': FixEventsDirection;
}
/**
 * 
 * @export
 * @interface ApiAppExportRequestPostRequest
 */
export interface ApiAppExportRequestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppExportRequestPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppExportRequestPostRequest
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppExportRequestPostRequest
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppExportRequestPostRequest
     */
    'includeDeleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppFleetmanagerGetRequest
 */
export interface ApiAppFleetmanagerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'groupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppFleetmanagerIdDeleteRequest
 */
export interface ApiAppFleetmanagerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppFlowapiclientGetRequest
 */
export interface ApiAppFlowapiclientGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFlowapiclientGetRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionGetRequest
 */
export interface ApiAppFmcsainspectionGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'fmcsaSenderNameOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'fmcsaSenderAddressOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'base64EncodedEldFileContents': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'mobileAppType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionIdDeleteRequest
 */
export interface ApiAppFmcsainspectionIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'eldFileUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
 */
export interface ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'timeOfReport': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'eldFileComment': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'mobileApplicationType': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionMarkunofficialPostRequest
 */
export interface ApiAppFmcsainspectionMarkunofficialPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionMarkunofficialPostRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionMarkunofficialPostRequest
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsatransferSubmittoemailPostRequest
 */
export interface ApiAppFmcsatransferSubmittoemailPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'recipientOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'fmcsaSenderNameOverride'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsatransferSubmittowebservicePostRequest
 */
export interface ApiAppFmcsatransferSubmittowebservicePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
 */
export interface ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
 */
export interface ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppFuelproviderGetRequest
 */
export interface ApiAppFuelproviderGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppFuelproviderIdDeleteRequest
 */
export interface ApiAppFuelproviderIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSenddevicecommandPostRequest
 */
export interface ApiAppGeometrisapiSenddevicecommandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSenddevicecommandPostRequest
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSenddevicecommandPostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSendresetcommandPostRequest
 */
export interface ApiAppGeometrisapiSendresetcommandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSendresetcommandPostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSetenginebustypePostRequest
 */
export interface ApiAppGeometrisapiSetenginebustypePostRequest {
    /**
     * 
     * @type {GeometrisEngineBusType}
     * @memberof ApiAppGeometrisapiSetenginebustypePostRequest
     */
    'engineBusType'?: GeometrisEngineBusType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSetenginebustypePostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSetodometervaluePostRequest
 */
export interface ApiAppGeometrisapiSetodometervaluePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppGeometrisapiSetodometervaluePostRequest
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSetodometervaluePostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGlobalsearchAdvancedsearchPostRequest
 */
export interface ApiAppGlobalsearchAdvancedsearchPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'searchText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeDrivers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeVehicles'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeTrailers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeEldDevices'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppGroupGetRequest
 */
export interface ApiAppGroupGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGroupGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppGroupGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppGroupGetRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppGroupGetRequest
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
 */
export interface ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
 */
export interface ApiAppHarsheventreportGetharshaccelerationeventsPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppHoslogsAddexceptionPostRequest
 */
export interface ApiAppHoslogsAddexceptionPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'exceptionId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppIdlingreportsGetidlingdatafordriversPostRequest
 */
export interface ApiAppIdlingreportsGetidlingdatafordriversPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
 */
export interface ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'periodType'?: PeriodType;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenGetRequest
 */
export interface ApiAppLivetracktokenGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenIdDeleteRequest
 */
export interface ApiAppLivetracktokenIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenUpdateManyPutRequest
 */
export interface ApiAppLivetracktokenUpdateManyPutRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppLivetracktokenUpdateManyPutRequest
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppLivetracktokenUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppLocationLiveTrackPostRequest
 */
export interface ApiAppLocationLiveTrackPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'deviceTimestamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'lat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'lng'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppLocationhistoryvehiclesGetRequest
 */
export interface ApiAppLocationhistoryvehiclesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
 */
export interface ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest {
    /**
     * 
     * @type {MaintenanceDashboardSaveType}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'saveType': MaintenanceDashboardSaveType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'maintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'vehicleMaintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'vehicleMaintenanceDashboardWidgetsConfiguration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceAssigntotenantPostRequest
 */
export interface ApiAppMasterelddeviceAssigntotenantPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceAssigntotenantPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppMasterelddeviceAssigntotenantPostRequest
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceGetRequest
 */
export interface ApiAppMasterelddeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceIdDeleteRequest
 */
export interface ApiAppMasterelddeviceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceMultipleelddevicesPostRequest
 */
export interface ApiAppMasterelddeviceMultipleelddevicesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'uploadInfoId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'hasHeader'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'serialNumberColumnIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'macAddressColumnIndex'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceUnassignfromtenantsPostRequest
 */
export interface ApiAppMasterelddeviceUnassignfromtenantsPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppMasterelddeviceUnassignfromtenantsPostRequest
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppMastereventIdGetRequest
 */
export interface ApiAppMastereventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMastereventPostRequest
 */
export interface ApiAppMastereventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof ApiAppMastereventPostRequest
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerGetRequest
 */
export interface ApiAppMasterfleetmanagerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerIdDeleteRequest
 */
export interface ApiAppMasterfleetmanagerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerResetpasswordPostRequest
 */
export interface ApiAppMasterfleetmanagerResetpasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest
 */
export interface ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMobileappversionIdDeleteRequest
 */
export interface ApiAppMobileappversionIdDeleteRequest {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'mobileApplicationType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'timestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'buildNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMobiletrailerPostRequest
 */
export interface ApiAppMobiletrailerPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'trailerType'?: TrailerType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSavenotificationpreferencePostRequest
 */
export interface ApiAppNotificationcenterSavenotificationpreferencePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'notificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
 */
export interface ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'trailerId'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
 */
export interface ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
     */
    'lastReadNotificationTime': string;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationsubscriptionGetRequest
 */
export interface ApiAppNotificationsubscriptionGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'name': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'sendWindowStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'sendWindowEndTime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<EventPreferenceDto>; }}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'eventPreferences'?: { [key: string]: Array<EventPreferenceDto>; } | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'selectedDrivers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'selectedVehicles'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'isAllDriversSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'isAllVehiclesSelected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppPrologsidentityroleGetRequest
 */
export interface ApiAppPrologsidentityroleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppPrologsidentityroleIdDeleteRequest
 */
export interface ApiAppPrologsidentityroleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiclientGetRequest
 */
export interface ApiAppPublicapiclientGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiredirectionGetRequest
 */
export interface ApiAppPublicapiredirectionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'callerTenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'callerTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'callbackUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionGetRequest
     */
    'callbackSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiredirectionIdApprovePostRequest
 */
export interface ApiAppPublicapiredirectionIdApprovePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppPublicapiredirectionIdApprovePostRequest
     */
    'accessTokenLifetimeSeconds'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiredirectionIdDeleteRequest
 */
export interface ApiAppPublicapiredirectionIdDeleteRequest {
    /**
     * 
     * @type {PublicApiRedirectionStatus}
     * @memberof ApiAppPublicapiredirectionIdDeleteRequest
     */
    'status'?: PublicApiRedirectionStatus;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionIdDeleteRequest
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionIdDeleteRequest
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionIdDeleteRequest
     */
    'callbackUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiredirectionrequestRequestredirectionPostRequest
 */
export interface ApiAppPublicapiredirectionrequestRequestredirectionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiredirectionrequestRequestredirectionPostRequest
     */
    'apiClientName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppPublicapiredirectionrequestRequestredirectionPostRequest
     */
    'companyId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppRoleGetRequest
 */
export interface ApiAppRoleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleGetRequest
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleGetRequest
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleGetRequest
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleGetRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleGetRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppRoleGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppRoleIdDeleteRequest
 */
export interface ApiAppRoleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantAcquiretenantadminaccesstokenPostRequest
 */
export interface ApiAppTenantAcquiretenantadminaccesstokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantAcquiretenantadminaccesstokenPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppTenantAcquiretenantadminaccesstokenPostRequest
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantGetRequest
 */
export interface ApiAppTenantGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'dbServer': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'dbName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'appUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'webApiUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantGetRequest
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantGetRequest
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof ApiAppTenantGetRequest
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'adminName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'domainName': string;
}
/**
 * 
 * @export
 * @interface ApiAppTenantIdDeleteRequest
 */
export interface ApiAppTenantIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'domainName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
 */
export interface ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     * @deprecated
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'assignedFromMaster'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'referenceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {EldDeviceAssignedToTenant}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'assignedToTenant'?: EldDeviceAssignedToTenant | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'bluetoothDeviceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {Array<GeometrisEvent>}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'geometrisEvents'?: Array<GeometrisEvent> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationApproveordenypendingrequestPostRequest
 */
export interface ApiAppTenantregistrationApproveordenypendingrequestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {ApiAppTenantGetRequest}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'tenantInfo'?: ApiAppTenantGetRequest | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationGetRequest
 */
export interface ApiAppTenantregistrationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationIdDeleteRequest
 */
export interface ApiAppTenantregistrationIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationReassigntenantPostRequest
 */
export interface ApiAppTenantregistrationReassigntenantPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationReassigntenantPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationReassigntenantPostRequest
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppTrailerGetRequest
 */
export interface ApiAppTrailerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppTrailerGetRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppTrailerGetRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppTrailerGetRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppTrailerGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailerGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTrailerIdDeleteRequest
 */
export interface ApiAppTrailerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
 */
export interface ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTrailertrackingproviderGetRequest
 */
export interface ApiAppTrailertrackingproviderGetRequest {
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof ApiAppTrailertrackingproviderGetRequest
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppTrailertrackingproviderGetRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppTrailertrackingproviderIdDeleteRequest
 */
export interface ApiAppTrailertrackingproviderIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsSavePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsSavePostRequest {
    /**
     * 
     * @type {TwoFactorAuthenticationType}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'selectedAuthenticationType'?: TwoFactorAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'authenticatorSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface ApiAppUnidentifiedeventsDeleteRequest
 */
export interface ApiAppUnidentifiedeventsDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppUnidentifiedeventsIdGetRequest
 */
export interface ApiAppUnidentifiedeventsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsIdGetRequest
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsIdGetRequest
     */
    'driverId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppUserpreferenceSaveuserpreferencesPostRequest
 */
export interface ApiAppUserpreferenceSaveuserpreferencesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppUserpreferenceSaveuserpreferencesPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUserpreferenceSaveuserpreferencesPostRequest
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppUtilObtainfmcsacredentialsPostRequest
 */
export interface ApiAppUtilObtainfmcsacredentialsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilObtainfmcsacredentialsPostRequest
     */
    'key': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppUtilObtainfmcsacredentialsPostRequest
     */
    'os': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface ApiAppUtilSetmobileappversionPostRequest
 */
export interface ApiAppUtilSetmobileappversionPostRequest {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'os'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'buildNumber'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppUtilSetmobiledeviceinformationPostRequest
 */
export interface ApiAppUtilSetmobiledeviceinformationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'sdkLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'appVersionCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'coarseLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'fineLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'backgroundLocationPermission'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'storageSpace'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'status'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'connectedToEld'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceTime'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppVehicleGetRequest
 */
export interface ApiAppVehicleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppVehicleGetRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppVehicleGetRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleGetRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleGetRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehicleGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppVehicleGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppVehicleIdDeleteRequest
 */
export interface ApiAppVehicleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppVehiclemaintenanceIdDeleteRequest
 */
export interface ApiAppVehiclemaintenanceIdDeleteRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'previousOilChangeId'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
 */
export interface ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'eldDevice'?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'odometerOffset'?: number | null;
    /**
     * 
     * @type {Array<GroupVehicle>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'vehicleGroups'?: Array<GroupVehicle> | null;
    /**
     * 
     * @type {Array<Event>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'events'?: Array<Event> | null;
    /**
     * 
     * @type {Array<Location>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'locations'?: Array<Location> | null;
    /**
     * 
     * @type {Array<VehicleMaintenance>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'maintenance'?: Array<VehicleMaintenance> | null;
    /**
     * 
     * @type {Array<TireStatus>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'tireStatuses'?: Array<TireStatus> | null;
    /**
     * 
     * @type {Array<IdlingEvent>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'idlingEvents'?: Array<IdlingEvent> | null;
    /**
     * 
     * @type {Array<IdlingFuelConsumption>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'idlingFuelConsumptions'?: Array<IdlingFuelConsumption> | null;
    /**
     * 
     * @type {Array<VehicleSensorAttributeValue>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'sensorAttributeValues'?: Array<VehicleSensorAttributeValue> | null;
    /**
     * 
     * @type {VehicleCurrentLocation}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentLocation'?: VehicleCurrentLocation | null;
    /**
     * 
     * @type {VehicleCurrentDutyStatusEvent}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentDutyStatusEvent'?: VehicleCurrentDutyStatusEvent | null;
    /**
     * 
     * @type {VehicleEldDisconnection}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'eldDisconnection'?: VehicleEldDisconnection | null;
    /**
     * 
     * @type {Array<DiagnosticRecord>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'diagnosticRecords'?: Array<DiagnosticRecord> | null;
    /**
     * 
     * @type {Array<EldConnection>}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'eldConnections'?: Array<EldConnection> | null;
    /**
     * 
     * @type {VehicleCurrentVehicleEldConnectionStatus}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'currentVehicleEldConnectionStatus'?: VehicleCurrentVehicleEldConnectionStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppVehicletrackingproviderGetRequest
 */
export interface ApiAppVehicletrackingproviderGetRequest {
    /**
     * 
     * @type {VehicleTrackingProviders}
     * @memberof ApiAppVehicletrackingproviderGetRequest
     */
    'provider': VehicleTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppVehicletrackingproviderGetRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppVehicletrackingproviderIdDeleteRequest
 */
export interface ApiAppVehicletrackingproviderIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicletrackingproviderIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehicletrackingproviderIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicletrackingproviderIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {VehicleTrackingProviders}
     * @memberof ApiAppVehicletrackingproviderIdDeleteRequest
     */
    'provider': VehicleTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppVehicletrackingproviderIdDeleteRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppVirtualtenantGetvehicledriversPostRequest
 */
export interface ApiAppVirtualtenantGetvehicledriversPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantGetvehicledriversPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppVirtualtenantGetvehicledriversPostRequest
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppVirtualtenantIdDeleteRequest
 */
export interface ApiAppVirtualtenantIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'overriddenCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'overriddenDot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'isOverridden'?: boolean;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<VirtualTenantVehicleRangeDto>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'vehicles'?: Array<VirtualTenantVehicleRangeDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'driverIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiClientDto
 */
export interface ApiClientDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof ApiClientDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof ApiClientDto
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof ApiClientDto
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiClientDtoPagedResultDto
 */
export interface ApiClientDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ApiClientDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ApiClientDto>}
     * @memberof ApiClientDtoPagedResultDto
     */
    'items'?: Array<ApiClientDto> | null;
}
/**
 * 
 * @export
 * @interface ApiClientListWithRedirectionDto
 */
export interface ApiClientListWithRedirectionDto {
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientListWithRedirectionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientListWithRedirectionDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiClientListWithRedirectionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiClientListWithRedirectionDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientListWithRedirectionDto
     */
    'hasRedirectionRequest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientListWithRedirectionDto
     */
    'redirectionRequestId'?: string | null;
    /**
     * 
     * @type {PublicApiRedirectionRequestStatus}
     * @memberof ApiClientListWithRedirectionDto
     */
    'redirectionRequestStatus'?: PublicApiRedirectionRequestStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ApiClientListWithRedirectionDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiClientListWithRedirectionDtoPagedResultDto
 */
export interface ApiClientListWithRedirectionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ApiClientListWithRedirectionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ApiClientListWithRedirectionDto>}
     * @memberof ApiClientListWithRedirectionDtoPagedResultDto
     */
    'items'?: Array<ApiClientListWithRedirectionDto> | null;
}
/**
 * 
 * @export
 * @interface ApiClientSecretDto
 */
export interface ApiClientSecretDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientSecretDto
     */
    'isExisting'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ApiClientSecretValueDto
 */
export interface ApiClientSecretValueDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretValueDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ApiFeatureManagementFeaturesGetRequest
 */
export interface ApiFeatureManagementFeaturesGetRequest {
    /**
     * 
     * @type {Array<UpdateFeatureDto>}
     * @memberof ApiFeatureManagementFeaturesGetRequest
     */
    'features'?: Array<UpdateFeatureDto> | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersGetRequest
 */
export interface ApiIdentityUsersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersGetRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersGetRequest
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersGetRequest
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiIdentityUsersGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersIdDeleteRequest
 */
export interface ApiIdentityUsersIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersIdRolesGetRequest
 */
export interface ApiIdentityUsersIdRolesGetRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersIdRolesGetRequest
     */
    'roleNames': Array<string>;
}
/**
 * 
 * @export
 * @interface ApiMultiTenancyTenantsGetRequest
 */
export interface ApiMultiTenancyTenantsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'adminPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiMultiTenancyTenantsIdDeleteRequest
 */
export interface ApiMultiTenancyTenantsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiPermissionManagementPermissionsGetRequest
 */
export interface ApiPermissionManagementPermissionsGetRequest {
    /**
     * 
     * @type {Array<UpdatePermissionDto>}
     * @memberof ApiPermissionManagementPermissionsGetRequest
     */
    'permissions'?: Array<UpdatePermissionDto> | null;
}
/**
 * 
 * @export
 * @interface ApiTelematicsPostRequest
 */
export interface ApiTelematicsPostRequest {
    /**
     * 
     * @type {Array<TelematicsInputDto>}
     * @memberof ApiTelematicsPostRequest
     */
    'items'?: Array<TelematicsInputDto> | null;
}
/**
 * 
 * @export
 * @interface AppData
 */
export interface AppData {
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'sensorAttributes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'cargoTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'odometerTypes'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<Int32DropDownAppData>; }}
     * @memberof AppData
     */
    'knownDocumentTypes'?: { [key: string]: Array<Int32DropDownAppData>; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'driverTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<CompanyAppData>}
     * @memberof AppData
     */
    'companies'?: Array<CompanyAppData> | null;
    /**
     * 
     * @type {Array<GuidDropDownAppData>}
     * @memberof AppData
     */
    'roles'?: Array<GuidDropDownAppData> | null;
    /**
     * 
     * @type {Array<Int32DropDownAppData>}
     * @memberof AppData
     */
    'fleetManagerGroups'?: Array<Int32DropDownAppData> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'fuelTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerOwnershipTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerSuspensionTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<TerminalTimeZoneAppData>}
     * @memberof AppData
     */
    'terminalTimeZones'?: Array<TerminalTimeZoneAppData> | null;
    /**
     * 
     * @type {Array<RootActionPermissionGroup>}
     * @memberof AppData
     */
    'actionPermissionDefinitions'?: Array<RootActionPermissionGroup> | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof AppData
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {Array<EldDeviceAppData>}
     * @memberof AppData
     */
    'eldDevices'?: Array<EldDeviceAppData> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'violationTypes'?: Array<string> | null;
    /**
     * 
     * @type {AppDataTenant}
     * @memberof AppData
     */
    'tenant'?: AppDataTenant | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'databaseServers'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'dutyStatuses'?: Array<string> | null;
    /**
     * 
     * @type {Array<GuidDropDownAppData>}
     * @memberof AppData
     */
    'tenants'?: Array<GuidDropDownAppData> | null;
    /**
     * 
     * @type {MultiTenancySides}
     * @memberof AppData
     */
    'multiTenancySide'?: MultiTenancySides;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'webAppUrl'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<HosExceptionAppData>; }}
     * @memberof AppData
     */
    'hosExceptions'?: { [key: string]: Array<HosExceptionAppData>; } | null;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'userPreferences'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppData
     */
    'hasVehicleGpsProvider'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppData
     */
    'hasCameraProvider'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppData
     */
    'isVehicleOffsetLocked'?: boolean;
    /**
     * 
     * @type {Array<CountryAppData>}
     * @memberof AppData
     */
    'countries'?: Array<CountryAppData> | null;
    /**
     * 
     * @type {{ [key: string]: EventTypeCode; }}
     * @memberof AppData
     */
    'eventTypeCodes'?: { [key: string]: EventTypeCode; } | null;
    /**
     * 
     * @type {AppDataCurrentCompanyTimeZone}
     * @memberof AppData
     */
    'currentCompanyTimeZone'?: AppDataCurrentCompanyTimeZone | null;
    /**
     * 
     * @type {AppDataUserPermissions}
     * @memberof AppData
     */
    'userPermissions'?: AppDataUserPermissions | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'masterAdminExclusivePermissions'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AppDataCurrentCompanyTimeZone
 */
export interface AppDataCurrentCompanyTimeZone {
    /**
     * 
     * @type {string}
     * @memberof AppDataCurrentCompanyTimeZone
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AppDataCurrentCompanyTimeZone
     */
    'utcOffset'?: number;
}
/**
 * 
 * @export
 * @interface AppDataTenant
 */
export interface AppDataTenant {
    /**
     * 
     * @type {string}
     * @memberof AppDataTenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppDataTenant
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppDataTenant
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface AppDataUserPermissions
 */
export interface AppDataUserPermissions {
    /**
     * 
     * @type {string}
     * @memberof AppDataUserPermissions
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGroupDto>}
     * @memberof AppDataUserPermissions
     */
    'actionPermissionGroups'?: Array<ActionPermissionGroupDto> | null;
    /**
     * 
     * @type {Array<FieldPermissionGroupDto>}
     * @memberof AppDataUserPermissions
     */
    'fieldPermissionGroups'?: Array<FieldPermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ApplicationApiDescriptionModel
 */
export interface ApplicationApiDescriptionModel {
    /**
     * 
     * @type {{ [key: string]: ModuleApiDescriptionModel; }}
     * @memberof ApplicationApiDescriptionModel
     */
    'modules'?: { [key: string]: ModuleApiDescriptionModel; } | null;
    /**
     * 
     * @type {{ [key: string]: TypeApiDescriptionModel; }}
     * @memberof ApplicationApiDescriptionModel
     */
    'types'?: { [key: string]: TypeApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationAuthConfigurationDto
 */
export interface ApplicationAuthConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationAuthConfigurationDto
     */
    'policies'?: { [key: string]: boolean; } | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationAuthConfigurationDto
     */
    'grantedPolicies'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDto
 */
export interface ApplicationConfigurationDto {
    /**
     * 
     * @type {ApplicationConfigurationDtoLocalization}
     * @memberof ApplicationConfigurationDto
     */
    'localization'?: ApplicationConfigurationDtoLocalization | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoAuth}
     * @memberof ApplicationConfigurationDto
     */
    'auth'?: ApplicationConfigurationDtoAuth | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoSetting}
     * @memberof ApplicationConfigurationDto
     */
    'setting'?: ApplicationConfigurationDtoSetting | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoCurrentUser}
     * @memberof ApplicationConfigurationDto
     */
    'currentUser'?: ApplicationConfigurationDtoCurrentUser | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoFeatures}
     * @memberof ApplicationConfigurationDto
     */
    'features'?: ApplicationConfigurationDtoFeatures | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoGlobalFeatures}
     * @memberof ApplicationConfigurationDto
     */
    'globalFeatures'?: ApplicationConfigurationDtoGlobalFeatures | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoMultiTenancy}
     * @memberof ApplicationConfigurationDto
     */
    'multiTenancy'?: ApplicationConfigurationDtoMultiTenancy | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoCurrentTenant}
     * @memberof ApplicationConfigurationDto
     */
    'currentTenant'?: ApplicationConfigurationDtoCurrentTenant | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoTiming}
     * @memberof ApplicationConfigurationDto
     */
    'timing'?: ApplicationConfigurationDtoTiming | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoClock}
     * @memberof ApplicationConfigurationDto
     */
    'clock'?: ApplicationConfigurationDtoClock | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoObjectExtensions}
     * @memberof ApplicationConfigurationDto
     */
    'objectExtensions'?: ApplicationConfigurationDtoObjectExtensions | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoAuth
 */
export interface ApplicationConfigurationDtoAuth {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationConfigurationDtoAuth
     */
    'policies'?: { [key: string]: boolean; } | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationConfigurationDtoAuth
     */
    'grantedPolicies'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoClock
 */
export interface ApplicationConfigurationDtoClock {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoClock
     */
    'kind'?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoCurrentTenant
 */
export interface ApplicationConfigurationDtoCurrentTenant {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoCurrentUser
 */
export interface ApplicationConfigurationDtoCurrentUser {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'isAuthenticated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'surName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'roles'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoFeatures
 */
export interface ApplicationConfigurationDtoFeatures {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationConfigurationDtoFeatures
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoGlobalFeatures
 */
export interface ApplicationConfigurationDtoGlobalFeatures {
    /**
     * 
     * @type {Set<string>}
     * @memberof ApplicationConfigurationDtoGlobalFeatures
     */
    'enabledFeatures'?: Set<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoLocalization
 */
export interface ApplicationConfigurationDtoLocalization {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'values'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {Array<LanguageInfo>}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languages'?: Array<LanguageInfo> | null;
    /**
     * 
     * @type {ApplicationLocalizationConfigurationDtoCurrentCulture}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'currentCulture'?: ApplicationLocalizationConfigurationDtoCurrentCulture | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'defaultResourceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languagesMap'?: { [key: string]: Array<NameValue>; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languageFilesMap'?: { [key: string]: Array<NameValue>; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoMultiTenancy
 */
export interface ApplicationConfigurationDtoMultiTenancy {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoMultiTenancy
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoObjectExtensions
 */
export interface ApplicationConfigurationDtoObjectExtensions {
    /**
     * 
     * @type {{ [key: string]: ModuleExtensionDto; }}
     * @memberof ApplicationConfigurationDtoObjectExtensions
     */
    'modules'?: { [key: string]: ModuleExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: ExtensionEnumDto; }}
     * @memberof ApplicationConfigurationDtoObjectExtensions
     */
    'enums'?: { [key: string]: ExtensionEnumDto; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoSetting
 */
export interface ApplicationConfigurationDtoSetting {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationConfigurationDtoSetting
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoTiming
 */
export interface ApplicationConfigurationDtoTiming {
    /**
     * 
     * @type {TimingDtoTimeZone}
     * @memberof ApplicationConfigurationDtoTiming
     */
    'timeZone'?: TimingDtoTimeZone | null;
}
/**
 * 
 * @export
 * @interface ApplicationFeatureConfigurationDto
 */
export interface ApplicationFeatureConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationFeatureConfigurationDto
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationGlobalFeatureConfigurationDto
 */
export interface ApplicationGlobalFeatureConfigurationDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof ApplicationGlobalFeatureConfigurationDto
     */
    'enabledFeatures'?: Set<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationLocalizationConfigurationDto
 */
export interface ApplicationLocalizationConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'values'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {Array<LanguageInfo>}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languages'?: Array<LanguageInfo> | null;
    /**
     * 
     * @type {ApplicationLocalizationConfigurationDtoCurrentCulture}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'currentCulture'?: ApplicationLocalizationConfigurationDtoCurrentCulture | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'defaultResourceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languagesMap'?: { [key: string]: Array<NameValue>; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languageFilesMap'?: { [key: string]: Array<NameValue>; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationLocalizationConfigurationDtoCurrentCulture
 */
export interface ApplicationLocalizationConfigurationDtoCurrentCulture {
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'threeLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'twoLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'isRightToLeft'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'nativeName'?: string | null;
    /**
     * 
     * @type {CurrentCultureDtoDateTimeFormat}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'dateTimeFormat'?: CurrentCultureDtoDateTimeFormat | null;
}
/**
 * 
 * @export
 * @interface ApplicationSettingConfigurationDto
 */
export interface ApplicationSettingConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationSettingConfigurationDto
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApproveOrDenyTenantRegistrationDto
 */
export interface ApproveOrDenyTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {ApiAppTenantGetRequest}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'tenantInfo'?: ApiAppTenantGetRequest | null;
}
/**
 * 
 * @export
 * @interface ApprovePublicApiRedirectionDto
 */
export interface ApprovePublicApiRedirectionDto {
    /**
     * 
     * @type {number}
     * @memberof ApprovePublicApiRedirectionDto
     */
    'accessTokenLifetimeSeconds'?: number | null;
}
/**
 * 
 * @export
 * @interface AssignEventsDto
 */
export interface AssignEventsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignEventsDto
     */
    'eventIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AssignEventsDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignEventsDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignEventsDto
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignToTenantInputDto
 */
export interface AssignToTenantInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssignToTenantInputDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignToTenantInputDto
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AssignUnidentifiedEventDto
 */
export interface AssignUnidentifiedEventDto {
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventDto
     */
    'driverId'?: number;
}
/**
 * 
 * @export
 * @interface AssignUnidentifiedEventsDto
 */
export interface AssignUnidentifiedEventsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignUnidentifiedEventsDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventsDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignUnidentifiedEventsDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignUnidentifiedEventsDto
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface AverageIdleTimeDto
 */
export interface AverageIdleTimeDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'nightValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'morningValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AxleStatusDto
 */
export interface AxleStatusDto {
    /**
     * 
     * @type {number}
     * @memberof AxleStatusDto
     */
    'axle'?: number;
    /**
     * 
     * @type {Array<TireStatusDto>}
     * @memberof AxleStatusDto
     */
    'tires'?: Array<TireStatusDto> | null;
}
/**
 * 
 * @export
 * @interface BareVehicleLocationDto
 */
export interface BareVehicleLocationDto {
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseSearchListDto
 */
export interface BaseSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof BaseSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface BestGeolocationCoordinatesOutput
 */
export interface BestGeolocationCoordinatesOutput {
    /**
     * 
     * @type {number}
     * @memberof BestGeolocationCoordinatesOutput
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof BestGeolocationCoordinatesOutput
     */
    'lng': number;
}
/**
 * 
 * @export
 * @interface BulkSetCoDriverInputDto
 */
export interface BulkSetCoDriverInputDto {
    /**
     * 
     * @type {number}
     * @memberof BulkSetCoDriverInputDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetCoDriverInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetCoDriverInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetShippingDocsInputDto
 */
export interface BulkSetShippingDocsInputDto {
    /**
     * 
     * @type {string}
     * @memberof BulkSetShippingDocsInputDto
     */
    'shippingDocs'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetShippingDocsInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetShippingDocsInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetTrailersInputDto
 */
export interface BulkSetTrailersInputDto {
    /**
     * 
     * @type {string}
     * @memberof BulkSetTrailersInputDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetTrailersInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetTrailersInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetVehicleInputDto
 */
export interface BulkSetVehicleInputDto {
    /**
     * 
     * @type {number}
     * @memberof BulkSetVehicleInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetVehicleInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetVehicleInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CameraAvailabilityStatus = {
    Unknown: 'Unknown',
    NotAvailable: 'NotAvailable',
    Available: 'Available'
} as const;

export type CameraAvailabilityStatus = typeof CameraAvailabilityStatus[keyof typeof CameraAvailabilityStatus];


/**
 * 
 * @export
 * @interface CameraEmbedLaunchDto
 */
export interface CameraEmbedLaunchDto {
    /**
     * 
     * @type {string}
     * @memberof CameraEmbedLaunchDto
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraEmbedLaunchDto
     */
    'embedUrl'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof CameraEmbedLaunchDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {CameraEmbedRenderStrategy}
     * @memberof CameraEmbedLaunchDto
     */
    'renderStrategy'?: CameraEmbedRenderStrategy;
    /**
     * 
     * @type {string}
     * @memberof CameraEmbedLaunchDto
     */
    'expiresAtUtc'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CameraEmbedRenderStrategy = {
    Iframe: 'Iframe',
    HtmlBootstrap: 'HtmlBootstrap',
    SdkBootstrap: 'SdkBootstrap'
} as const;

export type CameraEmbedRenderStrategy = typeof CameraEmbedRenderStrategy[keyof typeof CameraEmbedRenderStrategy];


/**
 * 
 * @export
 * @interface CameraMediaRequestEnumsDto
 */
export interface CameraMediaRequestEnumsDto {
    /**
     * 
     * @type {Array<MediaRequestStatus>}
     * @memberof CameraMediaRequestEnumsDto
     */
    'mediaRequestStatuses'?: Array<MediaRequestStatus> | null;
    /**
     * 
     * @type {Array<MediaRequestAbortReason>}
     * @memberof CameraMediaRequestEnumsDto
     */
    'mediaRequestAbortReasons'?: Array<MediaRequestAbortReason> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CameraPosition = {
    Road: 'Road',
    Cabin: 'Cabin'
} as const;

export type CameraPosition = typeof CameraPosition[keyof typeof CameraPosition];


/**
 * 
 * @export
 * @interface CameraRecordingSessionDto
 */
export interface CameraRecordingSessionDto {
    /**
     * 
     * @type {number}
     * @memberof CameraRecordingSessionDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'startedAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'endedAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'roadRecordingStartUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'roadRecordingEndUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'cabinRecordingStartUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionDto
     */
    'cabinRecordingEndUtc'?: string | null;
}
/**
 * 
 * @export
 * @interface CameraRecordingSessionsDto
 */
export interface CameraRecordingSessionsDto {
    /**
     * 
     * @type {number}
     * @memberof CameraRecordingSessionsDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionsDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionsDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraRecordingSessionsDto
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {Array<CameraRecordingSessionDto>}
     * @memberof CameraRecordingSessionsDto
     */
    'sessions'?: Array<CameraRecordingSessionDto> | null;
}
/**
 * 
 * @export
 * @interface CameraVideoDetailDto
 */
export interface CameraVideoDetailDto {
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'mediaId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'driverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'capturedUtc'?: string;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {CameraPosition}
     * @memberof CameraVideoDetailDto
     */
    'cameraPosition'?: CameraPosition;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'videoUrl'?: string | null;
    /**
     * 
     * @type {MediaLifecycleState}
     * @memberof CameraVideoDetailDto
     */
    'lifecycleStatus'?: MediaLifecycleState;
    /**
     * 
     * @type {boolean}
     * @memberof CameraVideoDetailDto
     */
    'requestedByUser'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'lng'?: number;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'locationDisplayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'aiEventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CameraVideoDetailDto
     */
    'accelerometer'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'speed'?: number;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'cpuUsage'?: number;
    /**
     * 
     * @type {number}
     * @memberof CameraVideoDetailDto
     */
    'luminosity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CameraVideoDetailDto
     */
    'isRoadRecording'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CameraVideoDetailDto
     */
    'isCabinRecording'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CameraVideoDetailDto
     */
    'otherInfo'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CargoType = {
    Property: 'Property',
    Passenger: 'Passenger'
} as const;

export type CargoType = typeof CargoType[keyof typeof CargoType];


/**
 * 
 * @export
 * @interface CertifyLogDateInputDto
 */
export interface CertifyLogDateInputDto {
    /**
     * 
     * @type {number}
     * @memberof CertifyLogDateInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CertifyLogDateInputDto
     */
    'logDate'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordDemoAccountInputDto
 */
export interface ChangePasswordDemoAccountInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDemoAccountInputDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDemoAccountInputDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordInput
 */
export interface ChangePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'currentPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordInputDto
 */
export interface ChangePasswordInputDto {
    /**
     * 
     * @type {number}
     * @memberof ChangePasswordInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInputDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ClockDto
 */
export interface ClockDto {
    /**
     * 
     * @type {string}
     * @memberof ClockDto
     */
    'kind'?: string | null;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof Company
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof Company
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'dot': string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof Company
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Odometer}
     * @memberof Company
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {Array<CompanyDutyCycle>}
     * @memberof Company
     */
    'companyDutyCycles'?: Array<CompanyDutyCycle> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof Company
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyAppData
 */
export interface CompanyAppData {
    /**
     * 
     * @type {CompanyAppDataDefaultHosData}
     * @memberof CompanyAppData
     */
    'defaultHosData'?: CompanyAppDataDefaultHosData | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyAppDataDefaultHosData
 */
export interface CompanyAppDataDefaultHosData {
    /**
     * 
     * @type {string}
     * @memberof CompanyAppDataDefaultHosData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'twentyFourHourCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CompanyAppDataDefaultHosData
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CompanyAppDataDefaultHosData
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {Array<EntityCycleRules>}
     * @memberof CompanyAppDataDefaultHosData
     */
    'cycleRules'?: Array<EntityCycleRules> | null;
}
/**
 * 
 * @export
 * @interface CompanyDto
 */
export interface CompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof CompanyDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof CompanyDto
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<DutyCycleDto>}
     * @memberof CompanyDto
     */
    'dutyCycles'?: Array<DutyCycleDto> | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof CompanyDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDtoEntityStatusChangeResult
 */
export interface CompanyDtoEntityStatusChangeResult {
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof CompanyDtoEntityStatusChangeResult
     */
    'entity'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResult
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface CompanyDtoEntityStatusChangeResultEntity
 */
export interface CompanyDtoEntityStatusChangeResultEntity {
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<DutyCycleDto>}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'dutyCycles'?: Array<DutyCycleDto> | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoEntityStatusChangeResultEntity
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDtoPagedResultDto
 */
export interface CompanyDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CompanyDto>}
     * @memberof CompanyDtoPagedResultDto
     */
    'items'?: Array<CompanyDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyDtoState
 */
export interface CompanyDtoState {
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoState
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoState
     */
    'icon'?: string | null;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof CompanyDtoState
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoState
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDutyCycle
 */
export interface CompanyDutyCycle {
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycle
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof CompanyDutyCycle
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycle
     */
    'dutyCycleId'?: number;
    /**
     * 
     * @type {CompanyDutyCycleDutyCycle}
     * @memberof CompanyDutyCycle
     */
    'dutyCycle'?: CompanyDutyCycleDutyCycle | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDutyCycle
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CompanyDutyCycle
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycle
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDutyCycleDutyCycle
 */
export interface CompanyDutyCycleDutyCycle {
    /**
     * 
     * @type {string}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDutyCycleDutyCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyListDto
 */
export interface CompanyListDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CompanyListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyListDtoPagedResultDto
 */
export interface CompanyListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CompanyListDto>}
     * @memberof CompanyListDtoPagedResultDto
     */
    'items'?: Array<CompanyListDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyState
 */
export interface CompanyState {
    /**
     * 
     * @type {string}
     * @memberof CompanyState
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyState
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyState
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyState
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ControllerApiDescriptionModel
 */
export interface ControllerApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'controllerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'controllerGroupName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControllerApiDescriptionModel
     */
    'isRemoteService'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'apiVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {Array<ControllerInterfaceApiDescriptionModel>}
     * @memberof ControllerApiDescriptionModel
     */
    'interfaces'?: Array<ControllerInterfaceApiDescriptionModel> | null;
    /**
     * 
     * @type {{ [key: string]: ActionApiDescriptionModel; }}
     * @memberof ControllerApiDescriptionModel
     */
    'actions'?: { [key: string]: ActionApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ControllerInterfaceApiDescriptionModel
 */
export interface ControllerInterfaceApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ControllerInterfaceApiDescriptionModel
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface ConvertEventToPersonalUseOfCmvOrYardMoveDto
 */
export interface ConvertEventToPersonalUseOfCmvOrYardMoveDto {
    /**
     * 
     * @type {number}
     * @memberof ConvertEventToPersonalUseOfCmvOrYardMoveDto
     */
    'endEventId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConvertEventToPersonalUseOfCmvOrYardMoveDto
     */
    'isPersonalUse'?: boolean;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {Array<State>}
     * @memberof Country
     */
    'states'?: Array<State> | null;
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CountryAppData
 */
export interface CountryAppData {
    /**
     * 
     * @type {Array<StateAppData>}
     * @memberof CountryAppData
     */
    'states'?: Array<StateAppData> | null;
    /**
     * 
     * @type {Array<Int32DropDownAppData>}
     * @memberof CountryAppData
     */
    'dutyCycles'?: Array<Int32DropDownAppData> | null;
    /**
     * 
     * @type {number}
     * @memberof CountryAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CountryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateBatchEventsDto
 */
export interface CreateBatchEventsDto {
    /**
     * 
     * @type {Array<CreateOrUpdateEventDto>}
     * @memberof CreateBatchEventsDto
     */
    'events'?: Array<CreateOrUpdateEventDto> | null;
}
/**
 * 
 * @export
 * @interface CreateChangeRequestEvent
 */
export interface CreateChangeRequestEvent {
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'time'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'notes'?: string | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof CreateChangeRequestEvent
     */
    'origin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'state'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'country'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'minTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'maxTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'totalVehicleMiles'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateCompanyDto
 */
export interface CreateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CreateCompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CreateCompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CreateCompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateCompanyDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateCompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateDemoAccountDto
 */
export interface CreateDemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'tenantId': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDemoAccountDto
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface CreateDocumentForEntityDto
 */
export interface CreateDocumentForEntityDto {
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'entityType': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'entityId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDriverDto
 */
export interface CreateDriverDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof CreateDriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof CreateDriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'password': string;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CreateDriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateDriverDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'hideUnidentifiedEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDriverImportDto
 */
export interface CreateDriverImportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDriverImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverImportDto
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface CreateDvirFormDto
 */
export interface CreateDvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof CreateDvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDvirFormDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateDvirReportDto
 */
export interface CreateDvirReportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof CreateDvirReportDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirReportDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirReportDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirReportDto
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {Array<DvirDefectDto>}
     * @memberof CreateDvirReportDto
     */
    'defects'?: Array<DvirDefectDto> | null;
}
/**
 * 
 * @export
 * @interface CreateEldDeviceDto
 */
export interface CreateEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateEldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateEldDisconnectionDto
 */
export interface CreateEldDisconnectionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEldDisconnectionDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDisconnectionDto
     */
    'time'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEldDisconnectionDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateEldFileExportDto
 */
export interface CreateEldFileExportDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateEldFileExportDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileExportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileExportDto
     */
    'timeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileExportDto
     */
    'timeTo'?: string;
}
/**
 * 
 * @export
 * @interface CreateEldFileImportDto
 */
export interface CreateEldFileImportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileImportDto
     */
    'importDateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileImportDto
     */
    'importDateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldFileImportDto
     */
    'eldFileUploadId'?: string;
}
/**
 * 
 * @export
 * @interface CreateEventOutputDto
 */
export interface CreateEventOutputDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEventOutputDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventOutputDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventOutputDto
     */
    'errorCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEventOutputDto
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventOutputDto
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateFleetManagerDto
 */
export interface CreateFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateFleetManagerDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateFleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateFleetManagerDto
     */
    'groupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateFmcsaInspectionDto
 */
export interface CreateFmcsaInspectionDto {
    /**
     * 
     * @type {number}
     * @memberof CreateFmcsaInspectionDto
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFmcsaInspectionDto
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'fmcsaSenderNameOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'fmcsaSenderAddressOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'base64EncodedEldFileContents': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFmcsaInspectionDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof CreateFmcsaInspectionDto
     */
    'mobileAppType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface CreateFuelProviderDto
 */
export interface CreateFuelProviderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof CreateFuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateLiveTrackTokenDto
 */
export interface CreateLiveTrackTokenDto {
    /**
     * 
     * @type {number}
     * @memberof CreateLiveTrackTokenDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveTrackTokenDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveTrackTokenDto
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface CreateLocationImportDto
 */
export interface CreateLocationImportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationImportDto
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface CreateMasterEldDeviceDto
 */
export interface CreateMasterEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateMasterEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateMasterEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMasterEldDeviceDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMasterEldDeviceDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateMasterEventInput
 */
export interface CreateMasterEventInput {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof CreateMasterEventInput
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateMasterFleetManagerDto
 */
export interface CreateMasterFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateMasterFleetManagerDto
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface CreateMultipleMasterEldDevicesDto
 */
export interface CreateMultipleMasterEldDevicesDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'uploadInfoId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'hasHeader'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'serialNumberColumnIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'macAddressColumnIndex'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateEventDto
 */
export interface CreateOrUpdateEventDto {
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'dutyStatusId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventSequenceIdNumber': string;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof CreateOrUpdateEventDto
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof CreateOrUpdateEventDto
     */
    'eventRecordOrigin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {EventType}
     * @memberof CreateOrUpdateEventDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'distanceSinceLastValidCoordinates'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEventDto
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventDataCheckValue': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEventDto
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'recordOriginator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof CreateOrUpdateEventDto
     */
    'totalVehicleMilesSource'?: OdometerSource | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'dvirId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEventDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'personalUseOrYardMoveActivationUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'personalUseOrYardMoveSessionUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'personalUseOrYardMoveDeactivationUUID'?: string | null;
}
/**
 * 
 * @export
 * @interface CreatePersonalUseOfCmvOrYardMovesEventDto
 */
export interface CreatePersonalUseOfCmvOrYardMovesEventDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalUseOfCmvOrYardMovesEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalUseOfCmvOrYardMovesEventDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonalUseOfCmvOrYardMovesEventDto
     */
    'isPersonalUse'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonalUseOfCmvOrYardMovesEventDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalUseOfCmvOrYardMovesEventDto
     */
    'dutyStatusAbbreviation'?: string | null;
}
/**
 * 
 * @export
 * @interface CreatePublicApiRedirectionDto
 */
export interface CreatePublicApiRedirectionDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'callerTenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'callerTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'callbackUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiRedirectionDto
     */
    'callbackSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CreateRoleDto
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CreateRoleDto
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'dbServer': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'dbName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'appUrl': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'webApiUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof CreateTenantDto
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'adminName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'domainName': string;
}
/**
 * 
 * @export
 * @interface CreateTenantRegistrationDto
 */
export interface CreateTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateTrailerDto
 */
export interface CreateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof CreateTrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof CreateTrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof CreateTrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateTrailerDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateTrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateTrailerImportDto
 */
export interface CreateTrailerImportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerImportDto
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface CreateTrailerTrackingProviderDto
 */
export interface CreateTrailerTrackingProviderDto {
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof CreateTrailerTrackingProviderDto
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateTrailerTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateUpdateGroupDto
 */
export interface CreateUpdateGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateGroupDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateGroupDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateGroupDto
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateVehicleDto
 */
export interface CreateVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof CreateVehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof CreateVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateVehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateVehicleDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateVehicleImportDto
 */
export interface CreateVehicleImportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleImportDto
     */
    'uploadId'?: string;
}
/**
 * 
 * @export
 * @interface CreateVehicleMaintenanceDto
 */
export interface CreateVehicleMaintenanceDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleMaintenanceDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'previousOilChangeId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateVehicleTrackingProviderDto
 */
export interface CreateVehicleTrackingProviderDto {
    /**
     * 
     * @type {VehicleTrackingProviders}
     * @memberof CreateVehicleTrackingProviderDto
     */
    'provider': VehicleTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateVehicleTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateVirtualTenantDto
 */
export interface CreateVirtualTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'overriddenCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'overriddenDot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVirtualTenantDto
     */
    'isOverridden'?: boolean;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof CreateVirtualTenantDto
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<VirtualTenantVehicleRangeDto>}
     * @memberof CreateVirtualTenantDto
     */
    'vehicles'?: Array<VirtualTenantVehicleRangeDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateVirtualTenantDto
     */
    'driverIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CurrentCultureDto
 */
export interface CurrentCultureDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'threeLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'twoLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentCultureDto
     */
    'isRightToLeft'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'nativeName'?: string | null;
    /**
     * 
     * @type {CurrentCultureDtoDateTimeFormat}
     * @memberof CurrentCultureDto
     */
    'dateTimeFormat'?: CurrentCultureDtoDateTimeFormat | null;
}
/**
 * 
 * @export
 * @interface CurrentCultureDtoDateTimeFormat
 */
export interface CurrentCultureDtoDateTimeFormat {
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'calendarAlgorithmType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'dateTimeFormatLong'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'shortDatePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'fullDateTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'dateSeparator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'shortTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'longTimePattern'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentDriverCycle
 */
export interface CurrentDriverCycle {
    /**
     * 
     * @type {DriverCycleClosedByCycle}
     * @memberof CurrentDriverCycle
     */
    'driverCycle'?: DriverCycleClosedByCycle | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverCycle
     */
    'driverCycleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverCycle
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverCycle
     */
    'mustEndCycleWorkBy'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentDriverCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentDriverDutyStatusEvent
 */
export interface CurrentDriverDutyStatusEvent {
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof CurrentDriverDutyStatusEvent
     */
    'event'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentDriverDutyStatusEvent
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentDriverDutyStatusEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentDriverHosStatus
 */
export interface CurrentDriverHosStatus {
    /**
     * 
     * @type {boolean}
     * @memberof CurrentDriverHosStatus
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentDriverHosStatus
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverHosStatus
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverHosStatus
     */
    'operationId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentDriverHosStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentDriverShift
 */
export interface CurrentDriverShift {
    /**
     * 
     * @type {DriverShiftClosedByShift}
     * @memberof CurrentDriverShift
     */
    'driverShift'?: DriverShiftClosedByShift | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'driverShiftId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'mustEndDrivingRunBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'completesBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     * @deprecated
     */
    'currentDrivingRun'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentDriverShift
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentDriverShift
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentLocationDto
 */
export interface CurrentLocationDto {
    /**
     * 
     * @type {VehicleIgnitionStatus}
     * @memberof CurrentLocationDto
     */
    'ignitionStatus'?: VehicleIgnitionStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'safetyStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'healthStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'violationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'geometrisSafetyEventsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'diagnosticRecordsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'isPlugged'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'ignitionStatusUpdateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'isPluggedUpdateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'fuelLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'fuelLevelUpdateTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'hasCamera'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestRoadMediaUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestRoadMediaDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestRoadMediaItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestDriverMediaUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestDriverMediaDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'latestDriverMediaItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'lastTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'eldConnected'?: boolean | null;
    /**
     * 
     * @type {CurrentLocationDtoHosDetails}
     * @memberof CurrentLocationDto
     */
    'hosDetails'?: CurrentLocationDtoHosDetails | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof CurrentLocationDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentLocationDtoHosDetails
 */
export interface CurrentLocationDtoHosDetails {
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDtoHosDetails
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDtoHosDetails
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentTenantDto
 */
export interface CurrentTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentTenantDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentTenantDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface CurrentTimeZoneInfoDto
 */
export interface CurrentTimeZoneInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentTimeZoneInfoDto
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentTimeZoneInfoDto
     */
    'utcOffset'?: number;
}
/**
 * 
 * @export
 * @interface CurrentUserDto
 */
export interface CurrentUserDto {
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'isAuthenticated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'surName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserDto
     */
    'roles'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CurrentVehicleDutyStatusEvent
 */
export interface CurrentVehicleDutyStatusEvent {
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof CurrentVehicleDutyStatusEvent
     */
    'event'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEvent
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEvent
     */
    'lastDriverChangeTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentVehicleDutyStatusEventEvent
 */
export interface CurrentVehicleDutyStatusEventEvent {
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'coDriverUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'dutyStatusId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'cycleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'recordOriginator'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'motorCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventRecordOrigin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {EventType}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'distanceSinceLastValidCoordinates'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventDataCheckValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'timeZoneOffset'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'driverLicenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'bearing'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {CompanyState}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'terminalStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'mileageSinceEventStarted'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'originalDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'totalVehicleMilesSource'?: OdometerSource | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'dvirId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'personalUseOrYardMoveActivationUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'personalUseOrYardMoveSessionUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'personalUseOrYardMoveDeactivationUUID'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleDutyStatusEventEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentVehicleEldConnectionStatus
 */
export interface CurrentVehicleEldConnectionStatus {
    /**
     * 
     * @type {CurrentVehicleEldConnectionStatusEldConnection}
     * @memberof CurrentVehicleEldConnectionStatus
     */
    'eldConnection'?: CurrentVehicleEldConnectionStatusEldConnection | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatus
     */
    'eldConnectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatus
     */
    'lastEldStatusChangeTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleEldConnectionStatus
     */
    'isFromGeometris'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentVehicleEldConnectionStatusEldConnection
 */
export interface CurrentVehicleEldConnectionStatusEldConnection {
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'disconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'reconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'disconnectMinutes'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleEldConnectionStatusEldConnection
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CurrentVehicleLocation
 */
export interface CurrentVehicleLocation {
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleLocation
     */
    'timestamp'?: string;
    /**
     * 
     * @type {GeometrisEventLocation}
     * @memberof CurrentVehicleLocation
     */
    'location'?: GeometrisEventLocation | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleLocation
     */
    'locationId'?: number;
    /**
     * 
     * @type {VehicleIgnitionStatus}
     * @memberof CurrentVehicleLocation
     */
    'ignitionStatus'?: VehicleIgnitionStatus;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleLocation
     */
    'ignitionStatusUpdateTime'?: string | null;
    /**
     * 
     * @type {VehicleEldPhysicalConnectionStatus}
     * @memberof CurrentVehicleLocation
     */
    'eldPhysicalConnectionStatus'?: VehicleEldPhysicalConnectionStatus;
    /**
     * 
     * @type {string}
     * @memberof CurrentVehicleLocation
     */
    'eldPhysicalConnectionStatusUpdateTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentVehicleLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CustomerEldDevicesViewList
 */
export interface CustomerEldDevicesViewList {
    /**
     * 
     * @type {number}
     * @memberof CustomerEldDevicesViewList
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerEldDevicesViewList
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerEldDevicesViewList
     */
    'assignedToCustomer'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerEldDevicesViewListPagedResultDto
 */
export interface CustomerEldDevicesViewListPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerEldDevicesViewListPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CustomerEldDevicesViewList>}
     * @memberof CustomerEldDevicesViewListPagedResultDto
     */
    'items'?: Array<CustomerEldDevicesViewList> | null;
}
/**
 * 
 * @export
 * @interface Cycle
 */
export interface Cycle {
    /**
     * 
     * @type {number}
     * @memberof Cycle
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cycle
     */
    'dutyCycleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Cycle
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Cycle
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Cycle
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Cycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CycleHosViolation
 */
export interface CycleHosViolation {
    /**
     * 
     * @type {string}
     * @memberof CycleHosViolation
     */
    'driverCycleId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CycleHosViolation
     */
    'causedByEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof CycleHosViolation
     */
    'causedByEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof CycleHosViolation
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CycleHosViolation
     */
    'endTime'?: string;
    /**
     * 
     * @type {ViolationType}
     * @memberof CycleHosViolation
     */
    'violationType'?: ViolationType;
    /**
     * 
     * @type {ViolationClass}
     * @memberof CycleHosViolation
     */
    'violationClass'?: ViolationClass;
    /**
     * 
     * @type {string}
     * @memberof CycleHosViolation
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CycleRuleDto
 */
export interface CycleRuleDto {
    /**
     * 
     * @type {number}
     * @memberof CycleRuleDto
     */
    'drivingCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CycleRuleDto
     */
    'cycleRuleId'?: number;
}
/**
 * 
 * @export
 * @interface DailyLogReportInput
 */
export interface DailyLogReportInput {
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'graphHtml'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DailyLogReportInput
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DailyLogReportInput
     */
    'showAllEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface DailyLogSummary
 */
export interface DailyLogSummary {
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'remainingWorkingMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'minutesGainedAfterToday'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyLogSummary
     */
    'isCurrentDay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DailyLogSummary
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'workingHours'?: string;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'workingMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'totalWorkingHours'?: string;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'totalWorkingMinutes'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DailyLogsDownloadFormat = {
    Zip: 'Zip',
    MergedPdf: 'MergedPdf'
} as const;

export type DailyLogsDownloadFormat = typeof DailyLogsDownloadFormat[keyof typeof DailyLogsDownloadFormat];


/**
 * 
 * @export
 * @interface DailyLogsReportInput
 */
export interface DailyLogsReportInput {
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DailyLogsReportInput
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {DailyLogsDownloadFormat}
     * @memberof DailyLogsReportInput
     */
    'downloadFormat'?: DailyLogsDownloadFormat;
}
/**
 * 
 * @export
 * @interface DailyRefuelDto
 */
export interface DailyRefuelDto {
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'customProviderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof DailyRefuelDto
     */
    'provider'?: FuelProviders | null;
    /**
     * 
     * @type {boolean}
     * @memberof DailyRefuelDto
     */
    'isFromProvider'?: boolean;
}
/**
 * 
 * @export
 * @interface DashboardDriverDto
 */
export interface DashboardDriverDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'vehicleNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'lastActivity'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'lastGeolocation'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardDriverHosEventsOutput
 */
export interface DashboardDriverHosEventsOutput {
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverHosEventsOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverHosEventsOutput
     */
    'hoursToday'?: number;
    /**
     * 
     * @type {Array<EventViewDto>}
     * @memberof DashboardDriverHosEventsOutput
     */
    'basicEvents'?: Array<EventViewDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DataTransferEntityType = {
    Trailers: 'Trailers',
    Vehicles: 'Vehicles',
    Drivers: 'Drivers',
    Locations: 'Locations',
    Events: 'Events'
} as const;

export type DataTransferEntityType = typeof DataTransferEntityType[keyof typeof DataTransferEntityType];


/**
 * 
 * @export
 * @interface DataTransferExportDto
 */
export interface DataTransferExportDto {
    /**
     * 
     * @type {boolean}
     * @memberof DataTransferExportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {DataTransferEntityType}
     * @memberof DataTransferExportDto
     */
    'entityType'?: DataTransferEntityType;
    /**
     * 
     * @type {ExportStatus}
     * @memberof DataTransferExportDto
     */
    'status'?: ExportStatus;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataTransferExportDto
     */
    'itemsProcessed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'creatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'creatorSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'filterDateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'filterDateTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataTransferExportDto
     */
    'filterDriverEntityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'filterDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'filterDriverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataTransferExportDto
     */
    'filterVehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'filterVehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferExportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DataTransferExportDtoPagedResultDto
 */
export interface DataTransferExportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DataTransferExportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DataTransferExportDto>}
     * @memberof DataTransferExportDtoPagedResultDto
     */
    'items'?: Array<DataTransferExportDto> | null;
}
/**
 * 
 * @export
 * @interface DataTransferImportDto
 */
export interface DataTransferImportDto {
    /**
     * 
     * @type {boolean}
     * @memberof DataTransferImportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {DataTransferEntityType}
     * @memberof DataTransferImportDto
     */
    'entityType'?: DataTransferEntityType;
    /**
     * 
     * @type {ImportStatus}
     * @memberof DataTransferImportDto
     */
    'status'?: ImportStatus;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'fileUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'processed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'inserted'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'updated'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedExisting'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedMissingIdentity'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedMissingCompanyName'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedCompanyNotFound'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedAmbiguousMatch'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'skippedDuplicateInPayload'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDto
     */
    'invalidLines'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'creatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'creatorSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataTransferImportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DataTransferImportDtoPagedResultDto
 */
export interface DataTransferImportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DataTransferImportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DataTransferImportDto>}
     * @memberof DataTransferImportDtoPagedResultDto
     */
    'items'?: Array<DataTransferImportDto> | null;
}
/**
 * 
 * @export
 * @interface DateTimeFormatDto
 */
export interface DateTimeFormatDto {
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'calendarAlgorithmType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'dateTimeFormatLong'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'shortDatePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'fullDateTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'dateSeparator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'shortTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'longTimePattern'?: string | null;
}
/**
 * 
 * @export
 * @interface DefaultHosData
 */
export interface DefaultHosData {
    /**
     * 
     * @type {string}
     * @memberof DefaultHosData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'twentyFourHourCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof DefaultHosData
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DefaultHosData
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {Array<EntityCycleRules>}
     * @memberof DefaultHosData
     */
    'cycleRules'?: Array<EntityCycleRules> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DefectCorrectedStatus = {
    Corrected: 'Corrected',
    NoNeedToCorrect: 'NoNeedToCorrect'
} as const;

export type DefectCorrectedStatus = typeof DefectCorrectedStatus[keyof typeof DefectCorrectedStatus];


/**
 * 
 * @export
 * @interface DemoAccountDto
 */
export interface DemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DemoAccountListDto
 */
export interface DemoAccountListDto {
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DemoAccountListDtoPagedResultDto
 */
export interface DemoAccountListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DemoAccountListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DemoAccountListDto>}
     * @memberof DemoAccountListDtoPagedResultDto
     */
    'items'?: Array<DemoAccountListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeviceType = {
    Invalid: 'Invalid',
    Series87: 'Series87',
    Series88: 'Series88',
    PacificTrack30: 'PacificTrack30',
    PacificTrack40: 'PacificTrack40',
    AiCamera: 'AiCamera',
    Io1020: 'Io1020'
} as const;

export type DeviceType = typeof DeviceType[keyof typeof DeviceType];


/**
 * 
 * @export
 * @interface DeviceUsageDetail
 */
export interface DeviceUsageDetail {
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'endTime'?: string;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof DeviceUsageDetail
     */
    'usageType'?: EldDeviceUsageType;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageOutput
 */
export interface DeviceUsageOutput {
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'tenantId'?: string;
    /**
     * 
     * @type {DeviceType}
     * @memberof DeviceUsageOutput
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceUsageOutput
     */
    'customerOwned'?: boolean;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof DeviceUsageOutput
     */
    'currentStatus'?: EldDeviceUsageType;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceUsageOutput
     */
    'used'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceUsageOutput
     */
    'usedInVehicles'?: Array<string> | null;
    /**
     * 
     * @type {Array<DeviceUsageDetail>}
     * @memberof DeviceUsageOutput
     */
    'usage'?: Array<DeviceUsageDetail> | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageOutputPagedResultDto
 */
export interface DeviceUsageOutputPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageOutputPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DeviceUsageOutput>}
     * @memberof DeviceUsageOutputPagedResultDto
     */
    'items'?: Array<DeviceUsageOutput> | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageSummary
 */
export interface DeviceUsageSummary {
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageSummary
     */
    'totalDevicesUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageSummary
     */
    'totalDevicesUsedInVehicles'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiagnosticCodeType = {
    J1939: 'J1939',
    J1708: 'J1708',
    Obd2: 'Obd2'
} as const;

export type DiagnosticCodeType = typeof DiagnosticCodeType[keyof typeof DiagnosticCodeType];


/**
 * 
 * @export
 * @interface DiagnosticRecord
 */
export interface DiagnosticRecord {
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecord
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DiagnosticRecord
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecord
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DiagnosticRecord
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {DiagnosticCodeType}
     * @memberof DiagnosticRecord
     */
    'type'?: DiagnosticCodeType;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'dtcSourceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'dtcSourceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'spnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'spnDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'fmiCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'fmiDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiagnosticRecord
     */
    'acknowledged'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'rawCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'spnDetail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecord
     */
    'oc'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiagnosticRecord
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecord
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecord
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DiagnosticRecordListDto
 */
export interface DiagnosticRecordListDto {
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'dtcSourceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'dtcSourceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'spnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'fmiCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'oc'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiagnosticRecordListDto
     */
    'acknowledged'?: boolean;
    /**
     * 
     * @type {DiagnosticCodeType}
     * @memberof DiagnosticRecordListDto
     */
    'type'?: DiagnosticCodeType;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DiagnosticRecordListDtoPagedResultDto
 */
export interface DiagnosticRecordListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DiagnosticRecordListDto>}
     * @memberof DiagnosticRecordListDtoPagedResultDto
     */
    'items'?: Array<DiagnosticRecordListDto> | null;
}
/**
 * 
 * @export
 * @interface DiagnosticResponse
 */
export interface DiagnosticResponse {
    /**
     * 
     * @type {string}
     * @memberof DiagnosticResponse
     */
    'boradcast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticResponse
     */
    'detail'?: string | null;
    /**
     * 
     * @type {DiagnosticResponseStatus}
     * @memberof DiagnosticResponse
     */
    'status'?: DiagnosticResponseStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiagnosticResponseStatus = {
    Success: 'Success',
    InvalidRegistrationData: 'InvalidRegistrationData',
    EldDecertified: 'ELDDecertified',
    UnexpectedError: 'UnexpectedError',
    ExpiredCertificate: 'ExpiredCertificate'
} as const;

export type DiagnosticResponseStatus = typeof DiagnosticResponseStatus[keyof typeof DiagnosticResponseStatus];


/**
 * 
 * @export
 * @interface DisconnectedDrivingFilterInputDto
 */
export interface DisconnectedDrivingFilterInputDto {
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'dateTo': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'groupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'isOngoing'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingFilterInputDto
     */
    'skipCount'?: number;
}
/**
 * 
 * @export
 * @interface DisconnectedDrivingLocationGroupDto
 */
export interface DisconnectedDrivingLocationGroupDto {
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'driverGivenId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'locationCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DisconnectedDrivingLocationGroupDto
     */
    'isOngoing'?: boolean;
}
/**
 * 
 * @export
 * @interface DisconnectedDrivingLocationGroupDtoPagedResultDto
 */
export interface DisconnectedDrivingLocationGroupDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DisconnectedDrivingLocationGroupDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DisconnectedDrivingLocationGroupDto>}
     * @memberof DisconnectedDrivingLocationGroupDtoPagedResultDto
     */
    'items'?: Array<DisconnectedDrivingLocationGroupDto> | null;
}
/**
 * 
 * @export
 * @interface DocumentCreateOrUpdateDto
 */
export interface DocumentCreateOrUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentCreateOrUpdateDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentCreateOrUpdateDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {DocumentDtoDocumentName}
     * @memberof DocumentDto
     */
    'documentName'?: DocumentDtoDocumentName | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DocumentDtoDocumentName
 */
export interface DocumentDtoDocumentName {
    /**
     * 
     * @type {string}
     * @memberof DocumentDtoDocumentName
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDtoDocumentName
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDtoDocumentName
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DocumentListDto
 */
export interface DocumentListDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentListDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentListDto
     */
    'id'?: number;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DocumentListDto
     */
    'documents'?: Array<DocumentDto> | null;
}
/**
 * 
 * @export
 * @interface DocumentListDtoPagedResultDto
 */
export interface DocumentListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DocumentListDto>}
     * @memberof DocumentListDtoPagedResultDto
     */
    'items'?: Array<DocumentListDto> | null;
}
/**
 * 
 * @export
 * @interface DocumentNameDto
 */
export interface DocumentNameDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentNameDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentNameDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentNameDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface Driver
 */
export interface Driver {
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof Driver
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof Driver
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof Driver
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof Driver
     */
    'licenceCountry'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof Driver
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof Driver
     */
    'licenceState'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Driver
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Driver
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {CargoType}
     * @memberof Driver
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'fcmToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'fcmTokenTimestamp'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof Driver
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'password'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'hideUnidentifiedEvents'?: boolean | null;
    /**
     * 
     * @type {Array<Event>}
     * @memberof Driver
     */
    'events'?: Array<Event> | null;
    /**
     * 
     * @type {Array<Cycle>}
     * @memberof Driver
     */
    'cycles'?: Array<Cycle> | null;
    /**
     * 
     * @type {Array<GroupDriver>}
     * @memberof Driver
     */
    'driverGroups'?: Array<GroupDriver> | null;
    /**
     * 
     * @type {Array<Violation>}
     * @memberof Driver
     */
    'violations'?: Array<Violation> | null;
    /**
     * 
     * @type {Array<DvirReport>}
     * @memberof Driver
     */
    'dvirReports'?: Array<DvirReport> | null;
    /**
     * 
     * @type {Array<DriverSignature>}
     * @memberof Driver
     */
    'driverSignatures'?: Array<DriverSignature> | null;
    /**
     * 
     * @type {Array<DriverDutyCycle>}
     * @memberof Driver
     */
    'driverDutyCycles'?: Array<DriverDutyCycle> | null;
    /**
     * 
     * @type {Array<IdlingEvent>}
     * @memberof Driver
     */
    'idlingEvents'?: Array<IdlingEvent> | null;
    /**
     * 
     * @type {Array<IdlingFuelConsumption>}
     * @memberof Driver
     */
    'idlingFuelConsumptions'?: Array<IdlingFuelConsumption> | null;
    /**
     * 
     * @type {DriverCurrentDutyStatusEvent}
     * @memberof Driver
     */
    'currentDutyStatusEvent'?: DriverCurrentDutyStatusEvent | null;
    /**
     * 
     * @type {DriverCurrentShift}
     * @memberof Driver
     */
    'currentShift'?: DriverCurrentShift | null;
    /**
     * 
     * @type {DriverCurrentCycle}
     * @memberof Driver
     */
    'currentCycle'?: DriverCurrentCycle | null;
    /**
     * 
     * @type {DriverCurrentHosStatus}
     * @memberof Driver
     */
    'currentHosStatus'?: DriverCurrentHosStatus | null;
    /**
     * 
     * @type {Array<DriverCycle>}
     * @memberof Driver
     */
    'driverCycles'?: Array<DriverCycle> | null;
    /**
     * 
     * @type {Array<DriverShift>}
     * @memberof Driver
     */
    'driverShifts'?: Array<DriverShift> | null;
    /**
     * 
     * @type {DriverUser}
     * @memberof Driver
     */
    'user'?: DriverUser | null;
    /**
     * 
     * @type {boolean}
     * @memberof Driver
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Driver
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Driver
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverActivityDto
 */
export interface DriverActivityDto {
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverActivityDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverActivityDto
     */
    'hasViolations'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'lastSync'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverActivityDto
     */
    'driverStatus'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface DriverActivityDtoPagedResultDto
 */
export interface DriverActivityDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverActivityDto>}
     * @memberof DriverActivityDtoPagedResultDto
     */
    'items'?: Array<DriverActivityDto> | null;
}
/**
 * 
 * @export
 * @interface DriverAdvancedSearchListDto
 */
export interface DriverAdvancedSearchListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverCurrentCycle
 */
export interface DriverCurrentCycle {
    /**
     * 
     * @type {DriverCycleClosedByCycle}
     * @memberof DriverCurrentCycle
     */
    'driverCycle'?: DriverCycleClosedByCycle | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentCycle
     */
    'driverCycleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentCycle
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentCycle
     */
    'mustEndCycleWorkBy'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCurrentCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverCurrentDutyStatusEvent
 */
export interface DriverCurrentDutyStatusEvent {
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof DriverCurrentDutyStatusEvent
     */
    'event'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCurrentDutyStatusEvent
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCurrentDutyStatusEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverCurrentHosStatus
 */
export interface DriverCurrentHosStatus {
    /**
     * 
     * @type {boolean}
     * @memberof DriverCurrentHosStatus
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverCurrentHosStatus
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentHosStatus
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentHosStatus
     */
    'operationId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCurrentHosStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverCurrentShift
 */
export interface DriverCurrentShift {
    /**
     * 
     * @type {DriverShiftClosedByShift}
     * @memberof DriverCurrentShift
     */
    'driverShift'?: DriverShiftClosedByShift | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'driverShiftId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'mustEndDrivingRunBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'completesBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     * @deprecated
     */
    'currentDrivingRun'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCurrentShift
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCurrentShift
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverCycle
 */
export interface DriverCycle {
    /**
     * 
     * @type {number}
     * @memberof DriverCycle
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverCycle
     */
    'dutyCycleId'?: number;
    /**
     * 
     * @type {CompanyDutyCycleDutyCycle}
     * @memberof DriverCycle
     */
    'dutyCycle'?: CompanyDutyCycleDutyCycle | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCycle
     */
    'startEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof DriverCycle
     */
    'startEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'mustEndBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'resetsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'closedByCycleId'?: string | null;
    /**
     * 
     * @type {DriverCycleClosedByCycle}
     * @memberof DriverCycle
     */
    'closedByCycle'?: DriverCycleClosedByCycle | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'maxWorkTime'?: string;
    /**
     * 
     * @type {Array<DriverCycleDay>}
     * @memberof DriverCycle
     */
    'cycleDays'?: Array<DriverCycleDay> | null;
    /**
     * 
     * @type {Array<CycleHosViolation>}
     * @memberof DriverCycle
     */
    'violations'?: Array<CycleHosViolation> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'workTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'driveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycle
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DriverCycleClosedByCycle
 */
export interface DriverCycleClosedByCycle {
    /**
     * 
     * @type {number}
     * @memberof DriverCycleClosedByCycle
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverCycleClosedByCycle
     */
    'dutyCycleId'?: number;
    /**
     * 
     * @type {CompanyDutyCycleDutyCycle}
     * @memberof DriverCycleClosedByCycle
     */
    'dutyCycle'?: CompanyDutyCycleDutyCycle | null;
    /**
     * 
     * @type {number}
     * @memberof DriverCycleClosedByCycle
     */
    'startEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof DriverCycleClosedByCycle
     */
    'startEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'mustEndBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'resetsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'closedByCycleId'?: string | null;
    /**
     * 
     * @type {DriverCycleClosedByCycle}
     * @memberof DriverCycleClosedByCycle
     */
    'closedByCycle'?: DriverCycleClosedByCycle | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'maxWorkTime'?: string;
    /**
     * 
     * @type {Array<DriverCycleDay>}
     * @memberof DriverCycleClosedByCycle
     */
    'cycleDays'?: Array<DriverCycleDay> | null;
    /**
     * 
     * @type {Array<CycleHosViolation>}
     * @memberof DriverCycleClosedByCycle
     */
    'violations'?: Array<CycleHosViolation> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'workTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'driveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleClosedByCycle
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DriverCycleDay
 */
export interface DriverCycleDay {
    /**
     * 
     * @type {string}
     * @memberof DriverCycleDay
     */
    'localDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleDay
     */
    'cycleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleDay
     */
    'driveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleDay
     */
    'workTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverCycleDay
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DriverDailyLogInput
 */
export interface DriverDailyLogInput {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogInput
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDailyLogInput
     */
    'showAllEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecap
 */
export interface DriverDailyLogRecap {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecap
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecap
     */
    'cycleWorkingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {Array<DailyLogSummary>}
     * @memberof DriverDailyLogRecap
     */
    'days'?: Array<DailyLogSummary> | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecapResult
 */
export interface DriverDailyLogRecapResult {
    /**
     * 
     * @type {DriverDailyLogRecapResultResult}
     * @memberof DriverDailyLogRecapResult
     */
    'result'?: DriverDailyLogRecapResultResult | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResult
     */
    'eventId'?: number | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecapResultResult
 */
export interface DriverDailyLogRecapResultResult {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleWorkingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {Array<DailyLogSummary>}
     * @memberof DriverDailyLogRecapResultResult
     */
    'days'?: Array<DailyLogSummary> | null;
}
/**
 * 
 * @export
 * @interface DriverDto
 */
export interface DriverDto {
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof DriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DriverDto
     */
    'licenceCountry'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof DriverDto
     */
    'licenceState'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof DriverDto
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof DriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DriverDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'editable'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverDtoEntityStatusChangeResult
 */
export interface DriverDtoEntityStatusChangeResult {
    /**
     * 
     * @type {DriverDtoEntityStatusChangeResultEntity}
     * @memberof DriverDtoEntityStatusChangeResult
     */
    'entity'?: DriverDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResult
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverDtoEntityStatusChangeResultEntity
 */
export interface DriverDtoEntityStatusChangeResultEntity {
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'licenceCountry'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'licenceState'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'hideUnidentifiedEvents'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoEntityStatusChangeResultEntity
     */
    'editable'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverDtoPagedResultDto
 */
export interface DriverDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverDto>}
     * @memberof DriverDtoPagedResultDto
     */
    'items'?: Array<DriverDto> | null;
}
/**
 * 
 * @export
 * @interface DriverDutyCycle
 */
export interface DriverDutyCycle {
    /**
     * 
     * @type {number}
     * @memberof DriverDutyCycle
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverDutyCycle
     */
    'dutyCycleId'?: number;
    /**
     * 
     * @type {CompanyDutyCycleDutyCycle}
     * @memberof DriverDutyCycle
     */
    'dutyCycle'?: CompanyDutyCycleDutyCycle | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDutyCycle
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDutyCycle
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDutyCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverDvirDefectDto
 */
export interface DriverDvirDefectDto {
    /**
     * 
     * @type {string}
     * @memberof DriverDvirDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DriverDvirDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDvirDefectDto
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof DriverDvirDefectDto
     */
    'corrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirDefectDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverDvirDefectDto
     */
    'photoUrls'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DriverDvirReportDto
 */
export interface DriverDvirReportDto {
    /**
     * 
     * @type {number}
     * @memberof DriverDvirReportDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof DriverDvirReportDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof DriverDvirReportDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirReportDto
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDvirReportDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDvirReportDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {Array<DriverDvirDefectDto>}
     * @memberof DriverDvirReportDto
     */
    'defects'?: Array<DriverDvirDefectDto> | null;
}
/**
 * 
 * @export
 * @interface DriverDvirReportDtoPagedResultDto
 */
export interface DriverDvirReportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverDvirReportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverDvirReportDto>}
     * @memberof DriverDvirReportDtoPagedResultDto
     */
    'items'?: Array<DriverDvirReportDto> | null;
}
/**
 * 
 * @export
 * @interface DriverFmcsaInspectionDto
 */
export interface DriverFmcsaInspectionDto {
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'reportTimeTo'?: string;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsBreakdownDto
 */
export interface DriverHarshEventsBreakdownDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshAccelerationEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshBrakeEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshTurnEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshStopEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'speedingEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'physicalEldDisconnectionEvents'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsSummaryDto
 */
export interface DriverHarshEventsSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsSummaryDto
     */
    'operator'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverHarshEventsSummaryDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsSummaryDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHarshEventsSummaryDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsSummaryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsTotalDto
 */
export interface DriverHarshEventsTotalDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshBrakes'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshTurns'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshAccelerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'speedingOccurrences'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshStops'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsTotalDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsTotalDto
     */
    'operator'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverHarshEventsTotalDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHarshEventsTotalDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsTotalDtoPagedResultDto
 */
export interface DriverHarshEventsTotalDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverHarshEventsTotalDto>}
     * @memberof DriverHarshEventsTotalDtoPagedResultDto
     */
    'items'?: Array<DriverHarshEventsTotalDto> | null;
}
/**
 * 
 * @export
 * @interface DriverHistoryStatusInfoDto
 */
export interface DriverHistoryStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHistoryStatusInfoDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHistoryStatusInfoDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverHistoryStatusInfoDto
     */
    'mobileAppType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'trailerNumbers'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverListDto
 */
export interface DriverListDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'drivingCycles'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'multiAccount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'personalAllowed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'yardMoveAllowed'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverListDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverListDtoPagedResultDto
 */
export interface DriverListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverListDto>}
     * @memberof DriverListDtoPagedResultDto
     */
    'items'?: Array<DriverListDto> | null;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedView
 */
export interface DriverLogDetailedView {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'windowsHomeTerminalZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'hoursToday'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'driverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {Array<ViolationViewDto>}
     * @memberof DriverLogDetailedView
     */
    'violations'?: Array<ViolationViewDto> | null;
    /**
     * 
     * @type {Array<EventViewDto>}
     * @memberof DriverLogDetailedView
     */
    'events'?: Array<EventViewDto> | null;
    /**
     * 
     * @type {Array<DriverViewDto>}
     * @memberof DriverLogDetailedView
     */
    'coDrivers'?: Array<DriverViewDto> | null;
    /**
     * 
     * @type {Array<VehicleViewDto>}
     * @memberof DriverLogDetailedView
     */
    'vehicles'?: Array<VehicleViewDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'odometerUnits'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'reassignInProgress'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'companyAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'minutesWorked'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'cycleRule'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'trailers'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'shippingDocs'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'pendingShippingDocs'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'nextLogDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'previousLogDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'certified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'signature'?: string | null;
    /**
     * 
     * @type {Array<InspectionReportViewDto>}
     * @memberof DriverLogDetailedView
     */
    'inspectionReports'?: Array<InspectionReportViewDto> | null;
    /**
     * 
     * @type {Array<ExceptionViewDto>}
     * @memberof DriverLogDetailedView
     */
    'exceptions'?: Array<ExceptionViewDto> | null;
    /**
     * 
     * @type {CurrentLocationDtoHosDetails}
     * @memberof DriverLogDetailedView
     */
    'hosDetails'?: CurrentLocationDtoHosDetails | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'cycleBreak'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'shiftBreak'?: string | null;
    /**
     * 
     * @type {DriverLogDetailedViewDriverFmcsaInspection}
     * @memberof DriverLogDetailedView
     */
    'driverFmcsaInspection'?: DriverLogDetailedViewDriverFmcsaInspection | null;
    /**
     * 
     * @type {Array<DailyRefuelDto>}
     * @memberof DriverLogDetailedView
     */
    'refuels'?: Array<DailyRefuelDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'firstEventTime'?: string | null;
    /**
     * 
     * @type {DriverLogDetailedViewEngineOnEventData}
     * @memberof DriverLogDetailedView
     */
    'engineOnEventData'?: DriverLogDetailedViewEngineOnEventData | null;
    /**
     * 
     * @type {DriverLogDetailedViewEngineOnEventData}
     * @memberof DriverLogDetailedView
     */
    'engineOnEventDataInnerEvents'?: DriverLogDetailedViewEngineOnEventData | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'isEngineOffFirstEvent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'isEngineOffInnerEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedViewDriverFmcsaInspection
 */
export interface DriverLogDetailedViewDriverFmcsaInspection {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'reportTimeTo'?: string;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedViewEngineOnEventData
 */
export interface DriverLogDetailedViewEngineOnEventData {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'totalEngineHours'?: number | null;
}
/**
 * 
 * @export
 * @interface DriverLogEventTimeRange
 */
export interface DriverLogEventTimeRange {
    /**
     * 
     * @type {string}
     * @memberof DriverLogEventTimeRange
     */
    'min'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogEventTimeRange
     */
    'max'?: string;
}
/**
 * 
 * @export
 * @interface DriverLogGridViewDto
 */
export interface DriverLogGridViewDto {
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'distanceInMiles'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'timeWorked'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'minutesWorked'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'hasInspectionReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'defectsFound'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'certified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'timeZoneOffset'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogGridViewDto
     */
    'violations'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DriverLogGridViewDtoPagedResultDto
 */
export interface DriverLogGridViewDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverLogGridViewDto>}
     * @memberof DriverLogGridViewDtoPagedResultDto
     */
    'items'?: Array<DriverLogGridViewDto> | null;
}
/**
 * 
 * @export
 * @interface DriverPasswordOutput
 */
export interface DriverPasswordOutput {
    /**
     * 
     * @type {string}
     * @memberof DriverPasswordOutput
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverPasswordOutput
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverPerformaceDto
 */
export interface DriverPerformaceDto {
    /**
     * 
     * @type {string}
     * @memberof DriverPerformaceDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Array<DriverPerformanceItemDto>}
     * @memberof DriverPerformaceDto
     */
    'data'?: Array<DriverPerformanceItemDto> | null;
}
/**
 * 
 * @export
 * @interface DriverPerformanceItemDto
 */
export interface DriverPerformanceItemDto {
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverPerformanceItemDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'numberOfHarshEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverPerformanceItemDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverPerformanceItemDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'rank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof DriverPerformanceItemDto
     */
    'rankStatus'?: RankStatus;
    /**
     * 
     * @type {string}
     * @memberof DriverPerformanceItemDto
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverProfileCycleDto
 */
export interface DriverProfileCycleDto {
    /**
     * 
     * @type {string}
     * @memberof DriverProfileCycleDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverProfileCycleDto
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverProfileCycleDto
     */
    'cycleHours'?: number;
}
/**
 * 
 * @export
 * @interface DriverProfileDto
 */
export interface DriverProfileDto {
    /**
     * 
     * @type {number}
     * @memberof DriverProfileDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'licenceState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierDotNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierStateAbbreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierPostalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'isExempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'exemptReason'?: string | null;
    /**
     * 
     * @type {Array<DriverProfileCycleDto>}
     * @memberof DriverProfileDto
     */
    'cycles'?: Array<DriverProfileCycleDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'hideUnidentified'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'noNewShiftIfNoCertify'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverQuickSearchListDto
 */
export interface DriverQuickSearchListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverQuickSearchListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverQuickSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverQuickSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverScoresOutput
 */
export interface DriverScoresOutput {
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'good'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'goodPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'satisfactory'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'satisfactoryPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'critical'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'criticalPercentage'?: number;
}
/**
 * 
 * @export
 * @interface DriverShift
 */
export interface DriverShift {
    /**
     * 
     * @type {number}
     * @memberof DriverShift
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverShift
     */
    'startEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof DriverShift
     */
    'startEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'mustEndBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'resetsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'driveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'workTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'regularShiftWorkTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'maxDriveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'maxWorkTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'currentDrivingRun'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'closedByShiftId'?: string | null;
    /**
     * 
     * @type {DriverShiftClosedByShift}
     * @memberof DriverShift
     */
    'closedByShift'?: DriverShiftClosedByShift | null;
    /**
     * 
     * @type {Array<SplitSleeperBreakEvent>}
     * @memberof DriverShift
     */
    'splitSleeperBreakEvents'?: Array<SplitSleeperBreakEvent> | null;
    /**
     * 
     * @type {Array<ShiftHosViolation>}
     * @memberof DriverShift
     */
    'violations'?: Array<ShiftHosViolation> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'regularStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShift
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DriverShiftClosedByShift
 */
export interface DriverShiftClosedByShift {
    /**
     * 
     * @type {number}
     * @memberof DriverShiftClosedByShift
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverShiftClosedByShift
     */
    'startEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof DriverShiftClosedByShift
     */
    'startEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'mustEndBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'resetsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'driveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'workTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'regularShiftWorkTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'maxDriveTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'maxWorkTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'currentDrivingRun'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'closedByShiftId'?: string | null;
    /**
     * 
     * @type {DriverShiftClosedByShift}
     * @memberof DriverShiftClosedByShift
     */
    'closedByShift'?: DriverShiftClosedByShift | null;
    /**
     * 
     * @type {Array<SplitSleeperBreakEvent>}
     * @memberof DriverShiftClosedByShift
     */
    'splitSleeperBreakEvents'?: Array<SplitSleeperBreakEvent> | null;
    /**
     * 
     * @type {Array<ShiftHosViolation>}
     * @memberof DriverShiftClosedByShift
     */
    'violations'?: Array<ShiftHosViolation> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'regularStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverShiftClosedByShift
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DriverSignature
 */
export interface DriverSignature {
    /**
     * 
     * @type {number}
     * @memberof DriverSignature
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'base64Signature'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverSignature
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverSignature
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSignature
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverSpeedingEventDetailsDto
 */
export interface DriverSpeedingEventDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'drivingSpeed'?: number;
}
/**
 * 
 * @export
 * @interface DriverSpeedingEventsSummaryDto
 */
export interface DriverSpeedingEventsSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'speedingEventsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'maxDrivingSpeed'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DriverType = {
    CompanyDriver: 'CompanyDriver',
    OwnerOperator: 'OwnerOperator',
    DrivingForOwner: 'DrivingForOwner'
} as const;

export type DriverType = typeof DriverType[keyof typeof DriverType];


/**
 * 
 * @export
 * @interface DriverUser
 */
export interface DriverUser {
    /**
     * 
     * @type {string}
     * @memberof DriverUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverUser
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverUser
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverUser
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverVehicleIdAndMobileAppTypeDto
 */
export interface DriverVehicleIdAndMobileAppTypeDto {
    /**
     * 
     * @type {number}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'mobileApplicationType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'ianaTimeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverViewDto
 */
export interface DriverViewDto {
    /**
     * 
     * @type {number}
     * @memberof DriverViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverViewDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverViewListDto
 */
export interface DriverViewListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverViewListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverViewListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverViewListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverViewListDtoPagedResultDto
 */
export interface DriverViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverViewListDto>}
     * @memberof DriverViewListDtoPagedResultDto
     */
    'items'?: Array<DriverViewListDto> | null;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionDto
 */
export interface DriversFuelConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'fuelConsumptionAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'speedingFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'accelerationFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'idleFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'maxFuelConsumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'minFuelConsumption'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriversFuelConsumptionDto
     */
    'eventScale'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriversFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriversFuelConsumptionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionDtoPagedResultDto
 */
export interface DriversFuelConsumptionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriversFuelConsumptionDto>}
     * @memberof DriversFuelConsumptionDtoPagedResultDto
     */
    'items'?: Array<DriversFuelConsumptionDto> | null;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionInputDto
 */
export interface DriversFuelConsumptionInputDto {
    /**
     * 
     * @type {PeriodType}
     * @memberof DriversFuelConsumptionInputDto
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionInputDto
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionInputDto
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface DriversVehicleUsageListDto
 */
export interface DriversVehicleUsageListDto {
    /**
     * 
     * @type {number}
     * @memberof DriversVehicleUsageListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface DutyCycle
 */
export interface DutyCycle {
    /**
     * 
     * @type {string}
     * @memberof DutyCycle
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycle
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyCycle
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyCycle
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof DutyCycle
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DutyCycleCountry
 */
export interface DutyCycleCountry {
    /**
     * 
     * @type {string}
     * @memberof DutyCycleCountry
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DutyCycleCountry
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DutyCycleCountry
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {Array<State>}
     * @memberof DutyCycleCountry
     */
    'states'?: Array<State> | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleCountry
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DutyCycleDto
 */
export interface DutyCycleDto {
    /**
     * 
     * @type {string}
     * @memberof DutyCycleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'days'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DutyCycleDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DutyIdleSummaryDto
 */
export interface DutyIdleSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DutyIdleSummaryDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyIdleSummaryDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DutyIdleSummaryDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DutyIdleSummaryDto
     */
    'stops'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DutyType = {
    OnDuty: 'OnDuty',
    OffDuty: 'OffDuty'
} as const;

export type DutyType = typeof DutyType[keyof typeof DutyType];


/**
 * 
 * @export
 * @interface DvirDefect
 */
export interface DvirDefect {
    /**
     * 
     * @type {number}
     * @memberof DvirDefect
     */
    'dvirId'?: number;
    /**
     * 
     * @type {DvirDefectDvirReport}
     * @memberof DvirDefect
     */
    'dvirReport'?: DvirDefectDvirReport | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirDefect
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'thumbnailPhoto'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirDefect
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof DvirDefect
     */
    'corrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'comment'?: string | null;
    /**
     * 
     * @type {Array<DvirDefectPhoto>}
     * @memberof DvirDefect
     */
    'photos'?: Array<DvirDefectPhoto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirDefect
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DvirDefect
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirDefect
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirDefectDto
 */
export interface DvirDefectDto {
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {Array<string>}
     * @memberof DvirDefectDto
     */
    'base64EncodedPhotos'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DvirDefectDvirReport
 */
export interface DvirDefectDvirReport {
    /**
     * 
     * @type {number}
     * @memberof DvirDefectDvirReport
     */
    'driverId'?: number;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DvirDefectDvirReport
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDvirReport
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof DvirDefectDvirReport
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof DvirDefectDvirReport
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DvirDefectDvirReport
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDvirReport
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirDefectDvirReport
     */
    'odometerValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDvirReport
     */
    'location'?: string | null;
    /**
     * 
     * @type {Array<DvirDefect>}
     * @memberof DvirDefectDvirReport
     */
    'defects'?: Array<DvirDefect> | null;
    /**
     * 
     * @type {number}
     * @memberof DvirDefectDvirReport
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirDefectPhoto
 */
export interface DvirDefectPhoto {
    /**
     * 
     * @type {number}
     * @memberof DvirDefectPhoto
     */
    'dvirDefectId'?: number;
    /**
     * 
     * @type {DvirDefectPhotoDvirDefect}
     * @memberof DvirDefectPhoto
     */
    'dvirDefect'?: DvirDefectPhotoDvirDefect | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhoto
     */
    'uri'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirDefectPhoto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirDefectPhotoDvirDefect
 */
export interface DvirDefectPhotoDvirDefect {
    /**
     * 
     * @type {number}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'dvirId'?: number;
    /**
     * 
     * @type {DvirDefectDvirReport}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'dvirReport'?: DvirDefectDvirReport | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'thumbnailPhoto'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'corrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'comment'?: string | null;
    /**
     * 
     * @type {Array<DvirDefectPhoto>}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'photos'?: Array<DvirDefectPhoto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirDefectPhotoDvirDefect
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormAreaDto
 */
export interface DvirFormAreaDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormAreaDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaDto
     */
    'dvirFormId'?: number;
    /**
     * 
     * @type {Array<DvirFormAreaPointDto>}
     * @memberof DvirFormAreaDto
     */
    'points'?: Array<DvirFormAreaPointDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormAreaPointDto
 */
export interface DvirFormAreaPointDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormAreaPointDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaPointDto
     */
    'dvirFormAreaId'?: number;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirFormAreaPointDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaPointDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DvirFormAreaPointSeverity = {
    None: 'None',
    Minor: 'Minor',
    Major: 'Major'
} as const;

export type DvirFormAreaPointSeverity = typeof DvirFormAreaPointSeverity[keyof typeof DvirFormAreaPointSeverity];


/**
 * 
 * @export
 * @interface DvirFormDto
 */
export interface DvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof DvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormDtoPagedResultDto
 */
export interface DvirFormDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirFormDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirFormDto>}
     * @memberof DvirFormDtoPagedResultDto
     */
    'items'?: Array<DvirFormDto> | null;
}
/**
 * 
 * @export
 * @interface DvirFormListDto
 */
export interface DvirFormListDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormListDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DvirFormListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormListDtoPagedResultDto
 */
export interface DvirFormListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirFormListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirFormListDto>}
     * @memberof DvirFormListDtoPagedResultDto
     */
    'items'?: Array<DvirFormListDto> | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryDefectDto
 */
export interface DvirHistoryDefectDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirHistoryDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'thumbnailPhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDto
     */
    'otherPhotosCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryDefectDto
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof DvirHistoryDefectDto
     */
    'corrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryDefectDtoPagedResultDto
 */
export interface DvirHistoryDefectDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirHistoryDefectDto>}
     * @memberof DvirHistoryDefectDtoPagedResultDto
     */
    'items'?: Array<DvirHistoryDefectDto> | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryListDto
 */
export interface DvirHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryListDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryListDto
     */
    'hasDefects'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryListDto
     */
    'hasUnresolvedDefects'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryListDtoPagedResultDto
 */
export interface DvirHistoryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirHistoryListDto>}
     * @memberof DvirHistoryListDtoPagedResultDto
     */
    'items'?: Array<DvirHistoryListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DvirInspectionType = {
    PreTrip: 'PreTrip',
    PostTrip: 'PostTrip'
} as const;

export type DvirInspectionType = typeof DvirInspectionType[keyof typeof DvirInspectionType];


/**
 * 
 * @export
 * @interface DvirInspectionsReportInput
 */
export interface DvirInspectionsReportInput {
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirInspectionsReportInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DvirInspectionsReportInput
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface DvirReport
 */
export interface DvirReport {
    /**
     * 
     * @type {number}
     * @memberof DvirReport
     */
    'driverId'?: number;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DvirReport
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof DvirReport
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof DvirReport
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof DvirReport
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof DvirReport
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof DvirReport
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirReport
     */
    'odometerValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirReport
     */
    'location'?: string | null;
    /**
     * 
     * @type {Array<DvirDefect>}
     * @memberof DvirReport
     */
    'defects'?: Array<DvirDefect> | null;
    /**
     * 
     * @type {number}
     * @memberof DvirReport
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ELDSubmissionResponse
 */
export interface ELDSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ELDSubmissionResponse
     */
    'broadcast'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ELDSubmissionResponse
     */
    'errorCount'?: number;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ELDSubmissionResponse
     */
    'errors'?: Array<ValidationError> | null;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ELDSubmissionResponse
     */
    'status'?: ValidationStatus;
    /**
     * 
     * @type {string}
     * @memberof ELDSubmissionResponse
     */
    'submissionId'?: string;
}
/**
 * 
 * @export
 * @interface EldConnection
 */
export interface EldConnection {
    /**
     * 
     * @type {number}
     * @memberof EldConnection
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EldConnection
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'disconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'reconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldConnection
     */
    'disconnectMinutes'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldConnection
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldConnection
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldConnection
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldConnection
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldCreationTimeOdometerSourceDto
 */
export interface EldCreationTimeOdometerSourceDto {
    /**
     * 
     * @type {string}
     * @memberof EldCreationTimeOdometerSourceDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof EldCreationTimeOdometerSourceDto
     */
    'odometerSource'?: OdometerSource | null;
}
/**
 * 
 * @export
 * @interface EldDevice
 */
export interface EldDevice {
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     * @deprecated
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDevice
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDevice
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDevice
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EldDevice
     */
    'assignedFromMaster'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EldDevice
     */
    'referenceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {EldDeviceAssignedToTenant}
     * @memberof EldDevice
     */
    'assignedToTenant'?: EldDeviceAssignedToTenant | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDevice
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldDevice
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'bluetoothDeviceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {Array<GeometrisEvent>}
     * @memberof EldDevice
     */
    'geometrisEvents'?: Array<GeometrisEvent> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDevice
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDevice
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDevice
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceAdvancedSearchListDto
 */
export interface EldDeviceAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'driverName'?: string | null;
}
/**
 * 
 * @export
 * @interface EldDeviceAppData
 */
export interface EldDeviceAppData {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAppData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceAppData
     */
    'assigned'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceAppData
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceAppData
     */
    'vendorType'?: Vendor;
}
/**
 * 
 * @export
 * @interface EldDeviceAssignedToTenant
 */
export interface EldDeviceAssignedToTenant {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<TenantConnectionString>}
     * @memberof EldDeviceAssignedToTenant
     */
    'connectionStrings'?: Array<TenantConnectionString> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceAssignedToTenant
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EldDeviceAssignedToTenant
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAssignedToTenant
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceCamerasDashboardDto
 */
export interface EldDeviceCamerasDashboardDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'eldDeviceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastConnectionUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastConnectionTerminal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'cameraStatusRaw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastRoadVideoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastRoadVideoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastCabinVideoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'lastCabinVideoId'?: string | null;
    /**
     * 
     * @type {CameraAvailabilityStatus}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'cameraStatus'?: CameraAvailabilityStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'cameraType'?: Vendor;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceCamerasDashboardDto
     */
    'isConnected'?: boolean;
}
/**
 * 
 * @export
 * @interface EldDeviceCamerasDashboardDtoPagedResultDto
 */
export interface EldDeviceCamerasDashboardDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceCamerasDashboardDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceCamerasDashboardDto>}
     * @memberof EldDeviceCamerasDashboardDtoPagedResultDto
     */
    'items'?: Array<EldDeviceCamerasDashboardDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceDto
 */
export interface EldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceDtoEntityStatusChangeResult
 */
export interface EldDeviceDtoEntityStatusChangeResult {
    /**
     * 
     * @type {EldDeviceDtoEntityStatusChangeResultEntity}
     * @memberof EldDeviceDtoEntityStatusChangeResult
     */
    'entity'?: EldDeviceDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceDtoEntityStatusChangeResult
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface EldDeviceDtoEntityStatusChangeResultEntity
 */
export interface EldDeviceDtoEntityStatusChangeResultEntity {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDtoEntityStatusChangeResultEntity
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceDtoPagedResultDto
 */
export interface EldDeviceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceDto>}
     * @memberof EldDeviceDtoPagedResultDto
     */
    'items'?: Array<EldDeviceDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceListDto
 */
export interface EldDeviceListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceListDto
     */
    'assignedByMaster'?: boolean;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceListDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceListDtoPagedResultDto
 */
export interface EldDeviceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceListDto>}
     * @memberof EldDeviceListDtoPagedResultDto
     */
    'items'?: Array<EldDeviceListDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceMessageDto
 */
export interface EldDeviceMessageDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceMessageDtoPagedResultDto
 */
export interface EldDeviceMessageDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceMessageDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceMessageDto>}
     * @memberof EldDeviceMessageDtoPagedResultDto
     */
    'items'?: Array<EldDeviceMessageDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceParsedMessageDto
 */
export interface EldDeviceParsedMessageDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EldDeviceParsedMessageDto
     */
    'parsedMessage'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceParsedMessageDto
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'utcTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageByDaysDto
 */
export interface EldDeviceUsageByDaysDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageByDaysDto
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageByDaysDtoPagedResultDto
 */
export interface EldDeviceUsageByDaysDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageByDaysDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceUsageByDaysDto>}
     * @memberof EldDeviceUsageByDaysDtoPagedResultDto
     */
    'items'?: Array<EldDeviceUsageByDaysDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageHistoryInputDto
 */
export interface EldDeviceUsageHistoryInputDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryInputDto
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryInputDto
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageHistoryListDto
 */
export interface EldDeviceUsageHistoryListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageOutputDto
 */
export interface EldDeviceUsageOutputDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageOutputDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageOutputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageOutputDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageOutputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageOutputDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageOutputDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageOutputDto
     */
    'numberOfDays'?: number;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceUsageOutputDto
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceUsageOutputDto
     */
    'customerOwned'?: boolean;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageOutputDtoPagedResultDto
 */
export interface EldDeviceUsageOutputDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageOutputDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceUsageOutputDto>}
     * @memberof EldDeviceUsageOutputDtoPagedResultDto
     */
    'items'?: Array<EldDeviceUsageOutputDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageReportInput
 */
export interface EldDeviceUsageReportInput {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'tenantId'?: string;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceUsageReportInput
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceUsageReportInput
     */
    'customerOwned'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageReportInput
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageReportInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceUsageReportInput
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceUsageReportInput
     */
    'used'?: boolean | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof EldDeviceUsageReportInput
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EldDeviceUsageType = {
    MasterAssignedToTenant: 'MasterAssignedToTenant',
    TenantAssignedToVehicle: 'TenantAssignedToVehicle',
    TenantUnassignedFromVehicle: 'TenantUnassignedFromVehicle',
    MasterUnassignedFromTenant: 'MasterUnassignedFromTenant',
    TenantAssignedToInactiveVehicle: 'TenantAssignedToInactiveVehicle'
} as const;

export type EldDeviceUsageType = typeof EldDeviceUsageType[keyof typeof EldDeviceUsageType];


/**
 * 
 * @export
 * @interface EldDisconnection
 */
export interface EldDisconnection {
    /**
     * 
     * @type {number}
     * @memberof EldDisconnection
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnection
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'disconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'reconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnection
     */
    'disconnectMinutes'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDisconnection
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldDisconnection
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnection
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnection
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDisconnectionListDto
 */
export interface EldDisconnectionListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDisconnectionListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'customDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDisconnectionListDto
     */
    'isConnectedNow'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'currentVehicleLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'lastDisconnectedDurationMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDisconnectionListDtoPagedResultDto
 */
export interface EldDisconnectionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDisconnectionListDto>}
     * @memberof EldDisconnectionListDtoPagedResultDto
     */
    'items'?: Array<EldDisconnectionListDto> | null;
}
/**
 * 
 * @export
 * @interface EldEventsReportInput
 */
export interface EldEventsReportInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof EldEventsReportInput
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof EldEventsReportInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface EldFileExportDto
 */
export interface EldFileExportDto {
    /**
     * 
     * @type {boolean}
     * @memberof EldFileExportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'timeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'timeTo'?: string;
    /**
     * 
     * @type {ExportStatus}
     * @memberof EldFileExportDto
     */
    'status'?: ExportStatus;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'creatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'creatorSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldFileExportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldFileExportDtoPagedResultDto
 */
export interface EldFileExportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldFileExportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldFileExportDto>}
     * @memberof EldFileExportDtoPagedResultDto
     */
    'items'?: Array<EldFileExportDto> | null;
}
/**
 * 
 * @export
 * @interface EldFileImportDto
 */
export interface EldFileImportDto {
    /**
     * 
     * @type {string}
     * @memberof EldFileImportDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ImportStatus}
     * @memberof EldFileImportDto
     */
    'status'?: ImportStatus;
    /**
     * 
     * @type {Array<EldFileImportFileDataDto>}
     * @memberof EldFileImportDto
     */
    'eldFiles'?: Array<EldFileImportFileDataDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldFileImportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldFileImportDtoPagedResultDto
 */
export interface EldFileImportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldFileImportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldFileImportDto>}
     * @memberof EldFileImportDtoPagedResultDto
     */
    'items'?: Array<EldFileImportDto> | null;
}
/**
 * 
 * @export
 * @interface EldFileImportFileDataDto
 */
export interface EldFileImportFileDataDto {
    /**
     * 
     * @type {Array<EldFileImportFileVehicleDataDto>}
     * @memberof EldFileImportFileDataDto
     */
    'vehicles'?: Array<EldFileImportFileVehicleDataDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldFileImportFileDataDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'suggestedDriverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'suggestedLicenseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'suggestedState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldFileImportFileDataDto
     */
    'hasEvents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldFileImportFileDataDto
     */
    'overwriteEvents'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'importDateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'importDateTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileDataDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldFileImportFileVehicleDataDto
 */
export interface EldFileImportFileVehicleDataDto {
    /**
     * 
     * @type {number}
     * @memberof EldFileImportFileVehicleDataDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileVehicleDataDto
     */
    'suggestedVin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileVehicleDataDto
     */
    'suggestedName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportFileVehicleDataDto
     */
    'vehicleOrderNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface EldFileImportListDto
 */
export interface EldFileImportListDto {
    /**
     * 
     * @type {ImportStatus}
     * @memberof EldFileImportListDto
     */
    'importStatus'?: ImportStatus;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'creatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'creatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'creatorSurname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof EldFileImportListDto
     */
    'filesCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'errorCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldFileImportListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldFileImportListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldFileImportListDtoPagedResultDto
 */
export interface EldFileImportListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldFileImportListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldFileImportListDto>}
     * @memberof EldFileImportListDtoPagedResultDto
     */
    'items'?: Array<EldFileImportListDto> | null;
}
/**
 * 
 * @export
 * @interface EldMalfunctionOrDataDiagnostic
 */
export interface EldMalfunctionOrDataDiagnostic {
    /**
     * 
     * @type {number}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'malfunctionOrDiagnostic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'isCleared'?: boolean;
}
/**
 * 
 * @export
 * @interface EldMalfunctionOrDataDiagnosticPagedResultDto
 */
export interface EldMalfunctionOrDataDiagnosticPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldMalfunctionOrDataDiagnosticPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldMalfunctionOrDataDiagnostic>}
     * @memberof EldMalfunctionOrDataDiagnosticPagedResultDto
     */
    'items'?: Array<EldMalfunctionOrDataDiagnostic> | null;
}
/**
 * 
 * @export
 * @interface EngineOnEventDataDto
 */
export interface EngineOnEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof EngineOnEventDataDto
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof EngineOnEventDataDto
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EngineOnEventDataDto
     */
    'totalEngineHours'?: number | null;
}
/**
 * 
 * @export
 * @interface EntityCycleRules
 */
export interface EntityCycleRules {
    /**
     * 
     * @type {number}
     * @memberof EntityCycleRules
     */
    'drivingCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCycleRules
     */
    'cycleRuleId'?: number;
}
/**
 * 
 * @export
 * @interface EntityExtensionDto
 */
export interface EntityExtensionDto {
    /**
     * 
     * @type {{ [key: string]: ExtensionPropertyDto; }}
     * @memberof EntityExtensionDto
     */
    'properties'?: { [key: string]: ExtensionPropertyDto; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EntityExtensionDto
     */
    'configuration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'coDriverUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'dutyStatusId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'cycleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'recordOriginator'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'motorCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof Event
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof Event
     */
    'eventRecordOrigin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {EventType}
     * @memberof Event
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'distanceSinceLastValidCoordinates'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventDataCheckValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'timeZoneOffset'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'driverLicenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'bearing'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof Event
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {CompanyState}
     * @memberof Event
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'terminalStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'mileageSinceEventStarted'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'originalDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof Event
     */
    'totalVehicleMilesSource'?: OdometerSource | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'dvirId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof Event
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'personalUseOrYardMoveActivationUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'personalUseOrYardMoveSessionUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'personalUseOrYardMoveDeactivationUUID'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Event
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EventErrorInfo
 */
export interface EventErrorInfo {
    /**
     * 
     * @type {number}
     * @memberof EventErrorInfo
     */
    'eventId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'ianaTimeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EventLocationSource = {
    ManualInput: 'ManualInput',
    SelectedFromMap: 'SelectedFromMap',
    None: 'None'
} as const;

export type EventLocationSource = typeof EventLocationSource[keyof typeof EventLocationSource];


/**
 * 
 * @export
 * @interface EventManipulationSyncOutputItemDto
 */
export interface EventManipulationSyncOutputItemDto {
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'operation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'driverUsername'?: string | null;
}
/**
 * 
 * @export
 * @interface EventPreferenceDto
 */
export interface EventPreferenceDto {
    /**
     * 
     * @type {number}
     * @memberof EventPreferenceDto
     */
    'eventId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventPreferenceDto
     */
    'urgent'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EventRecordOrigin = {
    AutomaticallyRecordedByEld: 'AutomaticallyRecordedByEld',
    EditedOrEnteredByTheDriver: 'EditedOrEnteredByTheDriver',
    EditRequestedByAnAuthenticatedUserOtherThanTheDriver: 'EditRequestedByAnAuthenticatedUserOtherThanTheDriver',
    AssumedFromUnidentifiedDriverProfile: 'AssumedFromUnidentifiedDriverProfile'
} as const;

export type EventRecordOrigin = typeof EventRecordOrigin[keyof typeof EventRecordOrigin];


/**
 * 
 * @export
 * @enum {string}
 */

export const EventRecordStatus = {
    Active: 'Active',
    InactiveChanged: 'InactiveChanged',
    InactiveChangeRequested: 'InactiveChangeRequested',
    InactiveChangeRejected: 'InactiveChangeRejected'
} as const;

export type EventRecordStatus = typeof EventRecordStatus[keyof typeof EventRecordStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EventType = {
    ChangeInDriversDutyStatus: 'ChangeInDriversDutyStatus',
    IntermediateLog: 'IntermediateLog',
    ChangeInDriversIndicationOfAuthorizedPersonalUseOfCmvOrYardMoves: 'ChangeInDriversIndicationOfAuthorizedPersonalUseOfCmvOrYardMoves',
    DriversCertificationOrRecertificationOfRecords: 'DriversCertificationOrRecertificationOfRecords',
    DriversLoginOrLogoutActivity: 'DriversLoginOrLogoutActivity',
    CmvEnginePowerUpOrShutDownActivity: 'CmvEnginePowerUpOrShutDownActivity',
    MalfunctionOrDataDiagnosticDetectionOccurrence: 'MalfunctionOrDataDiagnosticDetectionOccurrence',
    Custom: 'Custom'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];


/**
 * 
 * @export
 * @interface EventTypeCode
 */
export interface EventTypeCode {
    /**
     * 
     * @type {EventType}
     * @memberof EventTypeCode
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof EventTypeCode
     */
    'eventCode'?: number;
}
/**
 * 
 * @export
 * @interface EventViewDto
 */
export interface EventViewDto {
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'realStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'durationInSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'realDurationInSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'locationDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'engineMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'origin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isBasic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {EventType}
     * @memberof EventViewDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'coDriverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'shippingDocuments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'realEndTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'averageSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'eventSequenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'nextDayFirstEventOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isEventMissingPowerUp'?: boolean;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof EventViewDto
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'personalUseOrYardMoveSessionUUID'?: string | null;
}
/**
 * 
 * @export
 * @interface ExceptionViewDto
 */
export interface ExceptionViewDto {
    /**
     * 
     * @type {number}
     * @memberof ExceptionViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExceptionViewDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExceptionViewDto
     */
    'exception'?: string | null;
}
/**
 * 
 * @export
 * @interface ExportDriversInputDto
 */
export interface ExportDriversInputDto {
    /**
     * 
     * @type {string}
     * @memberof ExportDriversInputDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExportDriversInputDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ExportDriversInputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExportDriversInputDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ExportDriversInputDto
     */
    'status'?: RecordStatus | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ExportDriversInputDto
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @interface ExportFilterInputDto
 */
export interface ExportFilterInputDto {
    /**
     * 
     * @type {number}
     * @memberof ExportFilterInputDto
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportFilterInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExportFilterInputDto
     */
    'exportFormat'?: string | null;
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ExportFilterInputDto
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ExportFilterInputDto
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ExportFilterInputDto
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ExportLocationsInputDto
 */
export interface ExportLocationsInputDto {
    /**
     * 
     * @type {string}
     * @memberof ExportLocationsInputDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExportLocationsInputDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExportLocationsInputDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExportLocationsInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExportLocationsInputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ExportLocationsInputDto
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExportStatus = {
    Created: 'Created',
    Exporting: 'Exporting',
    Succeeded: 'Succeeded',
    Failed: 'Failed'
} as const;

export type ExportStatus = typeof ExportStatus[keyof typeof ExportStatus];


/**
 * 
 * @export
 * @interface ExportTrailersInputDto
 */
export interface ExportTrailersInputDto {
    /**
     * 
     * @type {string}
     * @memberof ExportTrailersInputDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ExportTrailersInputDto
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExportTrailersInputDto
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ExportVehiclesInputDto
 */
export interface ExportVehiclesInputDto {
    /**
     * 
     * @type {string}
     * @memberof ExportVehiclesInputDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExportVehiclesInputDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {ApiAppCompanyGetFilteredListPostRequest}
     * @memberof ExportVehiclesInputDto
     */
    'filter'?: ApiAppCompanyGetFilteredListPostRequest | null;
}
/**
 * 
 * @export
 * @interface ExtensionEnumDto
 */
export interface ExtensionEnumDto {
    /**
     * 
     * @type {Array<ExtensionEnumFieldDto>}
     * @memberof ExtensionEnumDto
     */
    'fields'?: Array<ExtensionEnumFieldDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionEnumDto
     */
    'localizationResource'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionEnumFieldDto
 */
export interface ExtensionEnumFieldDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionEnumFieldDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ExtensionEnumFieldDto
     */
    'value'?: any | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiCreateDto
 */
export interface ExtensionPropertyApiCreateDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiCreateDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDto
 */
export interface ExtensionPropertyApiDto {
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnGet}
     * @memberof ExtensionPropertyApiDto
     */
    'onGet'?: ExtensionPropertyApiDtoOnGet | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnCreate}
     * @memberof ExtensionPropertyApiDto
     */
    'onCreate'?: ExtensionPropertyApiDtoOnCreate | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnUpdate}
     * @memberof ExtensionPropertyApiDto
     */
    'onUpdate'?: ExtensionPropertyApiDtoOnUpdate | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnCreate
 */
export interface ExtensionPropertyApiDtoOnCreate {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnCreate
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnGet
 */
export interface ExtensionPropertyApiDtoOnGet {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnGet
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnUpdate
 */
export interface ExtensionPropertyApiDtoOnUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnUpdate
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiGetDto
 */
export interface ExtensionPropertyApiGetDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiGetDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiUpdateDto
 */
export interface ExtensionPropertyApiUpdateDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiUpdateDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyAttributeDto
 */
export interface ExtensionPropertyAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyAttributeDto
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExtensionPropertyAttributeDto
     */
    'config'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDto
 */
export interface ExtensionPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDto
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {ExtensionPropertyDtoDisplayName}
     * @memberof ExtensionPropertyDto
     */
    'displayName'?: ExtensionPropertyDtoDisplayName | null;
    /**
     * 
     * @type {ExtensionPropertyDtoApi}
     * @memberof ExtensionPropertyDto
     */
    'api'?: ExtensionPropertyDtoApi | null;
    /**
     * 
     * @type {ExtensionPropertyDtoUi}
     * @memberof ExtensionPropertyDto
     */
    'ui'?: ExtensionPropertyDtoUi | null;
    /**
     * 
     * @type {Array<ExtensionPropertyAttributeDto>}
     * @memberof ExtensionPropertyDto
     */
    'attributes'?: Array<ExtensionPropertyAttributeDto> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExtensionPropertyDto
     */
    'configuration'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {any}
     * @memberof ExtensionPropertyDto
     */
    'defaultValue'?: any | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoApi
 */
export interface ExtensionPropertyDtoApi {
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnGet}
     * @memberof ExtensionPropertyDtoApi
     */
    'onGet'?: ExtensionPropertyApiDtoOnGet | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnCreate}
     * @memberof ExtensionPropertyDtoApi
     */
    'onCreate'?: ExtensionPropertyApiDtoOnCreate | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnUpdate}
     * @memberof ExtensionPropertyDtoApi
     */
    'onUpdate'?: ExtensionPropertyApiDtoOnUpdate | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoDisplayName
 */
export interface ExtensionPropertyDtoDisplayName {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDtoDisplayName
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDtoDisplayName
     */
    'resource'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoUi
 */
export interface ExtensionPropertyDtoUi {
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnTable}
     * @memberof ExtensionPropertyDtoUi
     */
    'onTable'?: ExtensionPropertyUiDtoOnTable | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyDtoUi
     */
    'onCreateForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyDtoUi
     */
    'onEditForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoLookup}
     * @memberof ExtensionPropertyDtoUi
     */
    'lookup'?: ExtensionPropertyUiDtoLookup | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDto
 */
export interface ExtensionPropertyUiDto {
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnTable}
     * @memberof ExtensionPropertyUiDto
     */
    'onTable'?: ExtensionPropertyUiDtoOnTable | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyUiDto
     */
    'onCreateForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyUiDto
     */
    'onEditForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoLookup}
     * @memberof ExtensionPropertyUiDto
     */
    'lookup'?: ExtensionPropertyUiDtoLookup | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoLookup
 */
export interface ExtensionPropertyUiDtoLookup {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'resultListPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'displayPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'valuePropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'filterParamName'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoOnCreateForm
 */
export interface ExtensionPropertyUiDtoOnCreateForm {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiDtoOnCreateForm
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoOnTable
 */
export interface ExtensionPropertyUiDtoOnTable {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiDtoOnTable
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiFormDto
 */
export interface ExtensionPropertyUiFormDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiFormDto
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiLookupDto
 */
export interface ExtensionPropertyUiLookupDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'resultListPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'displayPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'valuePropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'filterParamName'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiTableDto
 */
export interface ExtensionPropertyUiTableDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiTableDto
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface FeatureDto
 */
export interface FeatureDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {FeatureDtoProvider}
     * @memberof FeatureDto
     */
    'provider'?: FeatureDtoProvider | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {FeatureDtoValueType}
     * @memberof FeatureDto
     */
    'valueType'?: FeatureDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof FeatureDto
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'parentName'?: string | null;
}
/**
 * 
 * @export
 * @interface FeatureDtoProvider
 */
export interface FeatureDtoProvider {
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoProvider
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoProvider
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface FeatureDtoValueType
 */
export interface FeatureDtoValueType {
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoValueType
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FeatureDtoValueType
     */
    'properties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {IStringValueTypeValidator}
     * @memberof FeatureDtoValueType
     */
    'validator'?: IStringValueTypeValidator | null;
}
/**
 * 
 * @export
 * @interface FeatureGroupDto
 */
export interface FeatureGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<FeatureDto>}
     * @memberof FeatureGroupDto
     */
    'features'?: Array<FeatureDto> | null;
}
/**
 * 
 * @export
 * @interface FeatureProviderDto
 */
export interface FeatureProviderDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureProviderDto
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldPermissionEntityGroupDto
 */
export interface FieldPermissionEntityGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionEntityGroupDto
     */
    'group'?: string | null;
    /**
     * 
     * @type {Array<FieldPermissionGrantDto>}
     * @memberof FieldPermissionEntityGroupDto
     */
    'permissions'?: Array<FieldPermissionGrantDto> | null;
}
/**
 * 
 * @export
 * @interface FieldPermissionGrantDto
 */
export interface FieldPermissionGrantDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionGrantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {ProtectedFieldLevel}
     * @memberof FieldPermissionGrantDto
     */
    'fieldAccessLevel'?: ProtectedFieldLevel;
}
/**
 * 
 * @export
 * @interface FieldPermissionGroupDto
 */
export interface FieldPermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionGroupDto
     */
    'entity'?: string | null;
    /**
     * 
     * @type {Array<FieldPermissionEntityGroupDto>}
     * @memberof FieldPermissionGroupDto
     */
    'groups'?: Array<FieldPermissionEntityGroupDto> | null;
}
/**
 * 
 * @export
 * @interface FilterBaseInput
 */
export interface FilterBaseInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FilterBaseInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FilterBaseInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterBaseInput
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface FilterInputDto
 */
export interface FilterInputDto {
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof FilterInputDto
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof FilterInputDto
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDto
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FilterInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface FilterInputDtoFilterRule
 */
export interface FilterInputDtoFilterRule {
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'operator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'condition'?: string | null;
    /**
     * 
     * @type {Array<FilterRule>}
     * @memberof FilterInputDtoFilterRule
     */
    'filterRules'?: Array<FilterRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilterInputDtoFilterRule
     */
    'isNestedRule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterInputDtoFilterRule
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface FilterInputDtoSearchRule
 */
export interface FilterInputDtoSearchRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterInputDtoSearchRule
     */
    'columns'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoSearchRule
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface FilterRule
 */
export interface FilterRule {
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'operator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'condition'?: string | null;
    /**
     * 
     * @type {Array<FilterRule>}
     * @memberof FilterRule
     */
    'filterRules'?: Array<FilterRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilterRule
     */
    'isNestedRule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterRule
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface FilteredHarshEventBaseInput
 */
export interface FilteredHarshEventBaseInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FilteredHarshEventBaseInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FilteredHarshEventBaseInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilteredHarshEventBaseInput
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof FilteredHarshEventBaseInput
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilteredHarshEventBaseInput
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface FindTenantResultDto
 */
export interface FindTenantResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof FindTenantResultDto
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindTenantResultDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindTenantResultDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FindTenantResultDto
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FixEventsDirection = {
    FromLastEvent: 'FromLastEvent',
    FromFirstEvent: 'FromFirstEvent'
} as const;

export type FixEventsDirection = typeof FixEventsDirection[keyof typeof FixEventsDirection];


/**
 * 
 * @export
 * @interface FixEventsInputDto
 */
export interface FixEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixEngineHours'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixSequenceNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixOdometer'?: boolean;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof FixEventsInputDto
     */
    'fixDirection': FixEventsDirection;
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'endEvent': number;
}
/**
 * 
 * @export
 * @interface FleetManager
 */
export interface FleetManager {
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FleetManager
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof FleetManager
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManager
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManager
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'companies'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof FleetManager
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManager
     */
    'autoProvisioned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'autoProvisionProvider'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManager
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FleetManager
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManager
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FleetManager
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FleetManagerDto
 */
export interface FleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<CompanyDto>}
     * @memberof FleetManagerDto
     */
    'companies'?: Array<CompanyDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof FleetManagerDto
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof FleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FleetManagerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FleetManagerDtoPagedResultDto
 */
export interface FleetManagerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FleetManagerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FleetManagerDto>}
     * @memberof FleetManagerDtoPagedResultDto
     */
    'items'?: Array<FleetManagerDto> | null;
}
/**
 * 
 * @export
 * @interface FleetManagerListDto
 */
export interface FleetManagerListDto {
    /**
     * 
     * @type {RecordStatus}
     * @memberof FleetManagerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'companies'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FleetManagerListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'fleetManagerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerListDto
     */
    'autoProvisioned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'autoProvisionProvider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FleetManagerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FleetManagerListDtoPagedResultDto
 */
export interface FleetManagerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FleetManagerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FleetManagerListDto>}
     * @memberof FleetManagerListDtoPagedResultDto
     */
    'items'?: Array<FleetManagerListDto> | null;
}
/**
 * 
 * @export
 * @interface FlowApiClientDto
 */
export interface FlowApiClientDto {
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientDto
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof FlowApiClientDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof FlowApiClientDto
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof FlowApiClientDto
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FlowApiClientDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FlowApiClientDtoPagedResultDto
 */
export interface FlowApiClientDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FlowApiClientDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FlowApiClientDto>}
     * @memberof FlowApiClientDtoPagedResultDto
     */
    'items'?: Array<FlowApiClientDto> | null;
}
/**
 * 
 * @export
 * @interface FlowApiClientListDto
 */
export interface FlowApiClientListDto {
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientListDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FlowApiClientListDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FlowApiClientListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlowApiClientListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FlowApiClientListDtoPagedResultDto
 */
export interface FlowApiClientListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FlowApiClientListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FlowApiClientListDto>}
     * @memberof FlowApiClientListDtoPagedResultDto
     */
    'items'?: Array<FlowApiClientListDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaCredentialsDto
 */
export interface FmcsaCredentialsDto {
    /**
     * 
     * @type {string}
     * @memberof FmcsaCredentialsDto
     */
    'key': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaCredentialsDto
     */
    'os': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface FmcsaEldFileOutputDto
 */
export interface FmcsaEldFileOutputDto {
    /**
     * 
     * @type {string}
     * @memberof FmcsaEldFileOutputDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEldFileOutputDto
     */
    'fileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaEmailTransferInput
 */
export interface FmcsaEmailTransferInput {
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'recipientOverride'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'fmcsaSenderNameOverride'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaEmailTransferInput
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionDto
 */
export interface FmcsaInspectionDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'eldFileUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaInspectionDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionDtoPagedResultDto
 */
export interface FmcsaInspectionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FmcsaInspectionDto>}
     * @memberof FmcsaInspectionDtoPagedResultDto
     */
    'items'?: Array<FmcsaInspectionDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionListDto
 */
export interface FmcsaInspectionListDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionListDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'time'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionListDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionListDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionListDtoPagedResultDto
 */
export interface FmcsaInspectionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FmcsaInspectionListDto>}
     * @memberof FmcsaInspectionListDtoPagedResultDto
     */
    'items'?: Array<FmcsaInspectionListDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionManualCreateInputDto
 */
export interface FmcsaInspectionManualCreateInputDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'timeOfReport': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'eldFileComment': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'mobileApplicationType': MobileApplicationType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FmcsaInspectionReportType = {
    Bluetooth: 'Bluetooth',
    Usb: 'USB',
    Web: 'Web',
    Email: 'Email',
    TestWeb: 'TestWeb',
    TestEmail: 'TestEmail',
    RoadsideInspectionOnly: 'RoadsideInspectionOnly'
} as const;

export type FmcsaInspectionReportType = typeof FmcsaInspectionReportType[keyof typeof FmcsaInspectionReportType];


/**
 * 
 * @export
 * @interface FmcsaMobileCredentials
 */
export interface FmcsaMobileCredentials {
    /**
     * 
     * @type {string}
     * @memberof FmcsaMobileCredentials
     */
    'certificatePassword'?: string | null;
    /**
     * 
     * @type {{ [key: string]: SmtpConfiguration; }}
     * @memberof FmcsaMobileCredentials
     */
    'mailServerSettings'?: { [key: string]: SmtpConfiguration; } | null;
}
/**
 * 
 * @export
 * @interface FmcsaOptions
 */
export interface FmcsaOptions {
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptions
     */
    'eldId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptions
     */
    'eldRegId'?: string | null;
    /**
     * 
     * @type {FmcsaOptionsSettings}
     * @memberof FmcsaOptions
     */
    'settings'?: FmcsaOptionsSettings | null;
    /**
     * 
     * @type {{ [key: string]: FmcsaOptions; }}
     * @memberof FmcsaOptions
     */
    'clients'?: { [key: string]: FmcsaOptions; } | null;
}
/**
 * 
 * @export
 * @interface FmcsaOptionsSettings
 */
export interface FmcsaOptionsSettings {
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaServerCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificatePassword'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaSettings
 */
export interface FmcsaSettings {
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaServerCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificatePassword'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaTransferInput
 */
export interface FmcsaTransferInput {
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaTransferInput
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface FormattedSensorValue
 */
export interface FormattedSensorValue {
    /**
     * 
     * @type {any}
     * @memberof FormattedSensorValue
     */
    'value'?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormattedSensorValue
     */
    'isNormal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormattedSensorValue
     */
    'unit'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueType}
     * @memberof FormattedSensorValue
     */
    'valueType'?: VehicleSensorAttributeValueType;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByActionDto
 */
export interface FuelConsumptionByActionDto {
    /**
     * 
     * @type {Array<FuelEconomyAction>}
     * @memberof FuelConsumptionByActionDto
     */
    'actions'?: Array<FuelEconomyAction> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByPeriodDto
 */
export interface FuelConsumptionByPeriodDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByPeriodDto
     */
    'values'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByTimeOfDayDto
 */
export interface FuelConsumptionByTimeOfDayDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'morningValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'afternoonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'nightValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionCardsDto
 */
export interface FuelConsumptionCardsDto {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionCardsDto
     */
    'value'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionCardsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionCardsDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FuelConsumptionCardsDto
     */
    'isGrowing'?: boolean;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDto
 */
export interface FuelConsumptionEfficiencyDto {
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'speedingConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency | null;
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'normalDriveConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency | null;
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'slowPacedConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelEconomyAction
 */
export interface FuelEconomyAction {
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyAction
     */
    'action'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FuelEconomyAction
     */
    'currentPeriod'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelEconomyAction
     */
    'previousPeriod'?: number;
}
/**
 * 
 * @export
 * @interface FuelEconomyInput
 */
export interface FuelEconomyInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FuelEconomyInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyInput
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface FuelProviderDto
 */
export interface FuelProviderDto {
    /**
     * 
     * @type {number}
     * @memberof FuelProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof FuelProviderDto
     */
    'status'?: RecordStatus;
    /**
     *
     * @type {number}
     * @memberof FuelProviderDto
     */
    'consecutiveFailureCount'?: number;
    /**
     *
     * @type {string}
     * @memberof FuelProviderDto
     */
    'lastFailureUtc'?: string | null;
    /**
     *
     * @type {string}
     * @memberof FuelProviderDto
     */
    'lastFailureReason'?: string | null;
    /**
     *
     * @type {string}
     * @memberof FuelProviderDto
     */
    'lastSuccessUtc'?: string | null;
    /**
     *
     * @type {string}
     * @memberof FuelProviderDto
     */
    'autoDisabledUtc'?: string | null;
    /**
     *
     * @type {string}
     * @memberof FuelProviderDto
     */
    'nextAttemptUtc'?: string | null;
    /**
     *
     * @type {ProviderDisabledBy}
     * @memberof FuelProviderDto
     */
    'disabledBy'?: ProviderDisabledBy | null;
    /**
     * 
     * @type {boolean}
     * @memberof FuelProviderDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof FuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface FuelProviderDtoPagedResultDto
 */
export interface FuelProviderDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FuelProviderDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FuelProviderDto>}
     * @memberof FuelProviderDtoPagedResultDto
     */
    'items'?: Array<FuelProviderDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FuelProviders = {
    Compass: 'Compass',
    Efs: 'EFS'
} as const;

export type FuelProviders = typeof FuelProviders[keyof typeof FuelProviders];

/**
 *
 * @export
 * @enum {string}
 */

export const ProviderDisabledBy = {
    User: 'User',
    System: 'System'
} as const;

export type ProviderDisabledBy = typeof ProviderDisabledBy[keyof typeof ProviderDisabledBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const FuelType = {
    Diesel: 'Diesel',
    Gasoline: 'Gasoline',
    Propane: 'Propane',
    LiquidNaturalGas: 'LiquidNaturalGas',
    CompressedNaturalGas: 'CompressedNaturalGas',
    Ethanol: 'Ethanol',
    Methanol: 'Methanol',
    E85: 'E85',
    M85: 'M85',
    A55: 'A55',
    Biodiesel: 'Biodiesel',
    Other: 'Other'
} as const;

export type FuelType = typeof FuelType[keyof typeof FuelType];


/**
 * 
 * @export
 * @interface GenerateOneTimeCodeInput
 */
export interface GenerateOneTimeCodeInput {
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeInput
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GenerateOneTimeCodeOutput
 */
export interface GenerateOneTimeCodeOutput {
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeOutput
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeOutput
     */
    'normalizedPhoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeolocationResultModel
 */
export interface GeolocationResultModel {
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeolocationResultModel
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeolocationResultModel
     */
    'bearing'?: number;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceCommandInput
 */
export interface GeometrisDeviceCommandInput {
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandInput
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceCommandOutput
 */
export interface GeometrisDeviceCommandOutput {
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisDeviceCommandOutput
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandOutput
     */
    'deviceCommandToken'?: string | null;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceInput
 */
export interface GeometrisDeviceInput {
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GeometrisEngineBusType = {
    Obd: 'Obd',
    J1939: 'J1939',
    Obd2: 'Obd2',
    J1708: 'J1708',
    AutoDetect: 'AutoDetect'
} as const;

export type GeometrisEngineBusType = typeof GeometrisEngineBusType[keyof typeof GeometrisEngineBusType];


/**
 * 
 * @export
 * @interface GeometrisEngineBusTypeInput
 */
export interface GeometrisEngineBusTypeInput {
    /**
     * 
     * @type {GeometrisEngineBusType}
     * @memberof GeometrisEngineBusTypeInput
     */
    'engineBusType'?: GeometrisEngineBusType;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEngineBusTypeInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisEvent
 */
export interface GeometrisEvent {
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'eldDeviceId'?: number;
    /**
     * 
     * @type {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GeometrisEvent
     */
    'eldDevice'?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {GeometrisEventLocation}
     * @memberof GeometrisEvent
     */
    'location'?: GeometrisEventLocation | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'measurements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'eventTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'eventDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'uniqueId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'locationAgeMin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'duration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'speed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'directionAlpha'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'odometer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'numSatellites'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'idleDuration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdEngineRPM'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdCoolant'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdSpeed'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'obdvin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdFuel'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdThrottle'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdmpg'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdTripMPG'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'obdInstantMPG'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'serializedInput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEvent
     */
    'sourceSystem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'sourceLocationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'sourceEventId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GeometrisEventLocation
 */
export interface GeometrisEventLocation {
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GeometrisEventLocation
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GeometrisEventLocation
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisEventLocation
     */
    'isDisconnectedDriving'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {CompanyState}
     * @memberof GeometrisEventLocation
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {LocationOrigin}
     * @memberof GeometrisEventLocation
     */
    'origin'?: LocationOrigin;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'reportedVehicleOdometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisEventLocation
     */
    'mileageFromEcu'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'tripMpg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'instantMpg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'totalFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'seatBeltUsage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'shiftedLocationId'?: number | null;
    /**
     * 
     * @type {LocationShiftedLocation}
     * @memberof GeometrisEventLocation
     */
    'shiftedLocation'?: LocationShiftedLocation | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'sourceSystem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'sourceLocationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'resolvedSpeedLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisEventLocation
     */
    'speedLimitUsedDefault'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'speedLimitDistanceMeters'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'speedLimitDatasetId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'speedLimitRoadClass'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'speedLimitEdgeId'?: number | null;
    /**
     * 
     * @type {SpeedLimitResolutionStatus}
     * @memberof GeometrisEventLocation
     */
    'speedLimitResolutionStatus'?: SpeedLimitResolutionStatus | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'speedLimitResolvedAtUtc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisEventLocation
     */
    'hasRoadMedia'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisEventLocation
     */
    'hasCabinMedia'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'aiEventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GeometrisEventLocation
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEventLocation
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeometrisEventLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GeometrisOdometerInput
 */
export interface GeometrisOdometerInput {
    /**
     * 
     * @type {number}
     * @memberof GeometrisOdometerInput
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisOdometerInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetDriverEventDto
 */
export interface GeometrisWidgetDriverEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverGivenId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetEventDto
 */
export interface GeometrisWidgetEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetEventDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetVehicleEventDto
 */
export interface GeometrisWidgetVehicleEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GetFeatureListResultDto
 */
export interface GetFeatureListResultDto {
    /**
     * 
     * @type {Array<FeatureGroupDto>}
     * @memberof GetFeatureListResultDto
     */
    'groups'?: Array<FeatureGroupDto> | null;
}
/**
 * 
 * @export
 * @interface GetPermissionListResultDto
 */
export interface GetPermissionListResultDto {
    /**
     * 
     * @type {string}
     * @memberof GetPermissionListResultDto
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<PermissionGroupDto>}
     * @memberof GetPermissionListResultDto
     */
    'groups'?: Array<PermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface GetSingleDocumentDto
 */
export interface GetSingleDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof GetSingleDocumentDto
     */
    'documentId': number;
    /**
     * 
     * @type {number}
     * @memberof GetSingleDocumentDto
     */
    'entityType': number;
}
/**
 * 
 * @export
 * @interface GetSystemNotificationsDto
 */
export interface GetSystemNotificationsDto {
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'notificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSystemNotificationsDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'notificationType'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSystemNotificationsDtoPagedResultDto
 */
export interface GetSystemNotificationsDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GetSystemNotificationsDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GetSystemNotificationsDto>}
     * @memberof GetSystemNotificationsDtoPagedResultDto
     */
    'items'?: Array<GetSystemNotificationsDto> | null;
}
/**
 * 
 * @export
 * @interface GetVehicleDriversInputDto
 */
export interface GetVehicleDriversInputDto {
    /**
     * 
     * @type {string}
     * @memberof GetVehicleDriversInputDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetVehicleDriversInputDto
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface GlobalSearchInputDto
 */
export interface GlobalSearchInputDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchInputDto
     */
    'searchText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeDrivers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeVehicles'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeTrailers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeEldDevices'?: boolean;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Group
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {Array<GroupFleetManager>}
     * @memberof Group
     */
    'groupFleetManagers'?: Array<GroupFleetManager> | null;
    /**
     * 
     * @type {Array<GroupVehicle>}
     * @memberof Group
     */
    'groupVehicles'?: Array<GroupVehicle> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupDriver
 */
export interface GroupDriver {
    /**
     * 
     * @type {number}
     * @memberof GroupDriver
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDriver
     */
    'groupId'?: number;
    /**
     * 
     * @type {GroupFleetManagerGroup}
     * @memberof GroupDriver
     */
    'group'?: GroupFleetManagerGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDriver
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof GroupDto
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DriverDto>}
     * @memberof GroupDto
     */
    'drivers'?: Array<DriverDto> | null;
    /**
     * 
     * @type {Array<VehicleDto>}
     * @memberof GroupDto
     */
    'vehicles'?: Array<VehicleDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupDtoPagedResultDto
 */
export interface GroupDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GroupDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GroupDto>}
     * @memberof GroupDtoPagedResultDto
     */
    'items'?: Array<GroupDto> | null;
}
/**
 * 
 * @export
 * @interface GroupFleetManager
 */
export interface GroupFleetManager {
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManager
     */
    'fleetManagerId'?: number;
    /**
     * 
     * @type {GroupFleetManagerFleetManager}
     * @memberof GroupFleetManager
     */
    'fleetManager'?: GroupFleetManagerFleetManager | null;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManager
     */
    'groupId'?: number;
    /**
     * 
     * @type {GroupFleetManagerGroup}
     * @memberof GroupFleetManager
     */
    'group'?: GroupFleetManagerGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManager
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupFleetManagerFleetManager
 */
export interface GroupFleetManagerFleetManager {
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManagerFleetManager
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GroupFleetManagerFleetManager
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFleetManagerFleetManager
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFleetManagerFleetManager
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'companies'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof GroupFleetManagerFleetManager
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFleetManagerFleetManager
     */
    'autoProvisioned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'autoProvisionProvider'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFleetManagerFleetManager
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GroupFleetManagerFleetManager
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerFleetManager
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManagerFleetManager
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupFleetManagerGroup
 */
export interface GroupFleetManagerGroup {
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManagerGroup
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GroupFleetManagerGroup
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {Array<GroupFleetManager>}
     * @memberof GroupFleetManagerGroup
     */
    'groupFleetManagers'?: Array<GroupFleetManager> | null;
    /**
     * 
     * @type {Array<GroupVehicle>}
     * @memberof GroupFleetManagerGroup
     */
    'groupVehicles'?: Array<GroupVehicle> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFleetManagerGroup
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupFleetManagerGroup
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupFleetManagerGroup
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupListDto
 */
export interface GroupListDto {
    /**
     * 
     * @type {string}
     * @memberof GroupListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupListDto
     */
    'creatorUserDisplayName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListDto
     */
    'driverNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListDto
     */
    'vehicleNames'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupListDtoPagedResultDto
 */
export interface GroupListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GroupListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GroupListDto>}
     * @memberof GroupListDtoPagedResultDto
     */
    'items'?: Array<GroupListDto> | null;
}
/**
 * 
 * @export
 * @interface GroupVehicle
 */
export interface GroupVehicle {
    /**
     * 
     * @type {number}
     * @memberof GroupVehicle
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof GroupVehicle
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof GroupVehicle
     */
    'groupId'?: number;
    /**
     * 
     * @type {GroupFleetManagerGroup}
     * @memberof GroupVehicle
     */
    'group'?: GroupFleetManagerGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GroupVehicle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GuidDropDownAppData
 */
export interface GuidDropDownAppData {
    /**
     * 
     * @type {string}
     * @memberof GuidDropDownAppData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidDropDownAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GuidUpdateManyInputDto
 */
export interface GuidUpdateManyInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GuidUpdateManyInputDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GuidUpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface HarshAccelerationEventsDto
 */
export interface HarshAccelerationEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshAccelerationEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshAccelerationEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshAccelerationEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshAccelerationEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshAccelerationEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshAccelerationEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshBreakingEventsDto
 */
export interface HarshBreakingEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshBreakingEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshBreakingEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshBreakingEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshBreakingEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshBreakingEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshBreakingEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshEventDailyLogDto
 */
export interface HarshEventDailyLogDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'morningValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'afternoonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'nightValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface HarshEventsBreakdownDto
 */
export interface HarshEventsBreakdownDto {
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshBraking'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshAcceleration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshTurn'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshStop'?: number;
}
/**
 * 
 * @export
 * @interface HarshEventsBreakdownInfoDto
 */
export interface HarshEventsBreakdownInfoDto {
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'activeDrivers'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshBraking'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshAcceleration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshTurn'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshStop'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'speeding'?: number;
}
/**
 * 
 * @export
 * @interface HarshSpeedingEventsDto
 */
export interface HarshSpeedingEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshSpeedingEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshSpeedingEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshSpeedingEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshSpeedingEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshSpeedingEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshSpeedingEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshStopEventsDto
 */
export interface HarshStopEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshStopEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshStopEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshStopEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshStopEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshStopEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshStopEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshTurnEventsDto
 */
export interface HarshTurnEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshTurnEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshTurnEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshTurnEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshTurnEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshTurnEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshTurnEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HosDetailsDto
 */
export interface HosDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDetailsDto
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDetailsDto
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface HosDriverDto
 */
export interface HosDriverDto {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'timeZoneOffset'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof HosDriverDto
     */
    'driverStatus'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverPhoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'vehicleNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'trailerNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'lastActivity'?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'lastPositionName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'lastPositionLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'lastPositionLong'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'violations'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'eldConnected'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eldDisconnectedSince'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDaysWorked'?: number;
    /**
     * 
     * @type {HosDriverDtoHosTimers}
     * @memberof HosDriverDto
     */
    'hosTimers'?: HosDriverDtoHosTimers | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface HosDriverDtoHosTimers
 */
export interface HosDriverDtoHosTimers {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'break'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'shiftDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'shiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'cycleDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'cycleWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'regularShiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'regularShiftDrive'?: number;
}
/**
 * 
 * @export
 * @interface HosDriverDtoPagedResultDto
 */
export interface HosDriverDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<HosDriverDto>}
     * @memberof HosDriverDtoPagedResultDto
     */
    'items'?: Array<HosDriverDto> | null;
}
/**
 * 
 * @export
 * @interface HosExceptionAppData
 */
export interface HosExceptionAppData {
    /**
     * 
     * @type {number}
     * @memberof HosExceptionAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosExceptionAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface HosTimers
 */
export interface HosTimers {
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'break'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'shiftDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'shiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'cycleDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'cycleWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'regularShiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'regularShiftDrive'?: number;
}
/**
 * 
 * @export
 * @interface IRemoteStreamContent
 */
export interface IRemoteStreamContent {
    /**
     * 
     * @type {string}
     * @memberof IRemoteStreamContent
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IRemoteStreamContent
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IRemoteStreamContent
     */
    'contentLength'?: number | null;
}
/**
 * 
 * @export
 * @interface IStringValueType
 */
export interface IStringValueType {
    /**
     * 
     * @type {string}
     * @memberof IStringValueType
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IStringValueType
     */
    'properties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {IStringValueTypeValidator}
     * @memberof IStringValueType
     */
    'validator'?: IStringValueTypeValidator | null;
}
/**
 * 
 * @export
 * @interface IStringValueTypeValidator
 */
export interface IStringValueTypeValidator {
    /**
     * 
     * @type {string}
     * @memberof IStringValueTypeValidator
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IStringValueTypeValidator
     */
    'properties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IValueValidator
 */
export interface IValueValidator {
    /**
     * 
     * @type {string}
     * @memberof IValueValidator
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IValueValidator
     */
    'properties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IanaTimeZone
 */
export interface IanaTimeZone {
    /**
     * 
     * @type {string}
     * @memberof IanaTimeZone
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface IdentityError
 */
export interface IdentityError {
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface IdentityResult
 */
export interface IdentityResult {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityResult
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {Array<IdentityError>}
     * @memberof IdentityResult
     */
    'errors'?: Array<IdentityError> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleCreateDto
 */
export interface IdentityRoleCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleCreateDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleCreateDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleCreateDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDto
 */
export interface IdentityRoleDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDtoListResultDto
 */
export interface IdentityRoleDtoListResultDto {
    /**
     * 
     * @type {Array<IdentityRoleDto>}
     * @memberof IdentityRoleDtoListResultDto
     */
    'items'?: Array<IdentityRoleDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDtoPagedResultDto
 */
export interface IdentityRoleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof IdentityRoleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<IdentityRoleDto>}
     * @memberof IdentityRoleDtoPagedResultDto
     */
    'items'?: Array<IdentityRoleDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleUpdateDto
 */
export interface IdentityRoleUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleUpdateDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleUpdateDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserCreateDto
 */
export interface IdentityUserCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserCreateDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserCreateDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserCreateDto
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserDto
 */
export interface IdentityUserDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'phoneNumberConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lockoutEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserDtoPagedResultDto
 */
export interface IdentityUserDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof IdentityUserDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<IdentityUserDto>}
     * @memberof IdentityUserDtoPagedResultDto
     */
    'items'?: Array<IdentityUserDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityUserUpdateDto
 */
export interface IdentityUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserUpdateDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserUpdateDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserUpdateDto
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserUpdateRolesDto
 */
export interface IdentityUserUpdateRolesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserUpdateRolesDto
     */
    'roleNames': Array<string>;
}
/**
 * 
 * @export
 * @interface IdleFuelConsumptionDto
 */
export interface IdleFuelConsumptionDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IdleFuelConsumptionDto
     */
    'currentValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof IdleFuelConsumptionDto
     */
    'previousValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface IdleReportInputDto
 */
export interface IdleReportInputDto {
    /**
     * 
     * @type {string}
     * @memberof IdleReportInputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdleReportInputDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof IdleReportInputDto
     */
    'periodType'?: PeriodType;
}
/**
 * 
 * @export
 * @interface IdlingEvent
 */
export interface IdlingEvent {
    /**
     * 
     * @type {string}
     * @memberof IdlingEvent
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdlingEvent
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingEvent
     */
    'duration'?: number | null;
    /**
     * 
     * @type {DutyType}
     * @memberof IdlingEvent
     */
    'dutyType'?: DutyType;
    /**
     * 
     * @type {number}
     * @memberof IdlingEvent
     */
    'eventCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof IdlingEvent
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IdlingEvent
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IdlingEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface IdlingFuelConsumption
 */
export interface IdlingFuelConsumption {
    /**
     * 
     * @type {string}
     * @memberof IdlingFuelConsumption
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdlingFuelConsumption
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'fuelOnStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'fuelOnEnd'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'totalFuelSpent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof IdlingFuelConsumption
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'driverId'?: number;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof IdlingFuelConsumption
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof IdlingFuelConsumption
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface IftaMileageReportInputDto
 */
export interface IftaMileageReportInputDto {
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof IftaMileageReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {FuelType}
     * @memberof IftaMileageReportInputDto
     */
    'fuelType'?: FuelType;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof IftaMileageReportInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof IftaMileageReportInputDto
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImportStatus = {
    Created: 'Created',
    Parsing: 'Parsing',
    ParsingFailed: 'ParsingFailed',
    ReadyToImport: 'ReadyToImport',
    Importing: 'Importing',
    ImportFailed: 'ImportFailed',
    ImportSuccess: 'ImportSuccess'
} as const;

export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];


/**
 * 
 * @export
 * @interface InspectionReportViewDto
 */
export interface InspectionReportViewDto {
    /**
     * 
     * @type {number}
     * @memberof InspectionReportViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionReportViewDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionReportViewDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InspectionReportViewDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InspectionReportViewDto
     */
    'defects'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionReportViewDto
     */
    'signed'?: boolean;
}
/**
 * 
 * @export
 * @interface Int32CommonDto
 */
export interface Int32CommonDto {
    /**
     * 
     * @type {number}
     * @memberof Int32CommonDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32CommonDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface Int32DropDownAppData
 */
export interface Int32DropDownAppData {
    /**
     * 
     * @type {number}
     * @memberof Int32DropDownAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32DropDownAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface Int32MultipleSelectedIds
 */
export interface Int32MultipleSelectedIds {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32MultipleSelectedIds
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Int32UpdateManyInputDto
 */
export interface Int32UpdateManyInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32UpdateManyInputDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Int32UpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface Int64UpdateManyInputDto
 */
export interface Int64UpdateManyInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int64UpdateManyInputDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Int64UpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface InvalidateMobileEventsInputDto
 */
export interface InvalidateMobileEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof InvalidateMobileEventsInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvalidateMobileEventsInputDto
     */
    'fromStartTime'?: string;
}
/**
 * 
 * @export
 * @interface LanguageInfo
 */
export interface LanguageInfo {
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'uiCultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'flagIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveTrackTokenDto
 */
export interface LiveTrackTokenDto {
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackTokenDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveTrackTokenDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveTrackTokenDtoPagedResultDto
 */
export interface LiveTrackTokenDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackTokenDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<LiveTrackTokenDto>}
     * @memberof LiveTrackTokenDtoPagedResultDto
     */
    'items'?: Array<LiveTrackTokenDto> | null;
}
/**
 * 
 * @export
 * @interface LiveTrackVehicleDto
 */
export interface LiveTrackVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Odometer}
     * @memberof LiveTrackVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {LiveTrackVehicleDtoCurrentLocation}
     * @memberof LiveTrackVehicleDto
     */
    'currentLocation'?: LiveTrackVehicleDtoCurrentLocation | null;
}
/**
 * 
 * @export
 * @interface LiveTrackVehicleDtoCurrentLocation
 */
export interface LiveTrackVehicleDtoCurrentLocation {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface LocalizableStringDto
 */
export interface LocalizableStringDto {
    /**
     * 
     * @type {string}
     * @memberof LocalizableStringDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalizableStringDto
     */
    'resource'?: string | null;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Location
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Location
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'isDisconnectedDriving'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {CompanyState}
     * @memberof Location
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {LocationOrigin}
     * @memberof Location
     */
    'origin'?: LocationOrigin;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'reportedVehicleOdometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'mileageFromEcu'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'tripMpg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'instantMpg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'totalFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'seatBeltUsage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'shiftedLocationId'?: number | null;
    /**
     * 
     * @type {LocationShiftedLocation}
     * @memberof Location
     */
    'shiftedLocation'?: LocationShiftedLocation | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'sourceSystem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'sourceLocationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'resolvedSpeedLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'speedLimitUsedDefault'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'speedLimitDistanceMeters'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'speedLimitDatasetId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'speedLimitRoadClass'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'speedLimitEdgeId'?: number | null;
    /**
     * 
     * @type {SpeedLimitResolutionStatus}
     * @memberof Location
     */
    'speedLimitResolutionStatus'?: SpeedLimitResolutionStatus | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'speedLimitResolvedAtUtc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'hasRoadMedia'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'hasCabinMedia'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'aiEventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Location
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface LocationHistoryDto
 */
export interface LocationHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {Array<LocationHistoryEntryDto>}
     * @memberof LocationHistoryDto
     */
    'locations'?: Array<LocationHistoryEntryDto> | null;
}
/**
 * 
 * @export
 * @interface LocationHistoryEntryDto
 */
export interface LocationHistoryEntryDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'lng'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'driverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'aiEventType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryEntryDto
     */
    'couldHaveVideoRoad'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryEntryDto
     */
    'couldHaveSnapshotRoad'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryEntryDto
     */
    'couldHaveVideoDriver'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryEntryDto
     */
    'couldHaveSnapshotDriver'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'snapshotRoadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'snapshotDriverUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'videoRoadUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'videoDriverUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'snapshotRoadMediaItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'snapshotDriverMediaItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'videoRoadMediaItemId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'videoDriverMediaItemId'?: string | null;
}
/**
 * 
 * @export
 * @interface LocationHistoryVehicleDto
 */
export interface LocationHistoryVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryVehicleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface LocationHistoryVehicleDtoPagedResultDto
 */
export interface LocationHistoryVehicleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryVehicleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<LocationHistoryVehicleDto>}
     * @memberof LocationHistoryVehicleDtoPagedResultDto
     */
    'items'?: Array<LocationHistoryVehicleDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LocationOrigin = {
    Unknown: 'Unknown',
    Eld: 'ELD',
    Geometris: 'Geometris'
} as const;

export type LocationOrigin = typeof LocationOrigin[keyof typeof LocationOrigin];


/**
 * 
 * @export
 * @interface LocationShiftedLocation
 */
export interface LocationShiftedLocation {
    /**
     * 
     * @type {number}
     * @memberof LocationShiftedLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationShiftedLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationShiftedLocation
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationShiftedLocation
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof LocationShiftedLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LoginResultType = {
    Success: 'Success',
    InvalidUserNameOrPassword: 'InvalidUserNameOrPassword',
    NotAllowed: 'NotAllowed',
    LockedOut: 'LockedOut',
    RequiresTwoFactor: 'RequiresTwoFactor'
} as const;

export type LoginResultType = typeof LoginResultType[keyof typeof LoginResultType];


/**
 * 
 * @export
 * @interface MaintenanceDashboardConfigurationDto
 */
export interface MaintenanceDashboardConfigurationDto {
    /**
     * 
     * @type {MaintenanceDashboardSaveType}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'saveType': MaintenanceDashboardSaveType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'maintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'vehicleMaintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'vehicleMaintenanceDashboardWidgetsConfiguration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MaintenanceDashboardSaveType = {
    Dashboard: 'Dashboard',
    VehicleDashboard: 'VehicleDashboard',
    VehicleWidgetsConfiguration: 'VehicleWidgetsConfiguration'
} as const;

export type MaintenanceDashboardSaveType = typeof MaintenanceDashboardSaveType[keyof typeof MaintenanceDashboardSaveType];


/**
 * 
 * @export
 * @interface MaintenanceDashboardVehicleDto
 */
export interface MaintenanceDashboardVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'mileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'eldDeviceSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driver'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driverName'?: string | null;
}
/**
 * 
 * @export
 * @interface MarkInspectionUnofficialInputDto
 */
export interface MarkInspectionUnofficialInputDto {
    /**
     * 
     * @type {string}
     * @memberof MarkInspectionUnofficialInputDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MarkInspectionUnofficialInputDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface MasterAppData
 */
export interface MasterAppData {
    /**
     * 
     * @type {Array<CountryAppData>}
     * @memberof MasterAppData
     */
    'countries'?: Array<CountryAppData> | null;
    /**
     * 
     * @type {{ [key: string]: EventTypeCode; }}
     * @memberof MasterAppData
     */
    'eventTypeCodes'?: { [key: string]: EventTypeCode; } | null;
    /**
     * 
     * @type {AppDataCurrentCompanyTimeZone}
     * @memberof MasterAppData
     */
    'currentCompanyTimeZone'?: AppDataCurrentCompanyTimeZone | null;
    /**
     * 
     * @type {AppDataUserPermissions}
     * @memberof MasterAppData
     */
    'userPermissions'?: AppDataUserPermissions | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterAppData
     */
    'masterAdminExclusivePermissions'?: Array<string> | null;
    /**
     * 
     * @type {Array<Int32DropDownAppData>}
     * @memberof MasterAppData
     */
    'companies'?: Array<Int32DropDownAppData> | null;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceDto
 */
export interface MasterEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof MasterEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof MasterEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceDtoPagedResultDto
 */
export interface MasterEldDeviceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterEldDeviceDto>}
     * @memberof MasterEldDeviceDtoPagedResultDto
     */
    'items'?: Array<MasterEldDeviceDto> | null;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceListDto
 */
export interface MasterEldDeviceListDto {
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'assignedToTenant'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof MasterEldDeviceListDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'hasNote'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceListDtoPagedResultDto
 */
export interface MasterEldDeviceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterEldDeviceListDto>}
     * @memberof MasterEldDeviceListDtoPagedResultDto
     */
    'items'?: Array<MasterEldDeviceListDto> | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResult
 */
export interface MasterFleetManagerCreateResult {
    /**
     * 
     * @type {MasterFleetManagerCreateResultFleetManager}
     * @memberof MasterFleetManagerCreateResult
     */
    'fleetManager'?: MasterFleetManagerCreateResultFleetManager | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResult
     */
    'setPasswordToken'?: string | null;
    /**
     * 
     * @type {MasterFleetManagerCreateResultUser}
     * @memberof MasterFleetManagerCreateResult
     */
    'user'?: MasterFleetManagerCreateResultUser | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResultFleetManager
 */
export interface MasterFleetManagerCreateResultFleetManager {
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'userId'?: string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResultUser
 */
export interface MasterFleetManagerCreateResultUser {
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'phoneNumberConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lockoutEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerDto
 */
export interface MasterFleetManagerDto {
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'userId'?: string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerDtoPagedResultDto
 */
export interface MasterFleetManagerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterFleetManagerDto>}
     * @memberof MasterFleetManagerDtoPagedResultDto
     */
    'items'?: Array<MasterFleetManagerDto> | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerListDto
 */
export interface MasterFleetManagerListDto {
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerListDtoPagedResultDto
 */
export interface MasterFleetManagerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterFleetManagerListDto>}
     * @memberof MasterFleetManagerListDtoPagedResultDto
     */
    'items'?: Array<MasterFleetManagerListDto> | null;
}
/**
 * 
 * @export
 * @interface MasterUploadedFileDto
 */
export interface MasterUploadedFileDto {
    /**
     * 
     * @type {string}
     * @memberof MasterUploadedFileDto
     */
    'processId'?: string;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof MasterUploadedFileDto
     */
    'fileData'?: Array<Array<string>> | null;
}
/**
 * 
 * @export
 * @interface MasterUserOverrideInput
 */
export interface MasterUserOverrideInput {
    /**
     * 
     * @type {string}
     * @memberof MasterUserOverrideInput
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterUserOverrideInput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface MasterUserOverrideOutput
 */
export interface MasterUserOverrideOutput {
    /**
     * 
     * @type {string}
     * @memberof MasterUserOverrideOutput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterUserOverrideOutput
     */
    'accessToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterUserOverrideOutput
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterUserOverrideOutput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MediaArchiveStatus = {
    Available: 'Available',
    Archived: 'Archived',
    RetrievalInProgress: 'RetrievalInProgress',
    RetrievalFailed: 'RetrievalFailed',
    Groomed: 'Groomed',
    RequestedFromDevice: 'RequestedFromDevice'
} as const;

export type MediaArchiveStatus = typeof MediaArchiveStatus[keyof typeof MediaArchiveStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaLifecycleState = {
    Live: 'Live',
    Archived: 'Archived',
    Groomed: 'Groomed',
    RetrievalPending: 'RetrievalPending',
    Retrieved: 'Retrieved',
    Unknown: 'Unknown'
} as const;

export type MediaLifecycleState = typeof MediaLifecycleState[keyof typeof MediaLifecycleState];


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaRequestAbortReason = {
    None: 'None',
    MediaTimeout: 'MediaTimeout',
    DeviceTimeout: 'DeviceTimeout',
    DeviceOffline: 'DeviceOffline',
    Superseded: 'Superseded',
    SystemError: 'SystemError',
    UserCancelled: 'UserCancelled',
    IngestionFailed: 'IngestionFailed',
    DuplicateVideoExists: 'DuplicateVideoExists',
    NoVideoAvailable: 'NoVideoAvailable',
    DeviceUploadError: 'DeviceUploadError',
    DeviceServerConnectionError: 'DeviceServerConnectionError'
} as const;

export type MediaRequestAbortReason = typeof MediaRequestAbortReason[keyof typeof MediaRequestAbortReason];


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaRequestStatus = {
    Queued: 'Queued',
    Requested: 'Requested',
    Polling: 'Polling',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    CommandSending: 'CommandSending',
    WaitingForMedia: 'WaitingForMedia',
    IngestedPendingVideo: 'IngestedPendingVideo',
    IngestedPendingDuration: 'IngestedPendingDuration'
} as const;

export type MediaRequestStatus = typeof MediaRequestStatus[keyof typeof MediaRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaRequestType = {
    Video: 'Video',
    Live: 'Live',
    ArchiveRestore: 'ArchiveRestore'
} as const;

export type MediaRequestType = typeof MediaRequestType[keyof typeof MediaRequestType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaType = {
    Video: 'Video',
    Snapshot: 'Snapshot'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];


/**
 * 
 * @export
 * @interface MethodParameterApiDescriptionModel
 */
export interface MethodParameterApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'typeAsString'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MethodParameterApiDescriptionModel
     */
    'isOptional'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof MethodParameterApiDescriptionModel
     */
    'defaultValue'?: any | null;
}
/**
 * 
 * @export
 * @interface MobileAppVersionDto
 */
export interface MobileAppVersionDto {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof MobileAppVersionDto
     */
    'mobileApplicationType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDto
     */
    'buildNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileAppVersionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MobileAppVersionDtoPagedResultDto
 */
export interface MobileAppVersionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MobileAppVersionDto>}
     * @memberof MobileAppVersionDtoPagedResultDto
     */
    'items'?: Array<MobileAppVersionDto> | null;
}
/**
 * 
 * @export
 * @interface MobileApplicationDto
 */
export interface MobileApplicationDto {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof MobileApplicationDto
     */
    'os'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof MobileApplicationDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileApplicationDto
     */
    'buildNumber'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MobileApplicationType = {
    None: 'None',
    Android: 'Android',
    AppleIos: 'AppleIos'
} as const;

export type MobileApplicationType = typeof MobileApplicationType[keyof typeof MobileApplicationType];


/**
 * 
 * @export
 * @interface MobileCreateTrailerDto
 */
export interface MobileCreateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof MobileCreateTrailerDto
     */
    'trailerType'?: TrailerType | null;
    /**
     * 
     * @type {number}
     * @memberof MobileCreateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MobileDeviceStatusPayload
 */
export interface MobileDeviceStatusPayload {
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'sdkLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'appVersionCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'coarseLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'fineLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'backgroundLocationPermission'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'storageSpace'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'status'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'connectedToEld'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceTime'?: string | null;
}
/**
 * 
 * @export
 * @interface MobileEventCreatorOutputDto
 */
export interface MobileEventCreatorOutputDto {
    /**
     * 
     * @type {string}
     * @memberof MobileEventCreatorOutputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventCreatorOutputDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventCreatorOutputDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface MobileEventOutputDto
 */
export interface MobileEventOutputDto {
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'coDriverUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {MobileEventOutputDtoCreator}
     * @memberof MobileEventOutputDto
     */
    'creator'?: MobileEventOutputDtoCreator | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'dutyStatusId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventRecordStatus'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventRecordOrigin'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventType'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'distanceSinceLastValidCoordinates'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileEventOutputDto
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventDataCheckValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'direction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileEventOutputDto
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalVehicleMilesSource'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eldSerialNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface MobileEventOutputDtoCreator
 */
export interface MobileEventOutputDtoCreator {
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDtoCreator
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDtoCreator
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDtoCreator
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface MobileEventOutputDtoPagedResultDto
 */
export interface MobileEventOutputDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MobileEventOutputDto>}
     * @memberof MobileEventOutputDtoPagedResultDto
     */
    'items'?: Array<MobileEventOutputDto> | null;
}
/**
 * 
 * @export
 * @interface ModuleApiDescriptionModel
 */
export interface ModuleApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ModuleApiDescriptionModel
     */
    'rootPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleApiDescriptionModel
     */
    'remoteServiceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: ControllerApiDescriptionModel; }}
     * @memberof ModuleApiDescriptionModel
     */
    'controllers'?: { [key: string]: ControllerApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ModuleExtensionDto
 */
export interface ModuleExtensionDto {
    /**
     * 
     * @type {{ [key: string]: EntityExtensionDto; }}
     * @memberof ModuleExtensionDto
     */
    'entities'?: { [key: string]: EntityExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ModuleExtensionDto
     */
    'configuration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MultiTenancyInfoDto
 */
export interface MultiTenancyInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof MultiTenancyInfoDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MultiTenancySides = {
    Tenant: 'Tenant',
    Host: 'Host',
    Both: 'Both'
} as const;

export type MultiTenancySides = typeof MultiTenancySides[keyof typeof MultiTenancySides];


/**
 * 
 * @export
 * @interface NameValue
 */
export interface NameValue {
    /**
     * 
     * @type {string}
     * @memberof NameValue
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameValue
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface NextDutyStatusEventDto
 */
export interface NextDutyStatusEventDto {
    /**
     * 
     * @type {number}
     * @memberof NextDutyStatusEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NextDutyStatusEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof NextDutyStatusEventDto
     */
    'odometer'?: number | null;
}
/**
 * 
 * @export
 * @interface NormalDriveConsumptionEfficiencyDto
 */
export interface NormalDriveConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationSubject = {
    Driver: 'Driver',
    Vehicle: 'Vehicle',
    Trailer: 'Trailer',
    Company: 'Company',
    Other: 'Other'
} as const;

export type NotificationSubject = typeof NotificationSubject[keyof typeof NotificationSubject];


/**
 * 
 * @export
 * @interface NotificationSubscriptionDto
 */
export interface NotificationSubscriptionDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'name': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof NotificationSubscriptionDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'sendWindowStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'sendWindowEndTime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionDto
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionDto
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<EventPreferenceDto>; }}
     * @memberof NotificationSubscriptionDto
     */
    'eventPreferences'?: { [key: string]: Array<EventPreferenceDto>; } | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationSubscriptionDto
     */
    'selectedDrivers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationSubscriptionDto
     */
    'selectedVehicles'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'isAllDriversSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'isAllVehiclesSelected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionDtoPagedResultDto
 */
export interface NotificationSubscriptionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<NotificationSubscriptionDto>}
     * @memberof NotificationSubscriptionDtoPagedResultDto
     */
    'items'?: Array<NotificationSubscriptionDto> | null;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionListDto
 */
export interface NotificationSubscriptionListDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionListDto
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionListDto
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof NotificationSubscriptionListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionListDtoPagedResultDto
 */
export interface NotificationSubscriptionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<NotificationSubscriptionListDto>}
     * @memberof NotificationSubscriptionListDtoPagedResultDto
     */
    'items'?: Array<NotificationSubscriptionListDto> | null;
}
/**
 * 
 * @export
 * @interface NotificationTypeDto
 */
export interface NotificationTypeDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationTypeDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {NotificationSubject}
     * @memberof NotificationTypeDto
     */
    'subject'?: NotificationSubject;
    /**
     * 
     * @type {number}
     * @memberof NotificationTypeDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ObjectExtensionsDto
 */
export interface ObjectExtensionsDto {
    /**
     * 
     * @type {{ [key: string]: ModuleExtensionDto; }}
     * @memberof ObjectExtensionsDto
     */
    'modules'?: { [key: string]: ModuleExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: ExtensionEnumDto; }}
     * @memberof ObjectExtensionsDto
     */
    'enums'?: { [key: string]: ExtensionEnumDto; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Odometer = {
    Kilometers: 'Kilometers',
    Miles: 'Miles'
} as const;

export type Odometer = typeof Odometer[keyof typeof Odometer];


/**
 * 
 * @export
 * @enum {string}
 */

export const OdometerSource = {
    EnteredManually: 'EnteredManually',
    RecordedFromEld: 'RecordedFromELD'
} as const;

export type OdometerSource = typeof OdometerSource[keyof typeof OdometerSource];


/**
 * 
 * @export
 * @interface OnDutyOffDutyIdleTimeSpentDto
 */
export interface OnDutyOffDutyIdleTimeSpentDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof OnDutyOffDutyIdleTimeSpentDto
     */
    'onDutyValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof OnDutyOffDutyIdleTimeSpentDto
     */
    'offDutyValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Ownership = {
    Company: 'Company',
    Contractor: 'Contractor',
    Leased: 'Leased'
} as const;

export type Ownership = typeof Ownership[keyof typeof Ownership];


/**
 * 
 * @export
 * @interface ParameterApiDescriptionModel
 */
export interface ParameterApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'nameOnMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'jsonName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterApiDescriptionModel
     */
    'isOptional'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ParameterApiDescriptionModel
     */
    'defaultValue'?: any | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParameterApiDescriptionModel
     */
    'constraintTypes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'bindingSourceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'descriptorName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodType = {
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type PeriodType = typeof PeriodType[keyof typeof PeriodType];


/**
 * 
 * @export
 * @interface PermissionGrantInfoDto
 */
export interface PermissionGrantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'parentName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionGrantInfoDto
     */
    'isGranted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionGrantInfoDto
     */
    'allowedProviders'?: Array<string> | null;
    /**
     * 
     * @type {Array<ProviderInfoDto>}
     * @memberof PermissionGrantInfoDto
     */
    'grantedProviders'?: Array<ProviderInfoDto> | null;
}
/**
 * 
 * @export
 * @interface PermissionGroupDto
 */
export interface PermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<PermissionGrantInfoDto>}
     * @memberof PermissionGroupDto
     */
    'permissions'?: Array<PermissionGrantInfoDto> | null;
}
/**
 * 
 * @export
 * @interface PermissionListResultDto
 */
export interface PermissionListResultDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionListResultDto
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGroupDto>}
     * @memberof PermissionListResultDto
     */
    'actionPermissionGroups'?: Array<ActionPermissionGroupDto> | null;
    /**
     * 
     * @type {Array<FieldPermissionGroupDto>}
     * @memberof PermissionListResultDto
     */
    'fieldPermissionGroups'?: Array<FieldPermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'isExternal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'hasPassword'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProfileDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PropertyApiDescriptionModel
 */
export interface PropertyApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'jsonName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyApiDescriptionModel
     */
    'isRequired'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProtectedFieldLevel = {
    Full: 'Full',
    ReadOnly: 'ReadOnly',
    Hidden: 'Hidden'
} as const;

export type ProtectedFieldLevel = typeof ProtectedFieldLevel[keyof typeof ProtectedFieldLevel];


/**
 * 
 * @export
 * @interface ProviderInfoDto
 */
export interface ProviderInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ProviderInfoDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderInfoDto
     */
    'providerKey'?: string | null;
}
/**
 * 
 * @export
 * @interface PublicApiRedirectionDto
 */
export interface PublicApiRedirectionDto {
    /**
     * 
     * @type {boolean}
     * @memberof PublicApiRedirectionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {PublicApiRedirectionStatus}
     * @memberof PublicApiRedirectionDto
     */
    'status'?: PublicApiRedirectionStatus;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'callerClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'proxyClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'callbackUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PublicApiRedirectionDtoPagedResultDto
 */
export interface PublicApiRedirectionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof PublicApiRedirectionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<PublicApiRedirectionDto>}
     * @memberof PublicApiRedirectionDtoPagedResultDto
     */
    'items'?: Array<PublicApiRedirectionDto> | null;
}
/**
 * 
 * @export
 * @interface PublicApiRedirectionListDto
 */
export interface PublicApiRedirectionListDto {
    /**
     * 
     * @type {boolean}
     * @memberof PublicApiRedirectionListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {PublicApiRedirectionStatus}
     * @memberof PublicApiRedirectionListDto
     */
    'status'?: PublicApiRedirectionStatus;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'proxyClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PublicApiRedirectionListDtoPagedResultDto
 */
export interface PublicApiRedirectionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof PublicApiRedirectionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<PublicApiRedirectionListDto>}
     * @memberof PublicApiRedirectionListDtoPagedResultDto
     */
    'items'?: Array<PublicApiRedirectionListDto> | null;
}
/**
 * 
 * @export
 * @interface PublicApiRedirectionProxyCredentialsDto
 */
export interface PublicApiRedirectionProxyCredentialsDto {
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionProxyCredentialsDto
     */
    'redirectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionProxyCredentialsDto
     */
    'proxyClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicApiRedirectionProxyCredentialsDto
     */
    'proxyClientSecret'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PublicApiRedirectionRequestStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    Denied: 'Denied'
} as const;

export type PublicApiRedirectionRequestStatus = typeof PublicApiRedirectionRequestStatus[keyof typeof PublicApiRedirectionRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const PublicApiRedirectionStatus = {
    Pending: 'Pending',
    Active: 'Active'
} as const;

export type PublicApiRedirectionStatus = typeof PublicApiRedirectionStatus[keyof typeof PublicApiRedirectionStatus];


/**
 * 
 * @export
 * @interface PublicLiveTrackTokenDto
 */
export interface PublicLiveTrackTokenDto {
    /**
     * 
     * @type {string}
     * @memberof PublicLiveTrackTokenDto
     */
    'token'?: string | null;
}
/**
 * 
 * @export
 * @interface QuickSearchListDto
 */
export interface QuickSearchListDto {
    /**
     * 
     * @type {Array<DriverQuickSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'drivers'?: Array<DriverQuickSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'vehicles'?: Array<BaseSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'trailers'?: Array<BaseSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'eldSerialNumbers'?: Array<BaseSearchListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RankStatus = {
    Up: 'Up',
    Down: 'Down',
    Idle: 'Idle'
} as const;

export type RankStatus = typeof RankStatus[keyof typeof RankStatus];


/**
 * 
 * @export
 * @interface RawLiveTrackEvent
 */
export interface RawLiveTrackEvent {
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'deviceTimestamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'lat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'lng'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ReassignEventsInputDto
 */
export interface ReassignEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'endEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'driverId': number;
}
/**
 * 
 * @export
 * @interface ReassignTenantInputDto
 */
export interface ReassignTenantInputDto {
    /**
     * 
     * @type {string}
     * @memberof ReassignTenantInputDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReassignTenantInputDto
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface RebuildCycleFromEventInputDto
 */
export interface RebuildCycleFromEventInputDto {
    /**
     * 
     * @type {number}
     * @memberof RebuildCycleFromEventInputDto
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface RebuildCycleInputDto
 */
export interface RebuildCycleInputDto {
    /**
     * 
     * @type {string}
     * @memberof RebuildCycleInputDto
     */
    'cycleId': string;
}
/**
 * 
 * @export
 * @interface RecentDriverViolationDto
 */
export interface RecentDriverViolationDto {
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'violationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'homeTerminalTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface RecentViolationDto
 */
export interface RecentViolationDto {
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecentViolationDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentViolationDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDto
     */
    'violationsCount'?: number;
    /**
     * 
     * @type {Array<RecentDriverViolationDto>}
     * @memberof RecentViolationDto
     */
    'violations'?: Array<RecentDriverViolationDto> | null;
}
/**
 * 
 * @export
 * @interface RecentViolationDtoPagedResultDto
 */
export interface RecentViolationDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RecentViolationDto>}
     * @memberof RecentViolationDtoPagedResultDto
     */
    'items'?: Array<RecentViolationDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecordStatus = {
    Inactive: 'Inactive',
    Active: 'Active'
} as const;

export type RecordStatus = typeof RecordStatus[keyof typeof RecordStatus];


/**
 * 
 * @export
 * @interface RegenerateIntermediatesInputDto
 */
export interface RegenerateIntermediatesInputDto {
    /**
     * 
     * @type {number}
     * @memberof RegenerateIntermediatesInputDto
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'appName': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RegisterDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorInfo
 */
export interface RemoteServiceErrorInfo {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'details'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RemoteServiceErrorInfo
     */
    'data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<RemoteServiceValidationErrorInfo>}
     * @memberof RemoteServiceErrorInfo
     */
    'validationErrors'?: Array<RemoteServiceValidationErrorInfo> | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorResponse
 */
export interface RemoteServiceErrorResponse {
    /**
     * 
     * @type {RemoteServiceErrorResponseError}
     * @memberof RemoteServiceErrorResponse
     */
    'error'?: RemoteServiceErrorResponseError | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorResponseError
 */
export interface RemoteServiceErrorResponseError {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'details'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RemoteServiceErrorResponseError
     */
    'data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<RemoteServiceValidationErrorInfo>}
     * @memberof RemoteServiceErrorResponseError
     */
    'validationErrors'?: Array<RemoteServiceValidationErrorInfo> | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceValidationErrorInfo
 */
export interface RemoteServiceValidationErrorInfo {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceValidationErrorInfo
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoteServiceValidationErrorInfo
     */
    'members'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ReportDailylogreportPostRequest
 */
export interface ReportDailylogreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'graphHtml'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDailylogreportPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDailylogreportPostRequest
     */
    'showAllEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface ReportDailylogsreportPostRequest
 */
export interface ReportDailylogsreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDailylogsreportPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {DailyLogsDownloadFormat}
     * @memberof ReportDailylogsreportPostRequest
     */
    'downloadFormat'?: DailyLogsDownloadFormat;
}
/**
 * 
 * @export
 * @interface ReportDto
 */
export interface ReportDto {
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'requestedTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'requestedByUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'fileLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportInput'?: string | null;
    /**
     * 
     * @type {ReportStatus}
     * @memberof ReportDto
     */
    'status'?: ReportStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ReportDtoPagedResultDto
 */
export interface ReportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ReportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ReportDto>}
     * @memberof ReportDtoPagedResultDto
     */
    'items'?: Array<ReportDto> | null;
}
/**
 * 
 * @export
 * @interface ReportDvirinspectionsreportPostRequest
 */
export interface ReportDvirinspectionsreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface ReportElddeviceusagereportPostRequest
 */
export interface ReportElddeviceusagereportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {DeviceType}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'customerOwned'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'numberOfDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'used'?: boolean | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportElddeviceusagereportPostRequest
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @interface ReportEldeventsreportPostRequest
 */
export interface ReportEldeventsreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportEldeventsreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportEldeventsreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportFormat = {
    Pdf: 'Pdf',
    Csv: 'Csv'
} as const;

export type ReportFormat = typeof ReportFormat[keyof typeof ReportFormat];


/**
 * 
 * @export
 * @interface ReportIftamileagereportPostRequest
 */
export interface ReportIftamileagereportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportIftamileagereportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {FuelType}
     * @memberof ReportIftamileagereportPostRequest
     */
    'fuelType'?: FuelType;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportIftamileagereportPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportIftamileagereportPostRequest
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @interface ReportSafetyreportPostRequest
 */
export interface ReportSafetyreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportSafetyreportPostRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportSafetyreportPostRequest
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof ReportSafetyreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportSafetyreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportSafetyreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportSafetyreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportSafetyreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportStatus = {
    Pending: 'Pending',
    Successful: 'Successful',
    Failed: 'Failed'
} as const;

export type ReportStatus = typeof ReportStatus[keyof typeof ReportStatus];


/**
 * 
 * @export
 * @interface ReportUnidentifiedeventsreportPostRequest
 */
export interface ReportUnidentifiedeventsreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportUnidentifiedeventsreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportVehicledistancereportPostRequest
 */
export interface ReportVehicledistancereportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportVehicleinactivityreportPostRequest
 */
export interface ReportVehicleinactivityreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportVehiclemileagesummaryreportPostRequest
 */
export interface ReportVehiclemileagesummaryreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestPublicApiRedirectionInputDto
 */
export interface RequestPublicApiRedirectionInputDto {
    /**
     * 
     * @type {string}
     * @memberof RequestPublicApiRedirectionInputDto
     */
    'apiClientName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestPublicApiRedirectionInputDto
     */
    'companyId'?: number;
}
/**
 * 
 * @export
 * @interface RequestPublicApiRedirectionResultDto
 */
export interface RequestPublicApiRedirectionResultDto {
    /**
     * 
     * @type {string}
     * @memberof RequestPublicApiRedirectionResultDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPublicApiRedirectionResultDto
     */
    'redirectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPublicApiRedirectionResultDto
     */
    'callerApiClientEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPublicApiRedirectionResultDto
     */
    'callerClientId'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestVideoUploadInputDto
 */
export interface RequestVideoUploadInputDto {
    /**
     * 
     * @type {CameraPosition}
     * @memberof RequestVideoUploadInputDto
     */
    'position'?: CameraPosition | null;
    /**
     * 
     * @type {number}
     * @memberof RequestVideoUploadInputDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestVideoUploadInputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestVideoUploadInputDto
     */
    'durationSeconds'?: number;
}
/**
 * 
 * @export
 * @interface RequestVideoUploadPostRequest
 */
export interface RequestVideoUploadPostRequest {
    /**
     * 
     * @type {CameraPosition}
     * @memberof RequestVideoUploadPostRequest
     */
    'position'?: CameraPosition | null;
    /**
     * 
     * @type {number}
     * @memberof RequestVideoUploadPostRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestVideoUploadPostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestVideoUploadPostRequest
     */
    'durationSeconds'?: number;
}
/**
 * 
 * @export
 * @interface ResetPasswordByEmailDto
 */
export interface ResetPasswordByEmailDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'resetToken': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResetTwoFactorAuthenticationSettingsInputDto
 */
export interface ResetTwoFactorAuthenticationSettingsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ResetTwoFactorAuthenticationSettingsInputDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ResizeEventInputDto
 */
export interface ResizeEventInputDto {
    /**
     * 
     * @type {number}
     * @memberof ResizeEventInputDto
     */
    'eventId': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeEventInputDto
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeEventInputDto
     */
    'durationAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ResolveDisconnectedDrivingInputDto
 */
export interface ResolveDisconnectedDrivingInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ResolveDisconnectedDrivingInputDto
     */
    'locationIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ResolveDvirDefectDto
 */
export interface ResolveDvirDefectDto {
    /**
     * 
     * @type {number}
     * @memberof ResolveDvirDefectDto
     */
    'defectId'?: number;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof ResolveDvirDefectDto
     */
    'isCorrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveDvirDefectDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ResolvedObd2Code
 */
export interface ResolvedObd2Code {
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'partCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'partName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'systemCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'systemName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'number'?: string | null;
}
/**
 * 
 * @export
 * @interface ReturnValueApiDescriptionModel
 */
export interface ReturnValueApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ReturnValueApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReturnValueApiDescriptionModel
     */
    'typeSimple'?: string | null;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'actionPermissions'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'fieldPermissions'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isAssigned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface RoleDtoPagedResultDto
 */
export interface RoleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RoleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof RoleDtoPagedResultDto
     */
    'items'?: Array<RoleDto> | null;
}
/**
 * 
 * @export
 * @interface RoleListDto
 */
export interface RoleListDto {
    /**
     * 
     * @type {string}
     * @memberof RoleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isAssigned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface RoleListDtoPagedResultDto
 */
export interface RoleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RoleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RoleListDto>}
     * @memberof RoleListDtoPagedResultDto
     */
    'items'?: Array<RoleListDto> | null;
}
/**
 * 
 * @export
 * @interface RolloverInputDto
 */
export interface RolloverInputDto {
    /**
     * 
     * @type {number}
     * @memberof RolloverInputDto
     */
    'fromDriverId': number;
    /**
     * 
     * @type {number}
     * @memberof RolloverInputDto
     */
    'toCoDriverId': number;
}
/**
 * 
 * @export
 * @interface RootActionPermissionGroup
 */
export interface RootActionPermissionGroup {
    /**
     * 
     * @type {RootActionPermissionGroupGroup}
     * @memberof RootActionPermissionGroup
     */
    'group'?: RootActionPermissionGroupGroup | null;
    /**
     * 
     * @type {Array<ActionPermissionGroup>}
     * @memberof RootActionPermissionGroup
     */
    'permissionGroups'?: Array<ActionPermissionGroup> | null;
}
/**
 * 
 * @export
 * @interface RootActionPermissionGroupGroup
 */
export interface RootActionPermissionGroupGroup {
    /**
     * 
     * @type {string}
     * @memberof RootActionPermissionGroupGroup
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RootActionPermissionGroupGroup
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface SafetyAlertListDto
 */
export interface SafetyAlertListDto {
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof SafetyAlertListDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface SafetyAlertListDtoListResultDto
 */
export interface SafetyAlertListDtoListResultDto {
    /**
     * 
     * @type {Array<SafetyAlertListDto>}
     * @memberof SafetyAlertListDtoListResultDto
     */
    'items'?: Array<SafetyAlertListDto> | null;
}
/**
 * 
 * @export
 * @interface SafetyDashboardDriverDto
 */
export interface SafetyDashboardDriverDto {
    /**
     * 
     * @type {number}
     * @memberof SafetyDashboardDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof SafetyDashboardDriverDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SafetyDashboardDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'vehicle'?: string | null;
}
/**
 * 
 * @export
 * @interface SafetyReportInputDto
 */
export interface SafetyReportInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof SafetyReportInputDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof SafetyReportInputDto
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof SafetyReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof SafetyReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SafetyReportInputDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyReportInputDto
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveNotificationPreferenceDto
 */
export interface SaveNotificationPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationPreferenceDto
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveNotificationPreferenceDto
     */
    'notificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface SaveSingleUserNotificationPreferenceDto
 */
export interface SaveSingleUserNotificationPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'trailerId'?: number | null;
}
/**
 * 
 * @export
 * @interface SaveUserLastReadNotificationDto
 */
export interface SaveUserLastReadNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof SaveUserLastReadNotificationDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveUserLastReadNotificationDto
     */
    'lastReadNotificationTime': string;
}
/**
 * 
 * @export
 * @interface SearchRule
 */
export interface SearchRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRule
     */
    'columns'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRule
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface SendPasswordResetCodeDto
 */
export interface SendPasswordResetCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'appName': string;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'returnUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'returnUrlHash'?: string | null;
}
/**
 * 
 * @export
 * @interface SensorAttribute
 */
export interface SensorAttribute {
    /**
     * 
     * @type {string}
     * @memberof SensorAttribute
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorAttribute
     */
    'units'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorAttribute
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorAttribute
     */
    'geometrisCapability'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SensorAttribute
     */
    'minValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SensorAttribute
     */
    'maxValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SensorAttribute
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ServiceAccountCreationInputDto
 */
export interface ServiceAccountCreationInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceAccountCreationInputDto
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @interface ServiceRemindersDto
 */
export interface ServiceRemindersDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceRemindersDto
     */
    'overdue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceRemindersDto
     */
    'soon'?: number;
}
/**
 * 
 * @export
 * @interface SetDrivingNoteInputDto
 */
export interface SetDrivingNoteInputDto {
    /**
     * 
     * @type {number}
     * @memberof SetDrivingNoteInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetDrivingNoteInputDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetDrivingNoteInputDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ShiftEventsDirection = {
    Past: 'Past',
    Future: 'Future'
} as const;

export type ShiftEventsDirection = typeof ShiftEventsDirection[keyof typeof ShiftEventsDirection];


/**
 * 
 * @export
 * @interface ShiftEventsInputDto
 */
export interface ShiftEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ShiftEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftEventsInputDto
     */
    'endEvent': number;
    /**
     * 
     * @type {ShiftEventsDirection}
     * @memberof ShiftEventsInputDto
     */
    'direction': ShiftEventsDirection;
    /**
     * 
     * @type {string}
     * @memberof ShiftEventsInputDto
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftEventsInputDto
     */
    'timeAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ShiftHosViolation
 */
export interface ShiftHosViolation {
    /**
     * 
     * @type {string}
     * @memberof ShiftHosViolation
     */
    'driverShiftId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShiftHosViolation
     */
    'causedByEventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof ShiftHosViolation
     */
    'causedByEvent'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {string}
     * @memberof ShiftHosViolation
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShiftHosViolation
     */
    'endTime'?: string;
    /**
     * 
     * @type {ViolationType}
     * @memberof ShiftHosViolation
     */
    'violationType'?: ViolationType;
    /**
     * 
     * @type {ViolationClass}
     * @memberof ShiftHosViolation
     */
    'violationClass'?: ViolationClass;
    /**
     * 
     * @type {string}
     * @memberof ShiftHosViolation
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ShiftedLocation
 */
export interface ShiftedLocation {
    /**
     * 
     * @type {number}
     * @memberof ShiftedLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShiftedLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShiftedLocation
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShiftedLocation
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShiftedLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SignatureDto
 */
export interface SignatureDto {
    /**
     * 
     * @type {number}
     * @memberof SignatureDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SignatureDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureDto
     */
    'signatureBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface SingleDeviceUsageDetail
 */
export interface SingleDeviceUsageDetail {
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'startTime'?: string;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof SingleDeviceUsageDetail
     */
    'usageType'?: EldDeviceUsageType;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface SlowPacedConsumptionEfficiencyDto
 */
export interface SlowPacedConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface SmartFixEventsInputDto
 */
export interface SmartFixEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof SmartFixEventsInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof SmartFixEventsInputDto
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof SmartFixEventsInputDto
     */
    'to': string;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof SmartFixEventsInputDto
     */
    'fixEventsDirection': FixEventsDirection;
}
/**
 * 
 * @export
 * @interface SmtpConfiguration
 */
export interface SmtpConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'server'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SmtpConfiguration
     */
    'port'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'senderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'defaultSenderAddress'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SpeedLimitResolutionStatus = {
    NotAttempted: 'NotAttempted',
    Disabled: 'Disabled',
    InvalidInput: 'InvalidInput',
    NoMatch: 'NoMatch',
    Success: 'Success',
    Failed: 'Failed'
} as const;

export type SpeedLimitResolutionStatus = typeof SpeedLimitResolutionStatus[keyof typeof SpeedLimitResolutionStatus];


/**
 * 
 * @export
 * @interface SpeedingConsumptionEfficiencyDto
 */
export interface SpeedingConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface SpeedingDto
 */
export interface SpeedingDto {
    /**
     * 
     * @type {string}
     * @memberof SpeedingDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SpeedingDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpeedingDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpeedingDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SpeedingDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SpeedingDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface SplitSleeperBreakEvent
 */
export interface SplitSleeperBreakEvent {
    /**
     * 
     * @type {string}
     * @memberof SplitSleeperBreakEvent
     */
    'driverShiftId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SplitSleeperBreakEvent
     */
    'eventId'?: number;
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof SplitSleeperBreakEvent
     */
    'event'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {SplitSleeperBreakType}
     * @memberof SplitSleeperBreakEvent
     */
    'breakType'?: SplitSleeperBreakType;
    /**
     * 
     * @type {boolean}
     * @memberof SplitSleeperBreakEvent
     */
    'isSecondBreak'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SplitSleeperBreakEvent
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitSleeperBreakEvent
     */
    'shiftDriveTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SplitSleeperBreakEvent
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SplitSleeperBreakType = {
    Short: 'Short',
    Long: 'Long'
} as const;

export type SplitSleeperBreakType = typeof SplitSleeperBreakType[keyof typeof SplitSleeperBreakType];


/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof State
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface StateAppData
 */
export interface StateAppData {
    /**
     * 
     * @type {string}
     * @memberof StateAppData
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StateAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StateAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'icon'?: string | null;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof StateDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof StateDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface StateDtoCountry
 */
export interface StateDtoCountry {
    /**
     * 
     * @type {string}
     * @memberof StateDtoCountry
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateDtoCountry
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StateDtoCountry
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface StateGeolocationResultModel
 */
export interface StateGeolocationResultModel {
    /**
     * 
     * @type {string}
     * @memberof StateGeolocationResultModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateGeolocationResultModel
     */
    'abbreviation'?: string | null;
}
/**
 * 
 * @export
 * @interface StringUpdateManyInputDto
 */
export interface StringUpdateManyInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringUpdateManyInputDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof StringUpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Suspension = {
    Air: 'Air',
    Spring: 'Spring'
} as const;

export type Suspension = typeof Suspension[keyof typeof Suspension];


/**
 * 
 * @export
 * @interface SystemNotificationDto
 */
export interface SystemNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'notificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemNotificationDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemNotificationDto
     */
    'isRead'?: boolean;
}
/**
 * 
 * @export
 * @interface SystemNotificationResultDto
 */
export interface SystemNotificationResultDto {
    /**
     * 
     * @type {Array<SystemNotificationDto>}
     * @memberof SystemNotificationResultDto
     */
    'items'?: Array<SystemNotificationDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemNotificationResultDto
     */
    'hasMore'?: boolean;
}
/**
 * 
 * @export
 * @interface TelematicsInputBatchDto
 */
export interface TelematicsInputBatchDto {
    /**
     * 
     * @type {Array<TelematicsInputDto>}
     * @memberof TelematicsInputBatchDto
     */
    'items'?: Array<TelematicsInputDto> | null;
}
/**
 * 
 * @export
 * @interface TelematicsInputDto
 */
export interface TelematicsInputDto {
    /**
     * 
     * @type {string}
     * @memberof TelematicsInputDto
     */
    'event'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TelematicsInputDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TelematicsInputDto
     */
    'eventTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'vehicleBatteryVoltage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'speedInMph'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'headingDegrees'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'odometerMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'bleClientState'?: number;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'ecuSpeedInMph'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'ecuOdometerMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'cumulativeFuelEconomy'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'tripFuelEconomy'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TelematicsInputDto
     */
    'currentFuelEconomy'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TelematicsInputDto
     */
    'dtcCodes'?: string | null;
}
/**
 * 
 * @export
 * @interface Tenant
 */
export interface Tenant {
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<TenantConnectionString>}
     * @memberof Tenant
     */
    'connectionStrings'?: Array<TenantConnectionString> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Tenant
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Tenant
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface TenantAppData
 */
export interface TenantAppData {
    /**
     * 
     * @type {string}
     * @memberof TenantAppData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantAppData
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAppData
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantConnectionString
 */
export interface TenantConnectionString {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionString
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionString
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionString
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantCreateDto
 */
export interface TenantCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'adminPassword': string;
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TenantDtoPagedResultDto
 */
export interface TenantDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantDto>}
     * @memberof TenantDtoPagedResultDto
     */
    'items'?: Array<TenantDto> | null;
}
/**
 * 
 * @export
 * @interface TenantEldDeviceViewDto
 */
export interface TenantEldDeviceViewDto {
    /**
     * 
     * @type {string}
     * @memberof TenantEldDeviceViewDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEldDeviceViewDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEldDeviceViewDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantEldDeviceViewDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TenantEldDeviceViewDtoPagedResultDto
 */
export interface TenantEldDeviceViewDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantEldDeviceViewDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantEldDeviceViewDto>}
     * @memberof TenantEldDeviceViewDtoPagedResultDto
     */
    'items'?: Array<TenantEldDeviceViewDto> | null;
}
/**
 * 
 * @export
 * @interface TenantExportEntity
 */
export interface TenantExportEntity {
    /**
     * 
     * @type {string}
     * @memberof TenantExportEntity
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantExportEntity
     */
    'link'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TenantExportEntity
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface TenantExportJobDto
 */
export interface TenantExportJobDto {
    /**
     * 
     * @type {string}
     * @memberof TenantExportJobDto
     */
    'jobId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantExportJobDto
     */
    'tenantId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantExportJobStatus = {
    Pending: 'Pending',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed',
    ReadyForUse: 'ReadyForUse'
} as const;

export type TenantExportJobStatus = typeof TenantExportJobStatus[keyof typeof TenantExportJobStatus];


/**
 * 
 * @export
 * @interface TenantExportProgressDto
 */
export interface TenantExportProgressDto {
    /**
     * 
     * @type {TenantExportJobStatus}
     * @memberof TenantExportProgressDto
     */
    'status'?: TenantExportJobStatus;
    /**
     * 
     * @type {number}
     * @memberof TenantExportProgressDto
     */
    'itemsExported'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantExportProgressDto
     */
    'totalItemsToExport'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantExportProgressDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantExportProgressDto
     */
    'lastStatusChangeTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantExportProgressDto
     */
    'currentEntity'?: string | null;
    /**
     * 
     * @type {Array<TenantExportEntity>}
     * @memberof TenantExportProgressDto
     */
    'entities'?: Array<TenantExportEntity> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantExportProgressDto
     */
    'jobId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantExportProgressDto
     */
    'tenantId'?: string;
}
/**
 * 
 * @export
 * @interface TenantExportRequestDto
 */
export interface TenantExportRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TenantExportRequestDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantExportRequestDto
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantExportRequestDto
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantExportRequestDto
     */
    'includeDeleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TenantOutputDto
 */
export interface TenantOutputDto {
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'appUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'webApiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantOutputDto
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantOutputDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface TenantOutputDtoPagedResultDto
 */
export interface TenantOutputDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantOutputDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantOutputDto>}
     * @memberof TenantOutputDtoPagedResultDto
     */
    'items'?: Array<TenantOutputDto> | null;
}
/**
 * 
 * @export
 * @interface TenantRegistrationBasicInfoDto
 */
export interface TenantRegistrationBasicInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationBasicInfoDto
     */
    'tenantRegistrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationBasicInfoDto
     */
    'tenantName'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantRegistrationDto
 */
export interface TenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof TenantRegistrationDto
     */
    'tenantRegistrationStatus'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'statusTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorTenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'masterAccessSuspended'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'isVehicleOffsetLocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof TenantRegistrationDto
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantRegistrationDtoPagedResultDto
 */
export interface TenantRegistrationDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantRegistrationDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantRegistrationDto>}
     * @memberof TenantRegistrationDtoPagedResultDto
     */
    'items'?: Array<TenantRegistrationDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantRegistrationStatus = {
    RegistrationPending: 'RegistrationPending',
    Active: 'Active',
    RegistrationRejected: 'RegistrationRejected',
    DeletePending: 'DeletePending',
    Deleted: 'Deleted',
    DeleteRejected: 'DeleteRejected',
    Registering: 'Registering',
    RegistrationFailed: 'RegistrationFailed',
    Deleting: 'Deleting',
    DeletionFailed: 'DeletionFailed',
    DeactivationPending: 'DeactivationPending',
    Deactivated: 'Deactivated',
    DeactivationRejected: 'DeactivationRejected',
    Deactivating: 'Deactivating',
    DeactivationFailed: 'DeactivationFailed',
    Reactivating: 'Reactivating',
    ReactivationFailed: 'ReactivationFailed'
} as const;

export type TenantRegistrationStatus = typeof TenantRegistrationStatus[keyof typeof TenantRegistrationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantRegistrationType = {
    Fleet: 'Fleet',
    Master: 'Master'
} as const;

export type TenantRegistrationType = typeof TenantRegistrationType[keyof typeof TenantRegistrationType];


/**
 * 
 * @export
 * @interface TenantServiceAccountCreationResult
 */
export interface TenantServiceAccountCreationResult {
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'passwordResetToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'contactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'createdUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantUpdateDto
 */
export interface TenantUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TerminalTimeZoneAppData
 */
export interface TerminalTimeZoneAppData {
    /**
     * 
     * @type {string}
     * @memberof TerminalTimeZoneAppData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalTimeZoneAppData
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface TimeZone
 */
export interface TimeZone {
    /**
     * 
     * @type {TimeZoneIana}
     * @memberof TimeZone
     */
    'iana'?: TimeZoneIana | null;
    /**
     * 
     * @type {TimeZoneWindows}
     * @memberof TimeZone
     */
    'windows'?: TimeZoneWindows | null;
}
/**
 * 
 * @export
 * @interface TimeZoneIana
 */
export interface TimeZoneIana {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneIana
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface TimeZoneWindows
 */
export interface TimeZoneWindows {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneWindows
     */
    'timeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface TimingDto
 */
export interface TimingDto {
    /**
     * 
     * @type {TimingDtoTimeZone}
     * @memberof TimingDto
     */
    'timeZone'?: TimingDtoTimeZone | null;
}
/**
 * 
 * @export
 * @interface TimingDtoTimeZone
 */
export interface TimingDtoTimeZone {
    /**
     * 
     * @type {TimeZoneIana}
     * @memberof TimingDtoTimeZone
     */
    'iana'?: TimeZoneIana | null;
    /**
     * 
     * @type {TimeZoneWindows}
     * @memberof TimingDtoTimeZone
     */
    'windows'?: TimeZoneWindows | null;
}
/**
 * 
 * @export
 * @interface TireStatus
 */
export interface TireStatus {
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof TireStatus
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'axle'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'tire'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'psi'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'temperature'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'airLeakageRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'fault'?: number;
    /**
     * 
     * @type {string}
     * @memberof TireStatus
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof TireStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TireStatusDto
 */
export interface TireStatusDto {
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'axle'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'tire'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'psi'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'airLeakageRate'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TireStatusDto
     */
    'faults'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface TotalDriversWidgetDto
 */
export interface TotalDriversWidgetDto {
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'activeDrivers'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithPhysicalEldDisconnections'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithHarshGeometrisEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithSpeedingEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithUnresolvedDvirDefects'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithPhysicalEldDisconnectionsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithHarshGeometrisEventsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithSpeedingEventsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithUnresolvedDvirDefectsPercentage'?: number | null;
}
/**
 * 
 * @export
 * @interface TotalFuelConsumptionDto
 */
export interface TotalFuelConsumptionDto {
    /**
     * 
     * @type {number}
     * @memberof TotalFuelConsumptionDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TotalFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof TotalFuelConsumptionDto
     */
    'stops'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TotalFuelPercentageInIdleStateDto
 */
export interface TotalFuelPercentageInIdleStateDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof TotalFuelPercentageInIdleStateDto
     */
    'values'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TotalVehiclesWidgetDto
 */
export interface TotalVehiclesWidgetDto {
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'activeVehicles'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithDiagnosticErrors'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithUnresolvedDvirDefects'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithTpmsAlerts'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithCriticalGeometrisEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithDiagnosticErrorsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithUnresolvedDvirDefectsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithTpmsAlertsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithCriticalGeometrisEventsPercentage'?: number | null;
}
/**
 * 
 * @export
 * @interface Trailer
 */
export interface Trailer {
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof Trailer
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof Trailer
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof Trailer
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof Trailer
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof Trailer
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Trailer
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof Trailer
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Trailer
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Trailer
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Trailer
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerAdvancedSearchListDto
 */
export interface TrailerAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerAdvancedSearchListDto
     */
    'inMotion'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'lastMotionStatusChange'?: string | null;
}
/**
 * 
 * @export
 * @interface TrailerDto
 */
export interface TrailerDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof TrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof TrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof TrailerDto
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof TrailerDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerDtoEntityStatusChangeResult
 */
export interface TrailerDtoEntityStatusChangeResult {
    /**
     * 
     * @type {TrailerDtoEntityStatusChangeResultEntity}
     * @memberof TrailerDtoEntityStatusChangeResult
     */
    'entity'?: TrailerDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerDtoEntityStatusChangeResult
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface TrailerDtoEntityStatusChangeResultEntity
 */
export interface TrailerDtoEntityStatusChangeResultEntity {
    /**
     * 
     * @type {string}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDtoEntityStatusChangeResultEntity
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerDtoPagedResultDto
 */
export interface TrailerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerDto>}
     * @memberof TrailerDtoPagedResultDto
     */
    'items'?: Array<TrailerDto> | null;
}
/**
 * 
 * @export
 * @interface TrailerGpsLocationDto
 */
export interface TrailerGpsLocationDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'lastMotionStatusChange'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerGpsLocationDto
     */
    'inMotion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'odometer'?: number | null;
}
/**
 * 
 * @export
 * @interface TrailerHistoryStatusInfoDto
 */
export interface TrailerHistoryStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'inMotion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerListDto
 */
export interface TrailerListDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerListDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof TrailerListDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof TrailerListDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrailerListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerListDtoPagedResultDto
 */
export interface TrailerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerListDto>}
     * @memberof TrailerListDtoPagedResultDto
     */
    'items'?: Array<TrailerListDto> | null;
}
/**
 * 
 * @export
 * @interface TrailerSyncDto
 */
export interface TrailerSyncDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'lastModificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrailerSyncDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerTrackingProviderDto
 */
export interface TrailerTrackingProviderDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerTrackingProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerTrackingProviderDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerTrackingProviderDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof TrailerTrackingProviderDto
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TrailerTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface TrailerTrackingProviderDtoPagedResultDto
 */
export interface TrailerTrackingProviderDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerTrackingProviderDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerTrackingProviderDto>}
     * @memberof TrailerTrackingProviderDtoPagedResultDto
     */
    'items'?: Array<TrailerTrackingProviderDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrailerTrackingProviders = {
    Spireon: 'Spireon',
    MachineLink: 'MachineLink',
    OneStepGps: 'OneStepGps'
} as const;

export type TrailerTrackingProviders = typeof TrailerTrackingProviders[keyof typeof TrailerTrackingProviders];


/**
 * 
 * @export
 * @enum {string}
 */

export const TrailerType = {
    DryVan: 'DryVan',
    Flatbed: 'Flatbed',
    Po: 'Po',
    Reefer: 'Reefer'
} as const;

export type TrailerType = typeof TrailerType[keyof typeof TrailerType];


/**
 * 
 * @export
 * @interface TrailersUsageHistoryListDto
 */
export interface TrailersUsageHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof TrailersUsageHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'startTime'?: string;
}
/**
 * 
 * @export
 * @interface TripDetailData
 */
export interface TripDetailData {
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'reportDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripDetailData
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<VehicleTripDetailData>}
     * @memberof TripDetailData
     */
    'vehicles'?: Array<VehicleTripDetailData> | null;
}
/**
 * 
 * @export
 * @interface TripReportDetailData
 */
export interface TripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'reportDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripReportDetailData
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<VehicleTripReportDetailData>}
     * @memberof TripReportDetailData
     */
    'vehicles'?: Array<VehicleTripReportDetailData> | null;
    /**
     * 
     * @type {number}
     * @memberof TripReportDetailData
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByStateListDto
 */
export interface TripsViewByStateListDto {
    /**
     * 
     * @type {string}
     * @memberof TripsViewByStateListDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewByStateListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByStateListDtoPagedResultDto
 */
export interface TripsViewByStateListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewByStateListDto>}
     * @memberof TripsViewByStateListDtoPagedResultDto
     */
    'items'?: Array<TripsViewByStateListDto> | null;
}
/**
 * 
 * @export
 * @interface TripsViewByVehicleListDto
 */
export interface TripsViewByVehicleListDto {
    /**
     * 
     * @type {string}
     * @memberof TripsViewByVehicleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewByVehicleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByVehicleListDtoPagedResultDto
 */
export interface TripsViewByVehicleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewByVehicleListDto>}
     * @memberof TripsViewByVehicleListDtoPagedResultDto
     */
    'items'?: Array<TripsViewByVehicleListDto> | null;
}
/**
 * 
 * @export
 * @interface TripsViewListDto
 */
export interface TripsViewListDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'startOdometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'endOdometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'ianaTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface TripsViewListDtoPagedResultDto
 */
export interface TripsViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewListDto>}
     * @memberof TripsViewListDtoPagedResultDto
     */
    'items'?: Array<TripsViewListDto> | null;
}
/**
 * 
 * @export
 * @interface TwoFactorAuthenticationSettingsDto
 */
export interface TwoFactorAuthenticationSettingsDto {
    /**
     * 
     * @type {TwoFactorAuthenticationType}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'selectedAuthenticationType'?: TwoFactorAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'authenticatorSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TwoFactorAuthenticationType = {
    None: 'None',
    Phone: 'Phone',
    Authenticator: 'Authenticator'
} as const;

export type TwoFactorAuthenticationType = typeof TwoFactorAuthenticationType[keyof typeof TwoFactorAuthenticationType];


/**
 * 
 * @export
 * @interface TypeApiDescriptionModel
 */
export interface TypeApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof TypeApiDescriptionModel
     */
    'baseType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeApiDescriptionModel
     */
    'isEnum'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeApiDescriptionModel
     */
    'enumNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof TypeApiDescriptionModel
     */
    'enumValues'?: Array<any> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeApiDescriptionModel
     */
    'genericArguments'?: Array<string> | null;
    /**
     * 
     * @type {Array<PropertyApiDescriptionModel>}
     * @memberof TypeApiDescriptionModel
     */
    'properties'?: Array<PropertyApiDescriptionModel> | null;
}
/**
 * 
 * @export
 * @interface UnidentifiedEventsListDto
 */
export interface UnidentifiedEventsListDto {
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'startLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'endLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'distance'?: number;
}
/**
 * 
 * @export
 * @interface UnidentifiedEventsListDtoPagedResultDto
 */
export interface UnidentifiedEventsListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<UnidentifiedEventsListDto>}
     * @memberof UnidentifiedEventsListDtoPagedResultDto
     */
    'items'?: Array<UnidentifiedEventsListDto> | null;
}
/**
 * 
 * @export
 * @interface UnidentifiedEventsReportInput
 */
export interface UnidentifiedEventsReportInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof UnidentifiedEventsReportInput
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof UnidentifiedEventsReportInput
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsReportInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface UnresolvedDvirDefectsDto
 */
export interface UnresolvedDvirDefectsDto {
    /**
     * 
     * @type {number}
     * @memberof UnresolvedDvirDefectsDto
     */
    'major'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnresolvedDvirDefectsDto
     */
    'minor'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCompanyDto
 */
export interface UpdateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof UpdateCompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof UpdateCompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof UpdateCompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateCompanyDto
     */
    'dutyCycleId'?: Array<number> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateCompanyDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateCompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'noCertifyIfTrailerOrBolMissing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'noNewShiftIfNoCertify'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDemoAccountDto
 */
export interface UpdateDemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDemoAccountDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface UpdateDriverDto
 */
export interface UpdateDriverDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof UpdateDriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateDriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof UpdateDriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof UpdateDriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateDriverDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateDvirFormDto
 */
export interface UpdateDvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof UpdateDvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateDvirFormDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateDvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateEldDeviceDto
 */
export interface UpdateEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateEldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof UpdateEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof UpdateEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFeatureDto
 */
export interface UpdateFeatureDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFeatureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeatureDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeaturesDto
 */
export interface UpdateFeaturesDto {
    /**
     * 
     * @type {Array<UpdateFeatureDto>}
     * @memberof UpdateFeaturesDto
     */
    'features'?: Array<UpdateFeatureDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateFleetManagerDto
 */
export interface UpdateFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFleetManagerDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFleetManagerDto
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFuelProviderDto
 */
export interface UpdateFuelProviderDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateFuelProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof UpdateFuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UpdateMasterEventInput
 */
export interface UpdateMasterEventInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof UpdateMasterEventInput
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMasterFleetManagerDto
 */
export interface UpdateMasterFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePermissionDto
 */
export interface UpdatePermissionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePermissionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePermissionDto
     */
    'isGranted'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatePermissionsDto
 */
export interface UpdatePermissionsDto {
    /**
     * 
     * @type {Array<UpdatePermissionDto>}
     * @memberof UpdatePermissionsDto
     */
    'permissions'?: Array<UpdatePermissionDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateProfileDto
 */
export interface UpdateProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateProfileDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface UpdatePublicApiRedirectionDto
 */
export interface UpdatePublicApiRedirectionDto {
    /**
     * 
     * @type {PublicApiRedirectionStatus}
     * @memberof UpdatePublicApiRedirectionDto
     */
    'status'?: PublicApiRedirectionStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicApiRedirectionDto
     */
    'authorityUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicApiRedirectionDto
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicApiRedirectionDto
     */
    'callbackUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateRoleDto
 */
export interface UpdateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof UpdateRoleDto
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof UpdateRoleDto
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface UpdateTenantDto
 */
export interface UpdateTenantDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'domainName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTenantRegistrationDto
 */
export interface UpdateTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationType}
     * @memberof UpdateTenantRegistrationDto
     */
    'tenantRegistrationType'?: TenantRegistrationType;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTrailerDto
 */
export interface UpdateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof UpdateTrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof UpdateTrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof UpdateTrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateTrailerDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateTrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateVehicleDto
 */
export interface UpdateVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof UpdateVehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof UpdateVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateVehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateVehicleDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UploadSignaturesInputDto
 */
export interface UploadSignaturesInputDto {
    /**
     * 
     * @type {Array<SignatureDto>}
     * @memberof UploadSignaturesInputDto
     */
    'signatures'?: Array<SignatureDto> | null;
}
/**
 * 
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    'phoneNumberConfirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDataListResultDto
 */
export interface UserDataListResultDto {
    /**
     * 
     * @type {Array<UserData>}
     * @memberof UserDataListResultDto
     */
    'items'?: Array<UserData> | null;
}
/**
 * 
 * @export
 * @interface UserLoginInfo
 */
export interface UserLoginInfo {
    /**
     * 
     * @type {string}
     * @memberof UserLoginInfo
     */
    'userNameOrEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UserLoginInfo
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserLoginInfo
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface UserNotificationPreferenceDto
 */
export interface UserNotificationPreferenceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredNotificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredVehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredDriverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredTrailerIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredCompanyIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UserOverrideInput
 */
export interface UserOverrideInput {
    /**
     * 
     * @type {string}
     * @memberof UserOverrideInput
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserOverrideInput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserOverrideOutput
 */
export interface UserOverrideOutput {
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'accessToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserOverrideOutput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserPreferenceGetDto
 */
export interface UserPreferenceGetDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceGetDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UserPreferenceSaveDto
 */
export interface UserPreferenceSaveDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceSaveDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceSaveDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UserView
 */
export interface UserView {
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'detail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'end'?: number;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ValidationError
     */
    'errorType'?: ValidationStatus;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'line'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'start'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ValidationStatus = {
    Valid: 'Valid',
    Error: 'Error',
    Warning: 'Warning',
    Information: 'Information',
    NotValidated: 'NotValidated'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];


/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof Vehicle
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'countryId'?: number;
    /**
     * 
     * @type {DutyCycleCountry}
     * @memberof Vehicle
     */
    'country'?: DutyCycleCountry | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyState}
     * @memberof Vehicle
     */
    'state'?: CompanyState | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'companyId'?: number;
    /**
     * 
     * @type {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Vehicle
     */
    'company'?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {Odometer}
     * @memberof Vehicle
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Vehicle
     */
    'eldDevice'?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof Vehicle
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'odometerOffset'?: number | null;
    /**
     * 
     * @type {Array<GroupVehicle>}
     * @memberof Vehicle
     */
    'vehicleGroups'?: Array<GroupVehicle> | null;
    /**
     * 
     * @type {Array<Event>}
     * @memberof Vehicle
     */
    'events'?: Array<Event> | null;
    /**
     * 
     * @type {Array<Location>}
     * @memberof Vehicle
     */
    'locations'?: Array<Location> | null;
    /**
     * 
     * @type {Array<VehicleMaintenance>}
     * @memberof Vehicle
     */
    'maintenance'?: Array<VehicleMaintenance> | null;
    /**
     * 
     * @type {Array<TireStatus>}
     * @memberof Vehicle
     */
    'tireStatuses'?: Array<TireStatus> | null;
    /**
     * 
     * @type {Array<IdlingEvent>}
     * @memberof Vehicle
     */
    'idlingEvents'?: Array<IdlingEvent> | null;
    /**
     * 
     * @type {Array<IdlingFuelConsumption>}
     * @memberof Vehicle
     */
    'idlingFuelConsumptions'?: Array<IdlingFuelConsumption> | null;
    /**
     * 
     * @type {Array<VehicleSensorAttributeValue>}
     * @memberof Vehicle
     */
    'sensorAttributeValues'?: Array<VehicleSensorAttributeValue> | null;
    /**
     * 
     * @type {VehicleCurrentLocation}
     * @memberof Vehicle
     */
    'currentLocation'?: VehicleCurrentLocation | null;
    /**
     * 
     * @type {VehicleCurrentDutyStatusEvent}
     * @memberof Vehicle
     */
    'currentDutyStatusEvent'?: VehicleCurrentDutyStatusEvent | null;
    /**
     * 
     * @type {VehicleEldDisconnection}
     * @memberof Vehicle
     */
    'eldDisconnection'?: VehicleEldDisconnection | null;
    /**
     * 
     * @type {Array<DiagnosticRecord>}
     * @memberof Vehicle
     */
    'diagnosticRecords'?: Array<DiagnosticRecord> | null;
    /**
     * 
     * @type {Array<EldConnection>}
     * @memberof Vehicle
     */
    'eldConnections'?: Array<EldConnection> | null;
    /**
     * 
     * @type {VehicleCurrentVehicleEldConnectionStatus}
     * @memberof Vehicle
     */
    'currentVehicleEldConnectionStatus'?: VehicleCurrentVehicleEldConnectionStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleAdvancedSearchListDto
 */
export interface VehicleAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'coDriverName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleCurrentDutyStatusEvent
 */
export interface VehicleCurrentDutyStatusEvent {
    /**
     * 
     * @type {CurrentVehicleDutyStatusEventEvent}
     * @memberof VehicleCurrentDutyStatusEvent
     */
    'event'?: CurrentVehicleDutyStatusEventEvent | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentDutyStatusEvent
     */
    'eventId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCurrentDutyStatusEvent
     */
    'lastDriverChangeTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentDutyStatusEvent
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleCurrentLocation
 */
export interface VehicleCurrentLocation {
    /**
     * 
     * @type {string}
     * @memberof VehicleCurrentLocation
     */
    'timestamp'?: string;
    /**
     * 
     * @type {GeometrisEventLocation}
     * @memberof VehicleCurrentLocation
     */
    'location'?: GeometrisEventLocation | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentLocation
     */
    'locationId'?: number;
    /**
     * 
     * @type {VehicleIgnitionStatus}
     * @memberof VehicleCurrentLocation
     */
    'ignitionStatus'?: VehicleIgnitionStatus;
    /**
     * 
     * @type {string}
     * @memberof VehicleCurrentLocation
     */
    'ignitionStatusUpdateTime'?: string | null;
    /**
     * 
     * @type {VehicleEldPhysicalConnectionStatus}
     * @memberof VehicleCurrentLocation
     */
    'eldPhysicalConnectionStatus'?: VehicleEldPhysicalConnectionStatus;
    /**
     * 
     * @type {string}
     * @memberof VehicleCurrentLocation
     */
    'eldPhysicalConnectionStatusUpdateTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleCurrentVehicleEldConnectionStatus
 */
export interface VehicleCurrentVehicleEldConnectionStatus {
    /**
     * 
     * @type {CurrentVehicleEldConnectionStatusEldConnection}
     * @memberof VehicleCurrentVehicleEldConnectionStatus
     */
    'eldConnection'?: CurrentVehicleEldConnectionStatusEldConnection | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentVehicleEldConnectionStatus
     */
    'eldConnectionId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCurrentVehicleEldConnectionStatus
     */
    'lastEldStatusChangeTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCurrentVehicleEldConnectionStatus
     */
    'isFromGeometris'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleCurrentVehicleEldConnectionStatus
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDiagnosticRecord
 */
export interface VehicleDiagnosticRecord {
    /**
     * 
     * @type {number}
     * @memberof VehicleDiagnosticRecord
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDiagnosticRecord
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'description'?: string | null;
    /**
     * 
     * @type {DiagnosticCodeType}
     * @memberof VehicleDiagnosticRecord
     */
    'type'?: DiagnosticCodeType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface VehicleDistanceReportDto
 */
export interface VehicleDistanceReportDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleDistanceReportDto
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDistanceReportDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDriversAndDrivingPeriodListDto
 */
export interface VehicleDriversAndDrivingPeriodListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDto
 */
export interface VehicleDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof VehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof VehicleDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof VehicleDto
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof VehicleDto
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {Odometer}
     * @memberof VehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof VehicleDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDtoEntityStatusChangeResult
 */
export interface VehicleDtoEntityStatusChangeResult {
    /**
     * 
     * @type {VehicleDtoEntityStatusChangeResultEntity}
     * @memberof VehicleDtoEntityStatusChangeResult
     */
    'entity'?: VehicleDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDtoEntityStatusChangeResult
     */
    'changed'?: boolean;
}
/**
 * 
 * @export
 * @interface VehicleDtoEntityStatusChangeResultEntity
 */
export interface VehicleDtoEntityStatusChangeResultEntity {
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'companyId'?: number;
    /**
     * 
     * @type {CompanyDtoEntityStatusChangeResultEntity}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'company'?: CompanyDtoEntityStatusChangeResultEntity | null;
    /**
     * 
     * @type {Odometer}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoEntityStatusChangeResultEntity
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDtoPagedResultDto
 */
export interface VehicleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleDto>}
     * @memberof VehicleDtoPagedResultDto
     */
    'items'?: Array<VehicleDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirDefectDto
 */
export interface VehicleDvirDefectDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'dvirReportId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof VehicleDvirDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryEntryDto
 */
export interface VehicleDvirHistoryEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'minorDefectsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'majorDefectsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'hasUnresolvedDefects'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'companyId'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryListDto
 */
export interface VehicleDvirHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof VehicleDvirHistoryListDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'minorDefectsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'majorDefectsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDvirHistoryListDto
     */
    'hasUnresolvedDefects'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryListDtoPagedResultDto
 */
export interface VehicleDvirHistoryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleDvirHistoryListDto>}
     * @memberof VehicleDvirHistoryListDtoPagedResultDto
     */
    'items'?: Array<VehicleDvirHistoryListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleEldDevicesUsageHistoryListDto
 */
export interface VehicleEldDevicesUsageHistoryListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleEldDisconnection
 */
export interface VehicleEldDisconnection {
    /**
     * 
     * @type {number}
     * @memberof VehicleEldDisconnection
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleEldDisconnection
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'disconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'reconnectionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleEldDisconnection
     */
    'disconnectMinutes'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleEldDisconnection
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleEldDisconnection
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDisconnection
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleEldDisconnection
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleEldPhysicalConnectionStatus = {
    UnableToDetermine: 'UnableToDetermine',
    Unplugged: 'Unplugged',
    Plugged: 'Plugged'
} as const;

export type VehicleEldPhysicalConnectionStatus = typeof VehicleEldPhysicalConnectionStatus[keyof typeof VehicleEldPhysicalConnectionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleIgnitionStatus = {
    IgnitionOff: 'IgnitionOff',
    IgnitionOnDriving: 'IgnitionOnDriving',
    IgnitionOnIdle: 'IgnitionOnIdle'
} as const;

export type VehicleIgnitionStatus = typeof VehicleIgnitionStatus[keyof typeof VehicleIgnitionStatus];


/**
 * 
 * @export
 * @interface VehicleInactivityReportInput
 */
export interface VehicleInactivityReportInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleInactivityReportInput
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleInactivityReportInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleListDto
 */
export interface VehicleListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {FuelType}
     * @memberof VehicleListDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleListDtoPagedResultDto
 */
export interface VehicleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleListDto>}
     * @memberof VehicleListDtoPagedResultDto
     */
    'items'?: Array<VehicleListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleLocationHistoryReportEntryDto
 */
export interface VehicleLocationHistoryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'mileageFromEcu'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverFullName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleLocationHistoryReportEntryListResultDto
 */
export interface VehicleLocationHistoryReportEntryListResultDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleLocationHistoryReportEntryDto>}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'items'?: Array<VehicleLocationHistoryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenance
 */
export interface VehicleMaintenance {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenance
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenance
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenance
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof VehicleMaintenance
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenance
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenance
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenance
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenance
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenance
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenance
     */
    'isNotified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenance
     */
    'nextMaintenanceDone'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenance
     */
    'previousOilChangeId'?: number | null;
    /**
     * 
     * @type {VehicleMaintenancePreviousOilChange}
     * @memberof VehicleMaintenance
     */
    'previousOilChange'?: VehicleMaintenancePreviousOilChange | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenance
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceDto
 */
export interface VehicleMaintenanceDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'previousOilChangeId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceDtoPagedResultDto
 */
export interface VehicleMaintenanceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceDto>}
     * @memberof VehicleMaintenanceDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceListDto
 */
export interface VehicleMaintenanceListDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceDone'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceListDtoPagedResultDto
 */
export interface VehicleMaintenanceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceListDto>}
     * @memberof VehicleMaintenanceListDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenancePreviousOilChange
 */
export interface VehicleMaintenancePreviousOilChange {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'isNotified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'nextMaintenanceDone'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'previousOilChangeId'?: number | null;
    /**
     * 
     * @type {VehicleMaintenancePreviousOilChange}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'previousOilChange'?: VehicleMaintenancePreviousOilChange | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenancePreviousOilChange
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryDto
 */
export interface VehicleMaintenanceSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleOdometerUnit'?: string | null;
    /**
     * 
     * @type {Array<TireStatusDto>}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'tireStatuses'?: Array<TireStatusDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryListDto
 */
export interface VehicleMaintenanceSummaryListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleOdometerUnit'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'tireFaults'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'tiresFaulty'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'lastMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryListDtoPagedResultDto
 */
export interface VehicleMaintenanceSummaryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceSummaryListDto>}
     * @memberof VehicleMaintenanceSummaryListDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceSummaryListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMediaItemDto
 */
export interface VehicleMediaItemDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMediaItemDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'vehicle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'driver'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMediaItemDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {MediaType}
     * @memberof VehicleMediaItemDto
     */
    'mediaType'?: MediaType;
    /**
     * 
     * @type {CameraPosition}
     * @memberof VehicleMediaItemDto
     */
    'cameraPosition'?: CameraPosition;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'captureStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'requestedStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'requestCreatedTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'captureStartTimeTerminal'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'requestedStartTimeTerminal'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'requestCreatedTimeTerminal'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'requestedBy'?: string | null;
    /**
     * 
     * @type {MediaArchiveStatus}
     * @memberof VehicleMediaItemDto
     */
    'status'?: MediaArchiveStatus;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'preSignedUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'urlExpiresAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {MediaRequestStatus}
     * @memberof VehicleMediaItemDto
     */
    'requestedStatus'?: MediaRequestStatus | null;
    /**
     * 
     * @type {MediaRequestType}
     * @memberof VehicleMediaItemDto
     */
    'requestedType'?: MediaRequestType | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMediaItemDto
     */
    'aiEventType'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMediaItemDtoPagedResultDto
 */
export interface VehicleMediaItemDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMediaItemDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMediaItemDto>}
     * @memberof VehicleMediaItemDtoPagedResultDto
     */
    'items'?: Array<VehicleMediaItemDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportEntryDto
 */
export interface VehicleMileageByStateSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportEntryListResultDto
 */
export interface VehicleMileageByStateSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageByStateSummaryReportEntryDto>}
     * @memberof VehicleMileageByStateSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleMileageByStateSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportViewInputDto
 */
export interface VehicleMileageByStateSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageReportInputDto
 */
export interface VehicleMileageReportInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageReportInputDto
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageReportInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof VehicleMileageReportInputDto
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryByVehicleDto
 */
export interface VehicleMileageSummaryReportEntryByVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryDto
 */
export interface VehicleMileageSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryListByVehicleResultDto
 */
export interface VehicleMileageSummaryReportEntryListByVehicleResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageSummaryReportEntryByVehicleDto>}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'items'?: Array<VehicleMileageSummaryReportEntryByVehicleDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryListResultDto
 */
export interface VehicleMileageSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageSummaryReportEntryDto>}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleMileageSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportViewInputDto
 */
export interface VehicleMileageSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageTripDetailData
 */
export interface VehicleMileageTripDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'startOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'endOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'destination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'eventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'duration'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageTripReportDetailData
 */
export interface VehicleMileageTripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startLatitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startLongitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endLatitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endLongitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValue
 */
export interface VehicleSensorAttributeValue {
    /**
     * 
     * @type {number}
     * @memberof VehicleSensorAttributeValue
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof VehicleSensorAttributeValue
     */
    'vehicle'?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSensorAttributeValue
     */
    'sensorAttributeId'?: number;
    /**
     * 
     * @type {VehicleSensorAttributeValueSensorAttribute}
     * @memberof VehicleSensorAttributeValue
     */
    'sensorAttribute'?: VehicleSensorAttributeValueSensorAttribute | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValue
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValue
     */
    'valueTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValue
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValueDto
 */
export interface VehicleSensorAttributeValueDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'units'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueDtoFormattedValue}
     * @memberof VehicleSensorAttributeValueDto
     */
    'formattedValue'?: VehicleSensorAttributeValueDtoFormattedValue | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'valueTimestamp'?: string;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValueDtoFormattedValue
 */
export interface VehicleSensorAttributeValueDtoFormattedValue {
    /**
     * 
     * @type {any}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'value'?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'isNormal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'unit'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueType}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'valueType'?: VehicleSensorAttributeValueType;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValueSensorAttribute
 */
export interface VehicleSensorAttributeValueSensorAttribute {
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'units'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'geometrisCapability'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'minValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'maxValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSensorAttributeValueSensorAttribute
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleSensorAttributeValueType = {
    Unformatted: 'Unformatted',
    Integer: 'Integer',
    Decimal: 'Decimal',
    Boolean: 'Boolean'
} as const;

export type VehicleSensorAttributeValueType = typeof VehicleSensorAttributeValueType[keyof typeof VehicleSensorAttributeValueType];


/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportEntryDto
 */
export interface VehicleStateMileageSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportEntryListResultDto
 */
export interface VehicleStateMileageSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleStateMileageSummaryReportEntryDto>}
     * @memberof VehicleStateMileageSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleStateMileageSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportViewInputDto
 */
export interface VehicleStateMileageSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleSyncDto
 */
export interface VehicleSyncDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Odometer}
     * @memberof VehicleSyncDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'lastModificationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSyncDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {DeviceType}
     * @memberof VehicleSyncDto
     */
    'deviceType'?: DeviceType | null;
    /**
     * 
     * @type {Vendor}
     * @memberof VehicleSyncDto
     */
    'vendorType'?: Vendor | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSyncDto
     */
    'odometerOffset'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleSyncDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof VehicleSyncDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleTrackingProviderDto
 */
export interface VehicleTrackingProviderDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleTrackingProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleTrackingProviderDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTrackingProviderDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {VehicleTrackingProviders}
     * @memberof VehicleTrackingProviderDto
     */
    'provider': VehicleTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof VehicleTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface VehicleTrackingProviderDtoPagedResultDto
 */
export interface VehicleTrackingProviderDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleTrackingProviderDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleTrackingProviderDto>}
     * @memberof VehicleTrackingProviderDtoPagedResultDto
     */
    'items'?: Array<VehicleTrackingProviderDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleTrackingProviders = {
    Spireon: 'Spireon',
    OneStepGps: 'OneStepGps'
} as const;

export type VehicleTrackingProviders = typeof VehicleTrackingProviders[keyof typeof VehicleTrackingProviders];


/**
 * 
 * @export
 * @interface VehicleTrailersUsageHistoryListDto
 */
export interface VehicleTrailersUsageHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'startTime'?: string;
}
/**
 * 
 * @export
 * @interface VehicleTripDetailData
 */
export interface VehicleTripDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleTripDetailData
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<VehicleMileageTripDetailData>}
     * @memberof VehicleTripDetailData
     */
    'vehicleMileages'?: Array<VehicleMileageTripDetailData> | null;
}
/**
 * 
 * @export
 * @interface VehicleTripReportDetailData
 */
export interface VehicleTripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleTripReportDetailData
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleTripReportDetailData
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {Array<VehicleMileageTripReportDetailData>}
     * @memberof VehicleTripReportDetailData
     */
    'vehicleMileages'?: Array<VehicleMileageTripReportDetailData> | null;
}
/**
 * 
 * @export
 * @interface VehicleUsageStatusInfoDto
 */
export interface VehicleUsageStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUsageStatusInfoDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'coDriverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleViewDto
 */
export interface VehicleViewDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleViewListDto
 */
export interface VehicleViewListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleViewListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleViewListDtoPagedResultDto
 */
export interface VehicleViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleViewListDto>}
     * @memberof VehicleViewListDtoPagedResultDto
     */
    'items'?: Array<VehicleViewListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleWithDiagnosticRecords
 */
export interface VehicleWithDiagnosticRecords {
    /**
     * 
     * @type {number}
     * @memberof VehicleWithDiagnosticRecords
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleWithDiagnosticRecords
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleWithDiagnosticRecords
     */
    'activeRecordsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleWithDiagnosticRecords
     */
    'lastDtcTime'?: string;
}
/**
 * 
 * @export
 * @interface VehiclesConditionOutput
 */
export interface VehiclesConditionOutput {
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'good'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'goodPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'satisfactory'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'satisfactoryPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'critical'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'criticalPercentage'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Vendor = {
    Invalid: 'Invalid',
    Geometris: 'Geometris',
    PacificTrack: 'PacificTrack',
    Iosix: 'Iosix'
} as const;

export type Vendor = typeof Vendor[keyof typeof Vendor];


/**
 * 
 * @export
 * @interface VerifyOneTimeCodeInput
 */
export interface VerifyOneTimeCodeInput {
    /**
     * 
     * @type {string}
     * @memberof VerifyOneTimeCodeInput
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface VerifyOneTimeCodeOutput
 */
export interface VerifyOneTimeCodeOutput {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyOneTimeCodeOutput
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyOneTimeCodeOutput
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewEventDto
 */
export interface ViewEventDto {
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'realStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'durationInSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'realDurationInSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'locationDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'engineMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'origin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isBasic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {EventType}
     * @memberof ViewEventDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'coDriverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'shippingDocuments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'realEndTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'averageSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'eventSequenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'nextDayFirstEventOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isEventMissingPowerUp'?: boolean;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof ViewEventDto
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'personalUseOrYardMoveSessionUUID'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewEventDtoPagedResultDto
 */
export interface ViewEventDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ViewEventDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ViewEventDto>}
     * @memberof ViewEventDtoPagedResultDto
     */
    'items'?: Array<ViewEventDto> | null;
}
/**
 * 
 * @export
 * @interface Violation
 */
export interface Violation {
    /**
     * 
     * @type {number}
     * @memberof Violation
     */
    'driverId'?: number;
    /**
     * 
     * @type {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest}
     * @memberof Violation
     */
    'driver'?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest | null;
    /**
     * 
     * @type {number}
     * @memberof Violation
     */
    'shiftId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Violation
     */
    'cycleId'?: number;
    /**
     * 
     * @type {ViolationType}
     * @memberof Violation
     */
    'violationType'?: ViolationType;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Violation
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Violation
     */
    'extraProperties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Violation
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Violation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ViolationClass = {
    Invalid: 'Invalid',
    ShiftViolation: 'ShiftViolation',
    CycleViolation: 'CycleViolation'
} as const;

export type ViolationClass = typeof ViolationClass[keyof typeof ViolationClass];


/**
 * 
 * @export
 * @enum {string}
 */

export const ViolationType = {
    EightHoursViolation: 'EightHoursViolation',
    ElevenHoursViolation: 'ElevenHoursViolation',
    FourteenHoursViolation: 'FourteenHoursViolation',
    ThirtyFourHoursResetViolation: 'ThirtyFourHoursResetViolation',
    DutyCycleViolation: 'DutyCycleViolation',
    ThirtyMinutesBreakViolation: 'ThirtyMinutesBreakViolation',
    TenHoursBreakRequiredViolation: 'TenHoursBreakRequiredViolation',
    UncertifiedLogsViolation: 'UncertifiedLogsViolation'
} as const;

export type ViolationType = typeof ViolationType[keyof typeof ViolationType];


/**
 * 
 * @export
 * @interface ViolationViewDto
 */
export interface ViolationViewDto {
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {ViolationType}
     * @memberof ViolationViewDto
     */
    'violationType'?: ViolationType;
    /**
     * 
     * @type {boolean}
     * @memberof ViolationViewDto
     */
    'isHosViolation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'violationError'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'startDateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'startTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'endDateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'endTime'?: number;
}
/**
 * 
 * @export
 * @interface VirtualTenantDriverDto
 */
export interface VirtualTenantDriverDto {
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDriverDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VirtualTenantDriverDto
     */
    'status'?: RecordStatus | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantDto
 */
export interface VirtualTenantDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'overriddenCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'overriddenDot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualTenantDto
     */
    'isOverridden'?: boolean;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof VirtualTenantDto
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<VirtualTenantVehicleDto>}
     * @memberof VirtualTenantDto
     */
    'vehicles'?: Array<VirtualTenantVehicleDto> | null;
    /**
     * 
     * @type {Array<VirtualTenantDriverDto>}
     * @memberof VirtualTenantDto
     */
    'drivers'?: Array<VirtualTenantDriverDto> | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantListDto
 */
export interface VirtualTenantListDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'overriddenCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'overriddenDot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualTenantListDto
     */
    'isOverridden'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDto
     */
    'vehiclesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDto
     */
    'driversCount'?: number;
}
/**
 * 
 * @export
 * @interface VirtualTenantListDtoPagedResultDto
 */
export interface VirtualTenantListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VirtualTenantListDto>}
     * @memberof VirtualTenantListDtoPagedResultDto
     */
    'items'?: Array<VirtualTenantListDto> | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantUserDto
 */
export interface VirtualTenantUserDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'role'?: string | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantVehicleDto
 */
export interface VirtualTenantVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VirtualTenantVehicleDto
     */
    'status'?: RecordStatus | null;
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantVehicleDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantVehicleRangeDto
 */
export interface VirtualTenantVehicleRangeDto {
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantVehicleRangeDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleRangeDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantVehicleRangeDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsTimeZone
 */
export interface WindowsTimeZone {
    /**
     * 
     * @type {string}
     * @memberof WindowsTimeZone
     */
    'timeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface WorstPerformersDto
 */
export interface WorstPerformersDto {
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'idleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorstPerformersDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorstPerformersDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'driverRank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof WorstPerformersDto
     */
    'rankStatus'?: RankStatus;
}
/**
 * 
 * @export
 * @interface WorstPerformersFuelConsumptionDto
 */
export interface WorstPerformersFuelConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'fuelConsumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'driverRank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'rankStatus'?: RankStatus;
}

/**
 * AbpApiDefinitionApi - axios parameter creator
 * @export
 */
export const AbpApiDefinitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApiDefinitionGet: async (includeTypes?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abp/api-definition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeTypes !== undefined) {
                localVarQueryParameter['IncludeTypes'] = includeTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpApiDefinitionApi - functional programming interface
 * @export
 */
export const AbpApiDefinitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpApiDefinitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpApiDefinitionGet(includeTypes?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationApiDescriptionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpApiDefinitionGet(includeTypes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpApiDefinitionApi - factory interface
 * @export
 */
export const AbpApiDefinitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpApiDefinitionApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApiDefinitionGet(includeTypes?: boolean, options?: any): AxiosPromise<ApplicationApiDescriptionModel> {
            return localVarFp.apiAbpApiDefinitionGet(includeTypes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpApiDefinitionApi - object-oriented interface
 * @export
 * @class AbpApiDefinitionApi
 * @extends {BaseAPI}
 */
export class AbpApiDefinitionApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [includeTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpApiDefinitionApi
     */
    public apiAbpApiDefinitionGet(includeTypes?: boolean, options?: AxiosRequestConfig) {
        return AbpApiDefinitionApiFp(this.configuration).apiAbpApiDefinitionGet(includeTypes, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AbpApplicationConfigurationApi - axios parameter creator
 * @export
 */
export const AbpApplicationConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abp/application-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpApplicationConfigurationApi - functional programming interface
 * @export
 */
export const AbpApplicationConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpApplicationConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpApplicationConfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpApplicationConfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpApplicationConfigurationApi - factory interface
 * @export
 */
export const AbpApplicationConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpApplicationConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet(options?: any): AxiosPromise<ApplicationConfigurationDto> {
            return localVarFp.apiAbpApplicationConfigurationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpApplicationConfigurationApi - object-oriented interface
 * @export
 * @class AbpApplicationConfigurationApi
 * @extends {BaseAPI}
 */
export class AbpApplicationConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpApplicationConfigurationApi
     */
    public apiAbpApplicationConfigurationGet(options?: AxiosRequestConfig) {
        return AbpApplicationConfigurationApiFp(this.configuration).apiAbpApplicationConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AbpTenantApi - axios parameter creator
 * @export
 */
export const AbpTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByIdIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAbpMultiTenancyTenantsByIdIdGet', 'id', id)
            const localVarPath = `/api/abp/multi-tenancy/tenants/by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByNameNameGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAbpMultiTenancyTenantsByNameNameGet', 'name', name)
            const localVarPath = `/api/abp/multi-tenancy/tenants/by-name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpTenantApi - functional programming interface
 * @export
 */
export const AbpTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindTenantResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpMultiTenancyTenantsByIdIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindTenantResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpMultiTenancyTenantsByNameNameGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpTenantApi - factory interface
 * @export
 */
export const AbpTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpTenantApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: any): AxiosPromise<FindTenantResultDto> {
            return localVarFp.apiAbpMultiTenancyTenantsByIdIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: any): AxiosPromise<FindTenantResultDto> {
            return localVarFp.apiAbpMultiTenancyTenantsByNameNameGet(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpTenantApi - object-oriented interface
 * @export
 * @class AbpTenantApi
 * @extends {BaseAPI}
 */
export class AbpTenantApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpTenantApi
     */
    public apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: AxiosRequestConfig) {
        return AbpTenantApiFp(this.configuration).apiAbpMultiTenancyTenantsByIdIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpTenantApi
     */
    public apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: AxiosRequestConfig) {
        return AbpTenantApiFp(this.configuration).apiAbpMultiTenancyTenantsByNameNameGet(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost: async (apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountRegisterPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost: async (apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountResetPasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountSendPasswordResetCodePost: async (apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/send-password-reset-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountSendPasswordResetCodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountRegisterPost(apiAccountRegisterPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiAccountRegisterPost(apiAccountRegisterPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountRegisterPost(apiAccountRegisterPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentCustomerEntityApi - axios parameter creator
 * @export
 */
export const AgentCustomerEntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/companies/{id}/deactivate`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesIdPut: async (tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesIdPut', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesIdPut', 'apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest', apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/companies/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdCompaniesPost', 'apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest', apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/companies`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/{id}/deactivate`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest} apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversIdPut: async (tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest: ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversIdPut', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversIdPut', 'apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest', apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversPostRequest} apiAppAgentOperationsTenantsTenantIdDriversPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversPost', 'apiAppAgentOperationsTenantsTenantIdDriversPostRequest', apiAppAgentOperationsTenantsTenantIdDriversPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/eld-devices/{id}/deactivate`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut: async (tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut', 'apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest', apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/eld-devices/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdEldDevicesPost', 'apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest', apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/eld-devices`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/trailers/{id}/deactivate`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersIdPut: async (tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersIdPut', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdTrailersPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersIdPut', 'apiAppAgentOperationsTenantsTenantIdTrailersPostRequest', apiAppAgentOperationsTenantsTenantIdTrailersPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/trailers/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdTrailersPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdTrailersPost', 'apiAppAgentOperationsTenantsTenantIdTrailersPostRequest', apiAppAgentOperationsTenantsTenantIdTrailersPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/trailers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/vehicles/{id}/deactivate`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesIdPut: async (tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesIdPut', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesIdPut', 'apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest', apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/vehicles/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdVehiclesPost', 'apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest', apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/vehicles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentCustomerEntityApi - functional programming interface
 * @export
 */
export const AgentCustomerEntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentCustomerEntityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest} apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest: ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversPostRequest} apiAppAgentOperationsTenantsTenantIdDriversPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentCustomerEntityApi - factory interface
 * @export
 */
export const AgentCustomerEntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentCustomerEntityApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId: string, id: number, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId: string, id: number, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest} apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest: ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversPostRequest} apiAppAgentOperationsTenantsTenantIdDriversPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId: string, id: number, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId: string, id: number, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId: string, id: number, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} id 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: any): AxiosPromise<AgentCustomerEntityResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentCustomerEntityApi - object-oriented interface
 * @export
 * @class AgentCustomerEntityApi
 * @extends {BaseAPI}
 */
export class AgentCustomerEntityApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdCompaniesIdDeactivatePost(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdCompaniesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest} apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest: ApiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdCompaniesPost(tenantId, apiAppAgentOperationsTenantsTenantIdCompaniesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversIdDeactivatePost(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest} apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest: ApiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdDriversIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversPostRequest} apiAppAgentOperationsTenantsTenantIdDriversPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdEldDevicesIdDeactivatePost(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdEldDevicesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest} apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest: ApiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdEldDevicesPost(tenantId, apiAppAgentOperationsTenantsTenantIdEldDevicesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdTrailersIdDeactivatePost(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdTrailersIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest} apiAppAgentOperationsTenantsTenantIdTrailersPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest: ApiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdTrailersPost(tenantId, apiAppAgentOperationsTenantsTenantIdTrailersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdVehiclesIdDeactivatePost(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} id 
     * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId: string, id: number, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdVehiclesIdPut(tenantId, id, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest} apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerEntityApi
     */
    public apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest: ApiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerEntityApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdVehiclesPost(tenantId, apiAppAgentOperationsTenantsTenantIdVehiclesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentCustomerSupportApi - axios parameter creator
 * @export
 */
export const AgentCustomerSupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost: async (tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost', 'tenantId', tenantId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost', 'driverId', driverId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost', 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest', apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/{driverId}/logout`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest} apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost', 'apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest', apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/export-csv`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} referenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet: async (tenantId: string, referenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet', 'tenantId', tenantId)
            // verify required parameter 'referenceId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet', 'referenceId', referenceId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/exports/{referenceId}/download`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"referenceId"}}`, encodeURIComponent(String(referenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/grant-master-account`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/resend-welcome-email`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentCustomerSupportApi - functional programming interface
 * @export
 */
export const AgentCustomerSupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentCustomerSupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDriverLogoutResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest} apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDriverCsvExportReferenceDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} referenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId: string, referenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IRemoteStreamContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId, referenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentGrantMasterAccountResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentWelcomeEmailResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentCustomerSupportApi - factory interface
 * @export
 */
export const AgentCustomerSupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentCustomerSupportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: any): AxiosPromise<AgentDriverLogoutResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest} apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options?: any): AxiosPromise<AgentDriverCsvExportReferenceDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} referenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId: string, referenceId: string, options?: any): AxiosPromise<IRemoteStreamContent> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId, referenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId: string, options?: any): AxiosPromise<AgentGrantMasterAccountResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId: string, options?: any): AxiosPromise<AgentWelcomeEmailResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentCustomerSupportApi - object-oriented interface
 * @export
 * @class AgentCustomerSupportApi
 * @extends {BaseAPI}
 */
export class AgentCustomerSupportApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {number} driverId 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerSupportApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerSupportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest} apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerSupportApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options?: AxiosRequestConfig) {
        return AgentCustomerSupportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversExportCsvPost(tenantId, apiAppAgentOperationsTenantsTenantIdDriversExportCsvPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} referenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerSupportApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId: string, referenceId: string, options?: AxiosRequestConfig) {
        return AgentCustomerSupportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversExportsReferenceIdDownloadGet(tenantId, referenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerSupportApi
     */
    public apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId: string, options?: AxiosRequestConfig) {
        return AgentCustomerSupportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdGrantMasterAccountPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentCustomerSupportApi
     */
    public apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId: string, options?: AxiosRequestConfig) {
        return AgentCustomerSupportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdResendWelcomeEmailPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentDriverLogApi - axios parameter creator
 * @export
 */
export const AgentDriverLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost: async (tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost', 'tenantId', tenantId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost', 'driverId', driverId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost', 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest', apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/drivers/{driverId}/logs/read`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentDriverLogApi - functional programming interface
 * @export
 */
export const AgentDriverLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentDriverLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDriverLogReadResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentDriverLogApi - factory interface
 * @export
 */
export const AgentDriverLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentDriverLogApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {number} driverId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options?: any): AxiosPromise<AgentDriverLogReadResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentDriverLogApi - object-oriented interface
 * @export
 * @class AgentDriverLogApi
 * @extends {BaseAPI}
 */
export class AgentDriverLogApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {number} driverId 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentDriverLogApi
     */
    public apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId: string, driverId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options?: AxiosRequestConfig) {
        return AgentDriverLogApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPost(tenantId, driverId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogsReadPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentFmcsaInspectionApi - axios parameter creator
 * @export
 */
export const AgentFmcsaInspectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost', 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest', apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/fmcsa-inspections/email`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost', 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest', apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/fmcsa-inspections/get-filtered-list`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet: async (tenantId: string, inspectionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet', 'tenantId', tenantId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet', 'inspectionId', inspectionId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/fmcsa-inspections/{inspectionId}/download`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost', 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest', apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/fmcsa-inspections/manual`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost', 'apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest', apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/fmcsa-inspections/web`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentFmcsaInspectionApi - functional programming interface
 * @export
 */
export const AgentFmcsaInspectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentFmcsaInspectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId: string, inspectionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IRemoteStreamContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId, inspectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentFmcsaInspectionApi - factory interface
 * @export
 */
export const AgentFmcsaInspectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentFmcsaInspectionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options?: any): AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options?: any): AxiosPromise<AgentFmcsaInspectionListItemDtoPagedResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId: string, inspectionId: string, options?: any): AxiosPromise<IRemoteStreamContent> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId, inspectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options?: any): AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options?: any): AxiosPromise<AgentFmcsaInspectionResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentFmcsaInspectionApi - object-oriented interface
 * @export
 * @class AgentFmcsaInspectionApi
 * @extends {BaseAPI}
 */
export class AgentFmcsaInspectionApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentFmcsaInspectionApi
     */
    public apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options?: AxiosRequestConfig) {
        return AgentFmcsaInspectionApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsEmailPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentFmcsaInspectionApi
     */
    public apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return AgentFmcsaInspectionApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} inspectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentFmcsaInspectionApi
     */
    public apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId: string, inspectionId: string, options?: AxiosRequestConfig) {
        return AgentFmcsaInspectionApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsInspectionIdDownloadGet(tenantId, inspectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentFmcsaInspectionApi
     */
    public apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options?: AxiosRequestConfig) {
        return AgentFmcsaInspectionApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsManualPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest} apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentFmcsaInspectionApi
     */
    public apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest: ApiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options?: AxiosRequestConfig) {
        return AgentFmcsaInspectionApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPost(tenantId, apiAppAgentOperationsTenantsTenantIdFmcsaInspectionsWebPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentMasterEldDeviceApi - axios parameter creator
 * @export
 */
export const AgentMasterEldDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdDeactivatePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdDelete', 'id', id)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdGet', 'id', id)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest} apiAppAgentOperationsMasterEldDevicesIdDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdPut: async (id: number, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest: ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdPut', 'id', id)
            // verify required parameter 'apiAppAgentOperationsMasterEldDevicesIdDeleteRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdPut', 'apiAppAgentOperationsMasterEldDevicesIdDeleteRequest', apiAppAgentOperationsMasterEldDevicesIdDeleteRequest)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsMasterEldDevicesIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet: async (id: number, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet', 'id', id)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/{id}/usage-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesListPostRequest} apiAppAgentOperationsMasterEldDevicesListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesListPost: async (apiAppAgentOperationsMasterEldDevicesListPostRequest: ApiAppAgentOperationsMasterEldDevicesListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAppAgentOperationsMasterEldDevicesListPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesListPost', 'apiAppAgentOperationsMasterEldDevicesListPostRequest', apiAppAgentOperationsMasterEldDevicesListPostRequest)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsMasterEldDevicesListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesPostRequest} apiAppAgentOperationsMasterEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesPost: async (apiAppAgentOperationsMasterEldDevicesPostRequest: ApiAppAgentOperationsMasterEldDevicesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAppAgentOperationsMasterEldDevicesPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesPost', 'apiAppAgentOperationsMasterEldDevicesPostRequest', apiAppAgentOperationsMasterEldDevicesPostRequest)
            const localVarPath = `/api/app/agent-operations/master-eld-devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsMasterEldDevicesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesTransferPostRequest} apiAppAgentOperationsMasterEldDevicesTransferPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesTransferPost: async (apiAppAgentOperationsMasterEldDevicesTransferPostRequest: ApiAppAgentOperationsMasterEldDevicesTransferPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAppAgentOperationsMasterEldDevicesTransferPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsMasterEldDevicesTransferPost', 'apiAppAgentOperationsMasterEldDevicesTransferPostRequest', apiAppAgentOperationsMasterEldDevicesTransferPostRequest)
            const localVarPath = `/api/app/agent-operations/master-eld-devices/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsMasterEldDevicesTransferPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost: async (tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost', 'tenantId', tenantId)
            // verify required parameter 'masterEldDeviceId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost', 'masterEldDeviceId', masterEldDeviceId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost', 'apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest', apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/master-eld-devices/{masterEldDeviceId}/assign-vehicle`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"masterEldDeviceId"}}`, encodeURIComponent(String(masterEldDeviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost: async (tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost', 'tenantId', tenantId)
            // verify required parameter 'masterEldDeviceId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost', 'masterEldDeviceId', masterEldDeviceId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost', 'apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest', apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/master-eld-devices/{masterEldDeviceId}/reset`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"masterEldDeviceId"}}`, encodeURIComponent(String(masterEldDeviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost: async (tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost', 'tenantId', tenantId)
            // verify required parameter 'masterEldDeviceId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost', 'masterEldDeviceId', masterEldDeviceId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost', 'apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest', apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/master-eld-devices/{masterEldDeviceId}/unassign-vehicle`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"masterEldDeviceId"}}`, encodeURIComponent(String(masterEldDeviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentMasterEldDeviceApi - functional programming interface
 * @export
 */
export const AgentMasterEldDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentMasterEldDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest} apiAppAgentOperationsMasterEldDevicesIdDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesIdPut(id: number, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest: ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesIdPut(id, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id: number, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesListPostRequest} apiAppAgentOperationsMasterEldDevicesListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest: ApiAppAgentOperationsMasterEldDevicesListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesPostRequest} apiAppAgentOperationsMasterEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest: ApiAppAgentOperationsMasterEldDevicesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesTransferPostRequest} apiAppAgentOperationsMasterEldDevicesTransferPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest: ApiAppAgentOperationsMasterEldDevicesTransferPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldTransferResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentEldResetResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentMasterEldDeviceApi - factory interface
 * @export
 */
export const AgentMasterEldDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentMasterEldDeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id: number, options?: any): AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdDelete(id: number, options?: any): AxiosPromise<AgentMasterEldDeviceDeleteResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdGet(id: number, options?: any): AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest} apiAppAgentOperationsMasterEldDevicesIdDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdPut(id: number, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest: ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options?: any): AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesIdPut(id, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id: number, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<AgentMasterEldDeviceUsageHistoryResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesListPostRequest} apiAppAgentOperationsMasterEldDevicesListPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest: ApiAppAgentOperationsMasterEldDevicesListPostRequest, options?: any): AxiosPromise<AgentMasterEldDeviceResultDtoPagedResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesPostRequest} apiAppAgentOperationsMasterEldDevicesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest: ApiAppAgentOperationsMasterEldDevicesPostRequest, options?: any): AxiosPromise<AgentMasterEldDeviceResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppAgentOperationsMasterEldDevicesTransferPostRequest} apiAppAgentOperationsMasterEldDevicesTransferPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest: ApiAppAgentOperationsMasterEldDevicesTransferPostRequest, options?: any): AxiosPromise<AgentMasterEldTransferResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: any): AxiosPromise<AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: any): AxiosPromise<AgentEldResetResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {number} masterEldDeviceId 
         * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: any): AxiosPromise<AgentMasterEldVehicleAssignmentResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentMasterEldDeviceApi - object-oriented interface
 * @export
 * @class AgentMasterEldDeviceApi
 * @extends {BaseAPI}
 */
export class AgentMasterEldDeviceApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id: number, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesIdDelete(id: number, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesIdGet(id: number, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest} apiAppAgentOperationsMasterEldDevicesIdDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesIdPut(id: number, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest: ApiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesIdPut(id, apiAppAgentOperationsMasterEldDevicesIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id: number, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesIdUsageHistoryGet(id, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppAgentOperationsMasterEldDevicesListPostRequest} apiAppAgentOperationsMasterEldDevicesListPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest: ApiAppAgentOperationsMasterEldDevicesListPostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesListPost(apiAppAgentOperationsMasterEldDevicesListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppAgentOperationsMasterEldDevicesPostRequest} apiAppAgentOperationsMasterEldDevicesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest: ApiAppAgentOperationsMasterEldDevicesPostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesPost(apiAppAgentOperationsMasterEldDevicesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppAgentOperationsMasterEldDevicesTransferPostRequest} apiAppAgentOperationsMasterEldDevicesTransferPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest: ApiAppAgentOperationsMasterEldDevicesTransferPostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsMasterEldDevicesTransferPost(apiAppAgentOperationsMasterEldDevicesTransferPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} masterEldDeviceId 
     * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} masterEldDeviceId 
     * @param {ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest} apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest: ApiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdResetPost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdDriversDriverIdLogoutPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {number} masterEldDeviceId 
     * @param {ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest} apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentMasterEldDeviceApi
     */
    public apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId: string, masterEldDeviceId: number, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest: ApiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options?: AxiosRequestConfig) {
        return AgentMasterEldDeviceApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdUnassignVehiclePost(tenantId, masterEldDeviceId, apiAppAgentOperationsTenantsTenantIdMasterEldDevicesMasterEldDeviceIdAssignVehiclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentOperationsApi - axios parameter creator
 * @export
 */
export const AgentOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/agent-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdActivatePost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdActivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenant-registrations/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest} apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdApprovePost: async (id: string, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest: ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdApprovePost', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdApprovePost', 'apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest', apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest)
            const localVarPath = `/api/app/agent-operations/tenant-registrations/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdDeactivatePost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/agent-operations/tenant-registrations/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest} apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdReassignPost: async (id: string, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest: ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdReassignPost', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdReassignPost', 'apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest', apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest)
            const localVarPath = `/api/app/agent-operations/tenant-registrations/{id}/reassign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest} apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdRejectPost: async (id: string, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest: ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdRejectPost', 'id', id)
            // verify required parameter 'apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsIdRejectPost', 'apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest', apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest)
            const localVarPath = `/api/app/agent-operations/tenant-registrations/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppAgentOperationsTenantRegistrationsPostRequest} apiAppAgentOperationsTenantRegistrationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsPost: async (apiAppAgentOperationsTenantRegistrationsPostRequest: ApiAppAgentOperationsTenantRegistrationsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAppAgentOperationsTenantRegistrationsPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantRegistrationsPost', 'apiAppAgentOperationsTenantRegistrationsPostRequest', apiAppAgentOperationsTenantRegistrationsPostRequest)
            const localVarPath = `/api/app/agent-operations/tenant-registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantRegistrationsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentOperationsApi - functional programming interface
 * @export
 */
export const AgentOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentOperationsApiInfoDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsIdActivatePost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsIdActivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest} apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsIdApprovePost(id: string, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest: ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsIdApprovePost(id, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest} apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsIdReassignPost(id: string, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest: ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsIdReassignPost(id, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest} apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsIdRejectPost(id: string, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest: ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsIdRejectPost(id, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppAgentOperationsTenantRegistrationsPostRequest} apiAppAgentOperationsTenantRegistrationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest: ApiAppAgentOperationsTenantRegistrationsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentOperationsApi - factory interface
 * @export
 */
export const AgentOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentOperationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsGet(options?: any): AxiosPromise<AgentOperationsApiInfoDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdActivatePost(id: string, options?: any): AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsIdActivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest} apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdApprovePost(id: string, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest: ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options?: any): AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsIdApprovePost(id, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id: string, options?: any): AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest} apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdReassignPost(id: string, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest: ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options?: any): AxiosPromise<AgentCustomerAdministrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsIdReassignPost(id, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest} apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsIdRejectPost(id: string, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest: ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options?: any): AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsIdRejectPost(id, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppAgentOperationsTenantRegistrationsPostRequest} apiAppAgentOperationsTenantRegistrationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest: ApiAppAgentOperationsTenantRegistrationsPostRequest, options?: any): AxiosPromise<AgentTenantRegistrationResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentOperationsApi - object-oriented interface
 * @export
 * @class AgentOperationsApi
 * @extends {BaseAPI}
 */
export class AgentOperationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsGet(options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsIdActivatePost(id: string, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsIdActivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest} apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsIdApprovePost(id: string, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest: ApiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsIdApprovePost(id, apiAppAgentOperationsTenantRegistrationsIdApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id: string, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest} apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsIdReassignPost(id: string, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest: ApiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsIdReassignPost(id, apiAppAgentOperationsTenantRegistrationsIdReassignPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest} apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsIdRejectPost(id: string, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest: ApiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsIdRejectPost(id, apiAppAgentOperationsTenantRegistrationsIdRejectPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppAgentOperationsTenantRegistrationsPostRequest} apiAppAgentOperationsTenantRegistrationsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentOperationsApi
     */
    public apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest: ApiAppAgentOperationsTenantRegistrationsPostRequest, options?: AxiosRequestConfig) {
        return AgentOperationsApiFp(this.configuration).apiAppAgentOperationsTenantRegistrationsPost(apiAppAgentOperationsTenantRegistrationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgentReportApi - axios parameter creator
 * @export
 */
export const AgentReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest} apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost', 'apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest', apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/daily-logs`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost', 'apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest', apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/eld-usage-by-events/export`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost', 'apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest', apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/eld-usage-by-events/query`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest} apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsIftaPost: async (tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsIftaPost', 'tenantId', tenantId)
            // verify required parameter 'apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsIftaPost', 'apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest', apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/ifta`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet: async (tenantId: string, reportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet', 'tenantId', tenantId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet', 'reportId', reportId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/{reportId}/download`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsReportIdGet: async (tenantId: string, reportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsReportIdGet', 'tenantId', tenantId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('apiAppAgentOperationsTenantsTenantIdReportsReportIdGet', 'reportId', reportId)
            const localVarPath = `/api/app/agent-operations/tenants/{tenantId}/reports/{reportId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentReportApi - functional programming interface
 * @export
 */
export const AgentReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest} apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentEldUsageByEventsResultDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest} apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId: string, reportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IRemoteStreamContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId, reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId: string, reportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentReportStatusDtoAgentOperationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId, reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgentReportApi - factory interface
 * @export
 */
export const AgentReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentReportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest} apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options?: any): AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options?: any): AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options?: any): AxiosPromise<AgentEldUsageByEventsResultDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest} apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options?: any): AxiosPromise<AgentReportReferenceDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId: string, reportId: string, options?: any): AxiosPromise<IRemoteStreamContent> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId: string, reportId: string, options?: any): AxiosPromise<AgentReportStatusDtoAgentOperationResultDto> {
            return localVarFp.apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId, reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentReportApi - object-oriented interface
 * @export
 * @class AgentReportApi
 * @extends {BaseAPI}
 */
export class AgentReportApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest} apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsDailyLogsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest} apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsEldUsageByEventsQueryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest} apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId: string, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest: ApiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsIftaPost(tenantId, apiAppAgentOperationsTenantsTenantIdReportsIftaPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId: string, reportId: string, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsReportIdDownloadGet(tenantId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentReportApi
     */
    public apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId: string, reportId: string, options?: AxiosRequestConfig) {
        return AgentReportApiFp(this.configuration).apiAppAgentOperationsTenantsTenantIdReportsReportIdGet(tenantId, reportId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AppDataApi - axios parameter creator
 * @export
 */
export const AppDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataAppdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/appdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataMasterappdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/masterappdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataUserpermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/userpermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppDataApi - functional programming interface
 * @export
 */
export const AppDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataAppdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataAppdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataMasterappdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterAppData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataMasterappdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataUserpermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataUserpermissionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppDataApi - factory interface
 * @export
 */
export const AppDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppDataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataAppdataGet(options?: any): AxiosPromise<AppData> {
            return localVarFp.apiAppAppdataAppdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataMasterappdataGet(options?: any): AxiosPromise<MasterAppData> {
            return localVarFp.apiAppAppdataMasterappdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataUserpermissionsGet(options?: any): AxiosPromise<PermissionListResultDto> {
            return localVarFp.apiAppAppdataUserpermissionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppDataApi - object-oriented interface
 * @export
 * @class AppDataApi
 * @extends {BaseAPI}
 */
export class AppDataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataAppdataGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataAppdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataMasterappdataGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataMasterappdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataUserpermissionsGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataUserpermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AppleAppSiteAssociationApi - axios parameter creator
 * @export
 */
export const AppleAppSiteAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wellKnownAppleAppSiteAssociationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/apple-app-site-association`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppleAppSiteAssociationApi - functional programming interface
 * @export
 */
export const AppleAppSiteAssociationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppleAppSiteAssociationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wellKnownAppleAppSiteAssociationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wellKnownAppleAppSiteAssociationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppleAppSiteAssociationApi - factory interface
 * @export
 */
export const AppleAppSiteAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppleAppSiteAssociationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wellKnownAppleAppSiteAssociationGet(options?: any): AxiosPromise<void> {
            return localVarFp.wellKnownAppleAppSiteAssociationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppleAppSiteAssociationApi - object-oriented interface
 * @export
 * @class AppleAppSiteAssociationApi
 * @extends {BaseAPI}
 */
export class AppleAppSiteAssociationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppleAppSiteAssociationApi
     */
    public wellKnownAppleAppSiteAssociationGet(options?: AxiosRequestConfig) {
        return AppleAppSiteAssociationApiFp(this.configuration).wellKnownAppleAppSiteAssociationGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CameraApi - axios parameter creator
 * @export
 */
export const CameraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraRecordingSessionsGet: async (vehicleId?: number, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/camera/recording-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraVideodetailMediaIdGet: async (mediaId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('apiAppCameraVideodetailMediaIdGet', 'mediaId', mediaId)
            const localVarPath = `/api/app/camera/videodetail/{mediaId}`
                .replace(`{${"mediaId"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDebugReplayMessagesFromCsvPost: async (path?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/debug/replay-messages-from-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaRequestEnumsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/media-request-enums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestVideoUploadPostRequest} [requestVideoUploadPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVideoUploadPost: async (requestVideoUploadPostRequest?: RequestVideoUploadPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request-video-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestVideoUploadPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startLiveStreamsVehicleIdPost: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('startLiveStreamsVehicleIdPost', 'vehicleId', vehicleId)
            const localVarPath = `/start-live-streams/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopLiveStreamsVehicleIdPost: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('stopLiveStreamsVehicleIdPost', 'vehicleId', vehicleId)
            const localVarPath = `/stop-live-streams/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CameraApi - functional programming interface
 * @export
 */
export const CameraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CameraApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCameraRecordingSessionsGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraRecordingSessionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCameraRecordingSessionsGet(vehicleId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCameraVideodetailMediaIdGet(mediaId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraVideoDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCameraVideodetailMediaIdGet(mediaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDebugReplayMessagesFromCsvPost(path?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDebugReplayMessagesFromCsvPost(path, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaRequestEnumsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraMediaRequestEnumsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaRequestEnumsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RequestVideoUploadPostRequest} [requestVideoUploadPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestVideoUploadPost(requestVideoUploadPostRequest?: RequestVideoUploadPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestVideoUploadPost(requestVideoUploadPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startLiveStreamsVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startLiveStreamsVehicleIdPost(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopLiveStreamsVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopLiveStreamsVehicleIdPost(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CameraApi - factory interface
 * @export
 */
export const CameraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CameraApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraRecordingSessionsGet(vehicleId?: number, date?: string, options?: any): AxiosPromise<CameraRecordingSessionsDto> {
            return localVarFp.apiAppCameraRecordingSessionsGet(vehicleId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraVideodetailMediaIdGet(mediaId: string, options?: any): AxiosPromise<CameraVideoDetailDto> {
            return localVarFp.apiAppCameraVideodetailMediaIdGet(mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDebugReplayMessagesFromCsvPost(path?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDebugReplayMessagesFromCsvPost(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaRequestEnumsGet(options?: any): AxiosPromise<CameraMediaRequestEnumsDto> {
            return localVarFp.mediaRequestEnumsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestVideoUploadPostRequest} [requestVideoUploadPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVideoUploadPost(requestVideoUploadPostRequest?: RequestVideoUploadPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.requestVideoUploadPost(requestVideoUploadPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startLiveStreamsVehicleIdPost(vehicleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.startLiveStreamsVehicleIdPost(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopLiveStreamsVehicleIdPost(vehicleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.stopLiveStreamsVehicleIdPost(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CameraApi - object-oriented interface
 * @export
 * @class CameraApi
 * @extends {BaseAPI}
 */
export class CameraApi extends BaseAPI {
    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public apiAppCameraRecordingSessionsGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).apiAppCameraRecordingSessionsGet(vehicleId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mediaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public apiAppCameraVideodetailMediaIdGet(mediaId: string, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).apiAppCameraVideodetailMediaIdGet(mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public apiAppDebugReplayMessagesFromCsvPost(path?: string, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).apiAppDebugReplayMessagesFromCsvPost(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public mediaRequestEnumsGet(options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).mediaRequestEnumsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RequestVideoUploadPostRequest} [requestVideoUploadPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public requestVideoUploadPost(requestVideoUploadPostRequest?: RequestVideoUploadPostRequest, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).requestVideoUploadPost(requestVideoUploadPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public startLiveStreamsVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).startLiveStreamsVehicleIdPost(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraApi
     */
    public stopLiveStreamsVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig) {
        return CameraApiFp(this.configuration).stopLiveStreamsVehicleIdPost(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CameraEmbedApi - axios parameter creator
 * @export
 */
export const CameraEmbedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cameraEmbedLiveSessionIdGet: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cameraEmbedLiveSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/camera/embed/live/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cameraEmbedLiveSessionIdThemeCssGet: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cameraEmbedLiveSessionIdThemeCssGet', 'sessionId', sessionId)
            const localVarPath = `/camera/embed/live/{sessionId}/theme.css`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CameraEmbedApi - functional programming interface
 * @export
 */
export const CameraEmbedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CameraEmbedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cameraEmbedLiveSessionIdGet(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cameraEmbedLiveSessionIdGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cameraEmbedLiveSessionIdThemeCssGet(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cameraEmbedLiveSessionIdThemeCssGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CameraEmbedApi - factory interface
 * @export
 */
export const CameraEmbedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CameraEmbedApiFp(configuration)
    return {
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cameraEmbedLiveSessionIdGet(sessionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cameraEmbedLiveSessionIdGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cameraEmbedLiveSessionIdThemeCssGet(sessionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cameraEmbedLiveSessionIdThemeCssGet(sessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CameraEmbedApi - object-oriented interface
 * @export
 * @class CameraEmbedApi
 * @extends {BaseAPI}
 */
export class CameraEmbedApi extends BaseAPI {
    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraEmbedApi
     */
    public cameraEmbedLiveSessionIdGet(sessionId: string, options?: AxiosRequestConfig) {
        return CameraEmbedApiFp(this.configuration).cameraEmbedLiveSessionIdGet(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraEmbedApi
     */
    public cameraEmbedLiveSessionIdThemeCssGet(sessionId: string, options?: AxiosRequestConfig) {
        return CameraEmbedApiFp(this.configuration).cameraEmbedLiveSessionIdThemeCssGet(sessionId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CameraEmbedSessionApi - axios parameter creator
 * @export
 */
export const CameraEmbedSessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/cameraembedsession/liveplayerlaunch/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CameraEmbedSessionApi - functional programming interface
 * @export
 */
export const CameraEmbedSessionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CameraEmbedSessionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraEmbedLaunchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CameraEmbedSessionApi - factory interface
 * @export
 */
export const CameraEmbedSessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CameraEmbedSessionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId: number, options?: any): AxiosPromise<CameraEmbedLaunchDto> {
            return localVarFp.apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CameraEmbedSessionApi - object-oriented interface
 * @export
 * @class CameraEmbedSessionApi
 * @extends {BaseAPI}
 */
export class CameraEmbedSessionApi extends BaseAPI {
    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CameraEmbedSessionApi
     */
    public apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId: number, options?: AxiosRequestConfig) {
        return CameraEmbedSessionApiFp(this.configuration).apiAppCameraembedsessionLiveplayerlaunchVehicleIdPost(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdDelete', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdGet', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdPut: async (id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdPut', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyPost: async (apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyPost(apiAppCompanyGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppCompanyDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<CompanyDtoPagedResultDto> {
            return localVarFp.apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<CompanyListDtoPagedResultDto> {
            return localVarFp.apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<CompanyListDto>> {
            return localVarFp.apiAppCompanyGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<CompanyListDto>> {
            return localVarFp.apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCompanyIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdGet(id: number, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyPost(apiAppCompanyGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdDelete(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyPost(apiAppCompanyGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyMutationWorkflowApi - axios parameter creator
 * @export
 */
export const CompanyMutationWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest} [apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowCheckuniqueconstraintsPost: async (apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/companymutationworkflow/checkuniqueconstraints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdChangestatusPost: async (id: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanymutationworkflowIdChangestatusPost', 'id', id)
            const localVarPath = `/api/app/companymutationworkflow/{id}/changestatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdDeactivatePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanymutationworkflowIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/companymutationworkflow/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdPut: async (id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanymutationworkflowIdPut', 'id', id)
            const localVarPath = `/api/app/companymutationworkflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preserveStatus !== undefined) {
                localVarQueryParameter['preserveStatus'] = preserveStatus;
            }

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowPost: async (updateDocuments?: boolean, apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/companymutationworkflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyMutationWorkflowApi - functional programming interface
 * @export
 */
export const CompanyMutationWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyMutationWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest} [apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanymutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanymutationworkflowIdChangestatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanymutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDtoEntityStatusChangeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanymutationworkflowIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanymutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanymutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppCompanyIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanymutationworkflowPost(updateDocuments?: boolean, apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanymutationworkflowPost(updateDocuments, apiAppCompanyGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyMutationWorkflowApi - factory interface
 * @export
 */
export const CompanyMutationWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyMutationWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest} [apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanymutationworkflowIdChangestatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdDeactivatePost(id: number, options?: any): AxiosPromise<CompanyDtoEntityStatusChangeResult> {
            return localVarFp.apiAppCompanymutationworkflowIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanymutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppCompanyIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanymutationworkflowPost(updateDocuments?: boolean, apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanymutationworkflowPost(updateDocuments, apiAppCompanyGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyMutationWorkflowApi - object-oriented interface
 * @export
 * @class CompanyMutationWorkflowApi
 * @extends {BaseAPI}
 */
export class CompanyMutationWorkflowApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest} [apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMutationWorkflowApi
     */
    public apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig) {
        return CompanyMutationWorkflowApiFp(this.configuration).apiAppCompanymutationworkflowCheckuniqueconstraintsPost(apiAppCompanymutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMutationWorkflowApi
     */
    public apiAppCompanymutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return CompanyMutationWorkflowApiFp(this.configuration).apiAppCompanymutationworkflowIdChangestatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMutationWorkflowApi
     */
    public apiAppCompanymutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig) {
        return CompanyMutationWorkflowApiFp(this.configuration).apiAppCompanymutationworkflowIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [preserveStatus] 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMutationWorkflowApi
     */
    public apiAppCompanymutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig) {
        return CompanyMutationWorkflowApiFp(this.configuration).apiAppCompanymutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppCompanyIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMutationWorkflowApi
     */
    public apiAppCompanymutationworkflowPost(updateDocuments?: boolean, apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig) {
        return CompanyMutationWorkflowApiFp(this.configuration).apiAppCompanymutationworkflowPost(updateDocuments, apiAppCompanyGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerServiceAccountApi - axios parameter creator
 * @export
 */
export const CustomerServiceAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest} [apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost: async (apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest?: ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customerserviceaccount/acquiremasteruseraccesstoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/customerserviceaccount/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRestoreserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdRestoreserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/restoreserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRevokeserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdRevokeserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/revokeserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdSuspendserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdSuspendserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/suspendserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/resendwelcomeemail/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost', 'userId', userId)
            const localVarPath = `/api/app/customerserviceaccount/resendwelcomeemailforserviceaccount/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/resettwofactorauthentication/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost', 'userId', userId)
            const localVarPath = `/api/app/customerserviceaccount/resettwofactorauthenticationforserviceaccount/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountServiceaccountPost: async (apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customerserviceaccount/serviceaccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCustomerserviceaccountServiceaccountPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerServiceAccountApi - functional programming interface
 * @export
 */
export const CustomerServiceAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerServiceAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest} [apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest?: ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterUserOverrideOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerServiceAccountApi - factory interface
 * @export
 */
export const CustomerServiceAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerServiceAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest} [apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest?: ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options?: any): AxiosPromise<MasterUserOverrideOutput> {
            return localVarFp.apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerServiceAccountApi - object-oriented interface
 * @export
 * @class CustomerServiceAccountApi
 * @extends {BaseAPI}
 */
export class CustomerServiceAccountApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest} [apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest?: ApiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPost(apiAppCustomerserviceaccountAcquiremasteruseraccesstokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomersEldDevicesApi - axios parameter creator
 * @export
 */
export const CustomersEldDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerselddevicesGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customerselddevices/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersEldDevicesApi - functional programming interface
 * @export
 */
export const CustomersEldDevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersEldDevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerEldDevicesViewListPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersEldDevicesApi - factory interface
 * @export
 */
export const CustomersEldDevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersEldDevicesApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<CustomerEldDevicesViewListPagedResultDto> {
            return localVarFp.apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersEldDevicesApi - object-oriented interface
 * @export
 * @class CustomersEldDevicesApi
 * @extends {BaseAPI}
 */
export class CustomersEldDevicesApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersEldDevicesApi
     */
    public apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CustomersEldDevicesApiFp(this.configuration).apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriverhoseventsGet: async (vehicleId?: number, logDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboarddriverhosevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (logDate !== undefined) {
                localVarQueryParameter['LogDate'] = (logDate as any instanceof Date) ?
                    (logDate as any).toISOString() :
                    logDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriversdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboarddriversdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboardlocationsdataGet: async (selectedCompanies?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboardlocationsdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedCompanies) {
                localVarQueryParameter['SelectedCompanies'] = selectedCompanies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardDriverHosEventsOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboarddriversdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardDriverDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboarddriversdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: any): AxiosPromise<Array<DashboardDriverHosEventsOutput>> {
            return localVarFp.apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriversdataGet(options?: any): AxiosPromise<Array<DashboardDriverDto>> {
            return localVarFp.apiAppDashboardDashboarddriversdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: any): AxiosPromise<Array<CurrentLocationDto>> {
            return localVarFp.apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [logDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboarddriversdataGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboarddriversdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [selectedCompanies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataTransferApi - axios parameter creator
 * @export
 */
export const DataTransferApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/drivers/export/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferDriversExportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/drivers/export/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversExportPostRequest} [apiAppDataTransferDriversExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportPost: async (apiAppDataTransferDriversExportPostRequest?: ApiAppDataTransferDriversExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/drivers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferDriversExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/drivers/import/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferDriversImportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/drivers/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversImportPostRequest} [apiAppDataTransferDriversImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportPost: async (apiAppDataTransferDriversImportPostRequest?: ApiAppDataTransferDriversImportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/drivers/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferDriversImportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportUploadPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/drivers/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/locations/export/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferLocationsExportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/locations/export/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsExportPostRequest} [apiAppDataTransferLocationsExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportPost: async (apiAppDataTransferLocationsExportPostRequest?: ApiAppDataTransferLocationsExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/locations/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferLocationsExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/locations/import/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferLocationsImportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/locations/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsImportPostRequest} [apiAppDataTransferLocationsImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportPost: async (apiAppDataTransferLocationsImportPostRequest?: ApiAppDataTransferLocationsImportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/locations/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferLocationsImportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportUploadPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/locations/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/trailers/export/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferTrailersExportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/trailers/export/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersExportPostRequest} [apiAppDataTransferTrailersExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportPost: async (apiAppDataTransferTrailersExportPostRequest?: ApiAppDataTransferTrailersExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/trailers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferTrailersExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/trailers/import/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferTrailersImportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/trailers/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersImportPostRequest} [apiAppDataTransferTrailersImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportPost: async (apiAppDataTransferTrailersImportPostRequest?: ApiAppDataTransferTrailersImportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/trailers/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferTrailersImportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportUploadPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/trailers/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/vehicles/export/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferVehiclesExportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/vehicles/export/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesExportPostRequest} [apiAppDataTransferVehiclesExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportPost: async (apiAppDataTransferVehiclesExportPostRequest?: ApiAppDataTransferVehiclesExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/vehicles/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferVehiclesExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/vehicles/import/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDataTransferVehiclesImportIdGet', 'id', id)
            const localVarPath = `/api/app/data-transfer/vehicles/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesImportPostRequest} [apiAppDataTransferVehiclesImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportPost: async (apiAppDataTransferVehiclesImportPostRequest?: ApiAppDataTransferVehiclesImportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/vehicles/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDataTransferVehiclesImportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportUploadPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/data-transfer/vehicles/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataTransferApi - functional programming interface
 * @export
 */
export const DataTransferApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataTransferApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversExportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversExportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversExportPostRequest} [apiAppDataTransferDriversExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest?: ApiAppDataTransferDriversExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversImportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversImportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversImportPostRequest} [apiAppDataTransferDriversImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest?: ApiAppDataTransferDriversImportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferDriversImportUploadPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferDriversImportUploadPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsExportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsExportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsExportPostRequest} [apiAppDataTransferLocationsExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest?: ApiAppDataTransferLocationsExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsImportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsImportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsImportPostRequest} [apiAppDataTransferLocationsImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest?: ApiAppDataTransferLocationsImportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferLocationsImportUploadPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferLocationsImportUploadPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersExportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersExportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersExportPostRequest} [apiAppDataTransferTrailersExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest?: ApiAppDataTransferTrailersExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersImportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersImportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersImportPostRequest} [apiAppDataTransferTrailersImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest?: ApiAppDataTransferTrailersImportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferTrailersImportUploadPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferTrailersImportUploadPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesExportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesExportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesExportPostRequest} [apiAppDataTransferVehiclesExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest?: ApiAppDataTransferVehiclesExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesImportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesImportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesImportPostRequest} [apiAppDataTransferVehiclesImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest?: ApiAppDataTransferVehiclesImportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTransferImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDataTransferVehiclesImportUploadPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDataTransferVehiclesImportUploadPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataTransferApi - factory interface
 * @export
 */
export const DataTransferApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataTransferApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferExportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportIdGet(id: string, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferDriversExportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversExportPostRequest} [apiAppDataTransferDriversExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest?: ApiAppDataTransferDriversExportPostRequest, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferImportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportIdGet(id: string, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferDriversImportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferDriversImportPostRequest} [apiAppDataTransferDriversImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest?: ApiAppDataTransferDriversImportPostRequest, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferDriversImportUploadPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDataTransferDriversImportUploadPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferExportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportIdGet(id: string, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferLocationsExportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsExportPostRequest} [apiAppDataTransferLocationsExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest?: ApiAppDataTransferLocationsExportPostRequest, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferImportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportIdGet(id: string, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferLocationsImportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferLocationsImportPostRequest} [apiAppDataTransferLocationsImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest?: ApiAppDataTransferLocationsImportPostRequest, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferLocationsImportUploadPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDataTransferLocationsImportUploadPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferExportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportIdGet(id: string, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferTrailersExportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersExportPostRequest} [apiAppDataTransferTrailersExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest?: ApiAppDataTransferTrailersExportPostRequest, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferImportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportIdGet(id: string, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferTrailersImportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferTrailersImportPostRequest} [apiAppDataTransferTrailersImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest?: ApiAppDataTransferTrailersImportPostRequest, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferTrailersImportUploadPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDataTransferTrailersImportUploadPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferExportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportIdGet(id: string, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferVehiclesExportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesExportPostRequest} [apiAppDataTransferVehiclesExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest?: ApiAppDataTransferVehiclesExportPostRequest, options?: any): AxiosPromise<DataTransferExportDto> {
            return localVarFp.apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DataTransferImportDtoPagedResultDto> {
            return localVarFp.apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportIdGet(id: string, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferVehiclesImportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDataTransferVehiclesImportPostRequest} [apiAppDataTransferVehiclesImportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest?: ApiAppDataTransferVehiclesImportPostRequest, options?: any): AxiosPromise<DataTransferImportDto> {
            return localVarFp.apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDataTransferVehiclesImportUploadPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDataTransferVehiclesImportUploadPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataTransferApi - object-oriented interface
 * @export
 * @class DataTransferApi
 * @extends {BaseAPI}
 */
export class DataTransferApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversExportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversExportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferDriversExportPostRequest} [apiAppDataTransferDriversExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest?: ApiAppDataTransferDriversExportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversExportPost(apiAppDataTransferDriversExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversImportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversImportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferDriversImportPostRequest} [apiAppDataTransferDriversImportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest?: ApiAppDataTransferDriversImportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversImportPost(apiAppDataTransferDriversImportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferDriversImportUploadPost(options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferDriversImportUploadPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsExportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsExportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferLocationsExportPostRequest} [apiAppDataTransferLocationsExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest?: ApiAppDataTransferLocationsExportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsExportPost(apiAppDataTransferLocationsExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsImportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsImportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferLocationsImportPostRequest} [apiAppDataTransferLocationsImportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest?: ApiAppDataTransferLocationsImportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsImportPost(apiAppDataTransferLocationsImportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferLocationsImportUploadPost(options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferLocationsImportUploadPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersExportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersExportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferTrailersExportPostRequest} [apiAppDataTransferTrailersExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest?: ApiAppDataTransferTrailersExportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersExportPost(apiAppDataTransferTrailersExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersImportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersImportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferTrailersImportPostRequest} [apiAppDataTransferTrailersImportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest?: ApiAppDataTransferTrailersImportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersImportPost(apiAppDataTransferTrailersImportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferTrailersImportUploadPost(options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferTrailersImportUploadPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesExportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesExportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesExportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferVehiclesExportPostRequest} [apiAppDataTransferVehiclesExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest?: ApiAppDataTransferVehiclesExportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesExportPost(apiAppDataTransferVehiclesExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesImportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesImportIdGet(id: string, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesImportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDataTransferVehiclesImportPostRequest} [apiAppDataTransferVehiclesImportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest?: ApiAppDataTransferVehiclesImportPostRequest, options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesImportPost(apiAppDataTransferVehiclesImportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTransferApi
     */
    public apiAppDataTransferVehiclesImportUploadPost(options?: AxiosRequestConfig) {
        return DataTransferApiFp(this.configuration).apiAppDataTransferVehiclesImportUploadPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DemoAccountApi - axios parameter creator
 * @export
 */
export const DemoAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangePasswordPost: async (apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountChangePasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdDelete', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdGet', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdPut: async (id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdPut', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountPost: async (apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemoAccountApi - functional programming interface
 * @export
 */
export const DemoAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemoAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemoAccountListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemoAccountListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemoAccountApi - factory interface
 * @export
 */
export const DemoAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemoAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDemoaccountDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DemoAccountListDtoPagedResultDto> {
            return localVarFp.apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<DemoAccountListDto>> {
            return localVarFp.apiAppDemoaccountGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DemoAccountListDto>> {
            return localVarFp.apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdGet(id: string, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemoAccountApi - object-oriented interface
 * @export
 * @class DemoAccountApi
 * @extends {BaseAPI}
 */
export class DemoAccountApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdDelete(id: string, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdGet(id: string, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DiagnosticsApi - axios parameter creator
 * @export
 */
export const DiagnosticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsAcknowledgeIdPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDiagnosticsAcknowledgeIdPost', 'id', id)
            const localVarPath = `/api/app/diagnostics/acknowledge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/diagnostics/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsResolveObd2CodeGet: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiAppDiagnosticsResolveObd2CodeGet', 'code', code)
            const localVarPath = `/api/app/diagnostics/resolve-obd2/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiagnosticsApi - functional programming interface
 * @export
 */
export const DiagnosticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiagnosticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticRecordListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsAcknowledgeIdPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticRecordListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedObd2Code>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsResolveObd2CodeGet(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DiagnosticsApi - factory interface
 * @export
 */
export const DiagnosticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiagnosticsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: any): AxiosPromise<DiagnosticRecordListDto> {
            return localVarFp.apiAppDiagnosticsAcknowledgeIdPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DiagnosticRecordListDtoPagedResultDto> {
            return localVarFp.apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: any): AxiosPromise<ResolvedObd2Code> {
            return localVarFp.apiAppDiagnosticsResolveObd2CodeGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiagnosticsApi - object-oriented interface
 * @export
 * @class DiagnosticsApi
 * @extends {BaseAPI}
 */
export class DiagnosticsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsAcknowledgeIdPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsResolveObd2CodeGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DisconnectedDrivingApi - axios parameter creator
 * @export
 */
export const DisconnectedDrivingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppDisconnecteddrivingGetFilteredListPostRequest} [apiAppDisconnecteddrivingGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDisconnecteddrivingGetFilteredListPost: async (apiAppDisconnecteddrivingGetFilteredListPostRequest?: ApiAppDisconnecteddrivingGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/disconnecteddriving/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDisconnecteddrivingGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDisconnecteddrivingResolvePostRequest} [apiAppDisconnecteddrivingResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDisconnecteddrivingResolvePost: async (apiAppDisconnecteddrivingResolvePostRequest?: ApiAppDisconnecteddrivingResolvePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/disconnecteddriving/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDisconnecteddrivingResolvePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DisconnectedDrivingApi - functional programming interface
 * @export
 */
export const DisconnectedDrivingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DisconnectedDrivingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppDisconnecteddrivingGetFilteredListPostRequest} [apiAppDisconnecteddrivingGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest?: ApiAppDisconnecteddrivingGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisconnectedDrivingLocationGroupDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDisconnecteddrivingResolvePostRequest} [apiAppDisconnecteddrivingResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest?: ApiAppDisconnecteddrivingResolvePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DisconnectedDrivingApi - factory interface
 * @export
 */
export const DisconnectedDrivingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DisconnectedDrivingApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppDisconnecteddrivingGetFilteredListPostRequest} [apiAppDisconnecteddrivingGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest?: ApiAppDisconnecteddrivingGetFilteredListPostRequest, options?: any): AxiosPromise<DisconnectedDrivingLocationGroupDtoPagedResultDto> {
            return localVarFp.apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDisconnecteddrivingResolvePostRequest} [apiAppDisconnecteddrivingResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest?: ApiAppDisconnecteddrivingResolvePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DisconnectedDrivingApi - object-oriented interface
 * @export
 * @class DisconnectedDrivingApi
 * @extends {BaseAPI}
 */
export class DisconnectedDrivingApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppDisconnecteddrivingGetFilteredListPostRequest} [apiAppDisconnecteddrivingGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisconnectedDrivingApi
     */
    public apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest?: ApiAppDisconnecteddrivingGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DisconnectedDrivingApiFp(this.configuration).apiAppDisconnecteddrivingGetFilteredListPost(apiAppDisconnecteddrivingGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDisconnecteddrivingResolvePostRequest} [apiAppDisconnecteddrivingResolvePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DisconnectedDrivingApi
     */
    public apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest?: ApiAppDisconnecteddrivingResolvePostRequest, options?: AxiosRequestConfig) {
        return DisconnectedDrivingApiFp(this.configuration).apiAppDisconnecteddrivingResolvePost(apiAppDisconnecteddrivingResolvePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDelete: async (url?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDownloadBlobNameGet: async (blobName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blobName' is not null or undefined
            assertParamExists('apiAppDocumentDownloadBlobNameGet', 'blobName', blobName)
            const localVarPath = `/api/app/document/download/{blobName}`
                .replace(`{${"blobName"}}`, encodeURIComponent(String(blobName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentUploadPost: async (input?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (input !== undefined) { 
                localVarFormParams.append('input', input as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentDelete(url?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentDelete(url, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentDownloadBlobNameGet(blobName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentDownloadBlobNameGet(blobName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentUploadPost(input?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentUploadPost(input, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDelete(url?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentDelete(url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDownloadBlobNameGet(blobName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentDownloadBlobNameGet(blobName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentUploadPost(input?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDocumentUploadPost(input, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentDelete(url?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentDelete(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} blobName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentDownloadBlobNameGet(blobName: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentDownloadBlobNameGet(blobName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentUploadPost(input?: any, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentUploadPost(input, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentCenterApi - axios parameter creator
 * @export
 */
export const DocumentCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityDelete: async (documentId: number, entityType: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAppDocumentcenterDocumentforentityDelete', 'documentId', documentId)
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('apiAppDocumentcenterDocumentforentityDelete', 'entityType', entityType)
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPost: async (apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterDocumentforentityDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPut: async (apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterDocumentforentityDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentbyidPost: async (apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/getdocumentbyid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterGetdocumentbyidPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentsbyentitytypePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/getdocumentsbyentitytype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentCenterApi - functional programming interface
 * @export
 */
export const DocumentCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentCenterApi - factory interface
 * @export
 */
export const DocumentCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DocumentListDtoPagedResultDto> {
            return localVarFp.apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentCenterApi - object-oriented interface
 * @export
 * @class DocumentCenterApi
 * @extends {BaseAPI}
 */
export class DocumentCenterApi extends BaseAPI {
    /**
     * 
     * @param {number} documentId 
     * @param {number} entityType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverApi - axios parameter creator
 * @export
 */
export const DriverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangepasswordPost: async (apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/changepassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverChangepasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetpasswordDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverGetpasswordDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driver/getpassword/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdDelete', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdGet', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdPut: async (id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdPut', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdTogglepersonalconveyancePut: async (id: number, togglePc?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdTogglepersonalconveyancePut', 'id', id)
            const localVarPath = `/api/app/driver/{id}/togglepersonalconveyance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (togglePc !== undefined) {
                localVarQueryParameter['togglePc'] = togglePc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdToggleyardmovePut: async (id: number, yardMove?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdToggleyardmovePut', 'id', id)
            const localVarPath = `/api/app/driver/{id}/toggleyardmove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (yardMove !== undefined) {
                localVarQueryParameter['yardMove'] = yardMove;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverLogoutDriverIdPost: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverLogoutDriverIdPost', 'driverId', driverId)
            const localVarPath = `/api/app/driver/logout/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverPost: async (apiAppDriverGetRequest?: ApiAppDriverGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverProfileIdGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/profile/{id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverRolloverPost: async (apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/rollover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverRolloverPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignatureDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverSignatureDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driver/signature/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignaturePost: async (apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverSignaturePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverApi - functional programming interface
 * @export
 */
export const DriverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPasswordOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetpasswordDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdToggleyardmovePut(id, yardMove, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverLogoutDriverIdPost(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverLogoutDriverIdPost(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverPost(apiAppDriverGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverProfileIdGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverProfileIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverSignatureDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverSignatureDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverApi - factory interface
 * @export
 */
export const DriverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDriverDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DriverDtoPagedResultDto> {
            return localVarFp.apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverListDtoPagedResultDto> {
            return localVarFp.apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DriverListDto>> {
            return localVarFp.apiAppDriverGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DriverListDto>> {
            return localVarFp.apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: any): AxiosPromise<DriverPasswordOutput> {
            return localVarFp.apiAppDriverGetpasswordDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdGet(id: number, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdToggleyardmovePut(id, yardMove, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverLogoutDriverIdPost(driverId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverLogoutDriverIdPost(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverPost(apiAppDriverGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverProfileIdGet(id?: number, options?: any): AxiosPromise<DriverProfileDto> {
            return localVarFp.apiAppDriverProfileIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignatureDriverIdGet(driverId: number, options?: any): AxiosPromise<SignatureDto> {
            return localVarFp.apiAppDriverSignatureDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverApi - object-oriented interface
 * @export
 * @class DriverApi
 * @extends {BaseAPI}
 */
export class DriverApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetpasswordDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdDelete(id: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdGet(id: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [togglePc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [yardMove] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdToggleyardmovePut(id, yardMove, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverLogoutDriverIdPost(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverLogoutDriverIdPost(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverPost(apiAppDriverGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverProfileIdGet(id?: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverProfileIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverSignatureDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverSignatureDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverDailyLogApi - axios parameter creator
 * @export
 */
export const DriverDailyLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverdailylogGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverdailylog/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverDailyLogApi - functional programming interface
 * @export
 */
export const DriverDailyLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverDailyLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogGridViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverDailyLogApi - factory interface
 * @export
 */
export const DriverDailyLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverDailyLogApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverLogGridViewDtoPagedResultDto> {
            return localVarFp.apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverDailyLogApi - object-oriented interface
 * @export
 * @class DriverDailyLogApi
 * @extends {BaseAPI}
 */
export class DriverDailyLogApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverDailyLogApi
     */
    public apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverDailyLogApiFp(this.configuration).apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverHistoryApi - axios parameter creator
 * @export
 */
export const DriverHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriverstatusinfoDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverhistoryDriverstatusinfoDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driverhistory/driverstatusinfo/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriversvehicleusageDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverhistoryDriversvehicleusageDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driverhistory/driversvehicleusage/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverHistoryApi - functional programming interface
 * @export
 */
export const DriverHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHistoryStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriversVehicleUsageListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverHistoryApi - factory interface
 * @export
 */
export const DriverHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: any): AxiosPromise<DriverHistoryStatusInfoDto> {
            return localVarFp.apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: any): AxiosPromise<Array<DriversVehicleUsageListDto>> {
            return localVarFp.apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverHistoryApi - object-oriented interface
 * @export
 * @class DriverHistoryApi
 * @extends {BaseAPI}
 */
export class DriverHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverHistoryApi
     */
    public apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverHistoryApiFp(this.configuration).apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverHistoryApi
     */
    public apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverHistoryApiFp(this.configuration).apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverLoginApi - axios parameter creator
 * @export
 */
export const DriverLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDriverloginPost: async (id?: string, time?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/driverlogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverLoginApi - functional programming interface
 * @export
 */
export const DriverLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDriverloginPost(id?: string, time?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDriverloginPost(id, time, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverLoginApi - factory interface
 * @export
 */
export const DriverLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverLoginApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDriverloginPost(id?: string, time?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDriverloginPost(id, time, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverLoginApi - object-oriented interface
 * @export
 * @class DriverLoginApi
 * @extends {BaseAPI}
 */
export class DriverLoginApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {string} [time] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverLoginApi
     */
    public apiDriverloginPost(id?: string, time?: string, options?: AxiosRequestConfig) {
        return DriverLoginApiFp(this.configuration).apiDriverloginPost(id, time, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverMutationWorkflowApi - axios parameter creator
 * @export
 */
export const DriverMutationWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowCheckuniqueconstraintsPost: async (apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/drivermutationworkflow/checkuniqueconstraints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdChangestatusPost: async (id: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDrivermutationworkflowIdChangestatusPost', 'id', id)
            const localVarPath = `/api/app/drivermutationworkflow/{id}/changestatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdDeactivatePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDrivermutationworkflowIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/drivermutationworkflow/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdPut: async (id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDrivermutationworkflowIdPut', 'id', id)
            const localVarPath = `/api/app/drivermutationworkflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preserveStatus !== undefined) {
                localVarQueryParameter['preserveStatus'] = preserveStatus;
            }

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {string} [creationTime] 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowPost: async (updateDocuments?: boolean, creationTime?: string, apiAppDriverGetRequest?: ApiAppDriverGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/drivermutationworkflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }

            if (creationTime !== undefined) {
                localVarQueryParameter['creationTime'] = (creationTime as any instanceof Date) ?
                    (creationTime as any).toISOString() :
                    creationTime;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverMutationWorkflowApi - functional programming interface
 * @export
 */
export const DriverMutationWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverMutationWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDrivermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDrivermutationworkflowIdChangestatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDrivermutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDtoEntityStatusChangeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDrivermutationworkflowIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDrivermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDrivermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppDriverIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {string} [creationTime] 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDrivermutationworkflowPost(updateDocuments?: boolean, creationTime?: string, apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDrivermutationworkflowPost(updateDocuments, creationTime, apiAppDriverGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverMutationWorkflowApi - factory interface
 * @export
 */
export const DriverMutationWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverMutationWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDrivermutationworkflowIdChangestatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdDeactivatePost(id: number, options?: any): AxiosPromise<DriverDtoEntityStatusChangeResult> {
            return localVarFp.apiAppDrivermutationworkflowIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDrivermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppDriverIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {string} [creationTime] 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDrivermutationworkflowPost(updateDocuments?: boolean, creationTime?: string, apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDrivermutationworkflowPost(updateDocuments, creationTime, apiAppDriverGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverMutationWorkflowApi - object-oriented interface
 * @export
 * @class DriverMutationWorkflowApi
 * @extends {BaseAPI}
 */
export class DriverMutationWorkflowApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverMutationWorkflowApi
     */
    public apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig) {
        return DriverMutationWorkflowApiFp(this.configuration).apiAppDrivermutationworkflowCheckuniqueconstraintsPost(apiAppDrivermutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverMutationWorkflowApi
     */
    public apiAppDrivermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DriverMutationWorkflowApiFp(this.configuration).apiAppDrivermutationworkflowIdChangestatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverMutationWorkflowApi
     */
    public apiAppDrivermutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig) {
        return DriverMutationWorkflowApiFp(this.configuration).apiAppDrivermutationworkflowIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [preserveStatus] 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverMutationWorkflowApi
     */
    public apiAppDrivermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig) {
        return DriverMutationWorkflowApiFp(this.configuration).apiAppDrivermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppDriverIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [updateDocuments] 
     * @param {string} [creationTime] 
     * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverMutationWorkflowApi
     */
    public apiAppDrivermutationworkflowPost(updateDocuments?: boolean, creationTime?: string, apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig) {
        return DriverMutationWorkflowApiFp(this.configuration).apiAppDrivermutationworkflowPost(updateDocuments, creationTime, apiAppDriverGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverViewApi - axios parameter creator
 * @export
 */
export const DriverViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet: async (driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-drivers-vehicle-and-mobile-app-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverviewIdGet', 'id', id)
            const localVarPath = `/api/app/driverview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverViewApi - functional programming interface
 * @export
 */
export const DriverViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverVehicleIdAndMobileAppTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverViewApi - factory interface
 * @export
 */
export const DriverViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DriverDtoPagedResultDto> {
            return localVarFp.apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: any): AxiosPromise<DriverVehicleIdAndMobileAppTypeDto> {
            return localVarFp.apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverViewListDtoPagedResultDto> {
            return localVarFp.apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppDriverviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewIdGet(id: number, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverViewApi - object-oriented interface
 * @export
 * @class DriverViewApi
 * @extends {BaseAPI}
 */
export class DriverViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewIdGet(id: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirApi - axios parameter creator
 * @export
 */
export const DvirApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [driverId] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDriverDvirListGet: async (driverId?: number, skip?: number, take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvir/driver-dvir-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDvirreportPost: async (apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvir/dvirreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirDvirreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirApi - functional programming interface
 * @export
 */
export const DvirApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [driverId] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirDriverDvirListGet(driverId?: number, skip?: number, take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDvirReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirDriverDvirListGet(driverId, skip, take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirApi - factory interface
 * @export
 */
export const DvirApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [driverId] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDriverDvirListGet(driverId?: number, skip?: number, take?: number, options?: any): AxiosPromise<DriverDvirReportDtoPagedResultDto> {
            return localVarFp.apiAppDvirDriverDvirListGet(driverId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirApi - object-oriented interface
 * @export
 * @class DvirApi
 * @extends {BaseAPI}
 */
export class DvirApi extends BaseAPI {
    /**
     * 
     * @param {number} [driverId] 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirApi
     */
    public apiAppDvirDriverDvirListGet(driverId?: number, skip?: number, take?: number, options?: AxiosRequestConfig) {
        return DvirApiFp(this.configuration).apiAppDvirDriverDvirListGet(driverId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirApi
     */
    public apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: AxiosRequestConfig) {
        return DvirApiFp(this.configuration).apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirFormApi - axios parameter creator
 * @export
 */
export const DvirFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDefaultdvirformGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/defaultdvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdDelete', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdGet', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdPut: async (id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdPut', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirformIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformPost: async (apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirformGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirFormApi - functional programming interface
 * @export
 */
export const DvirFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformDefaultdvirformGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformDefaultdvirformGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DvirFormListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DvirFormListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformPost(apiAppDvirformGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirFormApi - factory interface
 * @export
 */
export const DvirFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirFormApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDefaultdvirformGet(options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformDefaultdvirformGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDvirformDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DvirFormDtoPagedResultDto> {
            return localVarFp.apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirFormListDtoPagedResultDto> {
            return localVarFp.apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DvirFormListDto>> {
            return localVarFp.apiAppDvirformGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DvirFormListDto>> {
            return localVarFp.apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirformIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdGet(id: number, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformPost(apiAppDvirformGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirFormApi - object-oriented interface
 * @export
 * @class DvirFormApi
 * @extends {BaseAPI}
 */
export class DvirFormApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformDefaultdvirformGet(options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformDefaultdvirformGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdDelete(id: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformPost(apiAppDvirformGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirHistoryApi - axios parameter creator
 * @export
 */
export const DvirHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirhistory/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirhistoryIdGet', 'id', id)
            const localVarPath = `/api/app/dvirhistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetPhotosPost: async (defectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/get-photos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defectId !== undefined) {
                localVarQueryParameter['defectId'] = defectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsReopenPost: async (defectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/reopen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defectId !== undefined) {
                localVarQueryParameter['defectId'] = defectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsResolvePost: async (apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirvehicledefectsResolvePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehiclehistory/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirvehiclehistoryIdGet', 'id', id)
            const localVarPath = `/api/app/dvirvehiclehistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirHistoryApi - functional programming interface
 * @export
 */
export const DvirHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirhistoryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirhistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryDefectDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsGetPhotosPost(defectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsReopenPost(defectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDvirHistoryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehiclehistoryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDvirHistoryEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehiclehistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirHistoryApi - factory interface
 * @export
 */
export const DvirHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirHistoryListDtoPagedResultDto> {
            return localVarFp.apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryIdGet(id: number, options?: any): AxiosPromise<DvirHistoryListDto> {
            return localVarFp.apiAppDvirhistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirHistoryDefectDtoPagedResultDto> {
            return localVarFp.apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiAppDvirvehicledefectsGetPhotosPost(defectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirvehicledefectsReopenPost(defectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleDvirHistoryListDtoPagedResultDto> {
            return localVarFp.apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryIdGet(id: number, options?: any): AxiosPromise<VehicleDvirHistoryEntryDto> {
            return localVarFp.apiAppDvirvehiclehistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirHistoryApi - object-oriented interface
 * @export
 * @class DvirHistoryApi
 * @extends {BaseAPI}
 */
export class DvirHistoryApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirhistoryIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirhistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [defectId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsGetPhotosPost(defectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [defectId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsReopenPost(defectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehiclehistoryIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehiclehistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceApi - axios parameter creator
 * @export
 */
export const EldDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdDelete', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdGet', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdPut: async (id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdPut', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicePost: async (apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceApi - functional programming interface
 * @export
 */
export const EldDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicePost(apiAppElddeviceGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceApi - factory interface
 * @export
 */
export const EldDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppElddeviceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<EldDeviceDtoPagedResultDto> {
            return localVarFp.apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceListDtoPagedResultDto> {
            return localVarFp.apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<EldDeviceListDto>> {
            return localVarFp.apiAppElddeviceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<EldDeviceListDto>> {
            return localVarFp.apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppElddeviceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdGet(id: number, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddevicePost(apiAppElddeviceGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceApi - object-oriented interface
 * @export
 * @class EldDeviceApi
 * @extends {BaseAPI}
 */
export class EldDeviceApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdDelete(id: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdGet(id: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddevicePost(apiAppElddeviceGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceMessageApi - axios parameter creator
 * @export
 */
export const EldDeviceMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevicemessage/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddevicemessageIdGet', 'id', id)
            const localVarPath = `/api/app/elddevicemessage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceMessageApi - functional programming interface
 * @export
 */
export const EldDeviceMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceMessageDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicemessageIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceParsedMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicemessageIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceMessageApi - factory interface
 * @export
 */
export const EldDeviceMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceMessageApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceMessageDtoPagedResultDto> {
            return localVarFp.apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageIdGet(id: string, options?: any): AxiosPromise<EldDeviceParsedMessageDto> {
            return localVarFp.apiAppElddevicemessageIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceMessageApi - object-oriented interface
 * @export
 * @class EldDeviceMessageApi
 * @extends {BaseAPI}
 */
export class EldDeviceMessageApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceMessageApi
     */
    public apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceMessageApiFp(this.configuration).apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceMessageApi
     */
    public apiAppElddevicemessageIdGet(id: string, options?: AxiosRequestConfig) {
        return EldDeviceMessageApiFp(this.configuration).apiAppElddevicemessageIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceUsageHistoryApi - axios parameter creator
 * @export
 */
export const EldDeviceUsageHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost: async (apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddeviceusagehistory/getelddeviceusagehistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceUsageHistoryApi - functional programming interface
 * @export
 */
export const EldDeviceUsageHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceUsageHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceUsageHistoryApi - factory interface
 * @export
 */
export const EldDeviceUsageHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceUsageHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: any): AxiosPromise<Array<EldDeviceUsageHistoryListDto>> {
            return localVarFp.apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceUsageHistoryApi - object-oriented interface
 * @export
 * @class EldDeviceUsageHistoryApi
 * @extends {BaseAPI}
 */
export class EldDeviceUsageHistoryApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceUsageHistoryApi
     */
    public apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceUsageHistoryApiFp(this.configuration).apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDisconnectionApi - axios parameter creator
 * @export
 */
export const EldDisconnectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddisconnection/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionReporteldconnectionPost: async (apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddisconnection/reporteldconnection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddisconnectionReporteldconnectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDisconnectionApi - functional programming interface
 * @export
 */
export const EldDisconnectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDisconnectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDisconnectionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEldDisconnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDisconnectionApi - factory interface
 * @export
 */
export const EldDisconnectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDisconnectionApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDisconnectionListDtoPagedResultDto> {
            return localVarFp.apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: any): AxiosPromise<CreateEldDisconnectionDto> {
            return localVarFp.apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDisconnectionApi - object-oriented interface
 * @export
 * @class EldDisconnectionApi
 * @extends {BaseAPI}
 */
export class EldDisconnectionApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDisconnectionApi
     */
    public apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDisconnectionApiFp(this.configuration).apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDisconnectionApi
     */
    public apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: AxiosRequestConfig) {
        return EldDisconnectionApiFp(this.configuration).apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldFileExportApi - axios parameter creator
 * @export
 */
export const EldFileExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileexportIdDelete', 'id', id)
            const localVarPath = `/api/app/eldfileexport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileexportIdGet', 'id', id)
            const localVarPath = `/api/app/eldfileexport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileexportIdDeleteRequest} [apiAppEldfileexportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdPut: async (id: string, apiAppEldfileexportIdDeleteRequest?: ApiAppEldfileexportIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileexportIdPut', 'id', id)
            const localVarPath = `/api/app/eldfileexport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEldfileexportIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEldfileexportGetRequest} [apiAppEldfileexportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportPost: async (apiAppEldfileexportGetRequest?: ApiAppEldfileexportGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEldfileexportGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileexport/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldFileExportApi - functional programming interface
 * @export
 */
export const EldFileExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldFileExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldFileExportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldFileExportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileexportIdDeleteRequest} [apiAppEldfileexportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportIdPut(id: string, apiAppEldfileexportIdDeleteRequest?: ApiAppEldfileexportIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportIdPut(id, apiAppEldfileexportIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEldfileexportGetRequest} [apiAppEldfileexportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportPost(apiAppEldfileexportGetRequest?: ApiAppEldfileexportGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileExportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportPost(apiAppEldfileexportGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldFileExportApi - factory interface
 * @export
 */
export const EldFileExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldFileExportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<EldFileExportDto> {
            return localVarFp.apiAppEldfileexportChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppEldfileexportDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<EldFileExportDtoPagedResultDto> {
            return localVarFp.apiAppEldfileexportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldFileExportDtoPagedResultDto> {
            return localVarFp.apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<EldFileExportDto>> {
            return localVarFp.apiAppEldfileexportGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<EldFileExportDto>> {
            return localVarFp.apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEldfileexportIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdGet(id: string, options?: any): AxiosPromise<EldFileExportDto> {
            return localVarFp.apiAppEldfileexportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileexportIdDeleteRequest} [apiAppEldfileexportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportIdPut(id: string, apiAppEldfileexportIdDeleteRequest?: ApiAppEldfileexportIdDeleteRequest, options?: any): AxiosPromise<EldFileExportDto> {
            return localVarFp.apiAppEldfileexportIdPut(id, apiAppEldfileexportIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEldfileexportGetRequest} [apiAppEldfileexportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportPost(apiAppEldfileexportGetRequest?: ApiAppEldfileexportGetRequest, options?: any): AxiosPromise<EldFileExportDto> {
            return localVarFp.apiAppEldfileexportPost(apiAppEldfileexportGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldFileExportApi - object-oriented interface
 * @export
 * @class EldFileExportApi
 * @extends {BaseAPI}
 */
export class EldFileExportApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportIdDelete(id: string, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportIdGet(id: string, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppEldfileexportIdDeleteRequest} [apiAppEldfileexportIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportIdPut(id: string, apiAppEldfileexportIdDeleteRequest?: ApiAppEldfileexportIdDeleteRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportIdPut(id, apiAppEldfileexportIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEldfileexportGetRequest} [apiAppEldfileexportGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportPost(apiAppEldfileexportGetRequest?: ApiAppEldfileexportGetRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportPost(apiAppEldfileexportGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileExportApi
     */
    public apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return EldFileExportApiFp(this.configuration).apiAppEldfileexportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldFileImportApi - axios parameter creator
 * @export
 */
export const EldFileImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileimportIdDelete', 'id', id)
            const localVarPath = `/api/app/eldfileimport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileimportIdGet', 'id', id)
            const localVarPath = `/api/app/eldfileimport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileimportIdDeleteRequest} [apiAppEldfileimportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdPut: async (id: string, apiAppEldfileimportIdDeleteRequest?: ApiAppEldfileimportIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEldfileimportIdPut', 'id', id)
            const localVarPath = `/api/app/eldfileimport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEldfileimportIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEldfileimportGetRequest} [apiAppEldfileimportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportPost: async (apiAppEldfileimportGetRequest?: ApiAppEldfileimportGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEldfileimportGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportUploadPost: async (input?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldfileimport/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (input !== undefined) { 
                localVarFormParams.append('input', input as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldFileImportApi - functional programming interface
 * @export
 */
export const EldFileImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldFileImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldFileImportListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldFileImportListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileimportIdDeleteRequest} [apiAppEldfileimportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportIdPut(id: string, apiAppEldfileimportIdDeleteRequest?: ApiAppEldfileimportIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportIdPut(id, apiAppEldfileimportIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEldfileimportGetRequest} [apiAppEldfileimportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportPost(apiAppEldfileimportGetRequest?: ApiAppEldfileimportGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldFileImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportPost(apiAppEldfileimportGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldfileimportUploadPost(input?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldfileimportUploadPost(input, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldFileImportApi - factory interface
 * @export
 */
export const EldFileImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldFileImportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<EldFileImportDto> {
            return localVarFp.apiAppEldfileimportChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppEldfileimportDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<EldFileImportDtoPagedResultDto> {
            return localVarFp.apiAppEldfileimportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldFileImportListDtoPagedResultDto> {
            return localVarFp.apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<EldFileImportListDto>> {
            return localVarFp.apiAppEldfileimportGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<EldFileImportListDto>> {
            return localVarFp.apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEldfileimportIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdGet(id: string, options?: any): AxiosPromise<EldFileImportDto> {
            return localVarFp.apiAppEldfileimportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppEldfileimportIdDeleteRequest} [apiAppEldfileimportIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportIdPut(id: string, apiAppEldfileimportIdDeleteRequest?: ApiAppEldfileimportIdDeleteRequest, options?: any): AxiosPromise<EldFileImportDto> {
            return localVarFp.apiAppEldfileimportIdPut(id, apiAppEldfileimportIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEldfileimportGetRequest} [apiAppEldfileimportGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportPost(apiAppEldfileimportGetRequest?: ApiAppEldfileimportGetRequest, options?: any): AxiosPromise<EldFileImportDto> {
            return localVarFp.apiAppEldfileimportPost(apiAppEldfileimportGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldfileimportUploadPost(input?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppEldfileimportUploadPost(input, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldFileImportApi - object-oriented interface
 * @export
 * @class EldFileImportApi
 * @extends {BaseAPI}
 */
export class EldFileImportApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportIdDelete(id: string, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportIdGet(id: string, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppEldfileimportIdDeleteRequest} [apiAppEldfileimportIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportIdPut(id: string, apiAppEldfileimportIdDeleteRequest?: ApiAppEldfileimportIdDeleteRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportIdPut(id, apiAppEldfileimportIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEldfileimportGetRequest} [apiAppEldfileimportGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportPost(apiAppEldfileimportGetRequest?: ApiAppEldfileimportGetRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportPost(apiAppEldfileimportGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldFileImportApi
     */
    public apiAppEldfileimportUploadPost(input?: any, options?: AxiosRequestConfig) {
        return EldFileImportApiFp(this.configuration).apiAppEldfileimportUploadPost(input, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldMalfunctionsApi - axios parameter creator
 * @export
 */
export const EldMalfunctionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldmalfunctionsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldmalfunctions/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldMalfunctionsApi - functional programming interface
 * @export
 */
export const EldMalfunctionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldMalfunctionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldMalfunctionOrDataDiagnosticPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldMalfunctionsApi - factory interface
 * @export
 */
export const EldMalfunctionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldMalfunctionsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldMalfunctionOrDataDiagnosticPagedResultDto> {
            return localVarFp.apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldMalfunctionsApi - object-oriented interface
 * @export
 * @class EldMalfunctionsApi
 * @extends {BaseAPI}
 */
export class EldMalfunctionsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldMalfunctionsApi
     */
    public apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldMalfunctionsApiFp(this.configuration).apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddremarkPost: async (apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/addremark`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAddremarkPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddstatusPost: async (apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/addstatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAddstatusPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAssignPut: async (apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAssignPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBatchPost: async (apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBatchPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetcodriverPost: async (apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetcodriver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetcodriverPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetshippingdocsPost: async (apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetshippingdocs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetshippingdocsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksettrailersPost: async (apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksettrailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksettrailersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetvehiclePost: async (apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetvehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetvehiclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventCertifylogdatePost: async (apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/certifylogdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventCertifylogdatePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventConverteventtopersonaluseoryardmovePostRequest} [apiAppEventConverteventtopersonaluseoryardmovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventConverteventtopersonaluseoryardmovePost: async (apiAppEventConverteventtopersonaluseoryardmovePostRequest?: ApiAppEventConverteventtopersonaluseoryardmovePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/converteventtopersonaluseoryardmove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventConverteventtopersonaluseoryardmovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDeleteManyDelete: async (apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventDeleteManyDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDriversevendayhistoryGet: async (lastUpdated?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/driversevendayhistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastUpdated !== undefined) {
                localVarQueryParameter['lastUpdated'] = (lastUpdated as any instanceof Date) ?
                    (lastUpdated as any).toISOString() :
                    lastUpdated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventFixeventsPost: async (apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/fixevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventFixeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGet: async (uuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGetallowedeventtimerangeGet: async (driverId?: number, logDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/getallowedeventtimerange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['DriverId'] = driverId;
            }

            if (logDate !== undefined) {
                localVarQueryParameter['LogDate'] = (logDate as any instanceof Date) ?
                    (logDate as any).toISOString() :
                    logDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdDelete', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdGet', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdPut: async (id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdPut', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventInvalidatemobileeventsPost: async (apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/invalidatemobileevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventInvalidatemobileeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventNextdriverdutystatuseventEventIdGet: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiAppEventNextdriverdutystatuseventEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/app/event/nextdriverdutystatusevent/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventPersonaluseoryardmoveeventPostRequest} [apiAppEventPersonaluseoryardmoveeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventPersonaluseoryardmoveeventPost: async (apiAppEventPersonaluseoryardmoveeventPostRequest?: ApiAppEventPersonaluseoryardmoveeventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/personaluseoryardmoveevent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventPersonaluseoryardmoveeventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventReassigneventsPost: async (apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/reassignevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventReassigneventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclePost: async (apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/rebuildcycle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRebuildcyclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclefromeventPost: async (apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/rebuildcyclefromevent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRebuildcyclefromeventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRegenerateintermediatesPost: async (apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/regenerateintermediates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRegenerateintermediatesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventResizeeventsPost: async (apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/resizeevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventResizeeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSetdrivingnotePost: async (apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/setdrivingnote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventSetdrivingnotePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShifteventsPost: async (apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/shiftevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventShifteventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShipmentnumberPost: async (apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/shipmentnumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventShipmentnumberPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSmartfixeventsPost: async (apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/smartfixevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventSmartfixeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSynceventmanipulationGet: async (lastUpdated?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/synceventmanipulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastUpdated !== undefined) {
                localVarQueryParameter['lastUpdated'] = (lastUpdated as any instanceof Date) ?
                    (lastUpdated as any).toISOString() :
                    lastUpdated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAssignPut(apiAppEventAssignPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateEventOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBatchPost(apiAppEventBatchPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventConverteventtopersonaluseoryardmovePostRequest} [apiAppEventConverteventtopersonaluseoryardmovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest?: ApiAppEventConverteventtopersonaluseoryardmovePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateEventOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileEventOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventDriversevendayhistoryGet(lastUpdated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventGet(uuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventGet(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogEventTimeRange>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextDutyStatusEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventPersonaluseoryardmoveeventPostRequest} [apiAppEventPersonaluseoryardmoveeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest?: ApiAppEventPersonaluseoryardmoveeventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateEventOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventErrorInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventManipulationSyncOutputItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSynceventmanipulationGet(lastUpdated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: any): AxiosPromise<EventViewDto> {
            return localVarFp.apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: any): AxiosPromise<EventViewDto> {
            return localVarFp.apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventAssignPut(apiAppEventAssignPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: any): AxiosPromise<Array<CreateEventOutputDto>> {
            return localVarFp.apiAppEventBatchPost(apiAppEventBatchPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventConverteventtopersonaluseoryardmovePostRequest} [apiAppEventConverteventtopersonaluseoryardmovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest?: ApiAppEventConverteventtopersonaluseoryardmovePostRequest, options?: any): AxiosPromise<Array<CreateEventOutputDto>> {
            return localVarFp.apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: any): AxiosPromise<MobileEventOutputDtoPagedResultDto> {
            return localVarFp.apiAppEventDriversevendayhistoryGet(lastUpdated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGet(uuid?: string, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: any): AxiosPromise<DriverLogEventTimeRange> {
            return localVarFp.apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdGet(id: number, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: any): AxiosPromise<NextDutyStatusEventDto> {
            return localVarFp.apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventPersonaluseoryardmoveeventPostRequest} [apiAppEventPersonaluseoryardmoveeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest?: ApiAppEventPersonaluseoryardmoveeventPostRequest, options?: any): AxiosPromise<Array<CreateEventOutputDto>> {
            return localVarFp.apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: any): AxiosPromise<Array<EventErrorInfo>> {
            return localVarFp.apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: any): AxiosPromise<Array<EventManipulationSyncOutputItemDto>> {
            return localVarFp.apiAppEventSynceventmanipulationGet(lastUpdated, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAssignPut(apiAppEventAssignPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBatchPost(apiAppEventBatchPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventConverteventtopersonaluseoryardmovePostRequest} [apiAppEventConverteventtopersonaluseoryardmovePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest?: ApiAppEventConverteventtopersonaluseoryardmovePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventConverteventtopersonaluseoryardmovePost(apiAppEventConverteventtopersonaluseoryardmovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastUpdated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventDriversevendayhistoryGet(lastUpdated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [uuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventGet(uuid?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {string} [logDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdDelete(id: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdGet(id: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventPersonaluseoryardmoveeventPostRequest} [apiAppEventPersonaluseoryardmoveeventPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest?: ApiAppEventPersonaluseoryardmoveeventPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventPersonaluseoryardmoveeventPost(apiAppEventPersonaluseoryardmoveeventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastUpdated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSynceventmanipulationGet(lastUpdated, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventViewApi - axios parameter creator
 * @export
 */
export const EventViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/app/eventview/eventeldcreationtimeandodometersource/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventviewIdGet', 'id', id)
            const localVarPath = `/api/app/eventview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventViewApi - functional programming interface
 * @export
 */
export const EventViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldCreationTimeOdometerSourceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventViewApi - factory interface
 * @export
 */
export const EventViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventViewApiFp(configuration)
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: any): AxiosPromise<EldCreationTimeOdometerSourceDto> {
            return localVarFp.apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ViewEventDtoPagedResultDto> {
            return localVarFp.apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ViewEventDtoPagedResultDto> {
            return localVarFp.apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<ViewEventDto>> {
            return localVarFp.apiAppEventviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ViewEventDto>> {
            return localVarFp.apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewIdGet(id: number, options?: any): AxiosPromise<ViewEventDto> {
            return localVarFp.apiAppEventviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventViewApi - object-oriented interface
 * @export
 * @class EventViewApi
 * @extends {BaseAPI}
 */
export class EventViewApi extends BaseAPI {
    /**
     * 
     * @param {number} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewIdGet(id: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExportApi - axios parameter creator
 * @export
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppExportProgressJobIdGet: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiAppExportProgressJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/app/export/progress/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppExportRequestPostRequest} [apiAppExportRequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppExportRequestPost: async (apiAppExportRequestPostRequest?: ApiAppExportRequestPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/export/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppExportRequestPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppExportProgressJobIdGet(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantExportProgressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppExportProgressJobIdGet(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppExportRequestPostRequest} [apiAppExportRequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppExportRequestPost(apiAppExportRequestPostRequest?: ApiAppExportRequestPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantExportJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppExportRequestPost(apiAppExportRequestPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppExportProgressJobIdGet(jobId: string, options?: any): AxiosPromise<TenantExportProgressDto> {
            return localVarFp.apiAppExportProgressJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppExportRequestPostRequest} [apiAppExportRequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppExportRequestPost(apiAppExportRequestPostRequest?: ApiAppExportRequestPostRequest, options?: any): AxiosPromise<TenantExportJobDto> {
            return localVarFp.apiAppExportRequestPost(apiAppExportRequestPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
    /**
     * 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public apiAppExportProgressJobIdGet(jobId: string, options?: AxiosRequestConfig) {
        return ExportApiFp(this.configuration).apiAppExportProgressJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppExportRequestPostRequest} [apiAppExportRequestPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public apiAppExportRequestPost(apiAppExportRequestPostRequest?: ApiAppExportRequestPostRequest, options?: AxiosRequestConfig) {
        return ExportApiFp(this.configuration).apiAppExportRequestPost(apiAppExportRequestPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesGet: async (providerName?: string, providerKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feature-management/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesPut: async (providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feature-management/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiFeatureManagementFeaturesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeatureListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeatureManagementFeaturesGet(providerName, providerKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: any): AxiosPromise<GetFeatureListResultDto> {
            return localVarFp.apiFeatureManagementFeaturesGet(providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).apiFeatureManagementFeaturesGet(providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: AxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FleetManagerApi - axios parameter creator
 * @export
 */
export const FleetManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdDelete', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdGet', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdPut: async (id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdPut', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFleetmanagerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}/requestresetpasswordlinkforfleetmanager`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerPost: async (apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetManagerApi - functional programming interface
 * @export
 */
export const FleetManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FleetManagerApi - factory interface
 * @export
 */
export const FleetManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetManagerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFleetmanagerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FleetManagerDtoPagedResultDto> {
            return localVarFp.apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FleetManagerListDtoPagedResultDto> {
            return localVarFp.apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<FleetManagerListDto>> {
            return localVarFp.apiAppFleetmanagerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FleetManagerListDto>> {
            return localVarFp.apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdGet(id: number, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetManagerApi - object-oriented interface
 * @export
 * @class FleetManagerApi
 * @extends {BaseAPI}
 */
export class FleetManagerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdDelete(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdGet(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FleetManagerLoginApi - axios parameter creator
 * @export
 */
export const FleetManagerLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLoginPost: async (id?: string, sessionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLogoutPost: async (id?: string, sessionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginPasswordChangedPost: async (id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/password-changed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetManagerLoginApi - functional programming interface
 * @export
 */
export const FleetManagerLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetManagerLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginLoginPost(id, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginLogoutPost(id, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginPasswordChangedPost(id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginPasswordChangedPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FleetManagerLoginApi - factory interface
 * @export
 */
export const FleetManagerLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetManagerLoginApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginLoginPost(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginLogoutPost(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginPasswordChangedPost(id?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginPasswordChangedPost(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetManagerLoginApi - object-oriented interface
 * @export
 * @class FleetManagerLoginApi
 * @extends {BaseAPI}
 */
export class FleetManagerLoginApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginGet(options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginLoginPost(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginLogoutPost(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginPasswordChangedPost(id?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginPasswordChangedPost(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FlowApiClientApi - axios parameter creator
 * @export
 */
export const FlowApiClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFlowapiclientIdDelete', 'id', id)
            const localVarPath = `/api/app/flowapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFlowapiclientIdGet', 'id', id)
            const localVarPath = `/api/app/flowapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdPut: async (id: string, apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFlowapiclientIdPut', 'id', id)
            const localVarPath = `/api/app/flowapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFlowapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientPost: async (apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFlowapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/flowapiclient/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowApiClientApi - functional programming interface
 * @export
 */
export const FlowApiClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowApiClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlowApiClientListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlowApiClientListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientIdPut(id: string, apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientIdPut(id, apiAppFlowapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FlowApiClientApi - factory interface
 * @export
 */
export const FlowApiClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowApiClientApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<FlowApiClientDto> {
            return localVarFp.apiAppFlowapiclientChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFlowapiclientDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FlowApiClientDtoPagedResultDto> {
            return localVarFp.apiAppFlowapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FlowApiClientListDtoPagedResultDto> {
            return localVarFp.apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<FlowApiClientListDto>> {
            return localVarFp.apiAppFlowapiclientGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FlowApiClientListDto>> {
            return localVarFp.apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFlowapiclientIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdGet(id: string, options?: any): AxiosPromise<FlowApiClientDto> {
            return localVarFp.apiAppFlowapiclientIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientIdPut(id: string, apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: any): AxiosPromise<FlowApiClientDto> {
            return localVarFp.apiAppFlowapiclientIdPut(id, apiAppFlowapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: any): AxiosPromise<FlowApiClientDto> {
            return localVarFp.apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowApiClientApi - object-oriented interface
 * @export
 * @class FlowApiClientApi
 * @extends {BaseAPI}
 */
export class FlowApiClientApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientIdDelete(id: string, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientIdGet(id: string, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientIdPut(id: string, apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientIdPut(id, apiAppFlowapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFlowapiclientGetRequest} [apiAppFlowapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest?: ApiAppFlowapiclientGetRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientPost(apiAppFlowapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApiClientApi
     */
    public apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FlowApiClientApiFp(this.configuration).apiAppFlowapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FmcsaInspectionApi - axios parameter creator
 * @export
 */
export const FmcsaInspectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdDelete', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdGet', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdPut: async (id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdPut', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionManualcreatefmcsainspectionPost: async (base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/manualcreatefmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (base64EncodedEldFileContents !== undefined) {
                localVarQueryParameter['base64EncodedEldFileContents'] = base64EncodedEldFileContents;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionMarkunofficialPost: async (apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/markunofficial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionMarkunofficialPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionPost: async (apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FmcsaInspectionApi - functional programming interface
 * @export
 */
export const FmcsaInspectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FmcsaInspectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FmcsaInspectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FmcsaInspectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FmcsaInspectionApi - factory interface
 * @export
 */
export const FmcsaInspectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FmcsaInspectionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFmcsainspectionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FmcsaInspectionDtoPagedResultDto> {
            return localVarFp.apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FmcsaInspectionListDtoPagedResultDto> {
            return localVarFp.apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<FmcsaInspectionListDto>> {
            return localVarFp.apiAppFmcsainspectionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FmcsaInspectionListDto>> {
            return localVarFp.apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdGet(id: string, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FmcsaInspectionApi - object-oriented interface
 * @export
 * @class FmcsaInspectionApi
 * @extends {BaseAPI}
 */
export class FmcsaInspectionApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdDelete(id: string, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdGet(id: string, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [base64EncodedEldFileContents] 
     * @param {string} [fileName] 
     * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FmcsaTransferApi - axios parameter creator
 * @export
 */
export const FmcsaTransferApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferFmcsaoptionsGet: async (mobileApplicationType?: MobileApplicationType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/fmcsaoptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mobileApplicationType !== undefined) {
                localVarQueryParameter['mobileApplicationType'] = mobileApplicationType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferGenerateeldfilePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/generateeldfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferManualcreatefmcsainspectionPost: async (apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/manualcreatefmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferPingwebserviceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/pingwebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttoemailPost: async (apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittesttoemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittoemailPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttowebservicePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittesttowebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittoemailPost: async (apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittoemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittoemailPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittowebservicePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittowebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FmcsaTransferApi - functional programming interface
 * @export
 */
export const FmcsaTransferApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FmcsaTransferApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaEldFileOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferPingwebserviceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferPingwebserviceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELDSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELDSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FmcsaTransferApi - factory interface
 * @export
 */
export const FmcsaTransferApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FmcsaTransferApiFp(configuration)
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: any): AxiosPromise<FmcsaOptions> {
            return localVarFp.apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<FmcsaEldFileOutputDto> {
            return localVarFp.apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferPingwebserviceGet(options?: any): AxiosPromise<DiagnosticResponse> {
            return localVarFp.apiAppFmcsatransferPingwebserviceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<ELDSubmissionResponse> {
            return localVarFp.apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<ELDSubmissionResponse> {
            return localVarFp.apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FmcsaTransferApi - object-oriented interface
 * @export
 * @class FmcsaTransferApi
 * @extends {BaseAPI}
 */
export class FmcsaTransferApi extends BaseAPI {
    /**
     * 
     * @param {MobileApplicationType} [mobileApplicationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferPingwebserviceGet(options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferPingwebserviceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FuelEconomyReportApi - axios parameter creator
 * @export
 */
export const FuelEconomyReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetacceleratefuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getacceleratefuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetaveragefuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getaveragefuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetdriverfuelconsumptionPost: async (apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getdriverfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyactionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbyaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyperiodPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbyperiod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbytimeofday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionefficiencyPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionefficiency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetmaxfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getmaxfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetminfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getminfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetspeedingfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getspeedingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetworstperformersfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getworstperformersfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelEconomyReportApi - functional programming interface
 * @export
 */
export const FuelEconomyReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FuelEconomyReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriversFuelConsumptionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByPeriodDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByTimeOfDayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionEfficiencyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorstPerformersFuelConsumptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FuelEconomyReportApi - factory interface
 * @export
 */
export const FuelEconomyReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FuelEconomyReportApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: any): AxiosPromise<DriversFuelConsumptionDtoPagedResultDto> {
            return localVarFp.apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByActionDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByPeriodDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByTimeOfDayDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionEfficiencyDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<Array<WorstPerformersFuelConsumptionDto>> {
            return localVarFp.apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelEconomyReportApi - object-oriented interface
 * @export
 * @class FuelEconomyReportApi
 * @extends {BaseAPI}
 */
export class FuelEconomyReportApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FuelProviderApi - axios parameter creator
 * @export
 */
export const FuelProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdDelete', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdGet', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdPut: async (id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdPut', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFuelproviderIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderPost: async (apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFuelproviderGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelProviderApi - functional programming interface
 * @export
 */
export const FuelProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FuelProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FuelProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FuelProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FuelProviderApi - factory interface
 * @export
 */
export const FuelProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FuelProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFuelproviderDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FuelProviderDtoPagedResultDto> {
            return localVarFp.apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FuelProviderDtoPagedResultDto> {
            return localVarFp.apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<FuelProviderDto>> {
            return localVarFp.apiAppFuelproviderGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FuelProviderDto>> {
            return localVarFp.apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFuelproviderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdGet(id: number, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelProviderApi - object-oriented interface
 * @export
 * @class FuelProviderApi
 * @extends {BaseAPI}
 */
export class FuelProviderApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdDelete(id: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdGet(id: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeolocationApi - axios parameter creator
 * @export
 */
export const GeolocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationGet: async (lat?: number, lng?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/geolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationwithradiusGet: async (lat?: number, lng?: number, radius?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/geolocationwithradius`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationStategeolocationGet: async (lat?: number, lng?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/stategeolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeolocationApi - functional programming interface
 * @export
 */
export const GeolocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeolocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationGeolocationGet(lat, lng, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateGeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationStategeolocationGet(lat, lng, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeolocationApi - factory interface
 * @export
 */
export const GeolocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeolocationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: any): AxiosPromise<GeolocationResultModel> {
            return localVarFp.apiAppGeolocationGeolocationGet(lat, lng, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: any): AxiosPromise<GeolocationResultModel> {
            return localVarFp.apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: any): AxiosPromise<StateGeolocationResultModel> {
            return localVarFp.apiAppGeolocationStategeolocationGet(lat, lng, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeolocationApi - object-oriented interface
 * @export
 * @class GeolocationApi
 * @extends {BaseAPI}
 */
export class GeolocationApi extends BaseAPI {
    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationGeolocationGet(lat, lng, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {number} [radius] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationStategeolocationGet(lat, lng, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeometrisApiApi - axios parameter creator
 * @export
 */
export const GeometrisApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSenddevicecommandPost: async (apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/senddevicecommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSenddevicecommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendresetcommandPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/sendresetcommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendshipmodecommandPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/sendshipmodecommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetdeviceconfigurationPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setdeviceconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetenginebustypePost: async (apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setenginebustype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSetenginebustypePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetodometervaluePost: async (apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setodometervalue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSetodometervaluePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeometrisApiApi - functional programming interface
 * @export
 */
export const GeometrisApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeometrisApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeometrisApiApi - factory interface
 * @export
 */
export const GeometrisApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeometrisApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeometrisApiApi - object-oriented interface
 * @export
 * @class GeometrisApiApi
 * @extends {BaseAPI}
 */
export class GeometrisApiApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GlobalSearchApi - axios parameter creator
 * @export
 */
export const GlobalSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchAdvancedsearchPost: async (apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/globalsearch/advancedsearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGlobalsearchAdvancedsearchPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchQuicksearchGet: async (searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/globalsearch/quicksearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['SearchText'] = searchText;
            }

            if (includeDrivers !== undefined) {
                localVarQueryParameter['IncludeDrivers'] = includeDrivers;
            }

            if (includeVehicles !== undefined) {
                localVarQueryParameter['IncludeVehicles'] = includeVehicles;
            }

            if (includeTrailers !== undefined) {
                localVarQueryParameter['IncludeTrailers'] = includeTrailers;
            }

            if (includeEldDevices !== undefined) {
                localVarQueryParameter['IncludeEldDevices'] = includeEldDevices;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalSearchApi - functional programming interface
 * @export
 */
export const GlobalSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvancedSearchListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickSearchListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GlobalSearchApi - factory interface
 * @export
 */
export const GlobalSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalSearchApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: any): AxiosPromise<AdvancedSearchListDto> {
            return localVarFp.apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: any): AxiosPromise<QuickSearchListDto> {
            return localVarFp.apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalSearchApi - object-oriented interface
 * @export
 * @class GlobalSearchApi
 * @extends {BaseAPI}
 */
export class GlobalSearchApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchApi
     */
    public apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: AxiosRequestConfig) {
        return GlobalSearchApiFp(this.configuration).apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchText] 
     * @param {boolean} [includeDrivers] 
     * @param {boolean} [includeVehicles] 
     * @param {boolean} [includeTrailers] 
     * @param {boolean} [includeEldDevices] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchApi
     */
    public apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: AxiosRequestConfig) {
        return GlobalSearchApiFp(this.configuration).apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdDelete', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdGet', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdPut: async (id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdPut', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGroupGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupPost: async (apiAppGroupGetRequest?: ApiAppGroupGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGroupGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdPut(id, apiAppGroupGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupPost(apiAppGroupGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppGroupDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppGroupExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<GroupDtoPagedResultDto> {
            return localVarFp.apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<GroupListDtoPagedResultDto> {
            return localVarFp.apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<GroupListDto>> {
            return localVarFp.apiAppGroupGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<GroupListDto>> {
            return localVarFp.apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppGroupIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdGet(id: number, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupIdPut(id, apiAppGroupGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupPost(apiAppGroupGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdDelete(id: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdGet(id: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdPut(id, apiAppGroupGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupPost(apiAppGroupGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HarshEventReportApi - axios parameter creator
 * @export
 */
export const HarshEventReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetavgspeedingPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getavgspeeding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverharsheventssummaryPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverharsheventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverscoresPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverscores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithbestperformancePost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverswithbestperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithworstperformancePost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverswithworstperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost: async (apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getfiltereddriverharsheventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshaccelerationeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshaccelerationevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshbreakingeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshbreakingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventdailylogsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharsheventdailylogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventsbreakdowninformationPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharsheventsbreakdowninformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshspeedingeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshspeedingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshstopeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshstopevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshturneventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshturnevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HarshEventReportApi - functional programming interface
 * @export
 */
export const HarshEventReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HarshEventReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpeedingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverHarshEventsSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverScoresOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPerformaceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPerformaceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHarshEventsTotalDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshAccelerationEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshBreakingEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventDailyLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventsBreakdownInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshSpeedingEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshStopEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshTurnEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HarshEventReportApi - factory interface
 * @export
 */
export const HarshEventReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HarshEventReportApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<SpeedingDto> {
            return localVarFp.apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<Array<DriverHarshEventsSummaryDto>> {
            return localVarFp.apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverScoresOutput> {
            return localVarFp.apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverPerformaceDto> {
            return localVarFp.apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverPerformaceDto> {
            return localVarFp.apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: any): AxiosPromise<DriverHarshEventsTotalDtoPagedResultDto> {
            return localVarFp.apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshAccelerationEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshBreakingEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshEventDailyLogDto> {
            return localVarFp.apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshEventsBreakdownInfoDto> {
            return localVarFp.apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshSpeedingEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshStopEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshTurnEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HarshEventReportApi - object-oriented interface
 * @export
 * @class HarshEventReportApi
 * @extends {BaseAPI}
 */
export class HarshEventReportApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HosLogsApi - axios parameter creator
 * @export
 */
export const HosLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriveractivityGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driveractivity/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdailylogPost: async (apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/getdriverdailylog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdutystatuseventsPost: async (apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/getdriverdutystatusevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHosDriversGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hos-drivers/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsAddexceptionPost: async (apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/addexception`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHoslogsAddexceptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsDriverdailylogrecapGet: async (driverId?: number, currentLogDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/driverdailylogrecap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['DriverId'] = driverId;
            }

            if (currentLogDate !== undefined) {
                localVarQueryParameter['CurrentLogDate'] = (currentLogDate as any instanceof Date) ?
                    (currentLogDate as any).toISOString() :
                    currentLogDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRebuildHosInfoPost: async (driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/rebuild-hos-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRemoveexceptionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppHoslogsRemoveexceptionIdDelete', 'id', id)
            const localVarPath = `/api/app/hoslogs/removeexception/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HosLogsApi - functional programming interface
 * @export
 */
export const HosLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HosLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverActivityDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogGridViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogDetailedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HosDriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDailyLogRecapResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsRebuildHosInfoPost(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsRemoveexceptionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HosLogsApi - factory interface
 * @export
 */
export const HosLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HosLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverActivityDtoPagedResultDto> {
            return localVarFp.apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverLogGridViewDtoPagedResultDto> {
            return localVarFp.apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: any): AxiosPromise<DriverLogDetailedView> {
            return localVarFp.apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: any): AxiosPromise<Array<EventViewDto>> {
            return localVarFp.apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<HosDriverDtoPagedResultDto> {
            return localVarFp.apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: any): AxiosPromise<DriverDailyLogRecapResult> {
            return localVarFp.apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsRebuildHosInfoPost(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsRemoveexceptionIdDelete(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HosLogsApi - object-oriented interface
 * @export
 * @class HosLogsApi
 * @extends {BaseAPI}
 */
export class HosLogsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {string} [currentLogDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsRebuildHosInfoPost(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsRemoveexceptionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HubUserActivityApi - axios parameter creator
 * @export
 */
export const HubUserActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHubuseractivitySendpulsePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hubuseractivity/sendpulse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HubUserActivityApi - functional programming interface
 * @export
 */
export const HubUserActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HubUserActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHubuseractivitySendpulsePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHubuseractivitySendpulsePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HubUserActivityApi - factory interface
 * @export
 */
export const HubUserActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HubUserActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHubuseractivitySendpulsePost(options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHubuseractivitySendpulsePost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HubUserActivityApi - object-oriented interface
 * @export
 * @class HubUserActivityApi
 * @extends {BaseAPI}
 */
export class HubUserActivityApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HubUserActivityApi
     */
    public apiAppHubuseractivitySendpulsePost(options?: AxiosRequestConfig) {
        return HubUserActivityApiFp(this.configuration).apiAppHubuseractivitySendpulsePost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IdlingReportsApi - axios parameter creator
 * @export
 */
export const IdlingReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getaverageidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getaverageidlingtimefortimeofday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetfuelpercentageforidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getfuelpercentageforidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingdatafordriversPost: async (apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingdatafordrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingdatafordriversPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingfuelconsumptionPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingoffdutyaveragePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingoffdutyaverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingondutyaveragePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingondutyaverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingtimebydutyPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingtimebyduty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetmaxidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getmaxidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetminidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getminidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGettotalidlingfuelconsumptionPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/gettotalidlingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetworstperformersPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getworstperformers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdlingReportsApi - functional programming interface
 * @export
 */
export const IdlingReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdlingReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AverageIdleTimeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalFuelPercentageInIdleStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllDriversDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdleFuelConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDutyOffDutyIdleTimeSpentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalFuelConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorstPerformersDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IdlingReportsApi - factory interface
 * @export
 */
export const IdlingReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdlingReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<AverageIdleTimeDto> {
            return localVarFp.apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<TotalFuelPercentageInIdleStateDto> {
            return localVarFp.apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: any): AxiosPromise<AllDriversDtoPagedResultDto> {
            return localVarFp.apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<IdleFuelConsumptionDto> {
            return localVarFp.apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<OnDutyOffDutyIdleTimeSpentDto> {
            return localVarFp.apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<TotalFuelConsumptionDto> {
            return localVarFp.apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<Array<WorstPerformersDto>> {
            return localVarFp.apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IdlingReportsApi - object-oriented interface
 * @export
 * @class IdlingReportsApi
 * @extends {BaseAPI}
 */
export class IdlingReportsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LiveTrackTokenApi - axios parameter creator
 * @export
 */
export const LiveTrackTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdDelete', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdGet', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdPut: async (id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdPut', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdVehicleforlivetrackGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdVehicleforlivetrackGet', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}/vehicleforlivetrack`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenPost: async (apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenUpdateManyPut: async (apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantIdIdGet: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiTenantIdIdGet', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTenantIdIdGet', 'id', id)
            const localVarPath = `/api/{tenantId}/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiveTrackTokenApi - functional programming interface
 * @export
 */
export const LiveTrackTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiveTrackTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveTrackTokenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveTrackTokenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdVehicleforlivetrackGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTenantIdIdGet(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicLiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTenantIdIdGet(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LiveTrackTokenApi - factory interface
 * @export
 */
export const LiveTrackTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiveTrackTokenApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLivetracktokenDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<LiveTrackTokenDtoPagedResultDto> {
            return localVarFp.apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<LiveTrackTokenDtoPagedResultDto> {
            return localVarFp.apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<LiveTrackTokenDto>> {
            return localVarFp.apiAppLivetracktokenGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<LiveTrackTokenDto>> {
            return localVarFp.apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLivetracktokenIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdGet(id: string, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: any): AxiosPromise<LiveTrackVehicleDto> {
            return localVarFp.apiAppLivetracktokenIdVehicleforlivetrackGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantIdIdGet(tenantId: string, id: string, options?: any): AxiosPromise<PublicLiveTrackTokenDto> {
            return localVarFp.apiTenantIdIdGet(tenantId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiveTrackTokenApi - object-oriented interface
 * @export
 * @class LiveTrackTokenApi
 * @extends {BaseAPI}
 */
export class LiveTrackTokenApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdDelete(id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdGet(id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdVehicleforlivetrackGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiTenantIdIdGet(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiTenantIdIdGet(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentLocationsGet: async (selectedCompanies?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/current-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedCompanies) {
                localVarQueryParameter['SelectedCompanies'] = selectedCompanies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentVehicleGpsLocationsGet: async (selectedCompanies?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/current-vehicle-gps-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedCompanies) {
                localVarQueryParameter['SelectedCompanies'] = selectedCompanies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationLiveTrackPost: async (apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/live-track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationLiveTrackPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationTrailerLocationHistoryGet: async (name?: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/trailer-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleGpsLocationHistoryGet: async (vehicleId?: number, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/vehicle-gps-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleLocationHistoryGet: async (vehicleId?: number, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/vehicle-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerLocationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationCurrentLocationsGet(selectedCompanies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationTrailerLocationHistoryGet(name, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationVehicleGpsLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationVehicleGpsLocationHistoryGet(vehicleId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerLocationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerGpsLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerLocationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: any): AxiosPromise<Array<CurrentLocationDto>> {
            return localVarFp.apiAppLocationCurrentLocationsGet(selectedCompanies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies?: Array<number>, options?: any): AxiosPromise<Array<CurrentLocationDto>> {
            return localVarFp.apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: any): AxiosPromise<LocationHistoryDto> {
            return localVarFp.apiAppLocationTrailerLocationHistoryGet(name, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleGpsLocationHistoryGet(vehicleId?: number, date?: string, options?: any): AxiosPromise<LocationHistoryDto> {
            return localVarFp.apiAppLocationVehicleGpsLocationHistoryGet(vehicleId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: any): AxiosPromise<LocationHistoryDto> {
            return localVarFp.apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerLocationsGet(options?: any): AxiosPromise<Array<TrailerGpsLocationDto>> {
            return localVarFp.apiAppTrailerLocationsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} [selectedCompanies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationCurrentLocationsGet(selectedCompanies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [selectedCompanies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationCurrentVehicleGpsLocationsGet(selectedCompanies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationTrailerLocationHistoryGet(name, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationVehicleGpsLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationVehicleGpsLocationHistoryGet(vehicleId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppTrailerLocationsGet(options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppTrailerLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationHistoryVehiclesApi - axios parameter creator
 * @export
 */
export const LocationHistoryVehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdDelete', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdGet', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdPut: async (id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdPut', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationhistoryvehiclesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesPost: async (apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationhistoryvehiclesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationHistoryVehiclesApi - functional programming interface
 * @export
 */
export const LocationHistoryVehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationHistoryVehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationHistoryVehicleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationHistoryVehicleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationHistoryVehiclesApi - factory interface
 * @export
 */
export const LocationHistoryVehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationHistoryVehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<LocationHistoryVehicleDtoPagedResultDto> {
            return localVarFp.apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<LocationHistoryVehicleDtoPagedResultDto> {
            return localVarFp.apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<LocationHistoryVehicleDto>> {
            return localVarFp.apiAppLocationhistoryvehiclesGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<LocationHistoryVehicleDto>> {
            return localVarFp.apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationhistoryvehiclesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdGet(id: number, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationHistoryVehiclesApi - object-oriented interface
 * @export
 * @class LocationHistoryVehiclesApi
 * @extends {BaseAPI}
 */
export class LocationHistoryVehiclesApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdDelete(id: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdGet(id: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountCheckPasswordPost: async (apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/check-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: async (apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbpLoginResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbpLoginResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLoginPost(apiAccountLoginPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLogoutGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLogoutGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: any): AxiosPromise<AbpLoginResult> {
            return localVarFp.apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: any): AxiosPromise<AbpLoginResult> {
            return localVarFp.apiAccountLoginPost(apiAccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountLogoutGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountLoginPost(apiAccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountLogoutGet(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaintenanceDashboardApi - axios parameter creator
 * @export
 */
export const MaintenanceDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivediagnosticerrorsGet: async (take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/activediagnosticerrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/activevehiclediagnosticerrors/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/dvirdefectsforvehicle/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardGeometriseventsGet: async (take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/geometrisevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardIdVehicleGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardIdVehicleGet', 'id', id)
            const localVarPath = `/api/app/maintenancedashboard/{id}/vehicle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardMaintenancedashboardconfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/maintenancedashboardconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost: async (apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/savemaintenancedashboardconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardServiceremindersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/servicereminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTirestatusesVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardTirestatusesVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/tirestatuses/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTotalactivevehiclesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/totalactivevehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardUnresolveddvirdefectsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/unresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet: async (eldDeviceId: number, take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eldDeviceId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet', 'eldDeviceId', eldDeviceId)
            const localVarPath = `/api/app/maintenancedashboard/vehiclegeometrisevents/{eldDeviceId}`
                .replace(`{${"eldDeviceId"}}`, encodeURIComponent(String(eldDeviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesconditionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehiclescondition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesensorattributevaluesGet: async (id?: number, sensorAttributes?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehiclesensorattributevalues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (sensorAttributes) {
                localVarQueryParameter['SensorAttributes'] = sensorAttributes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithdiagnosticerrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithgeometrisalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithgeometrisalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithoverdueservicesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithoverdueservices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithtpmsalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithtpmsalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet: async (severity?: DvirFormAreaPointSeverity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithunresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithupcomingservicesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithupcomingservices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceDashboardApi - functional programming interface
 * @export
 */
export const MaintenanceDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleWithDiagnosticRecords>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDiagnosticRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDvirDefectDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardGeometriseventsGet(take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardIdVehicleGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardIdVehicleGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardServiceremindersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRemindersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardServiceremindersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AxleStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardTotalactivevehiclesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalVehiclesWidgetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardTotalactivevehiclesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnresolvedDvirDefectsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardUnresolveddvirdefectsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetVehicleEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclesconditionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehiclesConditionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclesconditionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: VehicleSensorAttributeValueDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaintenanceDashboardApi - factory interface
 * @export
 */
export const MaintenanceDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: any): AxiosPromise<Array<VehicleWithDiagnosticRecords>> {
            return localVarFp.apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDiagnosticRecord>> {
            return localVarFp.apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDvirDefectDto>> {
            return localVarFp.apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: any): AxiosPromise<Array<GeometrisWidgetEventDto>> {
            return localVarFp.apiAppMaintenancedashboardGeometriseventsGet(take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardIdVehicleGet(id: number, options?: any): AxiosPromise<MaintenanceDashboardVehicleDto> {
            return localVarFp.apiAppMaintenancedashboardIdVehicleGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: any): AxiosPromise<MaintenanceDashboardConfigurationDto> {
            return localVarFp.apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: any): AxiosPromise<MaintenanceDashboardConfigurationDto> {
            return localVarFp.apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardServiceremindersGet(options?: any): AxiosPromise<ServiceRemindersDto> {
            return localVarFp.apiAppMaintenancedashboardServiceremindersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<AxleStatusDto>> {
            return localVarFp.apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTotalactivevehiclesGet(options?: any): AxiosPromise<TotalVehiclesWidgetDto> {
            return localVarFp.apiAppMaintenancedashboardTotalactivevehiclesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: any): AxiosPromise<UnresolvedDvirDefectsDto> {
            return localVarFp.apiAppMaintenancedashboardUnresolveddvirdefectsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: any): AxiosPromise<Array<GeometrisWidgetVehicleEventDto>> {
            return localVarFp.apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesconditionGet(options?: any): AxiosPromise<VehiclesConditionOutput> {
            return localVarFp.apiAppMaintenancedashboardVehiclesconditionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: any): AxiosPromise<{ [key: string]: VehicleSensorAttributeValueDto; }> {
            return localVarFp.apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceDashboardApi - object-oriented interface
 * @export
 * @class MaintenanceDashboardApi
 * @extends {BaseAPI}
 */
export class MaintenanceDashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardGeometriseventsGet(take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardIdVehicleGet(id: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardIdVehicleGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardServiceremindersGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardServiceremindersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardTotalactivevehiclesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardTotalactivevehiclesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardUnresolveddvirdefectsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} eldDeviceId 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclesconditionGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclesconditionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {Array<string>} [sensorAttributes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DvirFormAreaPointSeverity} [severity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEldDeviceApi - axios parameter creator
 * @export
 */
export const MasterEldDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceAssigntotenantPost: async (apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/assigntotenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceAssigntotenantPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdDelete', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdGet', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdPut: async (id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdPut', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceMultipleelddevicesPost: async (apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/multipleelddevices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceMultipleelddevicesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddevicePost: async (apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUnassignfromtenantsPost: async (apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/unassignfromtenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceUnassignfromtenantsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUploadfilePost: async (file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/uploadfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEldDeviceApi - functional programming interface
 * @export
 */
export const MasterEldDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEldDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterEldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterEldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUploadfilePost(file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterUploadedFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUploadfilePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEldDeviceApi - factory interface
 * @export
 */
export const MasterEldDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEldDeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterelddeviceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MasterEldDeviceDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MasterEldDeviceListDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MasterEldDeviceListDto>> {
            return localVarFp.apiAppMasterelddeviceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MasterEldDeviceListDto>> {
            return localVarFp.apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdGet(id: number, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUploadfilePost(file?: any, options?: any): AxiosPromise<MasterUploadedFileDto> {
            return localVarFp.apiAppMasterelddeviceUploadfilePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEldDeviceApi - object-oriented interface
 * @export
 * @class MasterEldDeviceApi
 * @extends {BaseAPI}
 */
export class MasterEldDeviceApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdDelete(id: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUploadfilePost(file?: any, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUploadfilePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEldDeviceUsageApi - axios parameter creator
 * @export
 */
export const MasterEldDeviceUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageElddeviceusageTenantIdGet: async (tenantId: string, dateFrom?: string, dateTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppMasterelddeviceusageElddeviceusageTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/masterelddeviceusage/elddeviceusage/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/get-eld-device-usage-by-days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetEldDeviceUsageListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/get-eld-device-usage-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageSingleelddeviceusageGet: async (serialNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/singleelddeviceusage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEldDeviceUsageApi - functional programming interface
 * @export
 */
export const MasterEldDeviceUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEldDeviceUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceUsageSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceUsageByDaysDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceUsageOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceUsageOutputPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SingleDeviceUsageDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEldDeviceUsageApi - factory interface
 * @export
 */
export const MasterEldDeviceUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEldDeviceUsageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<DeviceUsageSummary> {
            return localVarFp.apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceUsageByDaysDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceUsageOutputDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DeviceUsageOutputPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: any): AxiosPromise<Array<SingleDeviceUsageDetail>> {
            return localVarFp.apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEldDeviceUsageApi - object-oriented interface
 * @export
 * @class MasterEldDeviceUsageApi
 * @extends {BaseAPI}
 */
export class MasterEldDeviceUsageApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageGetEldDeviceUsageByDaysPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageGetEldDeviceUsageListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEldUsageReportArchiveApi - axios parameter creator
 * @export
 */
export const MasterEldUsageReportArchiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereldusagereportarchiveGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mastereldusagereportarchive/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEldUsageReportArchiveApi - functional programming interface
 * @export
 */
export const MasterEldUsageReportArchiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEldUsageReportArchiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEldUsageReportArchiveApi - factory interface
 * @export
 */
export const MasterEldUsageReportArchiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEldUsageReportArchiveApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ReportDtoPagedResultDto> {
            return localVarFp.apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEldUsageReportArchiveApi - object-oriented interface
 * @export
 * @class MasterEldUsageReportArchiveApi
 * @extends {BaseAPI}
 */
export class MasterEldUsageReportArchiveApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldUsageReportArchiveApi
     */
    public apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldUsageReportArchiveApiFp(this.configuration).apiAppMastereldusagereportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEventApi - axios parameter creator
 * @export
 */
export const MasterEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventBestcoordinatesbygeolocationGet: async (geolocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterevent/bestcoordinatesbygeolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (geolocation !== undefined) {
                localVarQueryParameter['geolocation'] = geolocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMastereventIdGet', 'id', id)
            const localVarPath = `/api/app/masterevent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdPut: async (id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMastereventIdPut', 'id', id)
            const localVarPath = `/api/app/masterevent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMastereventIdGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastengineonDriverIdGet: async (driverId: number, time?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppMastereventLastengineonDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/masterevent/lastengineon/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} [time] 
         * @param {string} [eventSequenceIdNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastignitioneventVehicleIdGet: async (vehicleId: number, time?: string, eventSequenceIdNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMastereventLastignitioneventVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/masterevent/lastignitionevent/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }

            if (eventSequenceIdNumber !== undefined) {
                localVarQueryParameter['eventSequenceIdNumber'] = eventSequenceIdNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPost: async (apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterevent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMastereventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPreviouseventDriverIdGet: async (driverId: number, startTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppMastereventPreviouseventDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/masterevent/previousevent/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEventApi - functional programming interface
 * @export
 */
export const MasterEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BestGeolocationCoordinatesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventLastengineonDriverIdGet(driverId, time, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} [time] 
         * @param {string} [eventSequenceIdNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventLastignitioneventVehicleIdGet(vehicleId: number, time?: string, eventSequenceIdNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventLastignitioneventVehicleIdGet(vehicleId, time, eventSequenceIdNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventPost(apiAppMastereventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEventApi - factory interface
 * @export
 */
export const MasterEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEventApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: any): AxiosPromise<BestGeolocationCoordinatesOutput> {
            return localVarFp.apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdGet(id: number, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventLastengineonDriverIdGet(driverId, time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} [time] 
         * @param {string} [eventSequenceIdNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastignitioneventVehicleIdGet(vehicleId: number, time?: string, eventSequenceIdNumber?: string, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventLastignitioneventVehicleIdGet(vehicleId, time, eventSequenceIdNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventPost(apiAppMastereventPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEventApi - object-oriented interface
 * @export
 * @class MasterEventApi
 * @extends {BaseAPI}
 */
export class MasterEventApi extends BaseAPI {
    /**
     * 
     * @param {string} [geolocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {string} [time] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventLastengineonDriverIdGet(driverId, time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {string} [time] 
     * @param {string} [eventSequenceIdNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventLastignitioneventVehicleIdGet(vehicleId: number, time?: string, eventSequenceIdNumber?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventLastignitioneventVehicleIdGet(vehicleId, time, eventSequenceIdNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventPost(apiAppMastereventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {string} [startTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterFleetManagerApi - axios parameter creator
 * @export
 */
export const MasterFleetManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdDelete', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdGet', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdPut: async (id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdPut', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdRequestpasswordresetPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdRequestpasswordresetPost', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}/requestpasswordreset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerPost: async (apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerRequestpasswordresetbyemailPost: async (email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/requestpasswordresetbyemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResetpasswordPost: async (apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/resetpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerResetpasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResettwofactorauthenticationPost: async (apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/resettwofactorauthentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerWithtokenPost: async (apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/withtoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterFleetManagerApi - functional programming interface
 * @export
 */
export const MasterFleetManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterFleetManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterFleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterFleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterFleetManagerApi - factory interface
 * @export
 */
export const MasterFleetManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterFleetManagerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterfleetmanagerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MasterFleetManagerDtoPagedResultDto> {
            return localVarFp.apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MasterFleetManagerListDtoPagedResultDto> {
            return localVarFp.apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MasterFleetManagerListDto>> {
            return localVarFp.apiAppMasterfleetmanagerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MasterFleetManagerListDto>> {
            return localVarFp.apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdGet(id: number, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: any): AxiosPromise<IdentityResult> {
            return localVarFp.apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterFleetManagerApi - object-oriented interface
 * @export
 * @class MasterFleetManagerApi
 * @extends {BaseAPI}
 */
export class MasterFleetManagerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdDelete(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaRegistryApi - axios parameter creator
 * @export
 */
export const MediaRegistryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [dateFromUtc] 
         * @param {string} [dateToUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMediaregistryRefreshgeometrismediaPost: async (dateFromUtc?: string, dateToUtc?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mediaregistry/refreshgeometrismedia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFromUtc !== undefined) {
                localVarQueryParameter['dateFromUtc'] = (dateFromUtc as any instanceof Date) ?
                    (dateFromUtc as any).toISOString() :
                    dateFromUtc;
            }

            if (dateToUtc !== undefined) {
                localVarQueryParameter['dateToUtc'] = (dateToUtc as any instanceof Date) ?
                    (dateToUtc as any).toISOString() :
                    dateToUtc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [deviceId] 
         * @param {string} [fromUtc] 
         * @param {string} [toUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMediaregistrySyncgeometrisvideosPost: async (vehicleId?: number, deviceId?: string, fromUtc?: string, toUtc?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mediaregistry/syncgeometrisvideos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (fromUtc !== undefined) {
                localVarQueryParameter['fromUtc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['toUtc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaRegistryApi - functional programming interface
 * @export
 */
export const MediaRegistryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaRegistryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [dateFromUtc] 
         * @param {string} [dateToUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc?: string, dateToUtc?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc, dateToUtc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [deviceId] 
         * @param {string} [fromUtc] 
         * @param {string} [toUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMediaregistrySyncgeometrisvideosPost(vehicleId?: number, deviceId?: string, fromUtc?: string, toUtc?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMediaregistrySyncgeometrisvideosPost(vehicleId, deviceId, fromUtc, toUtc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaRegistryApi - factory interface
 * @export
 */
export const MediaRegistryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaRegistryApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [dateFromUtc] 
         * @param {string} [dateToUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc?: string, dateToUtc?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc, dateToUtc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [deviceId] 
         * @param {string} [fromUtc] 
         * @param {string} [toUtc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMediaregistrySyncgeometrisvideosPost(vehicleId?: number, deviceId?: string, fromUtc?: string, toUtc?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMediaregistrySyncgeometrisvideosPost(vehicleId, deviceId, fromUtc, toUtc, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaRegistryApi - object-oriented interface
 * @export
 * @class MediaRegistryApi
 * @extends {BaseAPI}
 */
export class MediaRegistryApi extends BaseAPI {
    /**
     * 
     * @param {string} [dateFromUtc] 
     * @param {string} [dateToUtc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaRegistryApi
     */
    public apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc?: string, dateToUtc?: string, options?: AxiosRequestConfig) {
        return MediaRegistryApiFp(this.configuration).apiAppMediaregistryRefreshgeometrismediaPost(dateFromUtc, dateToUtc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [deviceId] 
     * @param {string} [fromUtc] 
     * @param {string} [toUtc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaRegistryApi
     */
    public apiAppMediaregistrySyncgeometrisvideosPost(vehicleId?: number, deviceId?: string, fromUtc?: string, toUtc?: string, options?: AxiosRequestConfig) {
        return MediaRegistryApiFp(this.configuration).apiAppMediaregistrySyncgeometrisvideosPost(vehicleId, deviceId, fromUtc, toUtc, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobileAppVersionApi - axios parameter creator
 * @export
 */
export const MobileAppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdDelete', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdGet', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdPut: async (id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdPut', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMobileappversionIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionPost: async (mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileApplicationTypeString' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'mobileApplicationTypeString', mobileApplicationTypeString)
            // verify required parameter 'appVersion' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'appVersion', appVersion)
            // verify required parameter 'buildNumber' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'buildNumber', buildNumber)
            const localVarPath = `/api/app/mobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (mobileApplicationTypeString !== undefined) { 
                localVarFormParams.append('MobileApplicationTypeString', mobileApplicationTypeString as any);
            }
    
            if (mobileApplicationType !== undefined) { 
                localVarFormParams.append('MobileApplicationType', new Blob([JSON.stringify(mobileApplicationType)], { type: "application/json", }));
            }
    
            if (appVersion !== undefined) { 
                localVarFormParams.append('AppVersion', appVersion as any);
            }
    
            if (buildNumber !== undefined) { 
                localVarFormParams.append('BuildNumber', buildNumber as any);
            }
    
            if (downloadUrl !== undefined) { 
                localVarFormParams.append('DownloadUrl', downloadUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileAppVersionApi - functional programming interface
 * @export
 */
export const MobileAppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileAppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MobileAppVersionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MobileAppVersionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileAppVersionApi - factory interface
 * @export
 */
export const MobileAppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileAppVersionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMobileappversionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MobileAppVersionDtoPagedResultDto> {
            return localVarFp.apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MobileAppVersionDtoPagedResultDto> {
            return localVarFp.apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MobileAppVersionDto>> {
            return localVarFp.apiAppMobileappversionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MobileAppVersionDto>> {
            return localVarFp.apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMobileappversionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdGet(id: number, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileAppVersionApi - object-oriented interface
 * @export
 * @class MobileAppVersionApi
 * @extends {BaseAPI}
 */
export class MobileAppVersionApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdDelete(id: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdGet(id: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mobileApplicationTypeString 
     * @param {string} appVersion 
     * @param {number} buildNumber 
     * @param {any} [file] 
     * @param {MobileApplicationType} [mobileApplicationType] 
     * @param {string} [downloadUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobileTrailerApi - axios parameter creator
 * @export
 */
export const MobileTrailerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerPost: async (apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobiletrailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMobiletrailerPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobiletrailer/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileTrailerApi - functional programming interface
 * @export
 */
export const MobileTrailerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileTrailerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileCreateTrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobiletrailerSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileTrailerApi - factory interface
 * @export
 */
export const MobileTrailerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileTrailerApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: any): AxiosPromise<MobileCreateTrailerDto> {
            return localVarFp.apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<TrailerSyncDto>> {
            return localVarFp.apiAppMobiletrailerSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileTrailerApi - object-oriented interface
 * @export
 * @class MobileTrailerApi
 * @extends {BaseAPI}
 */
export class MobileTrailerApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileTrailerApi
     */
    public apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: AxiosRequestConfig) {
        return MobileTrailerApiFp(this.configuration).apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileTrailerApi
     */
    public apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return MobileTrailerApiFp(this.configuration).apiAppMobiletrailerSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationNotificationtypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notification/notificationtypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationNotificationtypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationNotificationtypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationNotificationtypesGet(options?: any): AxiosPromise<Array<NotificationTypeDto>> {
            return localVarFp.apiAppNotificationNotificationtypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public apiAppNotificationNotificationtypesGet(options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiAppNotificationNotificationtypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationCenterApi - axios parameter creator
 * @export
 */
export const NotificationCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterGetallnotificationsPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/getallnotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterNotificationsforuserGet: async (userId: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterNotificationsforuserGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/notificationsforuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavenotificationpreferencePost: async (apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/savenotificationpreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSavenotificationpreferencePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavesingleusernotificationpreferencePost: async (apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/savesingleusernotificationpreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSaveuserlastreadnotificationPost: async (apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/saveuserlastreadnotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUnreadnotificationnumberUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterUnreadnotificationnumberUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/unreadnotificationnumber/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUsernotificationpreferenceUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterUsernotificationpreferenceUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/usernotificationpreference/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationCenterApi - functional programming interface
 * @export
 */
export const NotificationCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSystemNotificationsDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemNotificationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationCenterApi - factory interface
 * @export
 */
export const NotificationCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<GetSystemNotificationsDtoPagedResultDto> {
            return localVarFp.apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<SystemNotificationResultDto> {
            return localVarFp.apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: any): AxiosPromise<UserNotificationPreferenceDto> {
            return localVarFp.apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationCenterApi - object-oriented interface
 * @export
 * @class NotificationCenterApi
 * @extends {BaseAPI}
 */
export class NotificationCenterApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationSubscriptionApi - axios parameter creator
 * @export
 */
export const NotificationSubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdDelete', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdGet', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdPut: async (id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdPut', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationsubscriptionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionPost: async (apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationsubscriptionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationSubscriptionApi - functional programming interface
 * @export
 */
export const NotificationSubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationSubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationSubscriptionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationSubscriptionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationSubscriptionApi - factory interface
 * @export
 */
export const NotificationSubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationSubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppNotificationsubscriptionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<NotificationSubscriptionDtoPagedResultDto> {
            return localVarFp.apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<NotificationSubscriptionListDtoPagedResultDto> {
            return localVarFp.apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<NotificationSubscriptionListDto>> {
            return localVarFp.apiAppNotificationsubscriptionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<NotificationSubscriptionListDto>> {
            return localVarFp.apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationsubscriptionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdGet(id: number, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationSubscriptionApi - object-oriented interface
 * @export
 * @class NotificationSubscriptionApi
 * @extends {BaseAPI}
 */
export class NotificationSubscriptionApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdDelete(id: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdGet(id: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet: async (providerName?: string, providerKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut: async (providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPermissionManagementPermissionsGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsGet(providerName, providerKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: any): AxiosPromise<GetPermissionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProLogsIdentityRoleApi - axios parameter creator
 * @export
 */
export const ProLogsIdentityRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdDelete', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdGet', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdPut: async (id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdPut', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityrolePost: async (apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProLogsIdentityRoleApi - functional programming interface
 * @export
 */
export const ProLogsIdentityRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProLogsIdentityRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProLogsIdentityRoleApi - factory interface
 * @export
 */
export const ProLogsIdentityRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProLogsIdentityRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityRoleDtoPagedResultDto> {
            return localVarFp.apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPrologsidentityroleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdGet(id: string, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityroleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleListGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiAppPrologsidentityroleListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProLogsIdentityRoleApi - object-oriented interface
 * @export
 * @class ProLogsIdentityRoleApi
 * @extends {BaseAPI}
 */
export class ProLogsIdentityRoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdDelete(id: string, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdGet(id: string, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleListGet(options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileChangePasswordPost: async (apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountMyProfileChangePasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfilePut: async (apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountMyProfileGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfileGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfileGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileGet(options?: any): AxiosPromise<ProfileDto> {
            return localVarFp.apiAccountMyProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: any): AxiosPromise<ProfileDto> {
            return localVarFp.apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfileGet(options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicApiClientApi - axios parameter creator
 * @export
 */
export const PublicApiClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdDelete', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdGet', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdPut: async (id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdPut', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientPost: async (apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiClientApi - functional programming interface
 * @export
 */
export const PublicApiClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientListWithRedirectionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiClientListWithRedirectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiClientListWithRedirectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicApiClientApi - factory interface
 * @export
 */
export const PublicApiClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiClientApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiclientDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ApiClientDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ApiClientListWithRedirectionDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<ApiClientListWithRedirectionDto>> {
            return localVarFp.apiAppPublicapiclientGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ApiClientListWithRedirectionDto>> {
            return localVarFp.apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiclientIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdGet(id: string, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApiClientApi - object-oriented interface
 * @export
 * @class PublicApiClientApi
 * @extends {BaseAPI}
 */
export class PublicApiClientApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdDelete(id: string, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdGet(id: string, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicApiRedirectionApi - axios parameter creator
 * @export
 */
export const PublicApiRedirectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdApprovePostRequest} [apiAppPublicapiredirectionIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdApprovePost: async (id: string, apiAppPublicapiredirectionIdApprovePostRequest?: ApiAppPublicapiredirectionIdApprovePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionIdApprovePost', 'id', id)
            const localVarPath = `/api/app/publicapiredirection/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiredirectionIdApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionIdDelete', 'id', id)
            const localVarPath = `/api/app/publicapiredirection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdDenyPost: async (id: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionIdDenyPost', 'id', id)
            const localVarPath = `/api/app/publicapiredirection/{id}/deny`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionIdGet', 'id', id)
            const localVarPath = `/api/app/publicapiredirection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdDeleteRequest} [apiAppPublicapiredirectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdPut: async (id: string, apiAppPublicapiredirectionIdDeleteRequest?: ApiAppPublicapiredirectionIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionIdPut', 'id', id)
            const localVarPath = `/api/app/publicapiredirection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiredirectionIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionGetRequest} [apiAppPublicapiredirectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionPost: async (apiAppPublicapiredirectionGetRequest?: ApiAppPublicapiredirectionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiredirectionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirection/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiRedirectionApi - functional programming interface
 * @export
 */
export const PublicApiRedirectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiRedirectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicApiRedirectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicApiRedirectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdApprovePostRequest} [apiAppPublicapiredirectionIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionIdApprovePost(id: string, apiAppPublicapiredirectionIdApprovePostRequest?: ApiAppPublicapiredirectionIdApprovePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionIdApprovePost(id, apiAppPublicapiredirectionIdApprovePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionIdDenyPost(id: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionIdDenyPost(id, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdDeleteRequest} [apiAppPublicapiredirectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionIdPut(id: string, apiAppPublicapiredirectionIdDeleteRequest?: ApiAppPublicapiredirectionIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionIdPut(id, apiAppPublicapiredirectionIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionGetRequest} [apiAppPublicapiredirectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest?: ApiAppPublicapiredirectionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicApiRedirectionApi - factory interface
 * @export
 */
export const PublicApiRedirectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiRedirectionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<PublicApiRedirectionDto> {
            return localVarFp.apiAppPublicapiredirectionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiredirectionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<PublicApiRedirectionDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiredirectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<PublicApiRedirectionListDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<PublicApiRedirectionListDto>> {
            return localVarFp.apiAppPublicapiredirectionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<PublicApiRedirectionListDto>> {
            return localVarFp.apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdApprovePostRequest} [apiAppPublicapiredirectionIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdApprovePost(id: string, apiAppPublicapiredirectionIdApprovePostRequest?: ApiAppPublicapiredirectionIdApprovePostRequest, options?: any): AxiosPromise<PublicApiRedirectionDto> {
            return localVarFp.apiAppPublicapiredirectionIdApprovePost(id, apiAppPublicapiredirectionIdApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiredirectionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdDenyPost(id: string, reason?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiredirectionIdDenyPost(id, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdGet(id: string, options?: any): AxiosPromise<PublicApiRedirectionDto> {
            return localVarFp.apiAppPublicapiredirectionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiredirectionIdDeleteRequest} [apiAppPublicapiredirectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionIdPut(id: string, apiAppPublicapiredirectionIdDeleteRequest?: ApiAppPublicapiredirectionIdDeleteRequest, options?: any): AxiosPromise<PublicApiRedirectionDto> {
            return localVarFp.apiAppPublicapiredirectionIdPut(id, apiAppPublicapiredirectionIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionGetRequest} [apiAppPublicapiredirectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest?: ApiAppPublicapiredirectionGetRequest, options?: any): AxiosPromise<PublicApiRedirectionDto> {
            return localVarFp.apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApiRedirectionApi - object-oriented interface
 * @export
 * @class PublicApiRedirectionApi
 * @extends {BaseAPI}
 */
export class PublicApiRedirectionApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPublicapiredirectionIdApprovePostRequest} [apiAppPublicapiredirectionIdApprovePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionIdApprovePost(id: string, apiAppPublicapiredirectionIdApprovePostRequest?: ApiAppPublicapiredirectionIdApprovePostRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionIdApprovePost(id, apiAppPublicapiredirectionIdApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionIdDelete(id: string, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionIdDenyPost(id: string, reason?: string, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionIdDenyPost(id, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionIdGet(id: string, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPublicapiredirectionIdDeleteRequest} [apiAppPublicapiredirectionIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionIdPut(id: string, apiAppPublicapiredirectionIdDeleteRequest?: ApiAppPublicapiredirectionIdDeleteRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionIdPut(id, apiAppPublicapiredirectionIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPublicapiredirectionGetRequest} [apiAppPublicapiredirectionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest?: ApiAppPublicapiredirectionGetRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionPost(apiAppPublicapiredirectionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionApi
     */
    public apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionApiFp(this.configuration).apiAppPublicapiredirectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicApiRedirectionCallbackApi - axios parameter creator
 * @export
 */
export const PublicApiRedirectionCallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicApiRedirectionsCallbackPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public-api-redirections/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiRedirectionCallbackApi - functional programming interface
 * @export
 */
export const PublicApiRedirectionCallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiRedirectionCallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicApiRedirectionsCallbackPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicApiRedirectionsCallbackPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicApiRedirectionCallbackApi - factory interface
 * @export
 */
export const PublicApiRedirectionCallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiRedirectionCallbackApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicApiRedirectionsCallbackPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPublicApiRedirectionsCallbackPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApiRedirectionCallbackApi - object-oriented interface
 * @export
 * @class PublicApiRedirectionCallbackApi
 * @extends {BaseAPI}
 */
export class PublicApiRedirectionCallbackApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionCallbackApi
     */
    public apiPublicApiRedirectionsCallbackPost(options?: AxiosRequestConfig) {
        return PublicApiRedirectionCallbackApiFp(this.configuration).apiPublicApiRedirectionsCallbackPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicApiRedirectionRequestApi - axios parameter creator
 * @export
 */
export const PublicApiRedirectionRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} redirectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet: async (redirectionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectionId' is not null or undefined
            assertParamExists('apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet', 'redirectionId', redirectionId)
            const localVarPath = `/api/app/publicapiredirectionrequest/proxycredentials/{redirectionId}`
                .replace(`{${"redirectionId"}}`, encodeURIComponent(String(redirectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionrequestRequestredirectionPostRequest} [apiAppPublicapiredirectionrequestRequestredirectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionrequestRequestredirectionPost: async (apiAppPublicapiredirectionrequestRequestredirectionPostRequest?: ApiAppPublicapiredirectionrequestRequestredirectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiredirectionrequest/requestredirection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiredirectionrequestRequestredirectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiRedirectionRequestApi - functional programming interface
 * @export
 */
export const PublicApiRedirectionRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiRedirectionRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} redirectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicApiRedirectionProxyCredentialsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionrequestRequestredirectionPostRequest} [apiAppPublicapiredirectionrequestRequestredirectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest?: ApiAppPublicapiredirectionrequestRequestredirectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestPublicApiRedirectionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicApiRedirectionRequestApi - factory interface
 * @export
 */
export const PublicApiRedirectionRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiRedirectionRequestApiFp(configuration)
    return {
        /**
         * 
         * @param {string} redirectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId: string, options?: any): AxiosPromise<PublicApiRedirectionProxyCredentialsDto> {
            return localVarFp.apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPublicapiredirectionrequestRequestredirectionPostRequest} [apiAppPublicapiredirectionrequestRequestredirectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest?: ApiAppPublicapiredirectionrequestRequestredirectionPostRequest, options?: any): AxiosPromise<RequestPublicApiRedirectionResultDto> {
            return localVarFp.apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApiRedirectionRequestApi - object-oriented interface
 * @export
 * @class PublicApiRedirectionRequestApi
 * @extends {BaseAPI}
 */
export class PublicApiRedirectionRequestApi extends BaseAPI {
    /**
     * 
     * @param {string} redirectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionRequestApi
     */
    public apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId: string, options?: AxiosRequestConfig) {
        return PublicApiRedirectionRequestApiFp(this.configuration).apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(redirectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPublicapiredirectionrequestRequestredirectionPostRequest} [apiAppPublicapiredirectionrequestRequestredirectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiRedirectionRequestApi
     */
    public apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest?: ApiAppPublicapiredirectionrequestRequestredirectionPostRequest, options?: AxiosRequestConfig) {
        return PublicApiRedirectionRequestApiFp(this.configuration).apiAppPublicapiredirectionrequestRequestredirectionPost(apiAppPublicapiredirectionrequestRequestredirectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RecentViolationApi - axios parameter creator
 * @export
 */
export const RecentViolationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRecentviolationGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/recentviolation/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecentViolationApi - functional programming interface
 * @export
 */
export const RecentViolationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecentViolationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentViolationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecentViolationApi - factory interface
 * @export
 */
export const RecentViolationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecentViolationApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<RecentViolationDtoPagedResultDto> {
            return localVarFp.apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecentViolationApi - object-oriented interface
 * @export
 * @class RecentViolationApi
 * @extends {BaseAPI}
 */
export class RecentViolationApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecentViolationApi
     */
    public apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RecentViolationApiFp(this.configuration).apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportApiApi - axios parameter creator
 * @export
 */
export const ReportApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogreportPost: async (reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dailylogreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDailylogreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogsreportPost: async (reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dailylogsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDailylogsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDvirinspectionsreportPost: async (reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dvirinspectionsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDvirinspectionsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportElddeviceusagereportPostRequest} [reportElddeviceusagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportElddeviceusagereportPost: async (reportElddeviceusagereportPostRequest?: ReportElddeviceusagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/elddeviceusagereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportElddeviceusagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportEldeventsreportPost: async (reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/eldeventsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportEldeventsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/iftamileagereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportbasicPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/iftamileagereportbasic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftasummaryreportPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/iftasummaryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLocationhistoryreportPost: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/locationhistoryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportSafetyreportPostRequest} [reportSafetyreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSafetyreportPost: async (reportSafetyreportPostRequest?: ReportSafetyreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/safetyreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportSafetyreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTestreportGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/testreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripdetailPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/tripdetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripreportdetailPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/tripreportdetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportUnidentifiedeventsreportPostRequest} [reportUnidentifiedeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportUnidentifiedeventsreportPost: async (reportUnidentifiedeventsreportPostRequest?: ReportUnidentifiedeventsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/unidentifiedeventsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportUnidentifiedeventsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereport2Post: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicledistancereport2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereportPost: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicledistancereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicleinactivityreportPost: async (reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicleinactivityreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicleinactivityreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagereportPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehiclemileagereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagesummaryreportPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehiclemileagesummaryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApiApi - functional programming interface
 * @export
 */
export const ReportApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDailylogreportPost(reportDailylogreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDailylogsreportPost(reportDailylogsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportElddeviceusagereportPostRequest} [reportElddeviceusagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest?: ReportElddeviceusagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportEldeventsreportPost(reportEldeventsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIftamileagereportPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIftasummaryreportPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportSafetyreportPostRequest} [reportSafetyreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportSafetyreportPost(reportSafetyreportPostRequest?: ReportSafetyreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportSafetyreportPost(reportSafetyreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTestreportGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTestreportGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportUnidentifiedeventsreportPostRequest} [reportUnidentifiedeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest?: ReportUnidentifiedeventsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportApiApi - factory interface
 * @export
 */
export const ReportApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDailylogreportPost(reportDailylogreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDailylogsreportPost(reportDailylogsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportElddeviceusagereportPostRequest} [reportElddeviceusagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest?: ReportElddeviceusagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportEldeventsreportPost(reportEldeventsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportIftamileagereportPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportIftasummaryreportPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportSafetyreportPostRequest} [reportSafetyreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSafetyreportPost(reportSafetyreportPostRequest?: ReportSafetyreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportSafetyreportPost(reportSafetyreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTestreportGet(options?: any): AxiosPromise<void> {
            return localVarFp.reportTestreportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportUnidentifiedeventsreportPostRequest} [reportUnidentifiedeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest?: ReportUnidentifiedeventsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApiApi - object-oriented interface
 * @export
 * @class ReportApiApi
 * @extends {BaseAPI}
 */
export class ReportApiApi extends BaseAPI {
    /**
     * 
     * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDailylogreportPost(reportDailylogreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDailylogsreportPost(reportDailylogsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportElddeviceusagereportPostRequest} [reportElddeviceusagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest?: ReportElddeviceusagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportElddeviceusagereportPost(reportElddeviceusagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportEldeventsreportPost(reportEldeventsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportIftamileagereportPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportIftamileagereportbasicPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportIftasummaryreportPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportSafetyreportPostRequest} [reportSafetyreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportSafetyreportPost(reportSafetyreportPostRequest?: ReportSafetyreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportSafetyreportPost(reportSafetyreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTestreportGet(options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTestreportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTripdetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTripreportdetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportUnidentifiedeventsreportPostRequest} [reportUnidentifiedeventsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest?: ReportUnidentifiedeventsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportUnidentifiedeventsreportPost(reportUnidentifiedeventsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportArchiveApi - axios parameter creator
 * @export
 */
export const ReportArchiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppReportarchiveIdGet', 'id', id)
            const localVarPath = `/api/app/reportarchive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportArchiveApi - functional programming interface
 * @export
 */
export const ReportArchiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportArchiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportArchiveApi - factory interface
 * @export
 */
export const ReportArchiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportArchiveApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ReportDtoPagedResultDto> {
            return localVarFp.apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ReportDtoPagedResultDto> {
            return localVarFp.apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<ReportDto>> {
            return localVarFp.apiAppReportarchiveGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ReportDto>> {
            return localVarFp.apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveIdGet(id: string, options?: any): AxiosPromise<ReportDto> {
            return localVarFp.apiAppReportarchiveIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportArchiveApi - object-oriented interface
 * @export
 * @class ReportArchiveApi
 * @extends {BaseAPI}
 */
export class ReportArchiveApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveIdGet(id: string, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportViewApi - axios parameter creator
 * @export
 */
export const ReportViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost: async (apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagebystatesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewPost: async (apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost: async (apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagesummaryreportviewbyvehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclestatemileagesummaryreportviewPost: async (apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclestatemileagesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewVehiclelocationhistoryreportviewGet: async (vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/vehiclelocationhistoryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['TimeFrom'] = (timeFrom as any instanceof Date) ?
                    (timeFrom as any).toISOString() :
                    timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['TimeTo'] = (timeTo as any instanceof Date) ?
                    (timeTo as any).toISOString() :
                    timeTo;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportViewApi - functional programming interface
 * @export
 */
export const ReportViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageByStateSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageSummaryReportEntryListByVehicleResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleStateMileageSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleLocationHistoryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportViewApi - factory interface
 * @export
 */
export const ReportViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportViewApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageByStateSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageSummaryReportEntryListByVehicleResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleStateMileageSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleLocationHistoryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportViewApi - object-oriented interface
 * @export
 * @class ReportViewApi
 * @extends {BaseAPI}
 */
export class ReportViewApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [timeFrom] 
     * @param {string} [timeTo] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdDelete', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdGet', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdPut: async (id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdPut', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppRoleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRolePost: async (apiAppRoleGetRequest?: ApiAppRoleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppRoleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesAllGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdDelete', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdGet', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdPut: async (id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdPut', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesPost: async (apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRolePost(apiAppRoleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesAllGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppRoleDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppRoleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<RoleDtoPagedResultDto> {
            return localVarFp.apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<RoleListDtoPagedResultDto> {
            return localVarFp.apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<RoleListDto>> {
            return localVarFp.apiAppRoleGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<RoleListDto>> {
            return localVarFp.apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppRoleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdGet(id: string, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRolePost(apiAppRoleGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesAllGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityRolesAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityRoleDtoPagedResultDto> {
            return localVarFp.apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityRolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdGet(id: string, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdDelete(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdGet(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRolePost(apiAppRoleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesAllGet(options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdDelete(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdGet(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RuntimeSettingsApi - axios parameter creator
 * @export
 */
export const RuntimeSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [setting] 
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRuntimesettingsSetsettingPost: async (setting?: string, value?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/runtimesettings/setsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (setting !== undefined) {
                localVarQueryParameter['setting'] = setting;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuntimeSettingsApi - functional programming interface
 * @export
 */
export const RuntimeSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuntimeSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [setting] 
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRuntimesettingsSetsettingPost(setting?: string, value?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRuntimesettingsSetsettingPost(setting, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RuntimeSettingsApi - factory interface
 * @export
 */
export const RuntimeSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuntimeSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [setting] 
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRuntimesettingsSetsettingPost(setting?: string, value?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppRuntimesettingsSetsettingPost(setting, value, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuntimeSettingsApi - object-oriented interface
 * @export
 * @class RuntimeSettingsApi
 * @extends {BaseAPI}
 */
export class RuntimeSettingsApi extends BaseAPI {
    /**
     * 
     * @param {string} [setting] 
     * @param {string} [value] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuntimeSettingsApi
     */
    public apiAppRuntimesettingsSetsettingPost(setting?: string, value?: string, options?: AxiosRequestConfig) {
        return RuntimeSettingsApiFp(this.configuration).apiAppRuntimesettingsSetsettingPost(setting, value, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyAlertsApi - axios parameter creator
 * @export
 */
export const SafetyAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetyalertsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetyalerts/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyAlertsApi - functional programming interface
 * @export
 */
export const SafetyAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyAlertListDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyAlertsApi - factory interface
 * @export
 */
export const SafetyAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyAlertsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<SafetyAlertListDtoListResultDto> {
            return localVarFp.apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyAlertsApi - object-oriented interface
 * @export
 * @class SafetyAlertsApi
 * @extends {BaseAPI}
 */
export class SafetyAlertsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAlertsApi
     */
    public apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return SafetyAlertsApiFp(this.configuration).apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyDashboardApi - axios parameter creator
 * @export
 */
export const SafetyDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverscoresGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverscores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithgeometrisalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithgeometrisalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshaccelerationeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshaccelerationevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshbrakingeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshbrakingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshturneventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshturnevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithimpacteventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithimpactevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithphysicalelddisconnections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithspeedingeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithspeedingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithunresolveddvirdefectsGet: async (severity?: DvirFormAreaPointSeverity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithunresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardGeometriseventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/geometrisevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardHarsheventsbreakdownGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/harsheventsbreakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdDriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdDriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/driver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdGeometriseventsfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdGeometriseventsfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/geometriseventsfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/harsheventsbreakdownfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdSpeedingeventsfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdSpeedingeventsfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/speedingeventsfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardSpeedingeventssummaryGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/speedingeventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardTotalactivedriversGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/totalactivedrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardUnresolveddvirdefectsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/unresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyDashboardApi - functional programming interface
 * @export
 */
export const SafetyDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverscoresGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverScoresOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverscoresGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithgeometrisalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshbrakingeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshturneventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshturneventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithimpacteventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithimpacteventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithspeedingeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithspeedingeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardGeometriseventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetDriverEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardGeometriseventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardHarsheventsbreakdownGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventsBreakdownDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardHarsheventsbreakdownGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdDriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyDashboardDriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdDriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetVehicleEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHarshEventsBreakdownDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverSpeedingEventDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardSpeedingeventssummaryGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverSpeedingEventsSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardSpeedingeventssummaryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardTotalactivedriversGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalDriversWidgetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardTotalactivedriversGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnresolvedDvirDefectsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardUnresolveddvirdefectsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyDashboardApi - factory interface
 * @export
 */
export const SafetyDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverscoresGet(options?: any): AxiosPromise<DriverScoresOutput> {
            return localVarFp.apiAppSafetydashboardDriverscoresGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithgeometrisalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshbrakingeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshturneventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshturneventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithimpacteventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithimpacteventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithspeedingeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithspeedingeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardGeometriseventsGet(options?: any): AxiosPromise<Array<GeometrisWidgetDriverEventDto>> {
            return localVarFp.apiAppSafetydashboardGeometriseventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardHarsheventsbreakdownGet(options?: any): AxiosPromise<HarshEventsBreakdownDto> {
            return localVarFp.apiAppSafetydashboardHarsheventsbreakdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdDriverGet(id: number, options?: any): AxiosPromise<SafetyDashboardDriverDto> {
            return localVarFp.apiAppSafetydashboardIdDriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: any): AxiosPromise<Array<GeometrisWidgetVehicleEventDto>> {
            return localVarFp.apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: any): AxiosPromise<DriverHarshEventsBreakdownDto> {
            return localVarFp.apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: any): AxiosPromise<Array<DriverSpeedingEventDetailsDto>> {
            return localVarFp.apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardSpeedingeventssummaryGet(options?: any): AxiosPromise<Array<DriverSpeedingEventsSummaryDto>> {
            return localVarFp.apiAppSafetydashboardSpeedingeventssummaryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardTotalactivedriversGet(options?: any): AxiosPromise<TotalDriversWidgetDto> {
            return localVarFp.apiAppSafetydashboardTotalactivedriversGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardUnresolveddvirdefectsGet(options?: any): AxiosPromise<UnresolvedDvirDefectsDto> {
            return localVarFp.apiAppSafetydashboardUnresolveddvirdefectsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyDashboardApi - object-oriented interface
 * @export
 * @class SafetyDashboardApi
 * @extends {BaseAPI}
 */
export class SafetyDashboardApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverscoresGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverscoresGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithgeometrisalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshbrakingeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshturneventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshturneventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithimpacteventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithimpacteventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithspeedingeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithspeedingeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DvirFormAreaPointSeverity} [severity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardGeometriseventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardGeometriseventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardHarsheventsbreakdownGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardHarsheventsbreakdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdDriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdDriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardSpeedingeventssummaryGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardSpeedingeventssummaryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardTotalactivedriversGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardTotalactivedriversGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardUnresolveddvirdefectsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TelematicsApi - axios parameter creator
 * @export
 */
export const TelematicsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiTelematicsPostRequest} [apiTelematicsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTelematicsPost: async (apiTelematicsPostRequest?: ApiTelematicsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/telematics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTelematicsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelematicsApi - functional programming interface
 * @export
 */
export const TelematicsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelematicsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiTelematicsPostRequest} [apiTelematicsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTelematicsPost(apiTelematicsPostRequest?: ApiTelematicsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTelematicsPost(apiTelematicsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TelematicsApi - factory interface
 * @export
 */
export const TelematicsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelematicsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiTelematicsPostRequest} [apiTelematicsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTelematicsPost(apiTelematicsPostRequest?: ApiTelematicsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiTelematicsPost(apiTelematicsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TelematicsApi - object-oriented interface
 * @export
 * @class TelematicsApi
 * @extends {BaseAPI}
 */
export class TelematicsApi extends BaseAPI {
    /**
     * 
     * @param {ApiTelematicsPostRequest} [apiTelematicsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelematicsApi
     */
    public apiTelematicsPost(apiTelematicsPostRequest?: ApiTelematicsPostRequest, options?: AxiosRequestConfig) {
        return TelematicsApiFp(this.configuration).apiTelematicsPost(apiTelematicsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantAcquiretenantadminaccesstokenPost: async (apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/acquiretenantadminaccesstoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantAcquiretenantadminaccesstokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdDelete', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdGet', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdPut: async (id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdPut', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantPost: async (apiAppTenantGetRequest?: ApiAppTenantGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsExportPost: async (id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/multi-tenancy/tenants/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/multi-tenancy/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringDelete', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringGet', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringPut: async (id: string, defaultConnectionString?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringPut', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defaultConnectionString !== undefined) {
                localVarQueryParameter['defaultConnectionString'] = defaultConnectionString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDelete', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdGet', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdPut: async (id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdPut', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiMultiTenancyTenantsIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsPost: async (apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/multi-tenancy/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiMultiTenancyTenantsGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOverrideOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantPost(apiAppTenantGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsExportPost(id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IRemoteStreamContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsExportPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: any): AxiosPromise<UserOverrideOutput> {
            return localVarFp.apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdGet(id: string, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantPost(apiAppTenantGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsExportPost(id?: string, options?: any): AxiosPromise<IRemoteStreamContent> {
            return localVarFp.apiMultiTenancyTenantsExportPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantDtoPagedResultDto> {
            return localVarFp.apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdGet(id: string, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantPost(apiAppTenantGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsExportPost(id?: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsExportPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [defaultConnectionString] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantEldDeviceMutationWorkflowApi - axios parameter creator
 * @export
 */
export const TenantEldDeviceMutationWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost: async (apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddevicemutationworkflow/checkuniqueconstraints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdChangestatusPost: async (id: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantelddevicemutationworkflowIdChangestatusPost', 'id', id)
            const localVarPath = `/api/app/tenantelddevicemutationworkflow/{id}/changestatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [requireTenantOwned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdDeactivatePost: async (id: number, requireTenantOwned?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantelddevicemutationworkflowIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/tenantelddevicemutationworkflow/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requireTenantOwned !== undefined) {
                localVarQueryParameter['requireTenantOwned'] = requireTenantOwned;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [requireTenantOwned] 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdPut: async (id: number, preserveStatus?: boolean, requireTenantOwned?: boolean, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantelddevicemutationworkflowIdPut', 'id', id)
            const localVarPath = `/api/app/tenantelddevicemutationworkflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preserveStatus !== undefined) {
                localVarQueryParameter['preserveStatus'] = preserveStatus;
            }

            if (requireTenantOwned !== undefined) {
                localVarQueryParameter['requireTenantOwned'] = requireTenantOwned;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowPost: async (apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddevicemutationworkflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantEldDeviceMutationWorkflowApi - functional programming interface
 * @export
 */
export const TenantEldDeviceMutationWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantEldDeviceMutationWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddevicemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddevicemutationworkflowIdChangestatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [requireTenantOwned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddevicemutationworkflowIdDeactivatePost(id: number, requireTenantOwned?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDtoEntityStatusChangeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddevicemutationworkflowIdDeactivatePost(id, requireTenantOwned, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [requireTenantOwned] 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddevicemutationworkflowIdPut(id: number, preserveStatus?: boolean, requireTenantOwned?: boolean, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddevicemutationworkflowIdPut(id, preserveStatus, requireTenantOwned, apiAppElddeviceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantEldDeviceMutationWorkflowApi - factory interface
 * @export
 */
export const TenantEldDeviceMutationWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantEldDeviceMutationWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppTenantelddevicemutationworkflowIdChangestatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [requireTenantOwned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdDeactivatePost(id: number, requireTenantOwned?: boolean, options?: any): AxiosPromise<EldDeviceDtoEntityStatusChangeResult> {
            return localVarFp.apiAppTenantelddevicemutationworkflowIdDeactivatePost(id, requireTenantOwned, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [requireTenantOwned] 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowIdPut(id: number, preserveStatus?: boolean, requireTenantOwned?: boolean, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppTenantelddevicemutationworkflowIdPut(id, preserveStatus, requireTenantOwned, apiAppElddeviceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantEldDeviceMutationWorkflowApi - object-oriented interface
 * @export
 * @class TenantEldDeviceMutationWorkflowApi
 * @extends {BaseAPI}
 */
export class TenantEldDeviceMutationWorkflowApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceMutationWorkflowApi
     */
    public apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceMutationWorkflowApiFp(this.configuration).apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPost(apiAppTenantelddevicemutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceMutationWorkflowApi
     */
    public apiAppTenantelddevicemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TenantEldDeviceMutationWorkflowApiFp(this.configuration).apiAppTenantelddevicemutationworkflowIdChangestatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [requireTenantOwned] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceMutationWorkflowApi
     */
    public apiAppTenantelddevicemutationworkflowIdDeactivatePost(id: number, requireTenantOwned?: boolean, options?: AxiosRequestConfig) {
        return TenantEldDeviceMutationWorkflowApiFp(this.configuration).apiAppTenantelddevicemutationworkflowIdDeactivatePost(id, requireTenantOwned, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [preserveStatus] 
     * @param {boolean} [requireTenantOwned] 
     * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceMutationWorkflowApi
     */
    public apiAppTenantelddevicemutationworkflowIdPut(id: number, preserveStatus?: boolean, requireTenantOwned?: boolean, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceMutationWorkflowApiFp(this.configuration).apiAppTenantelddevicemutationworkflowIdPut(id, preserveStatus, requireTenantOwned, apiAppElddeviceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceMutationWorkflowApi
     */
    public apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceMutationWorkflowApiFp(this.configuration).apiAppTenantelddevicemutationworkflowPost(apiAppElddeviceGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantEldDeviceViewApi - axios parameter creator
 * @export
 */
export const TenantEldDeviceViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantelddeviceviewIdGet', 'id', id)
            const localVarPath = `/api/app/tenantelddeviceview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantEldDeviceViewApi - functional programming interface
 * @export
 */
export const TenantEldDeviceViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantEldDeviceViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantEldDeviceViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantEldDeviceViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantEldDeviceViewApi - factory interface
 * @export
 */
export const TenantEldDeviceViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantEldDeviceViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantEldDeviceViewDtoPagedResultDto> {
            return localVarFp.apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantEldDeviceViewDtoPagedResultDto> {
            return localVarFp.apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TenantEldDeviceViewDto>> {
            return localVarFp.apiAppTenantelddeviceviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantEldDeviceViewDto>> {
            return localVarFp.apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewIdGet(id: number, options?: any): AxiosPromise<TenantEldDeviceViewDto> {
            return localVarFp.apiAppTenantelddeviceviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantEldDeviceViewApi - object-oriented interface
 * @export
 * @class TenantEldDeviceViewApi
 * @extends {BaseAPI}
 */
export class TenantEldDeviceViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewIdGet(id: number, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantRegistrationApi - axios parameter creator
 * @export
 */
export const TenantRegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationApproveordenypendingrequestPost: async (apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/approveordenypendingrequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationApproveordenypendingrequestPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDeactivatePost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdDelete', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdGet', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGrantmasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdGrantmasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/grantmasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdPut: async (id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdPut', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdReactivatemasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdReactivatemasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/reactivatemasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdRemovemasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdRemovemasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/removemasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdResendwelcomeemailPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdResendwelcomeemailPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/resendwelcomeemail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [isLocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSetvehicleoffsetlockPost: async (id: string, isLocked?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdSetvehicleoffsetlockPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/setvehicleoffsetlock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isLocked !== undefined) {
                localVarQueryParameter['isLocked'] = isLocked;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSuspendmasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdSuspendmasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/suspendmasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationPost: async (apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationReassigntenantPost: async (apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/reassigntenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationReassigntenantPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/tenantregistration/tenantregistrationbasicinfo/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantRegistrationApi - functional programming interface
 * @export
 */
export const TenantRegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantRegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantRegistrationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantRegistrationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdDeactivatePost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdGrantmasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdReactivatemasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdRemovemasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdResendwelcomeemailPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [isLocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdSetvehicleoffsetlockPost(id: string, isLocked?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdSetvehicleoffsetlockPost(id, isLocked, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdSuspendmasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationBasicInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantRegistrationApi - factory interface
 * @export
 */
export const TenantRegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantRegistrationApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantregistrationDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantRegistrationDtoPagedResultDto> {
            return localVarFp.apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantRegistrationDtoPagedResultDto> {
            return localVarFp.apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantRegistrationDto>> {
            return localVarFp.apiAppTenantregistrationGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantRegistrationDto>> {
            return localVarFp.apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDeactivatePost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGet(id: string, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdGrantmasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdReactivatemasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdRemovemasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdResendwelcomeemailPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [isLocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSetvehicleoffsetlockPost(id: string, isLocked?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdSetvehicleoffsetlockPost(id, isLocked, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdSuspendmasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: any): AxiosPromise<TenantRegistrationBasicInfoDto> {
            return localVarFp.apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantRegistrationApi - object-oriented interface
 * @export
 * @class TenantRegistrationApi
 * @extends {BaseAPI}
 */
export class TenantRegistrationApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdDeactivatePost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdGrantmasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdReactivatemasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdRemovemasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdResendwelcomeemailPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} [isLocked] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdSetvehicleoffsetlockPost(id: string, isLocked?: boolean, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdSetvehicleoffsetlockPost(id, isLocked, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdSuspendmasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantViewApi - axios parameter creator
 * @export
 */
export const TenantViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewAccessibletenantsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/accessibletenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parentTenantId 
         * @param {Array<string>} [childTenantsIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewChildtenantsParentTenantIdGet: async (parentTenantId: string, childTenantsIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentTenantId' is not null or undefined
            assertParamExists('apiAppTenantviewChildtenantsParentTenantIdGet', 'parentTenantId', parentTenantId)
            const localVarPath = `/api/app/tenantview/childtenants/{parentTenantId}`
                .replace(`{${"parentTenantId"}}`, encodeURIComponent(String(parentTenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (childTenantsIds) {
                localVarQueryParameter['childTenantsIds'] = childTenantsIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantviewIdGet', 'id', id)
            const localVarPath = `/api/app/tenantview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantViewApi - functional programming interface
 * @export
 */
export const TenantViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewAccessibletenantsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewAccessibletenantsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} parentTenantId 
         * @param {Array<string>} [childTenantsIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId: string, childTenantsIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId, childTenantsIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantViewApi - factory interface
 * @export
 */
export const TenantViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantViewApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewAccessibletenantsGet(options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewAccessibletenantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} parentTenantId 
         * @param {Array<string>} [childTenantsIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId: string, childTenantsIds?: Array<string>, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId, childTenantsIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewIdGet(id: string, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantViewApi - object-oriented interface
 * @export
 * @class TenantViewApi
 * @extends {BaseAPI}
 */
export class TenantViewApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewAccessibletenantsGet(options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewAccessibletenantsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} parentTenantId 
     * @param {Array<string>} [childTenantsIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId: string, childTenantsIds?: Array<string>, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewChildtenantsParentTenantIdGet(parentTenantId, childTenantsIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailerApi - axios parameter creator
 * @export
 */
export const TrailerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdDelete', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdGet', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdPut: async (id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdPut', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerPost: async (apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerApi - functional programming interface
 * @export
 */
export const TrailerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerPost(apiAppTrailerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailerApi - factory interface
 * @export
 */
export const TrailerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TrailerDtoPagedResultDto> {
            return localVarFp.apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TrailerListDtoPagedResultDto> {
            return localVarFp.apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TrailerListDto>> {
            return localVarFp.apiAppTrailerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TrailerListDto>> {
            return localVarFp.apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdGet(id: number, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerPost(apiAppTrailerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<TrailerSyncDto>> {
            return localVarFp.apiAppTrailerSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerApi - object-oriented interface
 * @export
 * @class TrailerApi
 * @extends {BaseAPI}
 */
export class TrailerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdDelete(id: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdGet(id: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerPost(apiAppTrailerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailerMutationWorkflowApi - axios parameter creator
 * @export
 */
export const TrailerMutationWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowCheckuniqueconstraintsPost: async (apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailermutationworkflow/checkuniqueconstraints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdChangestatusPost: async (id: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailermutationworkflowIdChangestatusPost', 'id', id)
            const localVarPath = `/api/app/trailermutationworkflow/{id}/changestatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdDeactivatePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailermutationworkflowIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/trailermutationworkflow/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdPut: async (id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailermutationworkflowIdPut', 'id', id)
            const localVarPath = `/api/app/trailermutationworkflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preserveStatus !== undefined) {
                localVarQueryParameter['preserveStatus'] = preserveStatus;
            }

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowPost: async (updateDocuments?: boolean, apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailermutationworkflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerMutationWorkflowApi - functional programming interface
 * @export
 */
export const TrailerMutationWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerMutationWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailermutationworkflowIdChangestatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailermutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDtoEntityStatusChangeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailermutationworkflowIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppTrailerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailermutationworkflowPost(updateDocuments?: boolean, apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailermutationworkflowPost(updateDocuments, apiAppTrailerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailerMutationWorkflowApi - factory interface
 * @export
 */
export const TrailerMutationWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerMutationWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailermutationworkflowIdChangestatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdDeactivatePost(id: number, options?: any): AxiosPromise<TrailerDtoEntityStatusChangeResult> {
            return localVarFp.apiAppTrailermutationworkflowIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppTrailerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailermutationworkflowPost(updateDocuments?: boolean, apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailermutationworkflowPost(updateDocuments, apiAppTrailerGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerMutationWorkflowApi - object-oriented interface
 * @export
 * @class TrailerMutationWorkflowApi
 * @extends {BaseAPI}
 */
export class TrailerMutationWorkflowApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest} [apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMutationWorkflowApi
     */
    public apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig) {
        return TrailerMutationWorkflowApiFp(this.configuration).apiAppTrailermutationworkflowCheckuniqueconstraintsPost(apiAppTrailermutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMutationWorkflowApi
     */
    public apiAppTrailermutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TrailerMutationWorkflowApiFp(this.configuration).apiAppTrailermutationworkflowIdChangestatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMutationWorkflowApi
     */
    public apiAppTrailermutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig) {
        return TrailerMutationWorkflowApiFp(this.configuration).apiAppTrailermutationworkflowIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [preserveStatus] 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMutationWorkflowApi
     */
    public apiAppTrailermutationworkflowIdPut(id: number, preserveStatus?: boolean, updateDocuments?: boolean, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig) {
        return TrailerMutationWorkflowApiFp(this.configuration).apiAppTrailermutationworkflowIdPut(id, preserveStatus, updateDocuments, apiAppTrailerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMutationWorkflowApi
     */
    public apiAppTrailermutationworkflowPost(updateDocuments?: boolean, apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig) {
        return TrailerMutationWorkflowApiFp(this.configuration).apiAppTrailermutationworkflowPost(updateDocuments, apiAppTrailerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailerTrackingProviderApi - axios parameter creator
 * @export
 */
export const TrailerTrackingProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdDelete', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdGet', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdPut: async (id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdPut', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailertrackingproviderIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderPost: async (apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailertrackingproviderGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerTrackingProviderApi - functional programming interface
 * @export
 */
export const TrailerTrackingProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerTrackingProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailerTrackingProviderApi - factory interface
 * @export
 */
export const TrailerTrackingProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerTrackingProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailertrackingproviderDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TrailerTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TrailerTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TrailerTrackingProviderDto>> {
            return localVarFp.apiAppTrailertrackingproviderGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TrailerTrackingProviderDto>> {
            return localVarFp.apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailertrackingproviderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdGet(id: number, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerTrackingProviderApi - object-oriented interface
 * @export
 * @class TrailerTrackingProviderApi
 * @extends {BaseAPI}
 */
export class TrailerTrackingProviderApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdDelete(id: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdGet(id: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailersHistoryApi - axios parameter creator
 * @export
 */
export const TrailersHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerstatusinfoTrailerIdGet: async (trailerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('apiAppTrailershistoryTrailerstatusinfoTrailerIdGet', 'trailerId', trailerId)
            const localVarPath = `/api/app/trailershistory/trailerstatusinfo/{trailerId}`
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerusagehistoryTrailerIdGet: async (trailerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('apiAppTrailershistoryTrailerusagehistoryTrailerIdGet', 'trailerId', trailerId)
            const localVarPath = `/api/app/trailershistory/trailerusagehistory/{trailerId}`
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailersHistoryApi - functional programming interface
 * @export
 */
export const TrailersHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailersHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerHistoryStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailersUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailersHistoryApi - factory interface
 * @export
 */
export const TrailersHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailersHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: any): AxiosPromise<TrailerHistoryStatusInfoDto> {
            return localVarFp.apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: any): AxiosPromise<Array<TrailersUsageHistoryListDto>> {
            return localVarFp.apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailersHistoryApi - object-oriented interface
 * @export
 * @class TrailersHistoryApi
 * @extends {BaseAPI}
 */
export class TrailersHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} trailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersHistoryApi
     */
    public apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: AxiosRequestConfig) {
        return TrailersHistoryApiFp(this.configuration).apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} trailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersHistoryApi
     */
    public apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: AxiosRequestConfig) {
        return TrailersHistoryApiFp(this.configuration).apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TripsViewApi - axios parameter creator
 * @export
 */
export const TripsViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetMasterTripDetailPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsview/get-master-trip-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetMasterTripReportDetailPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsview/get-master-trip-report-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetmastertripdetaildataPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsview/getmastertripdetaildata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbystateGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsviewbystate/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbyvehicleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsviewbyvehicle/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TripsViewApi - functional programming interface
 * @export
 */
export const TripsViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TripsViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripReportDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewByStateListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewByVehicleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TripsViewApi - factory interface
 * @export
 */
export const TripsViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TripsViewApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<TripDetailData> {
            return localVarFp.apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<TripReportDetailData> {
            return localVarFp.apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<TripDetailData> {
            return localVarFp.apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewByStateListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewByVehicleListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TripsViewApi - object-oriented interface
 * @export
 * @class TripsViewApi
 * @extends {BaseAPI}
 */
export class TripsViewApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewGetMasterTripDetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewGetMasterTripReportDetailPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewGetmastertripdetaildataPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TwoFactorAuthenticationSettingsApi - axios parameter creator
 * @export
 */
export const TwoFactorAuthenticationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGenerateonetimecodePost: async (apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/generateonetimecode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsSavePost: async (apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsSavePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsVerifyonetimecodePost: async (apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/verifyonetimecode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwoFactorAuthenticationSettingsApi - functional programming interface
 * @export
 */
export const TwoFactorAuthenticationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwoFactorAuthenticationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateOneTimeCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorAuthenticationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyOneTimeCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TwoFactorAuthenticationSettingsApi - factory interface
 * @export
 */
export const TwoFactorAuthenticationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwoFactorAuthenticationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: any): AxiosPromise<GenerateOneTimeCodeOutput> {
            return localVarFp.apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGet(options?: any): AxiosPromise<TwoFactorAuthenticationSettingsDto> {
            return localVarFp.apiAppTwofactorauthenticationsettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: any): AxiosPromise<VerifyOneTimeCodeOutput> {
            return localVarFp.apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwoFactorAuthenticationSettingsApi - object-oriented interface
 * @export
 * @class TwoFactorAuthenticationSettingsApi
 * @extends {BaseAPI}
 */
export class TwoFactorAuthenticationSettingsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsGet(options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UnidentifiedEventsApi - axios parameter creator
 * @export
 */
export const UnidentifiedEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsDelete: async (eventId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdGet: async (id: number, driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppUnidentifiedeventsIdGet', 'id', id)
            const localVarPath = `/api/app/unidentifiedevents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdPut: async (id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppUnidentifiedeventsIdPut', 'id', id)
            const localVarPath = `/api/app/unidentifiedevents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsIdGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsManyDelete: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents/many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsMastercreatePost: async (apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents/mastercreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsPost: async (apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnidentifiedEventsApi - functional programming interface
 * @export
 */
export const UnidentifiedEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnidentifiedEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsDelete(eventId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsDelete(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsIdGet(id, driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsManyDelete(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsManyDelete(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnidentifiedEventsApi - factory interface
 * @export
 */
export const UnidentifiedEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnidentifiedEventsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsDelete(eventId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUnidentifiedeventsDelete(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<UnidentifiedEventsListDtoPagedResultDto> {
            return localVarFp.apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsIdGet(id, driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsManyDelete(requestBody?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUnidentifiedeventsManyDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnidentifiedEventsApi - object-oriented interface
 * @export
 * @class UnidentifiedEventsApi
 * @extends {BaseAPI}
 */
export class UnidentifiedEventsApi extends BaseAPI {
    /**
     * 
     * @param {number} [eventId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsDelete(eventId?: number, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsDelete(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsIdGet(id, driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsManyDelete(requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsManyDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAssignableRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/assignable-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByEmailEmailGet: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiIdentityUsersByEmailEmailGet', 'email', email)
            const localVarPath = `/api/identity/users/by-email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByUsernameUserNameGet: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('apiIdentityUsersByUsernameUserNameGet', 'userName', userName)
            const localVarPath = `/api/identity/users/by-username/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdDelete', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdGet', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdPut: async (id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdPut', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdRolesGet', 'id', id)
            const localVarPath = `/api/identity/users/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesPut: async (id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdRolesPut', 'id', id)
            const localVarPath = `/api/identity/users/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersIdRolesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersPost: async (apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersAssignableRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersAssignableRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersByEmailEmailGet(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersByEmailEmailGet(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersByUsernameUserNameGet(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdRolesGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdRolesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersPost(apiIdentityUsersGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAssignableRolesGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityUsersAssignableRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByEmailEmailGet(email: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersByEmailEmailGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByUsernameUserNameGet(userName: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersByUsernameUserNameGet(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityUserDtoPagedResultDto> {
            return localVarFp.apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdGet(id: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesGet(id: string, options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityUsersIdRolesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersPost(apiIdentityUsersGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersAssignableRolesGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersAssignableRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersByEmailEmailGet(email: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersByEmailEmailGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersByUsernameUserNameGet(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdDelete(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdGet(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdRolesGet(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdRolesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersPost(apiIdentityUsersGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserLookupApi - axios parameter creator
 * @export
 */
export const UserLookupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupByUsernameUserNameGet: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('apiIdentityUsersLookupByUsernameUserNameGet', 'userName', userName)
            const localVarPath = `/api/identity/users/lookup/by-username/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupCountGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/lookup/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersLookupIdGet', 'id', id)
            const localVarPath = `/api/identity/users/lookup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupSearchGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/lookup/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLookupApi - functional programming interface
 * @export
 */
export const UserLookupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLookupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupByUsernameUserNameGet(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupCountGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupCountGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserLookupApi - factory interface
 * @export
 */
export const UserLookupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLookupApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: any): AxiosPromise<UserData> {
            return localVarFp.apiIdentityUsersLookupByUsernameUserNameGet(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupCountGet(filter?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiIdentityUsersLookupCountGet(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupIdGet(id: string, options?: any): AxiosPromise<UserData> {
            return localVarFp.apiIdentityUsersLookupIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<UserDataListResultDto> {
            return localVarFp.apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLookupApi - object-oriented interface
 * @export
 * @class UserLookupApi
 * @extends {BaseAPI}
 */
export class UserLookupApi extends BaseAPI {
    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupByUsernameUserNameGet(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupCountGet(filter?: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupCountGet(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupIdGet(id: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPreferenceApi - axios parameter creator
 * @export
 */
export const UserPreferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceSaveuserpreferencesPost: async (apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/userpreference/saveuserpreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUserpreferenceSaveuserpreferencesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceUserpreferencesUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppUserpreferenceUserpreferencesUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/userpreference/userpreferences/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPreferenceApi - functional programming interface
 * @export
 */
export const UserPreferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPreferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferenceGetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUserpreferenceUserpreferencesUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPreferenceApi - factory interface
 * @export
 */
export const UserPreferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPreferenceApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: any): AxiosPromise<UserPreferenceGetDto> {
            return localVarFp.apiAppUserpreferenceUserpreferencesUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPreferenceApi - object-oriented interface
 * @export
 * @class UserPreferenceApi
 * @extends {BaseAPI}
 */
export class UserPreferenceApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceApi
     */
    public apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: AxiosRequestConfig) {
        return UserPreferenceApiFp(this.configuration).apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceApi
     */
    public apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return UserPreferenceApiFp(this.configuration).apiAppUserpreferenceUserpreferencesUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilApi - axios parameter creator
 * @export
 */
export const UtilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilFmcsacredentialsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/fmcsacredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilObtainfmcsacredentialsPost: async (apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/obtainfmcsacredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilObtainfmcsacredentialsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilServertimeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/servertime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobileappversionPost: async (apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/setmobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilSetmobileappversionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobiledeviceinformationPost: async (apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/setmobiledeviceinformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilSetmobiledeviceinformationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilTaskcanceledexceptionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/taskcanceledexception`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilUploadmobileappdatabasePost: async (input?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/uploadmobileappdatabase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (input !== undefined) { 
                localVarFormParams.append('input', input as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilGetlogsarchivestreamGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/util/getlogsarchivestream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilApi - functional programming interface
 * @export
 */
export const UtilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilFmcsacredentialsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaMobileCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilFmcsacredentialsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilServertimeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilServertimeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilTaskcanceledexceptionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilTaskcanceledexceptionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilUploadmobileappdatabasePost(input?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilUploadmobileappdatabasePost(input, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilGetlogsarchivestreamGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilGetlogsarchivestreamGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilApi - factory interface
 * @export
 */
export const UtilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilFmcsacredentialsGet(options?: any): AxiosPromise<FmcsaMobileCredentials> {
            return localVarFp.apiAppUtilFmcsacredentialsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilServertimeGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppUtilServertimeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilTaskcanceledexceptionGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilTaskcanceledexceptionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilUploadmobileappdatabasePost(input?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppUtilUploadmobileappdatabasePost(input, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilGetlogsarchivestreamGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiUtilGetlogsarchivestreamGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilApi - object-oriented interface
 * @export
 * @class UtilApi
 * @extends {BaseAPI}
 */
export class UtilApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilFmcsacredentialsGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilFmcsacredentialsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilServertimeGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilServertimeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilTaskcanceledexceptionGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilTaskcanceledexceptionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilUploadmobileappdatabasePost(input?: any, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilUploadmobileappdatabasePost(input, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiUtilGetlogsarchivestreamGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiUtilGetlogsarchivestreamGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleApi - axios parameter creator
 * @export
 */
export const VehicleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdDelete', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdGet', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdPut: async (id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdPut', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclePost: async (apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleApi - functional programming interface
 * @export
 */
export const VehicleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclePost(apiAppVehicleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleApi - factory interface
 * @export
 */
export const VehicleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicleDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleDtoPagedResultDto> {
            return localVarFp.apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleListDtoPagedResultDto> {
            return localVarFp.apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleListDto>> {
            return localVarFp.apiAppVehicleGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleListDto>> {
            return localVarFp.apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdGet(id: number, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehiclePost(apiAppVehicleGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<VehicleSyncDto>> {
            return localVarFp.apiAppVehicleSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleApi - object-oriented interface
 * @export
 * @class VehicleApi
 * @extends {BaseAPI}
 */
export class VehicleApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehiclePost(apiAppVehicleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleHistoryApi - axios parameter creator
 * @export
 */
export const VehicleHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehicledriversusagehistory/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicleelddevicesusagehistoryGet: async (vehicleId: number, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicleelddevicesusagehistoryGet', 'vehicleId', vehicleId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicleelddevicesusagehistoryGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/vehiclehistory/vehicleelddevicesusagehistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['TenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehiclestatusinfo/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehicletrailersusagehistory/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleHistoryApi - functional programming interface
 * @export
 */
export const VehicleHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDriversAndDrivingPeriodListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleEldDevicesUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleUsageStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleTrailersUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleHistoryApi - factory interface
 * @export
 */
export const VehicleHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDriversAndDrivingPeriodListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: any): AxiosPromise<Array<VehicleEldDevicesUsageHistoryListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<VehicleUsageStatusInfoDto> {
            return localVarFp.apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleTrailersUsageHistoryListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleHistoryApi - object-oriented interface
 * @export
 * @class VehicleHistoryApi
 * @extends {BaseAPI}
 */
export class VehicleHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleMaintenanceApi - axios parameter creator
 * @export
 */
export const VehicleMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdDelete', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdGet', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdPut: async (id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdPut', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehiclemaintenanceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancePost: async (apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehiclemaintenanceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenancesummary/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenancesummaryIdGet', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenancesummary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMaintenanceApi - functional programming interface
 * @export
 */
export const VehicleMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleMaintenanceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleMaintenanceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceSummaryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancesummaryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancesummaryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleMaintenanceApi - factory interface
 * @export
 */
export const VehicleMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehiclemaintenanceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleMaintenanceDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleMaintenanceListDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleMaintenanceListDto>> {
            return localVarFp.apiAppVehiclemaintenanceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleMaintenanceListDto>> {
            return localVarFp.apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemaintenanceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdGet(id: number, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleMaintenanceSummaryListDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryIdGet(id: number, options?: any): AxiosPromise<VehicleMaintenanceSummaryDto> {
            return localVarFp.apiAppVehiclemaintenancesummaryIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleMaintenanceApi - object-oriented interface
 * @export
 * @class VehicleMaintenanceApi
 * @extends {BaseAPI}
 */
export class VehicleMaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancesummaryIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancesummaryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleMediaApi - axios parameter creator
 * @export
 */
export const VehicleMediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaGetcamerasdashboardPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemedia/getcamerasdashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaGetlistPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemedia/getlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mediaItemId 
         * @param {number} [width] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaPreviewMediaItemIdGet: async (mediaItemId: string, width?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaItemId' is not null or undefined
            assertParamExists('apiAppVehiclemediaPreviewMediaItemIdGet', 'mediaItemId', mediaItemId)
            const localVarPath = `/api/app/vehiclemedia/preview/{mediaItemId}`
                .replace(`{${"mediaItemId"}}`, encodeURIComponent(String(mediaItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaRefreshallnowPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemedia/refreshallnow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMediaApi - functional programming interface
 * @export
 */
export const VehicleMediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMediaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceCamerasDashboardDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMediaItemDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mediaItemId 
         * @param {number} [width] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId: string, width?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IRemoteStreamContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId, width, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleMediaApi - factory interface
 * @export
 */
export const VehicleMediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMediaApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceCamerasDashboardDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleMediaItemDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mediaItemId 
         * @param {number} [width] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId: string, width?: number, options?: any): AxiosPromise<IRemoteStreamContent> {
            return localVarFp.apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId, width, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleMediaApi - object-oriented interface
 * @export
 * @class VehicleMediaApi
 * @extends {BaseAPI}
 */
export class VehicleMediaApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMediaApi
     */
    public apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMediaApiFp(this.configuration).apiAppVehiclemediaGetcamerasdashboardPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMediaApi
     */
    public apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMediaApiFp(this.configuration).apiAppVehiclemediaGetlistPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mediaItemId 
     * @param {number} [width] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMediaApi
     */
    public apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId: string, width?: number, options?: AxiosRequestConfig) {
        return VehicleMediaApiFp(this.configuration).apiAppVehiclemediaPreviewMediaItemIdGet(mediaItemId, width, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMediaApi
     */
    public apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMediaApiFp(this.configuration).apiAppVehiclemediaRefreshallnowPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleMutationWorkflowApi - axios parameter creator
 * @export
 */
export const VehicleMutationWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowCheckuniqueconstraintsPost: async (apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemutationworkflow/checkuniqueconstraints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdChangestatusPost: async (id: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemutationworkflowIdChangestatusPost', 'id', id)
            const localVarPath = `/api/app/vehiclemutationworkflow/{id}/changestatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdDeactivatePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemutationworkflowIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/vehiclemutationworkflow/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [preserveEldAssignment] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdPut: async (id: number, preserveStatus?: boolean, preserveEldAssignment?: boolean, updateDocuments?: boolean, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemutationworkflowIdPut', 'id', id)
            const localVarPath = `/api/app/vehiclemutationworkflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preserveStatus !== undefined) {
                localVarQueryParameter['preserveStatus'] = preserveStatus;
            }

            if (preserveEldAssignment !== undefined) {
                localVarQueryParameter['preserveEldAssignment'] = preserveEldAssignment;
            }

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowPost: async (updateDocuments?: boolean, apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemutationworkflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateDocuments !== undefined) {
                localVarQueryParameter['updateDocuments'] = updateDocuments;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMutationWorkflowApi - functional programming interface
 * @export
 */
export const VehicleMutationWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMutationWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemutationworkflowIdChangestatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDtoEntityStatusChangeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemutationworkflowIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [preserveEldAssignment] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemutationworkflowIdPut(id: number, preserveStatus?: boolean, preserveEldAssignment?: boolean, updateDocuments?: boolean, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemutationworkflowIdPut(id, preserveStatus, preserveEldAssignment, updateDocuments, apiAppVehicleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemutationworkflowPost(updateDocuments?: boolean, apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemutationworkflowPost(updateDocuments, apiAppVehicleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleMutationWorkflowApi - factory interface
 * @export
 */
export const VehicleMutationWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMutationWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehiclemutationworkflowIdChangestatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdDeactivatePost(id: number, options?: any): AxiosPromise<VehicleDtoEntityStatusChangeResult> {
            return localVarFp.apiAppVehiclemutationworkflowIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [preserveStatus] 
         * @param {boolean} [preserveEldAssignment] 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowIdPut(id: number, preserveStatus?: boolean, preserveEldAssignment?: boolean, updateDocuments?: boolean, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehiclemutationworkflowIdPut(id, preserveStatus, preserveEldAssignment, updateDocuments, apiAppVehicleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [updateDocuments] 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemutationworkflowPost(updateDocuments?: boolean, apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehiclemutationworkflowPost(updateDocuments, apiAppVehicleGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleMutationWorkflowApi - object-oriented interface
 * @export
 * @class VehicleMutationWorkflowApi
 * @extends {BaseAPI}
 */
export class VehicleMutationWorkflowApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest} [apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMutationWorkflowApi
     */
    public apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest?: ApiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options?: AxiosRequestConfig) {
        return VehicleMutationWorkflowApiFp(this.configuration).apiAppVehiclemutationworkflowCheckuniqueconstraintsPost(apiAppVehiclemutationworkflowCheckuniqueconstraintsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMutationWorkflowApi
     */
    public apiAppVehiclemutationworkflowIdChangestatusPost(id: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleMutationWorkflowApiFp(this.configuration).apiAppVehiclemutationworkflowIdChangestatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMutationWorkflowApi
     */
    public apiAppVehiclemutationworkflowIdDeactivatePost(id: number, options?: AxiosRequestConfig) {
        return VehicleMutationWorkflowApiFp(this.configuration).apiAppVehiclemutationworkflowIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [preserveStatus] 
     * @param {boolean} [preserveEldAssignment] 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMutationWorkflowApi
     */
    public apiAppVehiclemutationworkflowIdPut(id: number, preserveStatus?: boolean, preserveEldAssignment?: boolean, updateDocuments?: boolean, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleMutationWorkflowApiFp(this.configuration).apiAppVehiclemutationworkflowIdPut(id, preserveStatus, preserveEldAssignment, updateDocuments, apiAppVehicleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [updateDocuments] 
     * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMutationWorkflowApi
     */
    public apiAppVehiclemutationworkflowPost(updateDocuments?: boolean, apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig) {
        return VehicleMutationWorkflowApiFp(this.configuration).apiAppVehiclemutationworkflowPost(updateDocuments, apiAppVehicleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleTrackingProviderApi - axios parameter creator
 * @export
 */
export const VehicleTrackingProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicletrackingproviderIdDelete', 'id', id)
            const localVarPath = `/api/app/vehicletrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicletrackingproviderIdGet', 'id', id)
            const localVarPath = `/api/app/vehicletrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicletrackingproviderIdDeleteRequest} [apiAppVehicletrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdPut: async (id: number, apiAppVehicletrackingproviderIdDeleteRequest?: ApiAppVehicletrackingproviderIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicletrackingproviderIdPut', 'id', id)
            const localVarPath = `/api/app/vehicletrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicletrackingproviderIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVehicletrackingproviderGetRequest} [apiAppVehicletrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderPost: async (apiAppVehicletrackingproviderGetRequest?: ApiAppVehicletrackingproviderGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicletrackingproviderGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicletrackingprovider/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleTrackingProviderApi - functional programming interface
 * @export
 */
export const VehicleTrackingProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleTrackingProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicletrackingproviderIdDeleteRequest} [apiAppVehicletrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderIdPut(id: number, apiAppVehicletrackingproviderIdDeleteRequest?: ApiAppVehicletrackingproviderIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderIdPut(id, apiAppVehicletrackingproviderIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVehicletrackingproviderGetRequest} [apiAppVehicletrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest?: ApiAppVehicletrackingproviderGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleTrackingProviderApi - factory interface
 * @export
 */
export const VehicleTrackingProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleTrackingProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleTrackingProviderDto> {
            return localVarFp.apiAppVehicletrackingproviderChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicletrackingproviderDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppVehicletrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleTrackingProviderDto>> {
            return localVarFp.apiAppVehicletrackingproviderGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleTrackingProviderDto>> {
            return localVarFp.apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicletrackingproviderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdGet(id: number, options?: any): AxiosPromise<VehicleTrackingProviderDto> {
            return localVarFp.apiAppVehicletrackingproviderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicletrackingproviderIdDeleteRequest} [apiAppVehicletrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderIdPut(id: number, apiAppVehicletrackingproviderIdDeleteRequest?: ApiAppVehicletrackingproviderIdDeleteRequest, options?: any): AxiosPromise<VehicleTrackingProviderDto> {
            return localVarFp.apiAppVehicletrackingproviderIdPut(id, apiAppVehicletrackingproviderIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVehicletrackingproviderGetRequest} [apiAppVehicletrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest?: ApiAppVehicletrackingproviderGetRequest, options?: any): AxiosPromise<VehicleTrackingProviderDto> {
            return localVarFp.apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleTrackingProviderApi - object-oriented interface
 * @export
 * @class VehicleTrackingProviderApi
 * @extends {BaseAPI}
 */
export class VehicleTrackingProviderApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppVehicletrackingproviderIdDeleteRequest} [apiAppVehicletrackingproviderIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderIdPut(id: number, apiAppVehicletrackingproviderIdDeleteRequest?: ApiAppVehicletrackingproviderIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderIdPut(id, apiAppVehicletrackingproviderIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVehicletrackingproviderGetRequest} [apiAppVehicletrackingproviderGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest?: ApiAppVehicletrackingproviderGetRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderPost(apiAppVehicletrackingproviderGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTrackingProviderApi
     */
    public apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return VehicleTrackingProviderApiFp(this.configuration).apiAppVehicletrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleViewApi - axios parameter creator
 * @export
 */
export const VehicleViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleviewIdGet', 'id', id)
            const localVarPath = `/api/app/vehicleview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewVehiclecurrentdriverVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehicleviewVehiclecurrentdriverVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehicleview/vehiclecurrentdriver/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleViewApi - functional programming interface
 * @export
 */
export const VehicleViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleViewApi - factory interface
 * @export
 */
export const VehicleViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleDtoPagedResultDto> {
            return localVarFp.apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleViewListDtoPagedResultDto> {
            return localVarFp.apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleViewListDto>> {
            return localVarFp.apiAppVehicleviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleViewListDto>> {
            return localVarFp.apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewIdGet(id: number, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleviewIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<number> {
            return localVarFp.apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleViewApi - object-oriented interface
 * @export
 * @class VehicleViewApi
 * @extends {BaseAPI}
 */
export class VehicleViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VirtualTenantApi - axios parameter creator
 * @export
 */
export const VirtualTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetvehicledriversPost: async (apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/getvehicledrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantGetvehicledriversPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdDelete', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdGet', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdPut: async (id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdPut', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantPost: async (apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantValidateEmailPost: async (email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/validate-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VirtualTenantApi - functional programming interface
 * @export
 */
export const VirtualTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VirtualTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VirtualTenantApi - factory interface
 * @export
 */
export const VirtualTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VirtualTenantApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VirtualTenantListDtoPagedResultDto> {
            return localVarFp.apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVirtualtenantIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdGet(id: string, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VirtualTenantApi - object-oriented interface
 * @export
 * @class VirtualTenantApi
 * @extends {BaseAPI}
 */
export class VirtualTenantApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdDelete(id: string, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdGet(id: string, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

